
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirebaba"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirebaba"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $7af3f3cc234ba8c0$exports = {};
$parcel$extendImportMap({
    "aExTk": "track-abudhabi.48b0a860.png",
    "jRHDS": "track-albertpark.b6e68254.png",
    "aeC0O": "track-americas.06767001.png",
    "kJK2s": "track-bahrain.868e77f3.png",
    "e5siq": "track-baku.69ca9a3b.png",
    "gCIlP": "track-budapest.7c9d8441.png",
    "fMkiN": "track-catalunya.374ff586.png",
    "bbloo": "track-hockenheim.6bdf2a89.png",
    "47dNC": "track-interlagos.8e0f9c51.png",
    "gRinf": "track-marinabay.0a33eeae.png",
    "9HuFo": "track-mexico.05ac784e.png",
    "drjyc": "track-monaco.38de39d2.png",
    "frgSB": "track-montreal.f0f0af0a.png",
    "5KWgb": "track-monza.a8fd1bd2.png",
    "g4oj3": "track-paulricard.de93379c.png",
    "eVCrK": "track-shanghai.44e80101.png",
    "zsGAz": "track-silverstone.91bfcf72.png",
    "jeVDx": "track-sochi.d2939093.png",
    "cASxw": "track-spa.77bf4db9.png",
    "cSrSj": "track-spielberg.ba82b40c.png",
    "fNqYa": "track-suzuka.9e7a1d61.png",
    "g8KzK": "car-sprites.57deb5a0.png",
    "9zTMV": "checkered-strip.57886508.png",
    "1U0Wl": "checkered-flag.8b33e35e.png",
    "cqMlZ": "game-logo-v2.2af910bd.png",
    "6Bb2K": "start-finish.81217006.png",
    "amb6j": "start-lights.ac925e98.png",
    "ksW3v": "starting-grid.b90d43f7.png",
    "1MB9f": "spinner.a04b6bb3.png",
    "9gynt": "track-abudhabi.4c458eb4.svg",
    "etgUB": "track-albertpark.81efd59b.svg",
    "aL5i9": "track-americas.bb15e10e.svg",
    "lX6k3": "track-bahrain.58c4793f.svg",
    "hgDRI": "track-baku.78fee08b.svg",
    "3kjs5": "track-budapest.7ce13b51.svg",
    "fl3CV": "track-catalunya.f8ed6876.svg",
    "dOQSS": "track-hockenheim.23a31ea9.svg",
    "lUHja": "track-interlagos.daae6ad3.svg",
    "hNa2C": "track-marinabay.deb40441.svg",
    "22HiZ": "track-mexico.ecb4e120.svg",
    "3fbpw": "track-monaco.62a314ac.svg",
    "5MwQg": "track-montreal.b0dd32e6.svg",
    "fAAmF": "track-monza.71a37b2f.svg",
    "3WKqT": "track-paulricard.cbc5cdd4.svg",
    "bzrOZ": "track-shanghai.36684f76.svg",
    "fLDMp": "track-silverstone.dd861d1d.svg",
    "gK0A1": "track-sochi.39e4efbf.svg",
    "3rYFL": "track-spa.a464ea36.svg",
    "kcVPY": "track-spielberg.fc115fd5.svg",
    "fzZBO": "track-suzuka.aca744cd.svg",
    "4Pd0n": "engine-loop.c3f7ee77.ogg",
    "92OO6": "game-music.6f06ebbc.ogg",
    "hIiQf": "title-music.c415dae8.ogg",
    "3pb4X": "start-light.c52cd330.ogg",
    "04DVU": "button-click.b49f30c2.ogg"
});

const $cb8a4fc1d1568115$var$HALF_PI = Math.PI * 0.5;
const $cb8a4fc1d1568115$var$TAU = Math.PI * 2;
function $cb8a4fc1d1568115$export$1391212d75b2ee65(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
async function $cb8a4fc1d1568115$export$c32505ea942c7f01(url, targetElement) {
    try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const svgText = await response.text();
        if (targetElement) // Insert the SVG content directly into the target element
        targetElement.innerHTML = svgText;
        else console.error(`Target element with ID '${targetElementId}' not found.`);
    } catch (error) {
        console.error("Error loading SVG:", error);
    }
}
function $cb8a4fc1d1568115$export$b61bf3053f58d778(gElement, gPath, posX, posY) {
    if (!gElement || !gPath) return false;
    const svgPoint = gElement.ownerSVGElement.createSVGPoint();
    svgPoint.x = posX;
    svgPoint.y = posY;
    const ctm = gElement.getScreenCTM().inverse();
    const transformedPoint = svgPoint.matrixTransform(ctm);
    return gPath.isPointInStroke(transformedPoint);
}
function $cb8a4fc1d1568115$export$17768e0e20632e02(transformStr) {
    if (!transformStr) return {
        x: 0,
        y: 0
    };
    // Match translate(...) with optional commas or spaces
    const match = transformStr.match(/translate\(\s*([-\d.]+)[ ,]?\s*([-\d.]*)\s*\)/);
    if (!match) return {
        x: 0,
        y: 0
    };
    const x = parseFloat(match[1]);
    const y = match[2] !== "" ? parseFloat(match[2]) : 0; // if only one number, y = 0
    return {
        x: x,
        y: y
    };
}
function $cb8a4fc1d1568115$export$9f6b931a34229784(pathEl, step = 2, trackCenterlineOffset, TRACK_SCALE) {
    const len = pathEl.getTotalLength();
    const pts = [];
    for(let d = 0; d <= len; d += step){
        const { x: x, y: y } = pathEl.getPointAtLength(d);
        pts.push({
            x: (x + trackCenterlineOffset.x) * TRACK_SCALE,
            y: (y + trackCenterlineOffset.y) * TRACK_SCALE
        });
    }
    // ensure last point included
    if (pts.length === 0 || pts[pts.length - 1][0] !== pathEl.getPointAtLength(len).x) {
        const p = pathEl.getPointAtLength(len);
        pts.push({
            x: (p.x + trackCenterlineOffset.x) * TRACK_SCALE,
            y: (p.y + trackCenterlineOffset.y) * TRACK_SCALE
        });
    }
    return pts;
}
function $cb8a4fc1d1568115$export$375e190ec3f34c7(points, qx, qy) {
    let best = -1, bestD2 = Infinity;
    for(let i = 0; i < points.length; i++){
        const { x: x, y: y } = points[i];
        const dx = x - qx, dy = y - qy;
        const d2 = dx * dx + dy * dy; // squared distance
        if (d2 < bestD2) {
            bestD2 = d2;
            best = i;
        }
    }
    return {
        index: best,
        point: points[best],
        dist: Math.sqrt(bestD2)
    };
}
function $cb8a4fc1d1568115$export$afd58ae2e5ad6fa2(points, index) {
    if (points.length < 2) return 0;
    // Handle endpoints gracefully
    const i1 = Math.max(0, index - 1);
    const i2 = Math.min(points.length - 1, index + 1);
    const { x: x1, y: y1 } = points[i1];
    const { x: x2, y: y2 } = points[i2];
    const dx = x2 - x1;
    const dy = y2 - y1;
    return Math.atan2(dy, dx) + $cb8a4fc1d1568115$var$HALF_PI;
}
function $cb8a4fc1d1568115$export$4e54fd7202dafda6(angleRad) {
    const c = Math.cos(angleRad - $cb8a4fc1d1568115$var$HALF_PI);
    const s = Math.sin(angleRad - $cb8a4fc1d1568115$var$HALF_PI);
    return {
        forward: {
            x: c,
            y: s
        },
        backward: {
            x: -c,
            y: -s
        },
        left: {
            x: s,
            y: -c
        },
        right: {
            x: -s,
            y: c
        }
    };
}
function $cb8a4fc1d1568115$export$ed0225908b7785ef(o, distance = 0, angleRad = 0) {
    const dv = $cb8a4fc1d1568115$export$4e54fd7202dafda6(angleRad || o.angle || o.heading);
    return {
        x: o.x + dv.forward.x * distance,
        y: o.y + dv.forward.y * distance
    };
}
function $cb8a4fc1d1568115$export$e3b8fbf5e09a802b(o, distance = 0, angleRad = 0) {
    const dv = $cb8a4fc1d1568115$export$4e54fd7202dafda6(angleRad || o.angle || o.heading);
    return {
        x: o.x + dv.backward.x * distance,
        y: o.y + dv.backward.y * distance
    };
}
function $cb8a4fc1d1568115$export$ce0a29c99027c51a(o, distance = 0, angleRad = 0) {
    const dv = $cb8a4fc1d1568115$export$4e54fd7202dafda6(angleRad || o.angle || o.heading);
    return {
        x: o.x + dv.left.x * distance,
        y: o.y + dv.left.y * distance
    };
}
function $cb8a4fc1d1568115$export$44368ef9a5d62e14(o, distance = 0, angleRad = 0) {
    const dv = $cb8a4fc1d1568115$export$4e54fd7202dafda6(angleRad || o.angle || o.heading);
    return {
        x: o.x + dv.right.x * distance,
        y: o.y + dv.right.y * distance
    };
}
function $cb8a4fc1d1568115$export$e2362a88e5cde023(ox, oy, headingRad, tx, ty) {
    // vector from object → target
    const dx = tx - ox;
    const dy = ty - oy;
    // absolute angle from object to target (0 = +X axis)
    const targetAngle = Math.atan2(dy, dx) + $cb8a4fc1d1568115$var$HALF_PI;
    // difference in [-PI, PI]
    let diff = targetAngle - headingRad;
    diff = (diff + Math.PI) % (2 * Math.PI) - Math.PI;
    return diff;
}
function $cb8a4fc1d1568115$export$bb945e451b3a4d79(cx, cy, headingRad, tx, ty) {
    const dx = tx - cx;
    const dy = ty - cy;
    // transform world delta into local coordinates (relative to heading)
    const cos = Math.cos(headingRad);
    const sin = Math.sin(headingRad);
    const localX = cos * dx + sin * dy; // +X = right of heading
    const localY = -sin * dx + cos * dy; // +Y = forward along heading
    // Determine primary direction
    let dirCode = 0;
    const forward = localY < 0.0001;
    const backward = localY > -0.0001;
    const right = localX > 0.0001;
    const left = localX < -0.0001;
    if (forward) dirCode |= 1; // front
    else if (backward) dirCode |= 2; // back
    if (right) dirCode |= 4; // right
    else if (left) dirCode |= 8; // left
    return dirCode;
}
// Direction bit flags
const $cb8a4fc1d1568115$var$DIR_FRONT = 1; // 0001
const $cb8a4fc1d1568115$var$DIR_BACK = 2; // 0010
const $cb8a4fc1d1568115$var$DIR_RIGHT = 4; // 0100
const $cb8a4fc1d1568115$var$DIR_LEFT = 8; // 1000
function $cb8a4fc1d1568115$export$356bfd1d9b75126e(code) {
    return (code & $cb8a4fc1d1568115$var$DIR_FRONT) !== 0;
}
function $cb8a4fc1d1568115$export$2bbcf85099b24e44(code) {
    return (code & $cb8a4fc1d1568115$var$DIR_BACK) !== 0;
}
function $cb8a4fc1d1568115$export$c58d401318d63dc9(code) {
    return (code & $cb8a4fc1d1568115$var$DIR_RIGHT) !== 0;
}
function $cb8a4fc1d1568115$export$a40afd0d6df5eee8(code) {
    return (code & $cb8a4fc1d1568115$var$DIR_LEFT) !== 0;
}
function $cb8a4fc1d1568115$export$e0b56eedabd2a5bd(ms) {
    if (ms < 0) return "-:--.---";
    const minutes = Math.floor(ms / 60000);
    const seconds = Math.floor(ms % 60000 / 1000);
    const millis = Math.floor(ms % 1000); // 3 digits
    if (isNaN(minutes) || isNaN(seconds) || isNaN(millis)) return "-:--.---";
    return `${minutes}:${seconds.toString().padStart(2, "0")}.${millis.toString().padStart(3, "0")}`;
}
function $cb8a4fc1d1568115$export$ba24de55cbae4fc0(value, max = 1) {
    if (value < -max) return -max;
    if (value > max) return max;
    return value;
}
function $cb8a4fc1d1568115$export$df664cc8cd3888d6(start, end, value) {
    const delta = end - start;
    const e1 = start + delta * Math.floor((value - start) / delta);
    return (value - e1) / delta;
}
function $cb8a4fc1d1568115$export$aa5a5b0e8a1e9daa(previous, current) {
    let diff = current - previous;
    diff = (diff + Math.PI) % $cb8a4fc1d1568115$var$TAU - Math.PI;
    return previous + diff;
}
function $cb8a4fc1d1568115$export$70c4ae293293ca1e(buf) {
    const u8 = new Uint8Array(buf);
    let bin = "";
    for(let i = 0; i < u8.length; i++)bin += String.fromCharCode(u8[i]);
    return btoa(bin);
}
function $cb8a4fc1d1568115$export$a7a17e76664e3e44(b64) {
    const bin = atob(b64);
    const u8 = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; i++)u8[i] = bin.charCodeAt(i);
    return u8.buffer;
}
async function $cb8a4fc1d1568115$export$2cdf1b96a9f86d16(text) {
    // Tier 1: Try modern Clipboard API
    if (navigator.clipboard && navigator.clipboard.writeText) try {
        await navigator.clipboard.writeText(text);
        return {
            success: true,
            method: 'modern'
        };
    } catch (error) {
        console.warn("Clipboard API blocked, trying fallback:", error);
    // Continue to Tier 2
    }
    // Tier 2: Try legacy execCommand method
    try {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        textarea.style.pointerEvents = 'none';
        document.body.appendChild(textarea);
        textarea.select();
        textarea.setSelectionRange(0, text.length);
        const success = document.execCommand('copy');
        document.body.removeChild(textarea);
        if (success) return {
            success: true,
            method: 'execCommand'
        };
    } catch (error) {
        console.warn("execCommand failed:", error);
    }
    // Tier 3: Return failure signal for manual UI fallback
    return {
        success: false,
        method: 'none',
        text: text
    };
}
function $cb8a4fc1d1568115$export$c45b2c24995cfb78() {
    return window.location.hostname.includes('html-classic.itch.zone');
}


const $3df263189409ffaa$var$POOL_SIZE = 100;
const $3df263189409ffaa$var$SPEED = 0.1;
const $3df263189409ffaa$var$DEFAULT_DURATION = 700;
const $3df263189409ffaa$var$DEFAULT_SPARK_COUNT = 10;
const $3df263189409ffaa$var$INITIAL_RANDOM_SCATTER = 15;
const $3df263189409ffaa$var$particles = [];
let $3df263189409ffaa$var$$root = null;
function $3df263189409ffaa$export$aff2be167080a97f(root) {
    $3df263189409ffaa$var$$root = root;
    for(let i = 0; i < $3df263189409ffaa$var$POOL_SIZE; i++){
        const $particle = document.createElement("div");
        $particle.x = 0;
        $particle.y = 0;
        $particle.prevX = 0;
        $particle.prevY = 0;
        $particle.vx = 0;
        $particle.vy = 0;
        $particle.active = false;
        $particle.endTime = -1;
        $3df263189409ffaa$var$particles.push($particle);
        $3df263189409ffaa$var$$root.appendChild($particle);
    }
}
function $3df263189409ffaa$export$82f1959c43a38055(now) {
    for(let i = 0; i < $3df263189409ffaa$var$POOL_SIZE; i++){
        const $particle = $3df263189409ffaa$var$particles[i];
        if (!$particle.active || now < $particle.startTime) continue;
        // Save previous position for interpolation
        $particle.prevX = $particle.x;
        $particle.prevY = $particle.y;
        // Update physics
        $particle.vx += -$3df263189409ffaa$var$SPEED + Math.random() * $3df263189409ffaa$var$SPEED * 2;
        $particle.vy += -$3df263189409ffaa$var$SPEED + Math.random() * $3df263189409ffaa$var$SPEED * 2;
        $particle.x += $particle.vx;
        $particle.y += $particle.vy;
        if (now > $particle.endTime) $particle.active = false;
    }
}
function $3df263189409ffaa$export$a47de188f7a2507b(now, alpha) {
    for(let i = 0; i < $3df263189409ffaa$var$POOL_SIZE; i++){
        const $particle = $3df263189409ffaa$var$particles[i];
        $particle.style.opacity = !$particle.active || now < $particle.startTime ? 0 : 1;
        if (!$particle.active || now < $particle.startTime) continue;
        // Interpolate between previous and current position
        const renderX = $particle.prevX + ($particle.x - $particle.prevX) * alpha;
        const renderY = $particle.prevY + ($particle.y - $particle.prevY) * alpha;
        $particle.style.transform = `translate(${renderX}px, ${renderY}px)`;
    }
}
function $3df263189409ffaa$var$getParticle() {
    for(let i = 0; i < $3df263189409ffaa$var$POOL_SIZE; i++){
        const $particle = $3df263189409ffaa$var$particles[i];
        if (!$particle.active) return $particle;
    }
    return null;
}
function $3df263189409ffaa$export$32465a74bc98bd3(now, x, y, vx, vy, count = $3df263189409ffaa$var$DEFAULT_SPARK_COUNT, duration = $3df263189409ffaa$var$DEFAULT_DURATION) {
    const halfDuration = duration * 0.5;
    for(let i = 0; i < count; i++){
        const $particle = $3df263189409ffaa$var$getParticle();
        if ($particle) {
            $particle.x = x + -$3df263189409ffaa$var$INITIAL_RANDOM_SCATTER + Math.random() * $3df263189409ffaa$var$INITIAL_RANDOM_SCATTER * 2;
            $particle.y = y + -$3df263189409ffaa$var$INITIAL_RANDOM_SCATTER + Math.random() * $3df263189409ffaa$var$INITIAL_RANDOM_SCATTER * 2;
            // Initialize prev position to current to avoid interpolation glitch on spawn
            $particle.prevX = $particle.x;
            $particle.prevY = $particle.y;
            $particle.vx = vx * Math.random() * 5;
            $particle.vy = vy * Math.random() * 5;
            $particle.active = true;
            $particle.startTime = now + Math.random() * halfDuration;
            $particle.endTime = $particle.startTime + halfDuration + Math.random() * halfDuration;
        }
    }
}


// Fixed timestep physics configuration
const $e24eb4b533960f8a$export$16de981e12aeb890 = 60;
const $e24eb4b533960f8a$export$cda3257a9191f950 = 1000 / $e24eb4b533960f8a$export$16de981e12aeb890; // ~16.67ms per tick
const $e24eb4b533960f8a$var$MAX_ACCUMULATED_TIME = $e24eb4b533960f8a$export$cda3257a9191f950 * 4; // Prevent spiral of death
// Physics timing state
let $e24eb4b533960f8a$var$accumulator = 0;
let $e24eb4b533960f8a$var$lastPhysicsTime = null;
function $e24eb4b533960f8a$export$ec57c86e1502e26() {
    $e24eb4b533960f8a$var$accumulator = 0;
    $e24eb4b533960f8a$var$lastPhysicsTime = null;
}
function $e24eb4b533960f8a$export$11ec2289ecd96598(currentTime, physicsTick) {
    if ($e24eb4b533960f8a$var$lastPhysicsTime === null) {
        $e24eb4b533960f8a$var$lastPhysicsTime = currentTime;
        return 0;
    }
    let deltaTime = currentTime - $e24eb4b533960f8a$var$lastPhysicsTime;
    $e24eb4b533960f8a$var$lastPhysicsTime = currentTime;
    // Cap accumulated time to prevent spiral of death at very low FPS
    $e24eb4b533960f8a$var$accumulator += Math.min(deltaTime, $e24eb4b533960f8a$var$MAX_ACCUMULATED_TIME);
    let ticksRun = 0;
    while($e24eb4b533960f8a$var$accumulator >= $e24eb4b533960f8a$export$cda3257a9191f950){
        physicsTick();
        $e24eb4b533960f8a$var$accumulator -= $e24eb4b533960f8a$export$cda3257a9191f950;
        ticksRun++;
    }
    return ticksRun;
}
function $e24eb4b533960f8a$export$2be38fe441e278c1() {
    return $e24eb4b533960f8a$var$accumulator / $e24eb4b533960f8a$export$cda3257a9191f950;
}



// ===== Quantisation & timing =====
const $74682beda20f55da$var$TAU = Math.PI * 2;
// centimetre precision
const $74682beda20f55da$var$POS_SCALE = 100; // metres -> centimetres
const $74682beda20f55da$var$TIME_SCALE_INT = 100; // centiseconds per second
const $74682beda20f55da$var$SAMPLE_RATE = 10; // Hz
const $74682beda20f55da$var$SAMPLE_INTERVAL_MS = 1000 / $74682beda20f55da$var$SAMPLE_RATE;
const $74682beda20f55da$var$HEADING_TO_U16 = 65535 / $74682beda20f55da$var$TAU;
const $74682beda20f55da$var$U16_TO_HEADING = $74682beda20f55da$var$TAU / 65535;
const $74682beda20f55da$var$GHOST_KEY = "ghostDataV3";
// ===== Runtime buffers (delta-encoded samples) =====
// Each sample: { tCS:uint24, dxI16:int16, dyI16:int16, hU16:uint16 }
let $74682beda20f55da$var$localGhostSamples = [];
let $74682beda20f55da$var$localFirstSampleMs = null;
let $74682beda20f55da$var$localLastSampleMs = -Infinity;
// keep last quantised absolute to compute deltas
let $74682beda20f55da$var$lastQx = 0; // int (cm)
let $74682beda20f55da$var$lastQy = 0; // int (cm)
let $74682beda20f55da$var$haveOrigin = false;
let $74682beda20f55da$var$startQx = 0; // header absolute origin (cm)
let $74682beda20f55da$var$startQy = 0;
function $74682beda20f55da$var$normAngle(a) {
    a %= $74682beda20f55da$var$TAU;
    if (a < 0) a += $74682beda20f55da$var$TAU;
    return a;
}
function $74682beda20f55da$export$5df67d441e0c8bea(tAbsMs, x, y, heading) {
    if ($74682beda20f55da$var$localFirstSampleMs === null) {
        $74682beda20f55da$var$localFirstSampleMs = tAbsMs;
        $74682beda20f55da$var$localLastSampleMs = tAbsMs;
    }
    // rate gate
    if (tAbsMs - $74682beda20f55da$var$localLastSampleMs < $74682beda20f55da$var$SAMPLE_INTERVAL_MS) return;
    $74682beda20f55da$var$localLastSampleMs = tAbsMs;
    const tSec = (tAbsMs - $74682beda20f55da$var$localFirstSampleMs) / 1000;
    // Optional: dedupe if basically unchanged
    const last = $74682beda20f55da$var$localGhostSamples[$74682beda20f55da$var$localGhostSamples.length - 1];
    if (last) {
        const dx = x - last.x;
        const dy = y - last.y;
        const d2 = dx * dx + dy * dy;
        const dHeading = Math.abs(heading - last.heading);
        if (d2 < 1e-6 && dHeading < 1e-3) return;
    }
    $74682beda20f55da$var$localGhostSamples.push({
        t: tSec,
        x: x,
        y: y,
        heading: heading
    });
}
function $74682beda20f55da$export$6353eccc1d45a7e0() {
    $74682beda20f55da$var$localGhostSamples = [];
    $74682beda20f55da$var$localFirstSampleMs = null;
    $74682beda20f55da$var$localLastSampleMs = -Infinity;
    $74682beda20f55da$var$haveOrigin = false;
    $74682beda20f55da$var$startQx = $74682beda20f55da$var$startQy = $74682beda20f55da$var$lastQx = $74682beda20f55da$var$lastQy = 0;
}
function $74682beda20f55da$export$addd7796303fe3fa(name = $74682beda20f55da$var$GHOST_KEY) {
    localStorage.removeItem(name);
    $74682beda20f55da$export$6353eccc1d45a7e0();
}
// Binary + sequential search helper (unchanged)
function $74682beda20f55da$var$findGhostSpan(samples, tSec, lastIdx = null) {
    const n = samples.length;
    if (!n || n === 0) return {
        i0: -1,
        i1: -1,
        alpha: 0
    };
    if (tSec <= samples[0].t) return {
        i0: 0,
        i1: 0,
        alpha: 0
    };
    if (tSec >= samples[n - 1].t) return {
        i0: n - 1,
        i1: n - 1,
        alpha: 1
    };
    // Sequential scan for monotonic playback
    if (lastIdx !== null && lastIdx >= 0 && lastIdx < n) {
        let i = lastIdx;
        if (tSec >= samples[i].t) {
            while(i + 1 < n && samples[i + 1].t <= tSec)i++;
            if (samples[i].t <= tSec && tSec < samples[i + 1].t) {
                const t0 = samples[i].t, t1 = samples[i + 1].t;
                const alpha = (tSec - t0) / (t1 - t0);
                return {
                    i0: i,
                    i1: i + 1,
                    alpha: alpha
                };
            }
        } else {
            while(i > 0 && samples[i - 1].t > tSec)i--;
            if (samples[i].t <= tSec && tSec < samples[i + 1].t) {
                const t0 = samples[i].t, t1 = samples[i + 1].t;
                const alpha = (tSec - t0) / (t1 - t0);
                return {
                    i0: i,
                    i1: i + 1,
                    alpha: alpha
                };
            }
        }
    }
    // Binary search fallback
    let lo = 0, hi = n - 1;
    while(lo + 1 < hi){
        const mid = lo + hi >> 1;
        if (samples[mid].t <= tSec) lo = mid;
        else hi = mid;
    }
    const t0 = samples[lo].t, t1 = samples[lo + 1].t;
    const alpha = (tSec - t0) / (t1 - t0);
    return {
        i0: lo,
        i1: lo + 1,
        alpha: alpha
    };
}
// Safe heading interpolation
function $74682beda20f55da$var$lerpAngle(a, b, alpha) {
    let d = b - a;
    d = (d + Math.PI) % $74682beda20f55da$var$TAU - Math.PI;
    return a + d * alpha;
}
function $74682beda20f55da$export$29b3a998a16c439(samples, tMs, lastIdx = null) {
    const tSec = tMs / 1000;
    const { i0: i0, i1: i1, alpha: alpha } = $74682beda20f55da$var$findGhostSpan(samples, tSec, lastIdx);
    if (i0 < 0) return null;
    const s0 = samples[i0], s1 = samples[i1];
    if (i0 === i1 || !isFinite(alpha)) return {
        x: s0.x,
        y: s0.y,
        heading: s0.heading,
        index: i0
    };
    const x = s0.x + (s1.x - s0.x) * alpha;
    const y = s0.y + (s1.y - s0.y) * alpha;
    return {
        x: x,
        y: y,
        heading: s1.heading,
        index: i0
    };
}
// Build GH3 ArrayBuffer from current in-memory samples
function $74682beda20f55da$var$packGhost(samples) {
    const n = samples.length;
    const HEADER = 21;
    const BYTES_PER_SAMPLE = 9;
    if (n === 0) return {
        buffer: new ArrayBuffer(0),
        samples: 0,
        bytes: 0
    };
    const buffer = new ArrayBuffer(HEADER + n * BYTES_PER_SAMPLE);
    const view = new DataView(buffer);
    let o = 0;
    // ---- Header "GH3\0" ----
    view.setUint8(o++, 0x47); // 'G'
    view.setUint8(o++, 0x48); // 'H'
    view.setUint8(o++, 0x33); // '3'
    view.setUint8(o++, 0x00);
    view.setUint8(o++, 3); // version
    view.setUint16(o, $74682beda20f55da$var$POS_SCALE, true);
    o += 2; // e.g. 100
    view.setUint16(o, $74682beda20f55da$var$TIME_SCALE_INT, true);
    o += 2; // e.g. 100
    // Quantise first sample as absolute origin (cm)
    const first = samples[0];
    let qx = Math.round(first.x * $74682beda20f55da$var$POS_SCALE);
    let qy = Math.round(first.y * $74682beda20f55da$var$POS_SCALE);
    view.setInt32(o, qx, true);
    o += 4; // startQx in cm
    view.setInt32(o, qy, true);
    o += 4; // startQy in cm
    view.setUint32(o, n, true);
    o += 4; // sample count
    // ---- Samples ----
    let lastQx = qx;
    let lastQy = qy;
    for(let i = 0; i < n; i++){
        const s = samples[i];
        // time: seconds -> centiseconds (uint24)
        const tCS = Math.min(0xffffff, Math.round(s.t * $74682beda20f55da$var$TIME_SCALE_INT) // TIME_SCALE_INT=100 → 100*seconds
        );
        qx = Math.round(s.x * $74682beda20f55da$var$POS_SCALE);
        qy = Math.round(s.y * $74682beda20f55da$var$POS_SCALE);
        let dxI16 = qx - lastQx;
        let dyI16 = qy - lastQy;
        // clamp to int16 range
        if (dxI16 < -32768) dxI16 = -32768;
        if (dxI16 > 32767) dxI16 = 32767;
        if (dyI16 < -32768) dyI16 = -32768;
        if (dyI16 > 32767) dyI16 = 32767;
        // heading: radians → uint16 [0..65535]
        const hNorm = (s.heading % $74682beda20f55da$var$TAU + $74682beda20f55da$var$TAU) % $74682beda20f55da$var$TAU;
        const hU16 = Math.round(hNorm * $74682beda20f55da$var$HEADING_TO_U16) & 0xffff;
        // write sample
        view.setInt16(o, dxI16, true);
        o += 2;
        view.setInt16(o, dyI16, true);
        o += 2;
        view.setUint16(o, hU16, true);
        o += 2;
        view.setUint8(o++, tCS & 0xff);
        view.setUint8(o++, tCS >>> 8 & 0xff);
        view.setUint8(o++, tCS >>> 16 & 0xff);
        lastQx += dxI16;
        lastQy += dyI16;
    }
    return {
        buffer: buffer,
        samples: n,
        bytes: HEADER + n * BYTES_PER_SAMPLE
    };
}
function $74682beda20f55da$export$2d3e1043d88392ae(buffer) {
    if (!(buffer instanceof ArrayBuffer) || buffer.byteLength < 21) return null;
    const view = new DataView(buffer);
    // Magic check
    if (!(view.getUint8(0) === 0x47 && view.getUint8(1) === 0x48)) return null; // "GH"
    let o = 4;
    const version = view.getUint8(o++); // expect 3
    const posScale = view.getUint16(o, true);
    o += 2; // expect 100
    const timeScale = view.getUint16(o, true);
    o += 2; // expect 100
    let qx = view.getInt32(o, true);
    o += 4; // startQx (cm)
    let qy = view.getInt32(o, true);
    o += 4; // startQy (cm)
    const count = view.getUint32(o, true);
    o += 4;
    const samples = new Array(count);
    for(let i = 0; i < count; i++){
        const dxI16 = view.getInt16(o, true);
        o += 2;
        const dyI16 = view.getInt16(o, true);
        o += 2;
        const hU16 = view.getUint16(o, true);
        o += 2;
        const tCS = view.getUint8(o) | view.getUint8(o + 1) << 8 | view.getUint8(o + 2) << 16;
        o += 3;
        qx += dxI16;
        qy += dyI16;
        samples[i] = {
            t: tCS / timeScale,
            x: qx / posScale,
            y: qy / posScale,
            heading: hU16 * $74682beda20f55da$var$U16_TO_HEADING
        };
    }
    return {
        version: version,
        posScale: posScale,
        timeScale: timeScale,
        samples: samples
    };
}
function $74682beda20f55da$export$1a28bbfe6308d9c9(name = $74682beda20f55da$var$GHOST_KEY) {
    const { buffer: buffer, samples: samples, bytes: bytes } = $74682beda20f55da$var$packGhost($74682beda20f55da$var$localGhostSamples);
    if (samples === 0) return {
        samples: samples,
        bytes: bytes,
        key: name,
        b64Bytes: 0
    };
    const b64 = (0, $cb8a4fc1d1568115$export$70c4ae293293ca1e)(buffer);
    localStorage.setItem(name, b64);
    return {
        samples: samples,
        bytes: bytes,
        key: name,
        b64Bytes: b64.length
    };
}
function $74682beda20f55da$export$1482634c4924b9b6(name = $74682beda20f55da$var$GHOST_KEY) {
    const b64 = localStorage.getItem(name);
    if (!b64) return null;
    const buf = (0, $cb8a4fc1d1568115$export$a7a17e76664e3e44)(b64);
    return $74682beda20f55da$export$2d3e1043d88392ae(buf);
}
function $74682beda20f55da$export$79b4d3528b9675c3(samples) {
    return $74682beda20f55da$var$packGhost(samples).buffer; // may be 0-length if nothing recorded
}
function $74682beda20f55da$export$130ae2c21d4eb59a() {
    return $74682beda20f55da$var$localGhostSamples;
}





const $88461f0b0f431f45$export$9badeb9b04b4b71c = "v1.0.8";
const $88461f0b0f431f45$export$d0e7720d468a5456 = [
    "abudhabi",
    "albertpark",
    "americas",
    "bahrain",
    "baku",
    "budapest",
    "catalunya",
    "hockenheim",
    "interlagos",
    "marinabay",
    "mexico",
    "monaco",
    "montreal",
    "monza",
    "paulricard",
    "shanghai",
    "silverstone",
    "sochi",
    "spa",
    "spielberg",
    "suzuka"
];
const $88461f0b0f431f45$export$5cc6edba7251fc3e = {
    abudhabi: "Yas Marina Circuit, United Arab Emirates",
    albertpark: "Albert Park Circuit, Australia",
    americas: "Circuit of the Americas, United States",
    bahrain: "Bahrain International Circuit, Bahrain",
    baku: "Baku City Circuit, Azerbaijan",
    budapest: "Hungaroring, Hungary",
    catalunya: "Circuit de Barcelona-Catalunya, Spain",
    hockenheim: "Hockenheimring, Germany",
    interlagos: "Aut\xf3dromo Jos\xe9 Carlos Pace, Brazil",
    marinabay: "Marina Bay Street Circuit, Singapore",
    mexico: "Aut\xf3dromo Hermanos Rodr\xedguez, Mexico",
    monaco: "Circuit de Monaco, Monaco",
    montreal: "Circuit Gilles Villeneuve, Canada",
    monza: "Autodromo Nazionale di Monza, Italy",
    paulricard: "Circuit Paul Ricard, France",
    shanghai: "Shanghai International Circuit, China",
    silverstone: "Silverstone Circuit, United Kingdom",
    sochi: "Sochi Autodrom, Russia",
    spa: "Circuit de Spa-Francorchamps, Belgium",
    spielberg: "Red Bull Ring, Austria",
    suzuka: "Suzuka Racing Course, Japan"
};
const $88461f0b0f431f45$export$d4e3681ec5762859 = [
    {
        name: "MacLairen Motors",
        primary: "#FF6E0A",
        secondary: "#1A1A1A",
        accent: "#00B5FF"
    },
    {
        name: "Astern Martian",
        primary: "#115C3C",
        secondary: "#C0B283",
        accent: "#25E89B"
    },
    {
        name: "Alphine Peaks",
        primary: "#1A3DE0",
        secondary: "#E2E2E2",
        accent: "#FF1E3C"
    },
    {
        name: "Alpha Omego Racing",
        primary: "#9A0019",
        secondary: "#EDEDED",
        accent: "#1F6FFF"
    },
    {
        name: "Hazz Autosport",
        primary: "#BFBFBF",
        secondary: "#212121",
        accent: "#E43131"
    },
    {
        name: "Red Ox Velocity",
        primary: "#2E2B87",
        secondary: "#F3D000",
        accent: "#E42C2C"
    },
    {
        name: "Scuderia Albatross",
        primary: "#2E89A0",
        secondary: "#ECECEC",
        accent: "#1E1E1E"
    },
    {
        name: "Willpower Racing",
        primary: "#2244FF",
        secondary: "#F0F0F0",
        accent: "#FF2C9F"
    },
    {
        name: "Scuderia Fajita",
        primary: "#D82020",
        secondary: "#F3E2C0",
        accent: "#222222"
    },
    {
        name: "Mercury-AMG Photon",
        primary: "#C0C0C0",
        secondary: "#111111",
        accent: "#05FFD5"
    }
];


class $d98bda1f7a768b4d$export$c6da3d87be4bd7ab {
    constructor(options = {}){
        // 🔊 How audio is provided:
        // - Preferred: options.audioData (ArrayBuffer from manifest)
        // - Or:       options.audioBuffer (decoded AudioBuffer)
        // - Fallback: options.audioUrl (fetch + decode)
        this.audioData = options.audioData || null; // ArrayBuffer
        this.audioBuffer = options.audioBuffer || null; // AudioBuffer
        this.audioUrl = options.audioUrl;
        // Gears and speeds (mph) – tune these
        this.gearMaxSpeeds = options.gearMaxSpeeds || [
            0,
            50,
            90,
            130,
            170,
            200,
            220,
            240
        ]; // 1–7
        this.maxGear = this.gearMaxSpeeds.length - 1;
        // Pitch tuning
        this.basePitch = options.basePitch ?? 0.6; // idle-ish pitch
        this.pitchRange = options.pitchRange ?? 1.4; // how much pitch rises with RPM
        this.minPlaybackRate = 0.5;
        this.maxPlaybackRate = 3.5;
        // Gear + RPM behaviour
        this.shiftRpmThreshold = options.shiftRpmThreshold ?? 0.96; // shift at 96% of gear
        this.shiftDuration = options.shiftDuration ?? 0.09; // seconds
        this.shiftDropFactor = options.shiftDropFactor ?? 0.72; // how much pitch drops on shift
        this.downshiftRpmThresholdOnGain = options.downshiftRpmThresholdOnGain ?? 0.25;
        this.downshiftRpmThresholdOnLoss = options.downshiftRpmThresholdOnLoss ?? 0.6;
        this.downshiftRpmThreshold = this.downshiftRpmThresholdOnGain;
        this.downshiftDuration = options.downshiftDuration ?? 0.07; // slightly quicker
        this.downshiftDropFactor = options.downshiftDropFactor ?? 0.55; // deeper dip
        // Internal state
        this.ctx = null;
        this.engineSource = null;
        this.engineGain = null;
        this.buffer = null;
        this.currentSpeed = 0; // mph (smoothed)
        this.targetSpeed = 0; // mph (what game passes in)
        this.speedSmoothing = 0.18;
        this.gear = 1;
        this.isShifting = false;
        this.shiftTimer = 0;
        this.shiftFromPitch = 1;
        this.shiftDropPitch = 1;
        this.shiftToPitch = 1;
        this.lastUpdateTime = null;
        this.running = false;
    }
    async init() {
        if (this.ctx) return; // already initialised
        this.ctx = new (window.AudioContext || window.webkitAudioContext)();
        // Prefer decoded buffer if already supplied
        if (this.audioBuffer instanceof AudioBuffer) this.buffer = this.audioBuffer;
        else if (this.audioData instanceof ArrayBuffer) // Use ArrayBuffer from manifest
        this.buffer = await this._decodeArrayBuffer(this.audioData);
        else if (this.audioUrl) // Fallback: fetch from URL (old behaviour)
        this.buffer = await this._loadAudioBuffer(this.audioUrl);
        else throw new Error("F1EngineSound: no audioData, audioBuffer or audioUrl provided");
        this._createEngineNode();
    }
    async _decodeArrayBuffer(arrayBuf) {
        // Defensive copy because decodeAudioData may detach the buffer in some browsers
        const copy = arrayBuf.slice(0);
        return await this.ctx.decodeAudioData(copy);
    }
    async _loadAudioBuffer(url) {
        const res = await fetch(url);
        const arrayBuf = await res.arrayBuffer();
        return await this._decodeArrayBuffer(arrayBuf);
    }
    _createEngineNode() {
        if (!this.ctx || !this.buffer) return;
        // Each start() needs a fresh BufferSource
        this.engineSource = this.ctx.createBufferSource();
        this.engineSource.buffer = this.buffer;
        this.engineSource.loop = true;
        this.engineGain = this.ctx.createGain();
        this.engineGain.gain.value = 0.25; // overall volume
        this.engineSource.connect(this.engineGain).connect(this.ctx.destination);
        this.engineSource.playbackRate.value = this.basePitch;
    }
    async start() {
        if (!this.ctx) await this.init();
        if (this.ctx.state === "suspended") await this.ctx.resume();
        if (this.running) return;
        if (!this.engineSource) this._createEngineNode();
        this.engineSource.start(0);
        this.running = true;
        this.lastUpdateTime = performance.now();
        this._loop();
    }
    stop() {
        if (this.engineSource && this.running) try {
            this.engineSource.stop();
        } catch (_) {}
        this.running = false;
        // 🔁 Allow clean restart later
        this.engineSource = null;
    }
    /**
   * Game calls this every frame: provide speed in mph
   */ setSpeedMph(speedMph) {
        this.targetSpeed = Math.max(0, speedMph);
    }
    _loop = ()=>{
        if (!this.running) return;
        const now = performance.now();
        const dt = (now - this.lastUpdateTime) / 1000;
        this.lastUpdateTime = now;
        this.update(dt);
        requestAnimationFrame(this._loop);
    };
    update(dt) {
        if (!this.engineSource) return;
        // Smooth the incoming speed to avoid jittery pitch
        this.currentSpeed += (this.targetSpeed - this.currentSpeed) * this.speedSmoothing;
        // Clamp speed to realistic range
        const maxPossibleSpeed = this.gearMaxSpeeds[this.maxGear];
        const clampedSpeed = Math.max(0, Math.min(this.currentSpeed, maxPossibleSpeed));
        // Determine RPM (0–1) for current gear
        const maxSpeedThisGear = this.gearMaxSpeeds[this.gear] || maxPossibleSpeed;
        const rpmRaw = maxSpeedThisGear > 0 ? clampedSpeed / maxSpeedThisGear : 0;
        const rpm = Math.pow(Math.min(Math.max(rpmRaw, 0), 1), 1.3);
        // Gear shift logic (upshift)
        if (!this.isShifting && rpm >= this.shiftRpmThreshold && this.gear < this.maxGear) this._startShift("up", clampedSpeed);
        // Downshift logic (on braking / slowing)
        this.downshiftRpmThreshold = this.targetSpeed > this.currentSpeed ? this.downshiftRpmThresholdOnGain : this.downshiftRpmThresholdOnLoss;
        if (!this.isShifting && rpm <= this.downshiftRpmThreshold && this.gear > 1) this._startShift("down", clampedSpeed);
        const basePitchForRpm = this.basePitch + rpm * this.pitchRange;
        let finalPitch;
        if (this.isShifting) {
            this.shiftTimer -= dt;
            const duration = this.shiftDirection === "up" ? this.shiftDuration : this.downshiftDuration;
            let t = Math.max(0, Math.min(1, 1 - this.shiftTimer / duration));
            // First half = dip
            if (t < 0.35) {
                const k = t / 0.35;
                finalPitch = this._lerp(this.shiftFromPitch, this.shiftDropPitch, k);
            } else {
                // Second half = climb to new gear pitch
                const k = (t - 0.35) / 0.65;
                finalPitch = this._lerp(this.shiftDropPitch, this.shiftToPitch, k);
            }
            if (this.shiftTimer <= 0) this.isShifting = false;
        } else finalPitch = basePitchForRpm;
        finalPitch = Math.min(Math.max(finalPitch, this.minPlaybackRate), this.maxPlaybackRate);
        this.engineSource.playbackRate.value = finalPitch;
    }
    _startShift(direction, currentSpeed) {
        this.isShifting = true;
        const isUp = direction === "up";
        const duration = isUp ? this.shiftDuration : this.downshiftDuration;
        this.shiftTimer = duration;
        const currentMax = this.gearMaxSpeeds[this.gear];
        const rpmCurrent = Math.max(0, Math.min(1, currentSpeed / currentMax));
        const pitchCurrent = this.basePitch + rpmCurrent * this.pitchRange;
        const nextGear = isUp ? Math.min(this.gear + 1, this.maxGear) : Math.max(this.gear - 1, 1);
        const nextMax = this.gearMaxSpeeds[nextGear];
        const rpmNext = Math.max(0, Math.min(1, currentSpeed / nextMax));
        const pitchNext = this.basePitch + rpmNext * this.pitchRange;
        this.shiftFromPitch = pitchCurrent;
        if (isUp) this.shiftDropPitch = pitchCurrent * this.shiftDropFactor;
        else // deeper drop for downshift "BRAAAP"
        this.shiftDropPitch = pitchCurrent * this.downshiftDropFactor;
        this.shiftToPitch = pitchNext;
        this.shiftDirection = direction;
        this.gear = nextGear;
    }
    _lerp(a, b, t) {
        return a + (b - a) * t;
    }
}


const $cfb31d3eb43e151e$var$SPARK_MIN_INTERVAL = 5000;
const $cfb31d3eb43e151e$var$SPARK_MAX_INTERVAL = 10000;
const $cfb31d3eb43e151e$var$SPARK_MIN_DURATION = 2000;
const $cfb31d3eb43e151e$var$SPARK_MAX_DURATION = 4000;
const $cfb31d3eb43e151e$var$ROAD_FRICTION = 0.99;
const $cfb31d3eb43e151e$var$OFFROAD_FRICTION = 0.97;
const $cfb31d3eb43e151e$var$HALF_PI = Math.PI * 0.5;
class $cfb31d3eb43e151e$export$91030e912f5b0749 {
    constructor($el, carId, colorIndex, isBot, engineAudioData){
        this.$el = $el;
        this.carId = carId;
        this.maxColorIndex = (0, $88461f0b0f431f45$export$d4e3681ec5762859).length;
        this.colorIndex = colorIndex;
        this.isVisible = true;
        this.raceStartTime = -1;
        this.$wheelFL = $el.querySelector(".wheel-fl");
        this.$wheelFR = $el.querySelector(".wheel-fr");
        this.control = {
            isBot: isBot
        };
        this.setEngineSound(engineAudioData);
        this.reset();
    }
    setEngineSound(engineAudioData) {
        if (!this.engineSound) this.engineSound = engineAudioData ? new (0, $d98bda1f7a768b4d$export$c6da3d87be4bd7ab)({
            audioData: engineAudioData,
            gearMaxSpeeds: [
                0,
                50,
                90,
                130,
                170,
                200,
                220,
                240
            ]
        }) : null;
    }
    setVisible(value) {
        this.isVisible = value;
        this.$el.classList.toggle("hidden", !value);
    }
    setBot(value) {
        this.control.isBot = value;
        if (this.control.isBot) this.engineSound.stop();
    }
    setGhostData(ghostData) {
        this.ghostData = ghostData;
        this.$el.classList.toggle("ghost", Boolean(this.ghostData));
    }
    setColor(colorIndex) {
        this.colorIndex = colorIndex;
        this.updateCarColor();
    }
    choosePreviousCarColor() {
        this.colorIndex--;
        this.updateCarColor();
    }
    chooseNextCarColor() {
        this.colorIndex++;
        this.updateCarColor();
    }
    updateCarColor() {
        if (this.colorIndex < 0) this.colorIndex = this.maxColorIndex;
        this.colorIndex %= this.maxColorIndex;
        this.$el.style.backgroundPositionX = `${this.colorIndex * -74}px`;
    }
    setTrackRacinglineSegments(value) {
        this.trackRacinglineSegments = value;
    }
    setStartingGrid(startingGrid) {
        this.heading = startingGrid.angle;
        const { x: x, y: y } = (0, $cb8a4fc1d1568115$export$e3b8fbf5e09a802b)(startingGrid, 4 * this.trackScale);
        this.x = x;
        this.y = y;
        this.prevX = x;
        this.prevY = y;
        this.prevHeading = this.heading;
        this.targetHeading = this.heading;
        // Set initial DOM position so car appears at grid before race starts
        this.$el.style.transform = `translate(${this.x}px, ${this.y}px) rotate(${this.heading}rad)`;
    }
    getMaxSpeed() {
        return this.control.speed < 0 ? this.control.maxReverseSpeed : this.control.maxForwardSpeed;
    }
    getLapTime(index) {
        return this.lapEndTimes[index] - this.lapStartTimes[index];
    }
    getLapCount() {
        return this.lapEndTimes.length;
    }
    getBestLapTime() {
        const lapCount = this.getLapCount();
        let bestLapTime = -1;
        let lapTime;
        for(let i = 0; i < lapCount; i++){
            lapTime = this.getLapTime(i);
            if (bestLapTime < 0 || lapTime < bestLapTime) bestLapTime = lapTime;
        }
        return bestLapTime;
    }
    processSteering() {
        const control = this.control;
        // Apply player steering input (bots handle their own in updateBotControl)
        if (!control.isBot) {
            if (control.isSteeringLeft) control.steeringAcc -= control.steeringSpeed;
            else if (control.isSteeringRight) control.steeringAcc += control.steeringSpeed;
        }
        control.steeringAcc = (0, $cb8a4fc1d1568115$export$ba24de55cbae4fc0)(control.steeringAcc, control.maxSteeringAcc);
        const playerMaxSpeed = this.getMaxSpeed();
        control.steering += control.steeringAcc * (0.1 + (playerMaxSpeed - control.speed) / playerMaxSpeed * 0.9);
        control.steering *= 0.9;
        control.steering = (0, $cb8a4fc1d1568115$export$ba24de55cbae4fc0)(control.steering);
        this.targetHeading = control.steering * this.maxHeading;
        control.acceleration *= 0.9;
        control.acceleration = (0, $cb8a4fc1d1568115$export$ba24de55cbae4fc0)(control.acceleration, control.maxAcceleration);
        control.speed += control.acceleration;
        // check if player is offroad and apply corresponding friction
        const isOffroad = !(0, $cb8a4fc1d1568115$export$b61bf3053f58d778)(this.$trackRoad, this.$trackRoadTarmac, this.x - this.camera.x + this.camera.hvw, this.y - this.camera.y + this.camera.hvh);
        this.isOffroad = isOffroad;
        let friction = !isOffroad ? $cfb31d3eb43e151e$var$ROAD_FRICTION : $cfb31d3eb43e151e$var$OFFROAD_FRICTION;
        if (control.speed > 0) control.speed *= friction;
        else if (control.speed < 0) control.speed *= friction;
        control.speed = (0, $cb8a4fc1d1568115$export$ba24de55cbae4fc0)(control.speed, playerMaxSpeed);
        this.heading += this.targetHeading * control.speed * 0.015;
        this.vx = Math.cos(this.heading - $cfb31d3eb43e151e$var$HALF_PI) * control.speed;
        this.vy = Math.sin(this.heading - $cfb31d3eb43e151e$var$HALF_PI) * control.speed;
        control.steeringAcc *= 0.9;
    }
    async reset() {
        const control = this.control;
        control.isAccelerate = false;
        control.isBreak = false;
        control.isSteeringLeft = false;
        control.isSteeringRight = false;
        control.speed = 0;
        control.acceleration = 0;
        control.accelerationSpeed = 0.025;
        control.maxAcceleration = 0.5;
        control.maxForwardSpeed = 25;
        control.maxReverseSpeed = 5;
        control.steering = 0;
        control.steeringAcc = 0;
        control.steeringSpeed = 0.006;
        control.maxSteeringAcc = 0.1;
        this.bestLapTime = -1;
        this.lap = 0;
        this.lapProgress = 0;
        this.currentTrackSegmentIndex = -1;
        this.racinglinePoint = null;
        this.lookaheadPoint = null;
        this.vx = 0;
        this.vy = 0;
        this.targetHeading = 0;
        this.heading = 0;
        this.maxHeading = Math.PI * 0.2;
        // Previous frame state for interpolation
        this.prevX = 0;
        this.prevY = 0;
        this.prevHeading = 0;
        this.sparkStartTime = Math.random() * $cfb31d3eb43e151e$var$SPARK_MAX_INTERVAL;
        this.lapStartTimes = [];
        this.lapEndTimes = [];
        this.sparkEndTime = this.sparkStartTime + $cfb31d3eb43e151e$var$SPARK_MIN_DURATION + Math.random() * ($cfb31d3eb43e151e$var$SPARK_MAX_DURATION - $cfb31d3eb43e151e$var$SPARK_MIN_DURATION);
        // Ghost replay state - ghosts start in bot phase, not replaying
        this.isGhostReplayActive = false;
        this.updateCarColor();
    }
    async startRace() {
        // All cars wait until they cross the finish line (lapStartTime = -1)
        // Ghosts will drive from grid to start line first, then begin replay
        this.lapStartTimes[this.lap] = -1;
        this.raceStartTime = 0;
        this.isGhostReplayActive = false;
        if (!this.control.isBot && !this.ghostData && this.engineSound) await this.engineSound.start();
    }
    updateBotControl(now) {
        if (now < this.raceStartTime) return;
        const control = this.control;
        const trackRacinglineSegments = this.trackRacinglineSegments;
        const { x: x, y: y } = (0, $cb8a4fc1d1568115$export$ed0225908b7785ef)(this, 10 * this.trackScale);
        const closestRacinglinePoint = (0, $cb8a4fc1d1568115$export$375e190ec3f34c7)(trackRacinglineSegments, x, y);
        let dx, dy;
        // pursue segments
        const lookaheadConfidence = Math.round(control.speed / control.maxForwardSpeed * 4);
        const pursueCount = 2 + lookaheadConfidence;
        const pursuePointIndex = (closestRacinglinePoint.index + pursueCount) % trackRacinglineSegments.length;
        let pursuePoint = trackRacinglineSegments[pursuePointIndex];
        if (this.ghostData) pursuePoint = (0, $74682beda20f55da$export$29b3a998a16c439)(this.ghostData, 0);
        dx = pursuePoint.x - x;
        dy = pursuePoint.y - y;
        const pursueRacinglinePoint = {
            index: pursuePointIndex,
            point: pursuePoint,
            dist: closestRacinglinePoint.dist
        };
        // look ahead segments
        const lookaheadCount = 6 + lookaheadConfidence;
        const lookaheadPointIndex = (closestRacinglinePoint.index + lookaheadCount) % trackRacinglineSegments.length;
        const lookaheadPoint = trackRacinglineSegments[lookaheadPointIndex];
        dx = lookaheadPoint.x - x;
        dy = lookaheadPoint.y - y;
        const lookaheadRacinglinePoint = {
            index: lookaheadPointIndex,
            point: lookaheadPoint,
            dist: closestRacinglinePoint.dist
        };
        if (!this.racinglinePoint || this.racinglinePoint.index < pursueRacinglinePoint.index || Math.abs(this.racinglinePoint.index - pursueRacinglinePoint.index) > trackRacinglineSegments.length * 0.5) this.racinglinePoint = pursueRacinglinePoint;
        if (!this.lookaheadPoint || this.lookaheadPoint.index < lookaheadRacinglinePoint.index || Math.abs(this.lookaheadPoint.index - lookaheadRacinglinePoint.index) > trackRacinglineSegments.length * 0.5) this.lookaheadPoint = lookaheadRacinglinePoint;
        const targetDir = (0, $cb8a4fc1d1568115$export$bb945e451b3a4d79)(this.x, this.y, this.heading, this.racinglinePoint.point.x, this.racinglinePoint.point.y);
        const angleDiff = (0, $cb8a4fc1d1568115$export$e2362a88e5cde023)(this.x, this.y, this.heading, this.lookaheadPoint.point.x, this.lookaheadPoint.point.y);
        if ((0, $cb8a4fc1d1568115$export$356bfd1d9b75126e)(targetDir)) {
            const sensitivity = $cfb31d3eb43e151e$var$HALF_PI * (0.5 + (1 - lookaheadConfidence) * 0.2);
            const idealSpeed = control.maxForwardSpeed * ((sensitivity - Math.min(sensitivity, Math.abs(angleDiff))) / sensitivity);
            if (control.speed <= idealSpeed * 2) {
                control.isAccelerate = true;
                control.isBreak = false;
            } else {
                control.isAccelerate = false;
                control.isBreak = Math.random() > 0.75 && control.speed > control.maxForwardSpeed * (1 - lookaheadConfidence);
            }
        } else if ((0, $cb8a4fc1d1568115$export$2bbcf85099b24e44)(targetDir)) {
            control.isAccelerate = false;
            control.isBreak = true;
        }
        if (control.isAccelerate) {
            if (this.racinglinePoint.dist > Math.abs(control.steeringAcc) * 5000) {
                const steeringSensitivity = Math.min(100, this.racinglinePoint.dist) / 100;
                if ((0, $cb8a4fc1d1568115$export$a40afd0d6df5eee8)(targetDir)) control.steeringAcc -= control.steeringSpeed * steeringSensitivity;
                if ((0, $cb8a4fc1d1568115$export$c58d401318d63dc9)(targetDir)) control.steeringAcc += control.steeringSpeed * steeringSensitivity;
            }
        } else {
            if ((0, $cb8a4fc1d1568115$export$a40afd0d6df5eee8)(targetDir)) {
                if (control.speed >= 0) control.steeringAcc -= control.steeringSpeed;
                else control.steeringAcc += control.steeringSpeed;
            }
            if ((0, $cb8a4fc1d1568115$export$c58d401318d63dc9)(targetDir)) {
                if (control.speed >= 0) control.steeringAcc += control.steeringSpeed;
                else control.steeringAcc -= control.steeringSpeed;
            }
        }
    }
    updateGhost(now) {
        // Only replay when ghost replay is active
        if (!this.isGhostReplayActive) return false;
        const lapStartTime = this.lapStartTimes[0];
        if (lapStartTime < 0 || now < lapStartTime) return false;
        // const lapDuration = this.ghostData[this.ghostData.length - 1].t * 1000;
        // const lapEndTime = lapStartTime + lapDuration;
        // const ghostSample = sampleGhostAt(
        //   this.ghostData,
        //   Math.floor(
        //     calcGeometricRatio(lapStartTime, lapEndTime, now) * lapDuration
        //   )
        // );
        const ghostSample = (0, $74682beda20f55da$export$29b3a998a16c439)(this.ghostData, now - lapStartTime);
        if (ghostSample.index >= this.ghostData.length - 1) this.lapStartTimes[0] = now;
        this.heading = (0, $cb8a4fc1d1568115$export$aa5a5b0e8a1e9daa)(this.heading, ghostSample.heading);
        this.x = ghostSample.x;
        this.y = ghostSample.y;
        this.$el.style.transform = `translate(${this.x}px, ${this.y}px) rotate(${this.heading}rad)`;
        return true;
    }
    /**
   * Physics tick - runs at fixed 60 Hz for frame-rate independent physics.
   * @param {number} now - Time in ms since race start (for lap timing and sparks)
   */ physicsTick(now) {
        // Ghost cars skip physics only when actively replaying
        // During bot phase (driving from grid to start line), physics runs normally
        if (this.ghostData && this.isGhostReplayActive) return;
        // Save previous state for interpolation
        this.prevX = this.x;
        this.prevY = this.y;
        this.prevHeading = this.heading;
        if (this.control.isBot) this.updateBotControl(now);
        this.processSteering();
        const control = this.control;
        const trackRacinglineSegments = this.trackRacinglineSegments;
        if (control.isAccelerate) control.acceleration += control.accelerationSpeed;
        if (control.isBreak) control.acceleration -= control.accelerationSpeed;
        this.targetHeading = control.steering * this.maxHeading;
        this.x += this.vx;
        this.y += this.vy;
        // Spark emission timing
        if (this.sparkStartTime >= 0 && now > this.sparkStartTime) {
            if (Math.random() < 0.1) {
                const vlen = Math.hypot(this.vx, this.vy);
                const nvx = this.vx / vlen;
                const nvy = this.vy / vlen;
                if (!this.isOffroad && control.speed > control.maxForwardSpeed * 0.4) (0, $3df263189409ffaa$export$32465a74bc98bd3)(now, this.x, this.y, -nvx * 2, -nvy * 2);
            }
        }
        if (this.sparkEndTime >= 0 && now > this.sparkEndTime) {
            this.sparkStartTime = now + $cfb31d3eb43e151e$var$SPARK_MIN_INTERVAL + Math.random() * ($cfb31d3eb43e151e$var$SPARK_MAX_INTERVAL - $cfb31d3eb43e151e$var$SPARK_MIN_INTERVAL);
            this.sparkEndTime = this.sparkStartTime + $cfb31d3eb43e151e$var$SPARK_MIN_DURATION + Math.random() * ($cfb31d3eb43e151e$var$SPARK_MAX_DURATION - $cfb31d3eb43e151e$var$SPARK_MIN_DURATION);
        }
        // Track racing line and lap progress
        const closestRacinglinePoint = (0, $cb8a4fc1d1568115$export$375e190ec3f34c7)(trackRacinglineSegments, this.x, this.y);
        this.racinglinePoint = closestRacinglinePoint;
        if (this.currentTrackSegmentIndex !== closestRacinglinePoint.index) {
            this.currentTrackSegmentIndex = closestRacinglinePoint.index;
            this.lapProgress++;
            if (this.currentTrackSegmentIndex === this.finishLine) {
                // Ghost cars: when reaching finish line for first time, activate replay
                if (this.ghostData && !this.isGhostReplayActive) {
                    this.isGhostReplayActive = true;
                    this.lapStartTimes[0] = now;
                    this.lapProgress = 0;
                    return; // Exit physics - ghost replay takes over
                }
                if (this.lapProgress / trackRacinglineSegments.length > 0.8) {
                    this.lapEndTimes[this.lap] = now;
                    const lapTime = this.lapEndTimes[this.lap] - this.lapStartTimes[this.lap];
                    if (this.bestLapTime === -1 || lapTime < this.bestLapTime) {
                        this.bestLapTime = lapTime;
                        if (this.onBestLapTime) this.onBestLapTime(this);
                    }
                    this.lap++;
                    if (this.onLapComplete) this.onLapComplete(this);
                }
                this.lapProgress = 0;
                this.lapStartTimes[this.lap] = now;
            }
        }
    }
    /**
   * Render car with interpolated position for smooth visuals.
   * @param {number} alpha - Interpolation factor (0-1) between physics frames
   */ render(alpha) {
        // Ghost cars set their own position in updateGhost, skip interpolation
        // But during bot phase (before replay is active), render with interpolation
        if (this.ghostData && this.isGhostReplayActive) return;
        // Interpolate between previous and current state
        const renderX = this.prevX + (this.x - this.prevX) * alpha;
        const renderY = this.prevY + (this.y - this.prevY) * alpha;
        const renderHeading = this.prevHeading + (this.heading - this.prevHeading) * alpha;
        this.$el.style.transform = `translate(${renderX}px, ${renderY}px) rotate(${renderHeading}rad)`;
        this.$wheelFL.style.transform = `rotate(${this.targetHeading}rad)`;
        this.$wheelFR.style.transform = `rotate(${this.targetHeading}rad)`;
    }
    /**
   * Update engine sound based on current speed.
   * Called from render loop (not physics) for smooth audio.
   */ updateEngineSound() {
        if (!this.control.isBot && this.engineSound) this.engineSound.setSpeedMph(this.control.speed * 10);
    }
}



const $1646ccdd12e58d51$export$6d3c090e66a883b1 = ()=>undefined;


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ const $b5eeaa155499f6b0$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: '${JSCORE_VERSION}'
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const $b5eeaa155499f6b0$export$a7a9523472993e97 = function(assertion, message) {
    if (!assertion) throw $b5eeaa155499f6b0$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const $b5eeaa155499f6b0$export$a39cad550e7ab28a = function(message) {
    return new Error('Firebase Database (' + $b5eeaa155499f6b0$export$588c7fdda06fbb0a.SDK_VERSION + ') INTERNAL ASSERT FAILED: ' + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b5eeaa155499f6b0$var$stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const $b5eeaa155499f6b0$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join('');
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
// TODO(dlarocque): Define this as a class, since we no longer target ES5.
const $b5eeaa155499f6b0$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error('encodeByteArray takes an array as a parameter');
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($b5eeaa155499f6b0$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $b5eeaa155499f6b0$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw new $b5eeaa155499f6b0$export$55ca9d4bee46aeb3();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */ class $b5eeaa155499f6b0$export$55ca9d4bee46aeb3 extends Error {
    constructor(){
        super(...arguments);
        this.name = 'DecodeBase64StringError';
    }
}
/**
 * URL-safe base64 encoding
 */ const $b5eeaa155499f6b0$export$e510a73ee562749 = function(str) {
    const utf8Bytes = $b5eeaa155499f6b0$var$stringToByteArray$1(str);
    return $b5eeaa155499f6b0$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const $b5eeaa155499f6b0$export$4b5284a3025a455 = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $b5eeaa155499f6b0$export$e510a73ee562749(str).replace(/\./g, '');
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const $b5eeaa155499f6b0$export$c62426fdd000a97e = function(str) {
    try {
        return $b5eeaa155499f6b0$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $b5eeaa155499f6b0$export$6c40052bed430212(value) {
    return $b5eeaa155499f6b0$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $b5eeaa155499f6b0$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$b5eeaa155499f6b0$var$isValidKey(prop)) continue;
        target[prop] = $b5eeaa155499f6b0$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $b5eeaa155499f6b0$var$isValidKey(key) {
    return key !== '__proto__';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */ function $b5eeaa155499f6b0$export$a4e55266d2135a7f() {
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    throw new Error('Unable to locate global object.');
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b5eeaa155499f6b0$var$getDefaultsFromGlobal = ()=>$b5eeaa155499f6b0$export$a4e55266d2135a7f().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */ const $b5eeaa155499f6b0$var$getDefaultsFromEnvVariable = ()=>{
    return;
};
const $b5eeaa155499f6b0$var$getDefaultsFromCookie = ()=>{
    if (typeof document === 'undefined') return;
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    } catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && $b5eeaa155499f6b0$export$c62426fdd000a97e(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */ const $b5eeaa155499f6b0$export$212bb2fc580a90a8 = ()=>{
    try {
        return (0, $1646ccdd12e58d51$export$6d3c090e66a883b1)() || $b5eeaa155499f6b0$var$getDefaultsFromGlobal() || $b5eeaa155499f6b0$var$getDefaultsFromEnvVariable() || $b5eeaa155499f6b0$var$getDefaultsFromCookie();
    } catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */ console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */ const $b5eeaa155499f6b0$export$9c11895284c8adad = (productName)=>$b5eeaa155499f6b0$export$212bb2fc580a90a8()?.emulatorHosts?.[productName];
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */ const $b5eeaa155499f6b0$export$a3febcf1f14a3a0c = (productName)=>{
    const host = $b5eeaa155499f6b0$export$9c11895284c8adad(productName);
    if (!host) return undefined;
    const separatorIndex = host.lastIndexOf(':'); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) throw new Error(`Invalid host ${host} with no separate hostname and port!`);
    // eslint-disable-next-line no-restricted-globals
    const port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === '[') // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
    return [
        host.substring(1, separatorIndex - 1),
        port
    ];
    else return [
        host.substring(0, separatorIndex),
        port
    ];
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */ const $b5eeaa155499f6b0$export$3dfb6827a9f89756 = ()=>$b5eeaa155499f6b0$export$212bb2fc580a90a8()?.config;
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */ const $b5eeaa155499f6b0$export$5539a1a3afe87d6 = (name)=>$b5eeaa155499f6b0$export$212bb2fc580a90a8()?.[`_${name}`];
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b5eeaa155499f6b0$export$85f6557964517f1a {
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promisified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Checks whether host is a cloud workstation or not.
 * @public
 */ function $b5eeaa155499f6b0$export$5b4d24b45140ad90(url) {
    // `isCloudWorkstation` is called without protocol in certain connect*Emulator functions
    // In HTTP request builders, it's called with the protocol.
    // If called with protocol prefix, it's a valid URL, so we extract the hostname
    // If called without, we assume the string is the hostname.
    try {
        const host = url.startsWith('http://') || url.startsWith('https://') ? new URL(url).hostname : url;
        return host.endsWith('.cloudworkstations.dev');
    } catch  {
        return false;
    }
}
/**
 * Makes a fetch request to the given server.
 * Mostly used for forwarding cookies in Firebase Studio.
 * @public
 */ async function $b5eeaa155499f6b0$export$c0f0d0ce4283a937(endpoint) {
    const result = await fetch(endpoint, {
        credentials: 'include'
    });
    return result.ok;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b5eeaa155499f6b0$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: 'none',
        type: 'JWT'
    };
    const project = projectId || 'demo-project';
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = {
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: 'custom',
            identities: {}
        },
        // Override with user options
        ...token
    };
    // Unsecured JWTs use the empty string as a signature.
    const signature = '';
    return [
        $b5eeaa155499f6b0$export$4b5284a3025a455(JSON.stringify(header)),
        $b5eeaa155499f6b0$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join('.');
}
const $b5eeaa155499f6b0$var$emulatorStatus = {};
// Checks whether any products are running on an emulator
function $b5eeaa155499f6b0$var$getEmulatorSummary() {
    const summary = {
        prod: [],
        emulator: []
    };
    for (const key of Object.keys($b5eeaa155499f6b0$var$emulatorStatus))if ($b5eeaa155499f6b0$var$emulatorStatus[key]) summary.emulator.push(key);
    else summary.prod.push(key);
    return summary;
}
function $b5eeaa155499f6b0$var$getOrCreateEl(id) {
    let parentDiv = document.getElementById(id);
    let created = false;
    if (!parentDiv) {
        parentDiv = document.createElement('div');
        parentDiv.setAttribute('id', id);
        created = true;
    }
    return {
        created: created,
        element: parentDiv
    };
}
let $b5eeaa155499f6b0$var$previouslyDismissed = false;
/**
 * Updates Emulator Banner. Primarily used for Firebase Studio
 * @param name
 * @param isRunningEmulator
 * @public
 */ function $b5eeaa155499f6b0$export$fd3d2954543183b1(name, isRunningEmulator) {
    if (typeof window === 'undefined' || typeof document === 'undefined' || !$b5eeaa155499f6b0$export$5b4d24b45140ad90(window.location.host) || $b5eeaa155499f6b0$var$emulatorStatus[name] === isRunningEmulator || $b5eeaa155499f6b0$var$emulatorStatus[name] || // If already set to use emulator, can't go back to prod.
    $b5eeaa155499f6b0$var$previouslyDismissed) return;
    $b5eeaa155499f6b0$var$emulatorStatus[name] = isRunningEmulator;
    function prefixedId(id) {
        return `__firebase__banner__${id}`;
    }
    const bannerId = '__firebase__banner';
    const summary = $b5eeaa155499f6b0$var$getEmulatorSummary();
    const showError = summary.prod.length > 0;
    function tearDown() {
        const element = document.getElementById(bannerId);
        if (element) element.remove();
    }
    function setupBannerStyles(bannerEl) {
        bannerEl.style.display = 'flex';
        bannerEl.style.background = '#7faaf0';
        bannerEl.style.position = 'fixed';
        bannerEl.style.bottom = '5px';
        bannerEl.style.left = '5px';
        bannerEl.style.padding = '.5em';
        bannerEl.style.borderRadius = '5px';
        bannerEl.style.alignItems = 'center';
    }
    function setupIconStyles(prependIcon, iconId) {
        prependIcon.setAttribute('width', '24');
        prependIcon.setAttribute('id', iconId);
        prependIcon.setAttribute('height', '24');
        prependIcon.setAttribute('viewBox', '0 0 24 24');
        prependIcon.setAttribute('fill', 'none');
        prependIcon.style.marginLeft = '-6px';
    }
    function setupCloseBtn() {
        const closeBtn = document.createElement('span');
        closeBtn.style.cursor = 'pointer';
        closeBtn.style.marginLeft = '16px';
        closeBtn.style.fontSize = '24px';
        closeBtn.innerHTML = ' &times;';
        closeBtn.onclick = ()=>{
            $b5eeaa155499f6b0$var$previouslyDismissed = true;
            tearDown();
        };
        return closeBtn;
    }
    function setupLinkStyles(learnMoreLink, learnMoreId) {
        learnMoreLink.setAttribute('id', learnMoreId);
        learnMoreLink.innerText = 'Learn more';
        learnMoreLink.href = 'https://firebase.google.com/docs/studio/preview-apps#preview-backend';
        learnMoreLink.setAttribute('target', '__blank');
        learnMoreLink.style.paddingLeft = '5px';
        learnMoreLink.style.textDecoration = 'underline';
    }
    function setupDom() {
        const banner = $b5eeaa155499f6b0$var$getOrCreateEl(bannerId);
        const firebaseTextId = prefixedId('text');
        const firebaseText = document.getElementById(firebaseTextId) || document.createElement('span');
        const learnMoreId = prefixedId('learnmore');
        const learnMoreLink = document.getElementById(learnMoreId) || document.createElement('a');
        const prependIconId = prefixedId('preprendIcon');
        const prependIcon = document.getElementById(prependIconId) || document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        if (banner.created) {
            // update styles
            const bannerEl = banner.element;
            setupBannerStyles(bannerEl);
            setupLinkStyles(learnMoreLink, learnMoreId);
            const closeBtn = setupCloseBtn();
            setupIconStyles(prependIcon, prependIconId);
            bannerEl.append(prependIcon, firebaseText, learnMoreLink, closeBtn);
            document.body.appendChild(bannerEl);
        }
        if (showError) {
            firebaseText.innerText = `Preview backend disconnected.`;
            prependIcon.innerHTML = `<g clip-path="url(#clip0_6013_33858)">
<path d="M4.8 17.6L12 5.6L19.2 17.6H4.8ZM6.91667 16.4H17.0833L12 7.93333L6.91667 16.4ZM12 15.6C12.1667 15.6 12.3056 15.5444 12.4167 15.4333C12.5389 15.3111 12.6 15.1667 12.6 15C12.6 14.8333 12.5389 14.6944 12.4167 14.5833C12.3056 14.4611 12.1667 14.4 12 14.4C11.8333 14.4 11.6889 14.4611 11.5667 14.5833C11.4556 14.6944 11.4 14.8333 11.4 15C11.4 15.1667 11.4556 15.3111 11.5667 15.4333C11.6889 15.5444 11.8333 15.6 12 15.6ZM11.4 13.6H12.6V10.4H11.4V13.6Z" fill="#212121"/>
</g>
<defs>
<clipPath id="clip0_6013_33858">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>`;
        } else {
            prependIcon.innerHTML = `<g clip-path="url(#clip0_6083_34804)">
<path d="M11.4 15.2H12.6V11.2H11.4V15.2ZM12 10C12.1667 10 12.3056 9.94444 12.4167 9.83333C12.5389 9.71111 12.6 9.56667 12.6 9.4C12.6 9.23333 12.5389 9.09444 12.4167 8.98333C12.3056 8.86111 12.1667 8.8 12 8.8C11.8333 8.8 11.6889 8.86111 11.5667 8.98333C11.4556 9.09444 11.4 9.23333 11.4 9.4C11.4 9.56667 11.4556 9.71111 11.5667 9.83333C11.6889 9.94444 11.8333 10 12 10ZM12 18.4C11.1222 18.4 10.2944 18.2333 9.51667 17.9C8.73889 17.5667 8.05556 17.1111 7.46667 16.5333C6.88889 15.9444 6.43333 15.2611 6.1 14.4833C5.76667 13.7056 5.6 12.8778 5.6 12C5.6 11.1111 5.76667 10.2833 6.1 9.51667C6.43333 8.73889 6.88889 8.06111 7.46667 7.48333C8.05556 6.89444 8.73889 6.43333 9.51667 6.1C10.2944 5.76667 11.1222 5.6 12 5.6C12.8889 5.6 13.7167 5.76667 14.4833 6.1C15.2611 6.43333 15.9389 6.89444 16.5167 7.48333C17.1056 8.06111 17.5667 8.73889 17.9 9.51667C18.2333 10.2833 18.4 11.1111 18.4 12C18.4 12.8778 18.2333 13.7056 17.9 14.4833C17.5667 15.2611 17.1056 15.9444 16.5167 16.5333C15.9389 17.1111 15.2611 17.5667 14.4833 17.9C13.7167 18.2333 12.8889 18.4 12 18.4ZM12 17.2C13.4444 17.2 14.6722 16.6944 15.6833 15.6833C16.6944 14.6722 17.2 13.4444 17.2 12C17.2 10.5556 16.6944 9.32778 15.6833 8.31667C14.6722 7.30555 13.4444 6.8 12 6.8C10.5556 6.8 9.32778 7.30555 8.31667 8.31667C7.30556 9.32778 6.8 10.5556 6.8 12C6.8 13.4444 7.30556 14.6722 8.31667 15.6833C9.32778 16.6944 10.5556 17.2 12 17.2Z" fill="#212121"/>
</g>
<defs>
<clipPath id="clip0_6083_34804">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>`;
            firebaseText.innerText = 'Preview backend running in this workspace.';
        }
        firebaseText.setAttribute('id', firebaseTextId);
    }
    if (document.readyState === 'loading') window.addEventListener('DOMContentLoaded', setupDom);
    else setupDom();
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $b5eeaa155499f6b0$export$c36915b22ce77c19() {
    if (typeof navigator !== 'undefined' && typeof navigator['userAgent'] === 'string') return navigator['userAgent'];
    else return '';
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $b5eeaa155499f6b0$export$872f8323f01d7ae0() {
    return typeof window !== 'undefined' && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($b5eeaa155499f6b0$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $b5eeaa155499f6b0$export$8ee0fc9ee280b4ee() {
    const forceEnvironment = $b5eeaa155499f6b0$export$212bb2fc580a90a8()?.forceEnvironment;
    if (forceEnvironment === 'node') return true;
    else if (forceEnvironment === 'browser') return false;
    try {
        return Object.prototype.toString.call($parcel$global.process) === '[object process]';
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment.
 * Note: This will return true for certain test frameworks that are incompletely
 * mimicking a browser, and should not lead to assuming all browser APIs are
 * available.
 */ function $b5eeaa155499f6b0$export$4e09c449d6c407f7() {
    return typeof window !== 'undefined' || $b5eeaa155499f6b0$export$97b87b8868ff7a3c();
}
/**
 * Detect Web Worker context.
 */ function $b5eeaa155499f6b0$export$97b87b8868ff7a3c() {
    return typeof WorkerGlobalScope !== 'undefined' && typeof self !== 'undefined' && self instanceof WorkerGlobalScope;
}
/**
 * Detect Cloudflare Worker context.
 */ function $b5eeaa155499f6b0$export$ad9e9b75cb9fb797() {
    return typeof navigator !== 'undefined' && navigator.userAgent === 'Cloudflare-Workers';
}
function $b5eeaa155499f6b0$export$caa8774a9107a58e() {
    const runtime = typeof chrome === 'object' ? chrome.runtime : typeof browser === 'object' ? browser.runtime : undefined;
    return typeof runtime === 'object' && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $b5eeaa155499f6b0$export$f7a1e23e542d38e3() {
    return typeof navigator === 'object' && navigator['product'] === 'ReactNative';
}
/** Detects Electron apps. */ function $b5eeaa155499f6b0$export$f2f6a8999f8ebd30() {
    return $b5eeaa155499f6b0$export$c36915b22ce77c19().indexOf('Electron/') >= 0;
}
/** Detects Internet Explorer. */ function $b5eeaa155499f6b0$export$7e7b1a9668aaed8() {
    const ua = $b5eeaa155499f6b0$export$c36915b22ce77c19();
    return ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
}
/** Detects Universal Windows Platform apps. */ function $b5eeaa155499f6b0$export$202944b2d2824246() {
    return $b5eeaa155499f6b0$export$c36915b22ce77c19().indexOf('MSAppHost/') >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $b5eeaa155499f6b0$export$5d1d834fbbf8bab7() {
    return $b5eeaa155499f6b0$export$588c7fdda06fbb0a.NODE_CLIENT === true || $b5eeaa155499f6b0$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $b5eeaa155499f6b0$export$95df08bae54cb4df() {
    return !$b5eeaa155499f6b0$export$8ee0fc9ee280b4ee() && !!navigator.userAgent && navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome');
}
/** Returns true if we are running in Safari or WebKit */ function $b5eeaa155499f6b0$export$ef10bcfb06572016() {
    return !$b5eeaa155499f6b0$export$8ee0fc9ee280b4ee() && !!navigator.userAgent && (navigator.userAgent.includes('Safari') || navigator.userAgent.includes('WebKit')) && !navigator.userAgent.includes('Chrome');
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $b5eeaa155499f6b0$export$3865db50535c2055() {
    try {
        return typeof indexedDB === 'object';
    } catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $b5eeaa155499f6b0$export$a8a3018f3d187a4d() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = 'validate-browser-context-for-indexeddb-analytics-module';
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                reject(request.error?.message || '');
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $b5eeaa155499f6b0$export$f172b7eb6cf60599() {
    if (typeof navigator === 'undefined' || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // TypeScript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const $b5eeaa155499f6b0$var$ERROR_NAME = 'FirebaseError';
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class $b5eeaa155499f6b0$export$dd24e9cd51226c56 extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = $b5eeaa155499f6b0$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        // TODO(dlarocque): Replace this with `new.target`: https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        //                   which we can now use since we no longer target ES5.
        Object.setPrototypeOf(this, $b5eeaa155499f6b0$export$dd24e9cd51226c56.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, $b5eeaa155499f6b0$export$3fa6e1b18a3b2d40.prototype.create);
    }
}
class $b5eeaa155499f6b0$export$3fa6e1b18a3b2d40 {
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? $b5eeaa155499f6b0$var$replaceTemplate(template, customData) : 'Error';
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new $b5eeaa155499f6b0$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
        return error;
    }
}
function $b5eeaa155499f6b0$var$replaceTemplate(template, data) {
    return template.replace($b5eeaa155499f6b0$var$PATTERN, (_, key)=>{
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const $b5eeaa155499f6b0$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $b5eeaa155499f6b0$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data JavaScript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $b5eeaa155499f6b0$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $b5eeaa155499f6b0$export$2f872c0f2117be69 = function(token) {
    let header = {}, claims = {}, data = {}, signature = '';
    try {
        const parts = token.split('.');
        header = $b5eeaa155499f6b0$export$c5a53ce6a17cf18d($b5eeaa155499f6b0$export$c62426fdd000a97e(parts[0]) || '');
        claims = $b5eeaa155499f6b0$export$c5a53ce6a17cf18d($b5eeaa155499f6b0$export$c62426fdd000a97e(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $b5eeaa155499f6b0$export$5f870fcca7ae6a88 = function(token) {
    const claims = $b5eeaa155499f6b0$export$2f872c0f2117be69(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) validSince = claims['nbf'];
        else if (claims.hasOwnProperty('iat')) validSince = claims['iat'];
        if (claims.hasOwnProperty('exp')) validUntil = claims['exp'];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $b5eeaa155499f6b0$export$701c661ec91095f2 = function(token) {
    const claims = $b5eeaa155499f6b0$export$2f872c0f2117be69(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) return claims['iat'];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $b5eeaa155499f6b0$export$9565ca3d387f8aa0 = function(token) {
    const decoded = $b5eeaa155499f6b0$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $b5eeaa155499f6b0$export$fc970ed23da99565 = function(token) {
    const claims = $b5eeaa155499f6b0$export$2f872c0f2117be69(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b5eeaa155499f6b0$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $b5eeaa155499f6b0$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $b5eeaa155499f6b0$export$dd1bc94b04021eeb(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $b5eeaa155499f6b0$export$871de8747c9eaa88(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $b5eeaa155499f6b0$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if ($b5eeaa155499f6b0$var$isObject(aProp) && $b5eeaa155499f6b0$var$isObject(bProp)) {
            if (!$b5eeaa155499f6b0$export$9cb4719e2e525b7a(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function $b5eeaa155499f6b0$var$isObject(thing) {
    return thing !== null && typeof thing === 'object';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */ function $b5eeaa155499f6b0$export$a9cd205a244d9f54(promise, timeInMS = 2000) {
    const deferredPromise = new $b5eeaa155499f6b0$export$85f6557964517f1a();
    setTimeout(()=>deferredPromise.reject('timeout!'), timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $b5eeaa155499f6b0$export$ac4103b836844853(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    return params.length ? '&' + params.join('&') : '';
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $b5eeaa155499f6b0$export$c1271ca4c8a70741(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split('=');
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $b5eeaa155499f6b0$export$1a8408415472d8ed(url) {
    const queryStart = url.indexOf('?');
    if (!queryStart) return '';
    const fragmentStart = url.indexOf('#', queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class $b5eeaa155499f6b0$export$c85d589bf4e25fef {
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === 'string') while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $b5eeaa155499f6b0$export$364097d812234b3f(executor, onNoObservers) {
    const proxy = new $b5eeaa155499f6b0$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class $b5eeaa155499f6b0$var$ObserverProxy {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber synchronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error('Missing Observer.');
        // Assemble an Observer object when passed as callback functions.
        if ($b5eeaa155499f6b0$var$implementsAnyMethods(nextOrObserver, [
            'next',
            'error',
            'complete'
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $b5eeaa155499f6b0$var$noop;
        if (observer.error === undefined) observer.error = $b5eeaa155499f6b0$var$noop;
        if (observer.complete === undefined) observer.complete = $b5eeaa155499f6b0$var$noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== 'undefined' && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $b5eeaa155499f6b0$export$12af436354f1a4f7(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $b5eeaa155499f6b0$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === 'function') return true;
    }
    return false;
}
function $b5eeaa155499f6b0$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const $b5eeaa155499f6b0$export$20164226a0ed35c3 = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = 'at least ' + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    if (argError) {
        const error = fnName + ' failed: Was called with ' + argCount + (argCount === 1 ? ' argument.' : ' arguments.') + ' Expects ' + argError + '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $b5eeaa155499f6b0$export$adea4917e02d93dc(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $b5eeaa155499f6b0$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== 'string') //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($b5eeaa155499f6b0$export$adea4917e02d93dc(fnName, 'namespace') + 'must be a valid firebase namespace.');
}
function $b5eeaa155499f6b0$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== 'function') throw new Error($b5eeaa155499f6b0$export$adea4917e02d93dc(fnName, argumentName) + 'must be a valid function.');
}
function $b5eeaa155499f6b0$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== 'object' || context === null) throw new Error($b5eeaa155499f6b0$export$adea4917e02d93dc(fnName, argumentName) + 'must be a valid context object.');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in JavaScript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const $b5eeaa155499f6b0$export$655666783217a925 = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            $b5eeaa155499f6b0$export$a7a9523472993e97(i < str.length, 'Surrogate pair missing trail surrogate.');
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const $b5eeaa155499f6b0$export$9536dc0a75b20bf9 = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const $b5eeaa155499f6b0$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const $b5eeaa155499f6b0$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const $b5eeaa155499f6b0$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const $b5eeaa155499f6b0$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $b5eeaa155499f6b0$export$4d810c0ca64ed8e9(backoffCount, intervalMillis = $b5eeaa155499f6b0$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = $b5eeaa155499f6b0$var$DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $b5eeaa155499f6b0$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($b5eeaa155499f6b0$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $b5eeaa155499f6b0$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + $b5eeaa155499f6b0$var$indicator(i);
}
function $b5eeaa155499f6b0$var$indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return 'th';
    const dec = i % 10;
    if (dec === 1) return 'st';
    if (dec === 2) return 'nd';
    if (dec === 3) return 'rd';
    return 'th';
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b5eeaa155499f6b0$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}


/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class $be24428bd46df3e1$export$16fa2f45be04daa8 {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */ ;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $be24428bd46df3e1$var$DEFAULT_ENTRY_NAME = '[DEFAULT]';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class $be24428bd46df3e1$export$2881499e37b75b9a {
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide multiple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, $b5eeaa155499f6b0$export$85f6557964517f1a)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options?.identifier);
        const optional = options?.optional ?? false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/cannot be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if ($be24428bd46df3e1$var$isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: $be24428bd46df3e1$var$DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = $be24428bd46df3e1$var$DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>'INTERNAL' in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>'_delete' in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = $be24428bd46df3e1$var$DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = $be24428bd46df3e1$var$DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options: options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = this.onInitCallbacks.get(normalizedIdentifier) ?? new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch  {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier: instanceIdentifier, options: options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: $be24428bd46df3e1$var$normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch  {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = $be24428bd46df3e1$var$DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : $be24428bd46df3e1$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */ ;
    }
}
// undefined should be passed to the service factory for the default instance
function $be24428bd46df3e1$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $be24428bd46df3e1$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $be24428bd46df3e1$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class $be24428bd46df3e1$export$436a80eea5d5c0c5 {
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new $be24428bd46df3e1$export$2881499e37b75b9a(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ const $6b8f1054ec67b81e$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $6b8f1054ec67b81e$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($6b8f1054ec67b81e$export$243e62d78d3b544d || ($6b8f1054ec67b81e$export$243e62d78d3b544d = {}));
const $6b8f1054ec67b81e$var$levelStringToEnum = {
    'debug': $6b8f1054ec67b81e$export$243e62d78d3b544d.DEBUG,
    'verbose': $6b8f1054ec67b81e$export$243e62d78d3b544d.VERBOSE,
    'info': $6b8f1054ec67b81e$export$243e62d78d3b544d.INFO,
    'warn': $6b8f1054ec67b81e$export$243e62d78d3b544d.WARN,
    'error': $6b8f1054ec67b81e$export$243e62d78d3b544d.ERROR,
    'silent': $6b8f1054ec67b81e$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ const $6b8f1054ec67b81e$var$defaultLogLevel = $6b8f1054ec67b81e$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ const $6b8f1054ec67b81e$var$ConsoleMethod = {
    [$6b8f1054ec67b81e$export$243e62d78d3b544d.DEBUG]: 'log',
    [$6b8f1054ec67b81e$export$243e62d78d3b544d.VERBOSE]: 'log',
    [$6b8f1054ec67b81e$export$243e62d78d3b544d.INFO]: 'info',
    [$6b8f1054ec67b81e$export$243e62d78d3b544d.WARN]: 'warn',
    [$6b8f1054ec67b81e$export$243e62d78d3b544d.ERROR]: 'error'
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ const $6b8f1054ec67b81e$var$defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now = new Date().toISOString();
    const method = $6b8f1054ec67b81e$var$ConsoleMethod[logType];
    if (method) console[method](`[${now}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class $6b8f1054ec67b81e$export$efa9a398d6368992 {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ constructor(name){
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $6b8f1054ec67b81e$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $6b8f1054ec67b81e$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $6b8f1054ec67b81e$var$instances.push(this);
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in $6b8f1054ec67b81e$export$243e62d78d3b544d)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === 'string' ? $6b8f1054ec67b81e$var$levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== 'function') throw new TypeError('Value assigned to `logHandler` must be a function');
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, $6b8f1054ec67b81e$export$243e62d78d3b544d.DEBUG, ...args);
        this._logHandler(this, $6b8f1054ec67b81e$export$243e62d78d3b544d.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, $6b8f1054ec67b81e$export$243e62d78d3b544d.VERBOSE, ...args);
        this._logHandler(this, $6b8f1054ec67b81e$export$243e62d78d3b544d.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, $6b8f1054ec67b81e$export$243e62d78d3b544d.INFO, ...args);
        this._logHandler(this, $6b8f1054ec67b81e$export$243e62d78d3b544d.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, $6b8f1054ec67b81e$export$243e62d78d3b544d.WARN, ...args);
        this._logHandler(this, $6b8f1054ec67b81e$export$243e62d78d3b544d.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, $6b8f1054ec67b81e$export$243e62d78d3b544d.ERROR, ...args);
        this._logHandler(this, $6b8f1054ec67b81e$export$243e62d78d3b544d.ERROR, ...args);
    }
}
function $6b8f1054ec67b81e$export$c622e99c0ce7b1c9(level) {
    $6b8f1054ec67b81e$var$instances.forEach((inst)=>{
        inst.setLogLevel(level);
    });
}
function $6b8f1054ec67b81e$export$29577d29c84db5f6(logCallback, options) {
    for (const instance of $6b8f1054ec67b81e$var$instances){
        let customLogLevel = null;
        if (options && options.level) customLogLevel = $6b8f1054ec67b81e$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = (instance, level, ...args)=>{
            const message = args.map((arg)=>{
                if (arg == null) return null;
                else if (typeof arg === 'string') return arg;
                else if (typeof arg === 'number' || typeof arg === 'boolean') return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter((arg)=>arg).join(' ');
            if (level >= (customLogLevel ?? instance.logLevel)) logCallback({
                level: $6b8f1054ec67b81e$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    }
}



const $5ae6a7106429e891$export$23f2a1d2818174ef = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $5ae6a7106429e891$var$idbProxyableTypes;
let $5ae6a7106429e891$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $5ae6a7106429e891$var$getIdbProxyableTypes() {
    return $5ae6a7106429e891$var$idbProxyableTypes || ($5ae6a7106429e891$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $5ae6a7106429e891$var$getCursorAdvanceMethods() {
    return $5ae6a7106429e891$var$cursorAdvanceMethods || ($5ae6a7106429e891$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $5ae6a7106429e891$var$cursorRequestMap = new WeakMap();
const $5ae6a7106429e891$var$transactionDoneMap = new WeakMap();
const $5ae6a7106429e891$var$transactionStoreNamesMap = new WeakMap();
const $5ae6a7106429e891$var$transformCache = new WeakMap();
const $5ae6a7106429e891$export$407448d2b89b1813 = new WeakMap();
function $5ae6a7106429e891$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        const success = ()=>{
            resolve($5ae6a7106429e891$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $5ae6a7106429e891$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $5ae6a7106429e891$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $5ae6a7106429e891$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($5ae6a7106429e891$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    $5ae6a7106429e891$var$transactionDoneMap.set(tx, done);
}
let $5ae6a7106429e891$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done') return $5ae6a7106429e891$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === 'objectStoreNames') return target.objectStoreNames || $5ae6a7106429e891$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $5ae6a7106429e891$export$efccba1c4a2ef57b(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === 'done' || prop === 'store')) return true;
        return prop in target;
    }
};
function $5ae6a7106429e891$export$43caf9889c228507(callback) {
    $5ae6a7106429e891$var$idbProxyTraps = callback($5ae6a7106429e891$var$idbProxyTraps);
}
function $5ae6a7106429e891$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !('objectStoreNames' in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call($5ae6a7106429e891$export$3b14a55fb2447963(this), storeNames, ...args);
        $5ae6a7106429e891$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $5ae6a7106429e891$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($5ae6a7106429e891$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($5ae6a7106429e891$export$3b14a55fb2447963(this), args);
        return $5ae6a7106429e891$export$efccba1c4a2ef57b($5ae6a7106429e891$var$cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $5ae6a7106429e891$export$efccba1c4a2ef57b(func.apply($5ae6a7106429e891$export$3b14a55fb2447963(this), args));
    };
}
function $5ae6a7106429e891$var$transformCachableValue(value) {
    if (typeof value === 'function') return $5ae6a7106429e891$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $5ae6a7106429e891$var$cacheDonePromiseForTransaction(value);
    if ($5ae6a7106429e891$export$23f2a1d2818174ef(value, $5ae6a7106429e891$var$getIdbProxyableTypes())) return new Proxy(value, $5ae6a7106429e891$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $5ae6a7106429e891$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $5ae6a7106429e891$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($5ae6a7106429e891$var$transformCache.has(value)) return $5ae6a7106429e891$var$transformCache.get(value);
    const newValue = $5ae6a7106429e891$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $5ae6a7106429e891$var$transformCache.set(value, newValue);
        $5ae6a7106429e891$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
const $5ae6a7106429e891$export$3b14a55fb2447963 = (value)=>$5ae6a7106429e891$export$407448d2b89b1813.get(value);


/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $1b1bada3b03888b0$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, $5ae6a7106429e891$export$efccba1c4a2ef57b)(request);
    if (upgrade) request.addEventListener('upgradeneeded', (event)=>{
        upgrade((0, $5ae6a7106429e891$export$efccba1c4a2ef57b)(request.result), event.oldVersion, event.newVersion, (0, $5ae6a7106429e891$export$efccba1c4a2ef57b)(request.transaction), event);
    });
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener('close', ()=>terminated());
        if (blocking) db.addEventListener('versionchange', (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $1b1bada3b03888b0$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return (0, $5ae6a7106429e891$export$efccba1c4a2ef57b)(request).then(()=>undefined);
}
const $1b1bada3b03888b0$var$readMethods = [
    'get',
    'getKey',
    'getAll',
    'getAllKeys',
    'count'
];
const $1b1bada3b03888b0$var$writeMethods = [
    'put',
    'add',
    'delete',
    'clear'
];
const $1b1bada3b03888b0$var$cachedMethods = new Map();
function $1b1bada3b03888b0$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === 'string')) return;
    if ($1b1bada3b03888b0$var$cachedMethods.get(prop)) return $1b1bada3b03888b0$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, '');
    const useIndex = prop !== targetFuncName;
    const isWrite = $1b1bada3b03888b0$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $1b1bada3b03888b0$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $1b1bada3b03888b0$var$cachedMethods.set(prop, method);
    return method;
}
(0, $5ae6a7106429e891$export$43caf9889c228507)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$1b1bada3b03888b0$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$1b1bada3b03888b0$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));


/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $1ad63299fe0e9682$var$PlatformLoggerServiceImpl {
    constructor(container){
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map((provider)=>{
            if ($1ad63299fe0e9682$var$isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            } else return null;
        }).filter((logString)=>logString).join(' ');
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $1ad63299fe0e9682$var$isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return component?.type === "VERSION" /* ComponentType.VERSION */ ;
}
const $1ad63299fe0e9682$var$name$q = "@firebase/app";
const $1ad63299fe0e9682$var$version$1 = "0.14.5";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1ad63299fe0e9682$var$logger = new (0, $6b8f1054ec67b81e$export$efa9a398d6368992)('@firebase/app');
const $1ad63299fe0e9682$var$name$p = "@firebase/app-compat";
const $1ad63299fe0e9682$var$name$o = "@firebase/analytics-compat";
const $1ad63299fe0e9682$var$name$n = "@firebase/analytics";
const $1ad63299fe0e9682$var$name$m = "@firebase/app-check-compat";
const $1ad63299fe0e9682$var$name$l = "@firebase/app-check";
const $1ad63299fe0e9682$var$name$k = "@firebase/auth";
const $1ad63299fe0e9682$var$name$j = "@firebase/auth-compat";
const $1ad63299fe0e9682$var$name$i = "@firebase/database";
const $1ad63299fe0e9682$var$name$h = "@firebase/data-connect";
const $1ad63299fe0e9682$var$name$g = "@firebase/database-compat";
const $1ad63299fe0e9682$var$name$f = "@firebase/functions";
const $1ad63299fe0e9682$var$name$e = "@firebase/functions-compat";
const $1ad63299fe0e9682$var$name$d = "@firebase/installations";
const $1ad63299fe0e9682$var$name$c = "@firebase/installations-compat";
const $1ad63299fe0e9682$var$name$b = "@firebase/messaging";
const $1ad63299fe0e9682$var$name$a = "@firebase/messaging-compat";
const $1ad63299fe0e9682$var$name$9 = "@firebase/performance";
const $1ad63299fe0e9682$var$name$8 = "@firebase/performance-compat";
const $1ad63299fe0e9682$var$name$7 = "@firebase/remote-config";
const $1ad63299fe0e9682$var$name$6 = "@firebase/remote-config-compat";
const $1ad63299fe0e9682$var$name$5 = "@firebase/storage";
const $1ad63299fe0e9682$var$name$4 = "@firebase/storage-compat";
const $1ad63299fe0e9682$var$name$3 = "@firebase/firestore";
const $1ad63299fe0e9682$var$name$2 = "@firebase/ai";
const $1ad63299fe0e9682$var$name$1 = "@firebase/firestore-compat";
const $1ad63299fe0e9682$var$name = "firebase";
const $1ad63299fe0e9682$var$version = "12.5.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ const $1ad63299fe0e9682$export$9f30fa0c10967f7f = '[DEFAULT]';
const $1ad63299fe0e9682$var$PLATFORM_LOG_STRING = {
    [$1ad63299fe0e9682$var$name$q]: 'fire-core',
    [$1ad63299fe0e9682$var$name$p]: 'fire-core-compat',
    [$1ad63299fe0e9682$var$name$n]: 'fire-analytics',
    [$1ad63299fe0e9682$var$name$o]: 'fire-analytics-compat',
    [$1ad63299fe0e9682$var$name$l]: 'fire-app-check',
    [$1ad63299fe0e9682$var$name$m]: 'fire-app-check-compat',
    [$1ad63299fe0e9682$var$name$k]: 'fire-auth',
    [$1ad63299fe0e9682$var$name$j]: 'fire-auth-compat',
    [$1ad63299fe0e9682$var$name$i]: 'fire-rtdb',
    [$1ad63299fe0e9682$var$name$h]: 'fire-data-connect',
    [$1ad63299fe0e9682$var$name$g]: 'fire-rtdb-compat',
    [$1ad63299fe0e9682$var$name$f]: 'fire-fn',
    [$1ad63299fe0e9682$var$name$e]: 'fire-fn-compat',
    [$1ad63299fe0e9682$var$name$d]: 'fire-iid',
    [$1ad63299fe0e9682$var$name$c]: 'fire-iid-compat',
    [$1ad63299fe0e9682$var$name$b]: 'fire-fcm',
    [$1ad63299fe0e9682$var$name$a]: 'fire-fcm-compat',
    [$1ad63299fe0e9682$var$name$9]: 'fire-perf',
    [$1ad63299fe0e9682$var$name$8]: 'fire-perf-compat',
    [$1ad63299fe0e9682$var$name$7]: 'fire-rc',
    [$1ad63299fe0e9682$var$name$6]: 'fire-rc-compat',
    [$1ad63299fe0e9682$var$name$5]: 'fire-gcs',
    [$1ad63299fe0e9682$var$name$4]: 'fire-gcs-compat',
    [$1ad63299fe0e9682$var$name$3]: 'fire-fst',
    [$1ad63299fe0e9682$var$name$1]: 'fire-fst-compat',
    [$1ad63299fe0e9682$var$name$2]: 'fire-vertex',
    'fire-js': 'fire-js',
    [$1ad63299fe0e9682$var$name]: 'fire-js-all'
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ const $1ad63299fe0e9682$export$b4e3c36c855b14b5 = new Map();
/**
 * @internal
 */ const $1ad63299fe0e9682$export$fb03ad8d3d5c5f76 = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1ad63299fe0e9682$export$9566bce3835c0f28 = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function $1ad63299fe0e9682$export$fa5244b94c62d36a(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        $1ad63299fe0e9682$var$logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */ function $1ad63299fe0e9682$export$4393112b42e2b41d(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function $1ad63299fe0e9682$export$c930050e7bb63965(component) {
    const componentName = component.name;
    if ($1ad63299fe0e9682$export$9566bce3835c0f28.has(componentName)) {
        $1ad63299fe0e9682$var$logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    $1ad63299fe0e9682$export$9566bce3835c0f28.set(componentName, component);
    // add the component to existing app instances
    for (const app of $1ad63299fe0e9682$export$b4e3c36c855b14b5.values())$1ad63299fe0e9682$export$fa5244b94c62d36a(app, component);
    for (const serverApp of $1ad63299fe0e9682$export$fb03ad8d3d5c5f76.values())$1ad63299fe0e9682$export$fa5244b94c62d36a(serverApp, component);
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function $1ad63299fe0e9682$export$fa0d6da0f5838f50(app, name) {
    const heartbeatController = app.container.getProvider('heartbeat').getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function $1ad63299fe0e9682$export$48d18de2ff1c45a5(app, name, instanceIdentifier = $1ad63299fe0e9682$export$9f30fa0c10967f7f) {
    $1ad63299fe0e9682$export$fa0d6da0f5838f50(app, name).clearInstance(instanceIdentifier);
}
/**
 *
 * @param obj - an object of type FirebaseApp, FirebaseOptions or FirebaseAppSettings.
 *
 * @returns true if the provide object is of type FirebaseApp.
 *
 * @internal
 */ function $1ad63299fe0e9682$export$110778f8e98b8257(obj) {
    return obj.options !== undefined;
}
/**
 *
 * @param obj - an object of type FirebaseApp, FirebaseOptions or FirebaseAppSettings.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */ function $1ad63299fe0e9682$export$38e311c93c671bec(obj) {
    if ($1ad63299fe0e9682$export$110778f8e98b8257(obj)) return false;
    return 'authIdToken' in obj || 'appCheckToken' in obj || 'releaseOnDeref' in obj || 'automaticDataCollectionEnabled' in obj;
}
/**
 *
 * @param obj - an object of type FirebaseApp.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */ function $1ad63299fe0e9682$export$643c8bc6c389f34e(obj) {
    if (obj === null || obj === undefined) return false;
    return obj.settings !== undefined;
}
/**
 * Test only
 *
 * @internal
 */ function $1ad63299fe0e9682$export$3685d89b9c3cdfaf() {
    $1ad63299fe0e9682$export$9566bce3835c0f28.clear();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1ad63299fe0e9682$var$ERRORS = {
    ["no-app" /* AppError.NO_APP */ ]: "No Firebase App '{$appName}' has been created - call initializeApp() first",
    ["bad-app-name" /* AppError.BAD_APP_NAME */ ]: "Illegal App name: '{$appName}'",
    ["duplicate-app" /* AppError.DUPLICATE_APP */ ]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* AppError.APP_DELETED */ ]: "Firebase App named '{$appName}' already deleted",
    ["server-app-deleted" /* AppError.SERVER_APP_DELETED */ ]: 'Firebase Server App has been deleted',
    ["no-options" /* AppError.NO_OPTIONS */ ]: 'Need to provide options, when not being deployed to hosting via source.',
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ ]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ ]: 'First argument to `onLog` must be null or a function.',
    ["idb-open" /* AppError.IDB_OPEN */ ]: 'Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-get" /* AppError.IDB_GET */ ]: 'Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-set" /* AppError.IDB_WRITE */ ]: 'Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-delete" /* AppError.IDB_DELETE */ ]: 'Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.',
    ["finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ ]: 'FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.',
    ["invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ ]: 'FirebaseServerApp is not for use in browser environments.'
};
const $1ad63299fe0e9682$var$ERROR_FACTORY = new (0, $b5eeaa155499f6b0$export$3fa6e1b18a3b2d40)('app', 'Firebase', $1ad63299fe0e9682$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $1ad63299fe0e9682$var$FirebaseAppImpl {
    constructor(options, config, container){
        this._isDeleted = false;
        this._options = {
            ...options
        };
        this._config = {
            ...config
        };
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, $be24428bd46df3e1$export$16fa2f45be04daa8)('app', ()=>this, "PUBLIC" /* ComponentType.PUBLIC */ ));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $1ad63299fe0e9682$var$ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */ , {
            appName: this._name
        });
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Parse the token and check to see if the `exp` claim is in the future.
// Reports an error to the console if the token or claim could not be parsed, or if `exp` is in
// the past.
function $1ad63299fe0e9682$var$validateTokenTTL(base64Token, tokenName) {
    const secondPart = (0, $b5eeaa155499f6b0$export$c62426fdd000a97e)(base64Token.split('.')[1]);
    if (secondPart === null) {
        console.error(`FirebaseServerApp ${tokenName} is invalid: second part could not be parsed.`);
        return;
    }
    const expClaim = JSON.parse(secondPart).exp;
    if (expClaim === undefined) {
        console.error(`FirebaseServerApp ${tokenName} is invalid: expiration claim could not be parsed`);
        return;
    }
    const exp = JSON.parse(secondPart).exp * 1000;
    const now = new Date().getTime();
    const diff = exp - now;
    if (diff <= 0) console.error(`FirebaseServerApp ${tokenName} is invalid: the token has expired.`);
}
class $1ad63299fe0e9682$var$FirebaseServerAppImpl extends $1ad63299fe0e9682$var$FirebaseAppImpl {
    constructor(options, serverConfig, name, container){
        // Build configuration parameters for the FirebaseAppImpl base class.
        const automaticDataCollectionEnabled = serverConfig.automaticDataCollectionEnabled !== undefined ? serverConfig.automaticDataCollectionEnabled : true;
        // Create the FirebaseAppSettings object for the FirebaseAppImp constructor.
        const config = {
            name: name,
            automaticDataCollectionEnabled: automaticDataCollectionEnabled
        };
        if (options.apiKey !== undefined) // Construct the parent FirebaseAppImp object.
        super(options, config, container);
        else {
            const appImpl = options;
            super(appImpl.options, config, container);
        }
        // Now construct the data for the FirebaseServerAppImpl.
        this._serverConfig = {
            automaticDataCollectionEnabled: automaticDataCollectionEnabled,
            ...serverConfig
        };
        // Ensure that the current time is within the `authIdtoken` window of validity.
        if (this._serverConfig.authIdToken) $1ad63299fe0e9682$var$validateTokenTTL(this._serverConfig.authIdToken, 'authIdToken');
        // Ensure that the current time is within the `appCheckToken` window of validity.
        if (this._serverConfig.appCheckToken) $1ad63299fe0e9682$var$validateTokenTTL(this._serverConfig.appCheckToken, 'appCheckToken');
        this._finalizationRegistry = null;
        if (typeof FinalizationRegistry !== 'undefined') this._finalizationRegistry = new FinalizationRegistry(()=>{
            this.automaticCleanup();
        });
        this._refCount = 0;
        this.incRefCount(this._serverConfig.releaseOnDeref);
        // Do not retain a hard reference to the dref object, otherwise the FinalizationRegistry
        // will never trigger.
        this._serverConfig.releaseOnDeref = undefined;
        serverConfig.releaseOnDeref = undefined;
        $1ad63299fe0e9682$export$d29d5299a7137abc($1ad63299fe0e9682$var$name$q, $1ad63299fe0e9682$var$version$1, 'serverapp');
    }
    toJSON() {
        return undefined;
    }
    get refCount() {
        return this._refCount;
    }
    // Increment the reference count of this server app. If an object is provided, register it
    // with the finalization registry.
    incRefCount(obj) {
        if (this.isDeleted) return;
        this._refCount++;
        if (obj !== undefined && this._finalizationRegistry !== null) this._finalizationRegistry.register(obj, this);
    }
    // Decrement the reference count.
    decRefCount() {
        if (this.isDeleted) return 0;
        return --this._refCount;
    }
    // Invoked by the FinalizationRegistry callback to note that this app should go through its
    // reference counts and delete itself if no reference count remain. The coordinating logic that
    // handles this is in deleteApp(...).
    automaticCleanup() {
        $1ad63299fe0e9682$export$6eec44aa53d5ea34(this);
    }
    get settings() {
        this.checkDestroyed();
        return this._serverConfig;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $1ad63299fe0e9682$var$ERROR_FACTORY.create("server-app-deleted" /* AppError.SERVER_APP_DELETED */ );
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ const $1ad63299fe0e9682$export$31499a9cd224b78c = $1ad63299fe0e9682$var$version;
function $1ad63299fe0e9682$export$c55cfd413944906d(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== 'object') {
        const name = rawConfig;
        rawConfig = {
            name: name
        };
    }
    const config = {
        name: $1ad63299fe0e9682$export$9f30fa0c10967f7f,
        automaticDataCollectionEnabled: true,
        ...rawConfig
    };
    const name = config.name;
    if (typeof name !== 'string' || !name) throw $1ad63299fe0e9682$var$ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */ , {
        appName: String(name)
    });
    options || (options = (0, $b5eeaa155499f6b0$export$3dfb6827a9f89756)());
    if (!options) throw $1ad63299fe0e9682$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    const existingApp = $1ad63299fe0e9682$export$b4e3c36c855b14b5.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0, $b5eeaa155499f6b0$export$9cb4719e2e525b7a)(options, existingApp.options) && (0, $b5eeaa155499f6b0$export$9cb4719e2e525b7a)(config, existingApp.config)) return existingApp;
        else throw $1ad63299fe0e9682$var$ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name
        });
    }
    const container = new (0, $be24428bd46df3e1$export$436a80eea5d5c0c5)(name);
    for (const component of $1ad63299fe0e9682$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $1ad63299fe0e9682$var$FirebaseAppImpl(options, config, container);
    $1ad63299fe0e9682$export$b4e3c36c855b14b5.set(name, newApp);
    return newApp;
}
function $1ad63299fe0e9682$export$45a407ab953b136b(_options, _serverAppConfig = {}) {
    if ((0, $b5eeaa155499f6b0$export$4e09c449d6c407f7)() && !(0, $b5eeaa155499f6b0$export$97b87b8868ff7a3c)()) // FirebaseServerApp isn't designed to be run in browsers.
    throw $1ad63299fe0e9682$var$ERROR_FACTORY.create("invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ );
    let firebaseOptions;
    let serverAppSettings = _serverAppConfig || {};
    if (_options) {
        if ($1ad63299fe0e9682$export$110778f8e98b8257(_options)) firebaseOptions = _options.options;
        else if ($1ad63299fe0e9682$export$38e311c93c671bec(_options)) serverAppSettings = _options;
        else firebaseOptions = _options;
    }
    if (serverAppSettings.automaticDataCollectionEnabled === undefined) serverAppSettings.automaticDataCollectionEnabled = true;
    firebaseOptions || (firebaseOptions = (0, $b5eeaa155499f6b0$export$3dfb6827a9f89756)());
    if (!firebaseOptions) throw $1ad63299fe0e9682$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    // Build an app name based on a hash of the configuration options.
    const nameObj = {
        ...serverAppSettings,
        ...firebaseOptions
    };
    // However, Do not mangle the name based on releaseOnDeref, since it will vary between the
    // construction of FirebaseServerApp instances. For example, if the object is the request headers.
    if (nameObj.releaseOnDeref !== undefined) delete nameObj.releaseOnDeref;
    const hashCode = (s)=>{
        return [
            ...s
        ].reduce((hash, c)=>Math.imul(31, hash) + c.charCodeAt(0) | 0, 0);
    };
    if (serverAppSettings.releaseOnDeref !== undefined) {
        if (typeof FinalizationRegistry === 'undefined') throw $1ad63299fe0e9682$var$ERROR_FACTORY.create("finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ , {});
    }
    const nameString = '' + hashCode(JSON.stringify(nameObj));
    const existingApp = $1ad63299fe0e9682$export$fb03ad8d3d5c5f76.get(nameString);
    if (existingApp) {
        existingApp.incRefCount(serverAppSettings.releaseOnDeref);
        return existingApp;
    }
    const container = new (0, $be24428bd46df3e1$export$436a80eea5d5c0c5)(nameString);
    for (const component of $1ad63299fe0e9682$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $1ad63299fe0e9682$var$FirebaseServerAppImpl(firebaseOptions, serverAppSettings, nameString, container);
    $1ad63299fe0e9682$export$fb03ad8d3d5c5f76.set(nameString, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function $1ad63299fe0e9682$export$f9962582c9e66d99(name = $1ad63299fe0e9682$export$9f30fa0c10967f7f) {
    const app = $1ad63299fe0e9682$export$b4e3c36c855b14b5.get(name);
    if (!app && name === $1ad63299fe0e9682$export$9f30fa0c10967f7f && (0, $b5eeaa155499f6b0$export$3dfb6827a9f89756)()) return $1ad63299fe0e9682$export$c55cfd413944906d();
    if (!app) throw $1ad63299fe0e9682$var$ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function $1ad63299fe0e9682$export$68ddedf7d44b3bdf() {
    return Array.from($1ad63299fe0e9682$export$b4e3c36c855b14b5.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ async function $1ad63299fe0e9682$export$6eec44aa53d5ea34(app) {
    let cleanupProviders = false;
    const name = app.name;
    if ($1ad63299fe0e9682$export$b4e3c36c855b14b5.has(name)) {
        cleanupProviders = true;
        $1ad63299fe0e9682$export$b4e3c36c855b14b5.delete(name);
    } else if ($1ad63299fe0e9682$export$fb03ad8d3d5c5f76.has(name)) {
        const firebaseServerApp = app;
        if (firebaseServerApp.decRefCount() <= 0) {
            $1ad63299fe0e9682$export$fb03ad8d3d5c5f76.delete(name);
            cleanupProviders = true;
        }
    }
    if (cleanupProviders) {
        await Promise.all(app.container.getProviders().map((provider)=>provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function $1ad63299fe0e9682$export$d29d5299a7137abc(libraryKeyOrName, version, variant) {
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = $1ad63299fe0e9682$var$PLATFORM_LOG_STRING[libraryKeyOrName] ?? libraryKeyOrName;
    if (variant) library += `-${variant}`;
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        if (libraryMismatch && versionMismatch) warning.push('and');
        if (versionMismatch) warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        $1ad63299fe0e9682$var$logger.warn(warning.join(' '));
        return;
    }
    $1ad63299fe0e9682$export$c930050e7bb63965(new (0, $be24428bd46df3e1$export$16fa2f45be04daa8)(`${library}-version`, ()=>({
            library: library,
            version: version
        }), "VERSION" /* ComponentType.VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function $1ad63299fe0e9682$export$a82ad227dc8163dc(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== 'function') throw $1ad63299fe0e9682$var$ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ );
    (0, $6b8f1054ec67b81e$export$29577d29c84db5f6)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function $1ad63299fe0e9682$export$c622e99c0ce7b1c9(logLevel) {
    (0, $6b8f1054ec67b81e$export$c622e99c0ce7b1c9)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1ad63299fe0e9682$var$DB_NAME = 'firebase-heartbeat-database';
const $1ad63299fe0e9682$var$DB_VERSION = 1;
const $1ad63299fe0e9682$var$STORE_NAME = 'firebase-heartbeat-store';
let $1ad63299fe0e9682$var$dbPromise = null;
function $1ad63299fe0e9682$var$getDbPromise() {
    if (!$1ad63299fe0e9682$var$dbPromise) $1ad63299fe0e9682$var$dbPromise = (0, $1b1bada3b03888b0$export$ca0ed41b1a2af7e)($1ad63299fe0e9682$var$DB_NAME, $1ad63299fe0e9682$var$DB_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    try {
                        db.createObjectStore($1ad63299fe0e9682$var$STORE_NAME);
                    } catch (e) {
                        // Safari/iOS browsers throw occasional exceptions on
                        // db.createObjectStore() that may be a bug. Avoid blocking
                        // the rest of the app functionality.
                        console.warn(e);
                    }
            }
        }
    }).catch((e)=>{
        throw $1ad63299fe0e9682$var$ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return $1ad63299fe0e9682$var$dbPromise;
}
async function $1ad63299fe0e9682$var$readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await $1ad63299fe0e9682$var$getDbPromise();
        const tx = db.transaction($1ad63299fe0e9682$var$STORE_NAME);
        const result = await tx.objectStore($1ad63299fe0e9682$var$STORE_NAME).get($1ad63299fe0e9682$var$computeKey(app));
        // We already have the value but tx.done can throw,
        // so we need to await it here to catch errors
        await tx.done;
        return result;
    } catch (e) {
        if (e instanceof (0, $b5eeaa155499f6b0$export$dd24e9cd51226c56)) $1ad63299fe0e9682$var$logger.warn(e.message);
        else {
            const idbGetError = $1ad63299fe0e9682$var$ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */ , {
                originalErrorMessage: e?.message
            });
            $1ad63299fe0e9682$var$logger.warn(idbGetError.message);
        }
    }
}
async function $1ad63299fe0e9682$var$writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await $1ad63299fe0e9682$var$getDbPromise();
        const tx = db.transaction($1ad63299fe0e9682$var$STORE_NAME, 'readwrite');
        const objectStore = tx.objectStore($1ad63299fe0e9682$var$STORE_NAME);
        await objectStore.put(heartbeatObject, $1ad63299fe0e9682$var$computeKey(app));
        await tx.done;
    } catch (e) {
        if (e instanceof (0, $b5eeaa155499f6b0$export$dd24e9cd51226c56)) $1ad63299fe0e9682$var$logger.warn(e.message);
        else {
            const idbGetError = $1ad63299fe0e9682$var$ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */ , {
                originalErrorMessage: e?.message
            });
            $1ad63299fe0e9682$var$logger.warn(idbGetError.message);
        }
    }
}
function $1ad63299fe0e9682$var$computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1ad63299fe0e9682$var$MAX_HEADER_BYTES = 1024;
const $1ad63299fe0e9682$var$MAX_NUM_STORED_HEARTBEATS = 30;
class $1ad63299fe0e9682$var$HeartbeatServiceImpl {
    constructor(container){
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        const app = this.container.getProvider('app').getImmediate();
        this._storage = new $1ad63299fe0e9682$var$HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then((result)=>{
            this._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ async triggerHeartbeat() {
        try {
            const platformLogger = this.container.getProvider('platform-logger').getImmediate();
            // This is the "Firebase user agent" string from the platform logger
            // service, not the browser user agent.
            const agent = platformLogger.getPlatformInfoString();
            const date = $1ad63299fe0e9682$var$getUTCDateString();
            if (this._heartbeatsCache?.heartbeats == null) {
                this._heartbeatsCache = await this._heartbeatsCachePromise;
                // If we failed to construct a heartbeats cache, then return immediately.
                if (this._heartbeatsCache?.heartbeats == null) return;
            }
            // Do not store a heartbeat if one is already stored for this day
            // or if a header has already been sent today.
            if (this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some((singleDateHeartbeat)=>singleDateHeartbeat.date === date)) return;
            else {
                // There is no entry for this date. Create one.
                this._heartbeatsCache.heartbeats.push({
                    date: date,
                    agent: agent
                });
                // If the number of stored heartbeats exceeds the maximum number of stored heartbeats, remove the heartbeat with the earliest date.
                // Since this is executed each time a heartbeat is pushed, the limit can only be exceeded by one, so only one needs to be removed.
                if (this._heartbeatsCache.heartbeats.length > $1ad63299fe0e9682$var$MAX_NUM_STORED_HEARTBEATS) {
                    const earliestHeartbeatIdx = $1ad63299fe0e9682$var$getEarliestHeartbeatIdx(this._heartbeatsCache.heartbeats);
                    this._heartbeatsCache.heartbeats.splice(earliestHeartbeatIdx, 1);
                }
            }
            return this._storage.overwrite(this._heartbeatsCache);
        } catch (e) {
            $1ad63299fe0e9682$var$logger.warn(e);
        }
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ async getHeartbeatsHeader() {
        try {
            if (this._heartbeatsCache === null) await this._heartbeatsCachePromise;
            // If it's still null or the array is empty, there is no data to send.
            if (this._heartbeatsCache?.heartbeats == null || this._heartbeatsCache.heartbeats.length === 0) return '';
            const date = $1ad63299fe0e9682$var$getUTCDateString();
            // Extract as many heartbeats from the cache as will fit under the size limit.
            const { heartbeatsToSend: heartbeatsToSend, unsentEntries: unsentEntries } = $1ad63299fe0e9682$var$extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
            const headerString = (0, $b5eeaa155499f6b0$export$4b5284a3025a455)(JSON.stringify({
                version: 2,
                heartbeats: heartbeatsToSend
            }));
            // Store last sent date to prevent another being logged/sent for the same day.
            this._heartbeatsCache.lastSentHeartbeatDate = date;
            if (unsentEntries.length > 0) {
                // Store any unsent entries if they exist.
                this._heartbeatsCache.heartbeats = unsentEntries;
                // This seems more likely than emptying the array (below) to lead to some odd state
                // since the cache isn't empty and this will be called again on the next request,
                // and is probably safest if we await it.
                await this._storage.overwrite(this._heartbeatsCache);
            } else {
                this._heartbeatsCache.heartbeats = [];
                // Do not wait for this, to reduce latency.
                this._storage.overwrite(this._heartbeatsCache);
            }
            return headerString;
        } catch (e) {
            $1ad63299fe0e9682$var$logger.warn(e);
            return '';
        }
    }
}
function $1ad63299fe0e9682$var$getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function $1ad63299fe0e9682$var$extractHeartbeatsForHeader(heartbeatsCache, maxSize = $1ad63299fe0e9682$var$MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache){
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find((hb)=>hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [
                    singleDateHeartbeat.date
                ]
            });
            if ($1ad63299fe0e9682$var$countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        } else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if ($1ad63299fe0e9682$var$countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend: heartbeatsToSend,
        unsentEntries: unsentEntries
    };
}
class $1ad63299fe0e9682$var$HeartbeatStorageImpl {
    constructor(app){
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!(0, $b5eeaa155499f6b0$export$3865db50535c2055)()) return false;
        else return (0, $b5eeaa155499f6b0$export$a8a3018f3d187a4d)().then(()=>true).catch(()=>false);
    }
    /**
     * Read all heartbeats.
     */ async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return {
            heartbeats: []
        };
        else {
            const idbHeartbeatObject = await $1ad63299fe0e9682$var$readHeartbeatsFromIndexedDB(this.app);
            if (idbHeartbeatObject?.heartbeats) return idbHeartbeatObject;
            else return {
                heartbeats: []
            };
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $1ad63299fe0e9682$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: heartbeatsObject.lastSentHeartbeatDate ?? existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $1ad63299fe0e9682$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: heartbeatsObject.lastSentHeartbeatDate ?? existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function $1ad63299fe0e9682$var$countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, $b5eeaa155499f6b0$export$4b5284a3025a455)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * Returns the index of the heartbeat with the earliest date.
 * If the heartbeats array is empty, -1 is returned.
 */ function $1ad63299fe0e9682$var$getEarliestHeartbeatIdx(heartbeats) {
    if (heartbeats.length === 0) return -1;
    let earliestHeartbeatIdx = 0;
    let earliestHeartbeatDate = heartbeats[0].date;
    for(let i = 1; i < heartbeats.length; i++)if (heartbeats[i].date < earliestHeartbeatDate) {
        earliestHeartbeatDate = heartbeats[i].date;
        earliestHeartbeatIdx = i;
    }
    return earliestHeartbeatIdx;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $1ad63299fe0e9682$var$registerCoreComponents(variant) {
    $1ad63299fe0e9682$export$c930050e7bb63965(new (0, $be24428bd46df3e1$export$16fa2f45be04daa8)('platform-logger', (container)=>new $1ad63299fe0e9682$var$PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    $1ad63299fe0e9682$export$c930050e7bb63965(new (0, $be24428bd46df3e1$export$16fa2f45be04daa8)('heartbeat', (container)=>new $1ad63299fe0e9682$var$HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    // Register `app` package.
    $1ad63299fe0e9682$export$d29d5299a7137abc($1ad63299fe0e9682$var$name$q, $1ad63299fe0e9682$var$version$1, variant);
    // BUILD_TARGET will be replaced by values like esm, cjs, etc during the compilation
    $1ad63299fe0e9682$export$d29d5299a7137abc($1ad63299fe0e9682$var$name$q, $1ad63299fe0e9682$var$version$1, 'esm2020');
    // Register platform SDK identifier (no version).
    $1ad63299fe0e9682$export$d29d5299a7137abc('fire-js', '');
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ $1ad63299fe0e9682$var$registerCoreComponents('');


var $ac721a0feabba790$var$name = "firebase";
var $ac721a0feabba790$var$version = "12.5.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $1ad63299fe0e9682$export$d29d5299a7137abc)($ac721a0feabba790$var$name, $ac721a0feabba790$var$version, 'app');










const $e6a31eba2ef4ef31$var$name = "@firebase/installations";
const $e6a31eba2ef4ef31$var$version = "0.6.19";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e6a31eba2ef4ef31$var$PENDING_TIMEOUT_MS = 10000;
const $e6a31eba2ef4ef31$var$PACKAGE_VERSION = `w:${$e6a31eba2ef4ef31$var$version}`;
const $e6a31eba2ef4ef31$var$INTERNAL_AUTH_VERSION = 'FIS_v2';
const $e6a31eba2ef4ef31$var$INSTALLATIONS_API_URL = 'https://firebaseinstallations.googleapis.com/v1';
const $e6a31eba2ef4ef31$var$TOKEN_EXPIRATION_BUFFER = 3600000; // One hour
const $e6a31eba2ef4ef31$var$SERVICE = 'installations';
const $e6a31eba2ef4ef31$var$SERVICE_NAME = 'Installations';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e6a31eba2ef4ef31$var$ERROR_DESCRIPTION_MAP = {
    ["missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ ]: 'Missing App configuration value: "{$valueName}"',
    ["not-registered" /* ErrorCode.NOT_REGISTERED */ ]: 'Firebase Installation is not registered.',
    ["installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */ ]: 'Firebase Installation not found.',
    ["request-failed" /* ErrorCode.REQUEST_FAILED */ ]: '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"',
    ["app-offline" /* ErrorCode.APP_OFFLINE */ ]: 'Could not process request. Application offline.',
    ["delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */ ]: "Can't delete installation while there is a pending registration request."
};
const $e6a31eba2ef4ef31$var$ERROR_FACTORY = new (0, $b5eeaa155499f6b0$export$3fa6e1b18a3b2d40)($e6a31eba2ef4ef31$var$SERVICE, $e6a31eba2ef4ef31$var$SERVICE_NAME, $e6a31eba2ef4ef31$var$ERROR_DESCRIPTION_MAP);
/** Returns true if error is a FirebaseError that is based on an error from the server. */ function $e6a31eba2ef4ef31$var$isServerError(error) {
    return error instanceof (0, $b5eeaa155499f6b0$export$dd24e9cd51226c56) && error.code.includes("request-failed" /* ErrorCode.REQUEST_FAILED */ );
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $e6a31eba2ef4ef31$var$getInstallationsEndpoint({ projectId: projectId }) {
    return `${$e6a31eba2ef4ef31$var$INSTALLATIONS_API_URL}/projects/${projectId}/installations`;
}
function $e6a31eba2ef4ef31$var$extractAuthTokenInfoFromResponse(response) {
    return {
        token: response.token,
        requestStatus: 2 /* RequestStatus.COMPLETED */ ,
        expiresIn: $e6a31eba2ef4ef31$var$getExpiresInFromResponseExpiresIn(response.expiresIn),
        creationTime: Date.now()
    };
}
async function $e6a31eba2ef4ef31$var$getErrorFromResponse(requestName, response) {
    const responseJson = await response.json();
    const errorData = responseJson.error;
    return $e6a31eba2ef4ef31$var$ERROR_FACTORY.create("request-failed" /* ErrorCode.REQUEST_FAILED */ , {
        requestName: requestName,
        serverCode: errorData.code,
        serverMessage: errorData.message,
        serverStatus: errorData.status
    });
}
function $e6a31eba2ef4ef31$var$getHeaders({ apiKey: apiKey }) {
    return new Headers({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'x-goog-api-key': apiKey
    });
}
function $e6a31eba2ef4ef31$var$getHeadersWithAuth(appConfig, { refreshToken: refreshToken }) {
    const headers = $e6a31eba2ef4ef31$var$getHeaders(appConfig);
    headers.append('Authorization', $e6a31eba2ef4ef31$var$getAuthorizationHeader(refreshToken));
    return headers;
}
/**
 * Calls the passed in fetch wrapper and returns the response.
 * If the returned response has a status of 5xx, re-runs the function once and
 * returns the response.
 */ async function $e6a31eba2ef4ef31$var$retryIfServerError(fn) {
    const result = await fn();
    if (result.status >= 500 && result.status < 600) // Internal Server Error. Retry request.
    return fn();
    return result;
}
function $e6a31eba2ef4ef31$var$getExpiresInFromResponseExpiresIn(responseExpiresIn) {
    // This works because the server will never respond with fractions of a second.
    return Number(responseExpiresIn.replace('s', '000'));
}
function $e6a31eba2ef4ef31$var$getAuthorizationHeader(refreshToken) {
    return `${$e6a31eba2ef4ef31$var$INTERNAL_AUTH_VERSION} ${refreshToken}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $e6a31eba2ef4ef31$var$createInstallationRequest({ appConfig: appConfig, heartbeatServiceProvider: heartbeatServiceProvider }, { fid: fid }) {
    const endpoint = $e6a31eba2ef4ef31$var$getInstallationsEndpoint(appConfig);
    const headers = $e6a31eba2ef4ef31$var$getHeaders(appConfig);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) headers.append('x-firebase-client', heartbeatsHeader);
    }
    const body = {
        fid: fid,
        authVersion: $e6a31eba2ef4ef31$var$INTERNAL_AUTH_VERSION,
        appId: appConfig.appId,
        sdkVersion: $e6a31eba2ef4ef31$var$PACKAGE_VERSION
    };
    const request = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(body)
    };
    const response = await $e6a31eba2ef4ef31$var$retryIfServerError(()=>fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const registeredInstallationEntry = {
            fid: responseValue.fid || fid,
            registrationStatus: 2 /* RequestStatus.COMPLETED */ ,
            refreshToken: responseValue.refreshToken,
            authToken: $e6a31eba2ef4ef31$var$extractAuthTokenInfoFromResponse(responseValue.authToken)
        };
        return registeredInstallationEntry;
    } else throw await $e6a31eba2ef4ef31$var$getErrorFromResponse('Create Installation', response);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a promise that resolves after given time passes. */ function $e6a31eba2ef4ef31$var$sleep(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $e6a31eba2ef4ef31$var$bufferToBase64UrlSafe(array) {
    const b64 = btoa(String.fromCharCode(...array));
    return b64.replace(/\+/g, '-').replace(/\//g, '_');
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e6a31eba2ef4ef31$var$VALID_FID_PATTERN = /^[cdef][\w-]{21}$/;
const $e6a31eba2ef4ef31$var$INVALID_FID = '';
/**
 * Generates a new FID using random values from Web Crypto API.
 * Returns an empty string if FID generation fails for any reason.
 */ function $e6a31eba2ef4ef31$var$generateFid() {
    try {
        // A valid FID has exactly 22 base64 characters, which is 132 bits, or 16.5
        // bytes. our implementation generates a 17 byte array instead.
        const fidByteArray = new Uint8Array(17);
        const crypto = self.crypto || self.msCrypto;
        crypto.getRandomValues(fidByteArray);
        // Replace the first 4 random bits with the constant FID header of 0b0111.
        fidByteArray[0] = 112 + fidByteArray[0] % 16;
        const fid = $e6a31eba2ef4ef31$var$encode(fidByteArray);
        return $e6a31eba2ef4ef31$var$VALID_FID_PATTERN.test(fid) ? fid : $e6a31eba2ef4ef31$var$INVALID_FID;
    } catch  {
        // FID generation errored
        return $e6a31eba2ef4ef31$var$INVALID_FID;
    }
}
/** Converts a FID Uint8Array to a base64 string representation. */ function $e6a31eba2ef4ef31$var$encode(fidByteArray) {
    const b64String = $e6a31eba2ef4ef31$var$bufferToBase64UrlSafe(fidByteArray);
    // Remove the 23rd character that was added because of the extra 4 bits at the
    // end of our 17 byte array, and the '=' padding.
    return b64String.substr(0, 22);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a string key that can be used to identify the app. */ function $e6a31eba2ef4ef31$var$getKey(appConfig) {
    return `${appConfig.appName}!${appConfig.appId}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e6a31eba2ef4ef31$var$fidChangeCallbacks = new Map();
/**
 * Calls the onIdChange callbacks with the new FID value, and broadcasts the
 * change to other tabs.
 */ function $e6a31eba2ef4ef31$var$fidChanged(appConfig, fid) {
    const key = $e6a31eba2ef4ef31$var$getKey(appConfig);
    $e6a31eba2ef4ef31$var$callFidChangeCallbacks(key, fid);
    $e6a31eba2ef4ef31$var$broadcastFidChange(key, fid);
}
function $e6a31eba2ef4ef31$var$addCallback(appConfig, callback) {
    // Open the broadcast channel if it's not already open,
    // to be able to listen to change events from other tabs.
    $e6a31eba2ef4ef31$var$getBroadcastChannel();
    const key = $e6a31eba2ef4ef31$var$getKey(appConfig);
    let callbackSet = $e6a31eba2ef4ef31$var$fidChangeCallbacks.get(key);
    if (!callbackSet) {
        callbackSet = new Set();
        $e6a31eba2ef4ef31$var$fidChangeCallbacks.set(key, callbackSet);
    }
    callbackSet.add(callback);
}
function $e6a31eba2ef4ef31$var$removeCallback(appConfig, callback) {
    const key = $e6a31eba2ef4ef31$var$getKey(appConfig);
    const callbackSet = $e6a31eba2ef4ef31$var$fidChangeCallbacks.get(key);
    if (!callbackSet) return;
    callbackSet.delete(callback);
    if (callbackSet.size === 0) $e6a31eba2ef4ef31$var$fidChangeCallbacks.delete(key);
    // Close broadcast channel if there are no more callbacks.
    $e6a31eba2ef4ef31$var$closeBroadcastChannel();
}
function $e6a31eba2ef4ef31$var$callFidChangeCallbacks(key, fid) {
    const callbacks = $e6a31eba2ef4ef31$var$fidChangeCallbacks.get(key);
    if (!callbacks) return;
    for (const callback of callbacks)callback(fid);
}
function $e6a31eba2ef4ef31$var$broadcastFidChange(key, fid) {
    const channel = $e6a31eba2ef4ef31$var$getBroadcastChannel();
    if (channel) channel.postMessage({
        key: key,
        fid: fid
    });
    $e6a31eba2ef4ef31$var$closeBroadcastChannel();
}
let $e6a31eba2ef4ef31$var$broadcastChannel = null;
/** Opens and returns a BroadcastChannel if it is supported by the browser. */ function $e6a31eba2ef4ef31$var$getBroadcastChannel() {
    if (!$e6a31eba2ef4ef31$var$broadcastChannel && 'BroadcastChannel' in self) {
        $e6a31eba2ef4ef31$var$broadcastChannel = new BroadcastChannel('[Firebase] FID Change');
        $e6a31eba2ef4ef31$var$broadcastChannel.onmessage = (e)=>{
            $e6a31eba2ef4ef31$var$callFidChangeCallbacks(e.data.key, e.data.fid);
        };
    }
    return $e6a31eba2ef4ef31$var$broadcastChannel;
}
function $e6a31eba2ef4ef31$var$closeBroadcastChannel() {
    if ($e6a31eba2ef4ef31$var$fidChangeCallbacks.size === 0 && $e6a31eba2ef4ef31$var$broadcastChannel) {
        $e6a31eba2ef4ef31$var$broadcastChannel.close();
        $e6a31eba2ef4ef31$var$broadcastChannel = null;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e6a31eba2ef4ef31$var$DATABASE_NAME = 'firebase-installations-database';
const $e6a31eba2ef4ef31$var$DATABASE_VERSION = 1;
const $e6a31eba2ef4ef31$var$OBJECT_STORE_NAME = 'firebase-installations-store';
let $e6a31eba2ef4ef31$var$dbPromise = null;
function $e6a31eba2ef4ef31$var$getDbPromise() {
    if (!$e6a31eba2ef4ef31$var$dbPromise) $e6a31eba2ef4ef31$var$dbPromise = (0, $1b1bada3b03888b0$export$ca0ed41b1a2af7e)($e6a31eba2ef4ef31$var$DATABASE_NAME, $e6a31eba2ef4ef31$var$DATABASE_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    db.createObjectStore($e6a31eba2ef4ef31$var$OBJECT_STORE_NAME);
            }
        }
    });
    return $e6a31eba2ef4ef31$var$dbPromise;
}
/** Assigns or overwrites the record for the given key with the given value. */ async function $e6a31eba2ef4ef31$var$set(appConfig, value) {
    const key = $e6a31eba2ef4ef31$var$getKey(appConfig);
    const db = await $e6a31eba2ef4ef31$var$getDbPromise();
    const tx = db.transaction($e6a31eba2ef4ef31$var$OBJECT_STORE_NAME, 'readwrite');
    const objectStore = tx.objectStore($e6a31eba2ef4ef31$var$OBJECT_STORE_NAME);
    const oldValue = await objectStore.get(key);
    await objectStore.put(value, key);
    await tx.done;
    if (!oldValue || oldValue.fid !== value.fid) $e6a31eba2ef4ef31$var$fidChanged(appConfig, value.fid);
    return value;
}
/** Removes record(s) from the objectStore that match the given key. */ async function $e6a31eba2ef4ef31$var$remove(appConfig) {
    const key = $e6a31eba2ef4ef31$var$getKey(appConfig);
    const db = await $e6a31eba2ef4ef31$var$getDbPromise();
    const tx = db.transaction($e6a31eba2ef4ef31$var$OBJECT_STORE_NAME, 'readwrite');
    await tx.objectStore($e6a31eba2ef4ef31$var$OBJECT_STORE_NAME).delete(key);
    await tx.done;
}
/**
 * Atomically updates a record with the result of updateFn, which gets
 * called with the current value. If newValue is undefined, the record is
 * deleted instead.
 * @return Updated value
 */ async function $e6a31eba2ef4ef31$var$update(appConfig, updateFn) {
    const key = $e6a31eba2ef4ef31$var$getKey(appConfig);
    const db = await $e6a31eba2ef4ef31$var$getDbPromise();
    const tx = db.transaction($e6a31eba2ef4ef31$var$OBJECT_STORE_NAME, 'readwrite');
    const store = tx.objectStore($e6a31eba2ef4ef31$var$OBJECT_STORE_NAME);
    const oldValue = await store.get(key);
    const newValue = updateFn(oldValue);
    if (newValue === undefined) await store.delete(key);
    else await store.put(newValue, key);
    await tx.done;
    if (newValue && (!oldValue || oldValue.fid !== newValue.fid)) $e6a31eba2ef4ef31$var$fidChanged(appConfig, newValue.fid);
    return newValue;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates and returns the InstallationEntry from the database.
 * Also triggers a registration request if it is necessary and possible.
 */ async function $e6a31eba2ef4ef31$var$getInstallationEntry(installations) {
    let registrationPromise;
    const installationEntry = await $e6a31eba2ef4ef31$var$update(installations.appConfig, (oldEntry)=>{
        const installationEntry = $e6a31eba2ef4ef31$var$updateOrCreateInstallationEntry(oldEntry);
        const entryWithPromise = $e6a31eba2ef4ef31$var$triggerRegistrationIfNecessary(installations, installationEntry);
        registrationPromise = entryWithPromise.registrationPromise;
        return entryWithPromise.installationEntry;
    });
    if (installationEntry.fid === $e6a31eba2ef4ef31$var$INVALID_FID) // FID generation failed. Waiting for the FID from the server.
    return {
        installationEntry: await registrationPromise
    };
    return {
        installationEntry: installationEntry,
        registrationPromise: registrationPromise
    };
}
/**
 * Creates a new Installation Entry if one does not exist.
 * Also clears timed out pending requests.
 */ function $e6a31eba2ef4ef31$var$updateOrCreateInstallationEntry(oldEntry) {
    const entry = oldEntry || {
        fid: $e6a31eba2ef4ef31$var$generateFid(),
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
    };
    return $e6a31eba2ef4ef31$var$clearTimedOutRequest(entry);
}
/**
 * If the Firebase Installation is not registered yet, this will trigger the
 * registration and return an InProgressInstallationEntry.
 *
 * If registrationPromise does not exist, the installationEntry is guaranteed
 * to be registered.
 */ function $e6a31eba2ef4ef31$var$triggerRegistrationIfNecessary(installations, installationEntry) {
    if (installationEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) {
        if (!navigator.onLine) {
            // Registration required but app is offline.
            const registrationPromiseWithError = Promise.reject($e6a31eba2ef4ef31$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ ));
            return {
                installationEntry: installationEntry,
                registrationPromise: registrationPromiseWithError
            };
        }
        // Try registering. Change status to IN_PROGRESS.
        const inProgressEntry = {
            fid: installationEntry.fid,
            registrationStatus: 1 /* RequestStatus.IN_PROGRESS */ ,
            registrationTime: Date.now()
        };
        const registrationPromise = $e6a31eba2ef4ef31$var$registerInstallation(installations, inProgressEntry);
        return {
            installationEntry: inProgressEntry,
            registrationPromise: registrationPromise
        };
    } else if (installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ) return {
        installationEntry: installationEntry,
        registrationPromise: $e6a31eba2ef4ef31$var$waitUntilFidRegistration(installations)
    };
    else return {
        installationEntry: installationEntry
    };
}
/** This will be executed only once for each new Firebase Installation. */ async function $e6a31eba2ef4ef31$var$registerInstallation(installations, installationEntry) {
    try {
        const registeredInstallationEntry = await $e6a31eba2ef4ef31$var$createInstallationRequest(installations, installationEntry);
        return $e6a31eba2ef4ef31$var$set(installations.appConfig, registeredInstallationEntry);
    } catch (e) {
        if ($e6a31eba2ef4ef31$var$isServerError(e) && e.customData.serverCode === 409) // Server returned a "FID cannot be used" error.
        // Generate a new ID next time.
        await $e6a31eba2ef4ef31$var$remove(installations.appConfig);
        else // Registration failed. Set FID as not registered.
        await $e6a31eba2ef4ef31$var$set(installations.appConfig, {
            fid: installationEntry.fid,
            registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
        });
        throw e;
    }
}
/** Call if FID registration is pending in another request. */ async function $e6a31eba2ef4ef31$var$waitUntilFidRegistration(installations) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await $e6a31eba2ef4ef31$var$updateInstallationRequest(installations.appConfig);
    while(entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ){
        // createInstallation request still in progress.
        await $e6a31eba2ef4ef31$var$sleep(100);
        entry = await $e6a31eba2ef4ef31$var$updateInstallationRequest(installations.appConfig);
    }
    if (entry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) {
        // The request timed out or failed in a different call. Try again.
        const { installationEntry: installationEntry, registrationPromise: registrationPromise } = await $e6a31eba2ef4ef31$var$getInstallationEntry(installations);
        if (registrationPromise) return registrationPromise;
        else // if there is no registrationPromise, entry is registered.
        return installationEntry;
    }
    return entry;
}
/**
 * Called only if there is a CreateInstallation request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * CreateInstallation request.
 *
 * Returns the updated InstallationEntry.
 */ function $e6a31eba2ef4ef31$var$updateInstallationRequest(appConfig) {
    return $e6a31eba2ef4ef31$var$update(appConfig, (oldEntry)=>{
        if (!oldEntry) throw $e6a31eba2ef4ef31$var$ERROR_FACTORY.create("installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */ );
        return $e6a31eba2ef4ef31$var$clearTimedOutRequest(oldEntry);
    });
}
function $e6a31eba2ef4ef31$var$clearTimedOutRequest(entry) {
    if ($e6a31eba2ef4ef31$var$hasInstallationRequestTimedOut(entry)) return {
        fid: entry.fid,
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
    };
    return entry;
}
function $e6a31eba2ef4ef31$var$hasInstallationRequestTimedOut(installationEntry) {
    return installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */  && installationEntry.registrationTime + $e6a31eba2ef4ef31$var$PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $e6a31eba2ef4ef31$var$generateAuthTokenRequest({ appConfig: appConfig, heartbeatServiceProvider: heartbeatServiceProvider }, installationEntry) {
    const endpoint = $e6a31eba2ef4ef31$var$getGenerateAuthTokenEndpoint(appConfig, installationEntry);
    const headers = $e6a31eba2ef4ef31$var$getHeadersWithAuth(appConfig, installationEntry);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) headers.append('x-firebase-client', heartbeatsHeader);
    }
    const body = {
        installation: {
            sdkVersion: $e6a31eba2ef4ef31$var$PACKAGE_VERSION,
            appId: appConfig.appId
        }
    };
    const request = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(body)
    };
    const response = await $e6a31eba2ef4ef31$var$retryIfServerError(()=>fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const completedAuthToken = $e6a31eba2ef4ef31$var$extractAuthTokenInfoFromResponse(responseValue);
        return completedAuthToken;
    } else throw await $e6a31eba2ef4ef31$var$getErrorFromResponse('Generate Auth Token', response);
}
function $e6a31eba2ef4ef31$var$getGenerateAuthTokenEndpoint(appConfig, { fid: fid }) {
    return `${$e6a31eba2ef4ef31$var$getInstallationsEndpoint(appConfig)}/${fid}/authTokens:generate`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a valid authentication token for the installation. Generates a new
 * token if one doesn't exist, is expired or about to expire.
 *
 * Should only be called if the Firebase Installation is registered.
 */ async function $e6a31eba2ef4ef31$var$refreshAuthToken(installations, forceRefresh = false) {
    let tokenPromise;
    const entry = await $e6a31eba2ef4ef31$var$update(installations.appConfig, (oldEntry)=>{
        if (!$e6a31eba2ef4ef31$var$isEntryRegistered(oldEntry)) throw $e6a31eba2ef4ef31$var$ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */ );
        const oldAuthToken = oldEntry.authToken;
        if (!forceRefresh && $e6a31eba2ef4ef31$var$isAuthTokenValid(oldAuthToken)) // There is a valid token in the DB.
        return oldEntry;
        else if (oldAuthToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ ) {
            // There already is a token request in progress.
            tokenPromise = $e6a31eba2ef4ef31$var$waitUntilAuthTokenRequest(installations, forceRefresh);
            return oldEntry;
        } else {
            // No token or token expired.
            if (!navigator.onLine) throw $e6a31eba2ef4ef31$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ );
            const inProgressEntry = $e6a31eba2ef4ef31$var$makeAuthTokenRequestInProgressEntry(oldEntry);
            tokenPromise = $e6a31eba2ef4ef31$var$fetchAuthTokenFromServer(installations, inProgressEntry);
            return inProgressEntry;
        }
    });
    const authToken = tokenPromise ? await tokenPromise : entry.authToken;
    return authToken;
}
/**
 * Call only if FID is registered and Auth Token request is in progress.
 *
 * Waits until the current pending request finishes. If the request times out,
 * tries once in this thread as well.
 */ async function $e6a31eba2ef4ef31$var$waitUntilAuthTokenRequest(installations, forceRefresh) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await $e6a31eba2ef4ef31$var$updateAuthTokenRequest(installations.appConfig);
    while(entry.authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ ){
        // generateAuthToken still in progress.
        await $e6a31eba2ef4ef31$var$sleep(100);
        entry = await $e6a31eba2ef4ef31$var$updateAuthTokenRequest(installations.appConfig);
    }
    const authToken = entry.authToken;
    if (authToken.requestStatus === 0 /* RequestStatus.NOT_STARTED */ ) // The request timed out or failed in a different call. Try again.
    return $e6a31eba2ef4ef31$var$refreshAuthToken(installations, forceRefresh);
    else return authToken;
}
/**
 * Called only if there is a GenerateAuthToken request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * GenerateAuthToken request.
 *
 * Returns the updated InstallationEntry.
 */ function $e6a31eba2ef4ef31$var$updateAuthTokenRequest(appConfig) {
    return $e6a31eba2ef4ef31$var$update(appConfig, (oldEntry)=>{
        if (!$e6a31eba2ef4ef31$var$isEntryRegistered(oldEntry)) throw $e6a31eba2ef4ef31$var$ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */ );
        const oldAuthToken = oldEntry.authToken;
        if ($e6a31eba2ef4ef31$var$hasAuthTokenRequestTimedOut(oldAuthToken)) return {
            ...oldEntry,
            authToken: {
                requestStatus: 0 /* RequestStatus.NOT_STARTED */ 
            }
        };
        return oldEntry;
    });
}
async function $e6a31eba2ef4ef31$var$fetchAuthTokenFromServer(installations, installationEntry) {
    try {
        const authToken = await $e6a31eba2ef4ef31$var$generateAuthTokenRequest(installations, installationEntry);
        const updatedInstallationEntry = {
            ...installationEntry,
            authToken: authToken
        };
        await $e6a31eba2ef4ef31$var$set(installations.appConfig, updatedInstallationEntry);
        return authToken;
    } catch (e) {
        if ($e6a31eba2ef4ef31$var$isServerError(e) && (e.customData.serverCode === 401 || e.customData.serverCode === 404)) // Server returned a "FID not found" or a "Invalid authentication" error.
        // Generate a new ID next time.
        await $e6a31eba2ef4ef31$var$remove(installations.appConfig);
        else {
            const updatedInstallationEntry = {
                ...installationEntry,
                authToken: {
                    requestStatus: 0 /* RequestStatus.NOT_STARTED */ 
                }
            };
            await $e6a31eba2ef4ef31$var$set(installations.appConfig, updatedInstallationEntry);
        }
        throw e;
    }
}
function $e6a31eba2ef4ef31$var$isEntryRegistered(installationEntry) {
    return installationEntry !== undefined && installationEntry.registrationStatus === 2 /* RequestStatus.COMPLETED */ ;
}
function $e6a31eba2ef4ef31$var$isAuthTokenValid(authToken) {
    return authToken.requestStatus === 2 /* RequestStatus.COMPLETED */  && !$e6a31eba2ef4ef31$var$isAuthTokenExpired(authToken);
}
function $e6a31eba2ef4ef31$var$isAuthTokenExpired(authToken) {
    const now = Date.now();
    return now < authToken.creationTime || authToken.creationTime + authToken.expiresIn < now + $e6a31eba2ef4ef31$var$TOKEN_EXPIRATION_BUFFER;
}
/** Returns an updated InstallationEntry with an InProgressAuthToken. */ function $e6a31eba2ef4ef31$var$makeAuthTokenRequestInProgressEntry(oldEntry) {
    const inProgressAuthToken = {
        requestStatus: 1 /* RequestStatus.IN_PROGRESS */ ,
        requestTime: Date.now()
    };
    return {
        ...oldEntry,
        authToken: inProgressAuthToken
    };
}
function $e6a31eba2ef4ef31$var$hasAuthTokenRequestTimedOut(authToken) {
    return authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */  && authToken.requestTime + $e6a31eba2ef4ef31$var$PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Creates a Firebase Installation if there isn't one for the app and
 * returns the Installation ID.
 * @param installations - The `Installations` instance.
 *
 * @public
 */ async function $e6a31eba2ef4ef31$export$218c8c3169c024d2(installations) {
    const installationsImpl = installations;
    const { installationEntry: installationEntry, registrationPromise: registrationPromise } = await $e6a31eba2ef4ef31$var$getInstallationEntry(installationsImpl);
    if (registrationPromise) registrationPromise.catch(console.error);
    else // If the installation is already registered, update the authentication
    // token if needed.
    $e6a31eba2ef4ef31$var$refreshAuthToken(installationsImpl).catch(console.error);
    return installationEntry.fid;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a Firebase Installations auth token, identifying the current
 * Firebase Installation.
 * @param installations - The `Installations` instance.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function $e6a31eba2ef4ef31$export$257b2d10b709d8ef(installations, forceRefresh = false) {
    const installationsImpl = installations;
    await $e6a31eba2ef4ef31$var$completeInstallationRegistration(installationsImpl);
    // At this point we either have a Registered Installation in the DB, or we've
    // already thrown an error.
    const authToken = await $e6a31eba2ef4ef31$var$refreshAuthToken(installationsImpl, forceRefresh);
    return authToken.token;
}
async function $e6a31eba2ef4ef31$var$completeInstallationRegistration(installations) {
    const { registrationPromise: registrationPromise } = await $e6a31eba2ef4ef31$var$getInstallationEntry(installations);
    if (registrationPromise) // A createInstallation request is in progress. Wait until it finishes.
    await registrationPromise;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $e6a31eba2ef4ef31$var$deleteInstallationRequest(appConfig, installationEntry) {
    const endpoint = $e6a31eba2ef4ef31$var$getDeleteEndpoint(appConfig, installationEntry);
    const headers = $e6a31eba2ef4ef31$var$getHeadersWithAuth(appConfig, installationEntry);
    const request = {
        method: 'DELETE',
        headers: headers
    };
    const response = await $e6a31eba2ef4ef31$var$retryIfServerError(()=>fetch(endpoint, request));
    if (!response.ok) throw await $e6a31eba2ef4ef31$var$getErrorFromResponse('Delete Installation', response);
}
function $e6a31eba2ef4ef31$var$getDeleteEndpoint(appConfig, { fid: fid }) {
    return `${$e6a31eba2ef4ef31$var$getInstallationsEndpoint(appConfig)}/${fid}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Deletes the Firebase Installation and all associated data.
 * @param installations - The `Installations` instance.
 *
 * @public
 */ async function $e6a31eba2ef4ef31$export$5f6b87a08674814c(installations) {
    const { appConfig: appConfig } = installations;
    const entry = await $e6a31eba2ef4ef31$var$update(appConfig, (oldEntry)=>{
        if (oldEntry && oldEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) // Delete the unregistered entry without sending a deleteInstallation request.
        return undefined;
        return oldEntry;
    });
    if (entry) {
        if (entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ) // Can't delete while trying to register.
        throw $e6a31eba2ef4ef31$var$ERROR_FACTORY.create("delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */ );
        else if (entry.registrationStatus === 2 /* RequestStatus.COMPLETED */ ) {
            if (!navigator.onLine) throw $e6a31eba2ef4ef31$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ );
            else {
                await $e6a31eba2ef4ef31$var$deleteInstallationRequest(appConfig, entry);
                await $e6a31eba2ef4ef31$var$remove(appConfig);
            }
        }
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sets a new callback that will get called when Installation ID changes.
 * Returns an unsubscribe function that will remove the callback when called.
 * @param installations - The `Installations` instance.
 * @param callback - The callback function that is invoked when FID changes.
 * @returns A function that can be called to unsubscribe.
 *
 * @public
 */ function $e6a31eba2ef4ef31$export$ceb4c11381bc36e8(installations, callback) {
    const { appConfig: appConfig } = installations;
    $e6a31eba2ef4ef31$var$addCallback(appConfig, callback);
    return ()=>{
        $e6a31eba2ef4ef31$var$removeCallback(appConfig, callback);
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an instance of {@link Installations} associated with the given
 * {@link @firebase/app#FirebaseApp} instance.
 * @param app - The {@link @firebase/app#FirebaseApp} instance.
 *
 * @public
 */ function $e6a31eba2ef4ef31$export$9bfc115e43431ff5(app = (0, $1ad63299fe0e9682$export$f9962582c9e66d99)()) {
    const installationsImpl = (0, $1ad63299fe0e9682$export$fa0d6da0f5838f50)(app, 'installations').getImmediate();
    return installationsImpl;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $e6a31eba2ef4ef31$var$extractAppConfig(app) {
    if (!app || !app.options) throw $e6a31eba2ef4ef31$var$getMissingValueError('App Configuration');
    if (!app.name) throw $e6a31eba2ef4ef31$var$getMissingValueError('App Name');
    // Required app config keys
    const configKeys = [
        'projectId',
        'apiKey',
        'appId'
    ];
    for (const keyName of configKeys){
        if (!app.options[keyName]) throw $e6a31eba2ef4ef31$var$getMissingValueError(keyName);
    }
    return {
        appName: app.name,
        projectId: app.options.projectId,
        apiKey: app.options.apiKey,
        appId: app.options.appId
    };
}
function $e6a31eba2ef4ef31$var$getMissingValueError(valueName) {
    return $e6a31eba2ef4ef31$var$ERROR_FACTORY.create("missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ , {
        valueName: valueName
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e6a31eba2ef4ef31$var$INSTALLATIONS_NAME = 'installations';
const $e6a31eba2ef4ef31$var$INSTALLATIONS_NAME_INTERNAL = 'installations-internal';
const $e6a31eba2ef4ef31$var$publicFactory = (container)=>{
    const app = container.getProvider('app').getImmediate();
    // Throws if app isn't configured properly.
    const appConfig = $e6a31eba2ef4ef31$var$extractAppConfig(app);
    const heartbeatServiceProvider = (0, $1ad63299fe0e9682$export$fa0d6da0f5838f50)(app, 'heartbeat');
    const installationsImpl = {
        app: app,
        appConfig: appConfig,
        heartbeatServiceProvider: heartbeatServiceProvider,
        _delete: ()=>Promise.resolve()
    };
    return installationsImpl;
};
const $e6a31eba2ef4ef31$var$internalFactory = (container)=>{
    const app = container.getProvider('app').getImmediate();
    // Internal FIS instance relies on public FIS instance.
    const installations = (0, $1ad63299fe0e9682$export$fa0d6da0f5838f50)(app, $e6a31eba2ef4ef31$var$INSTALLATIONS_NAME).getImmediate();
    const installationsInternal = {
        getId: ()=>$e6a31eba2ef4ef31$export$218c8c3169c024d2(installations),
        getToken: (forceRefresh)=>$e6a31eba2ef4ef31$export$257b2d10b709d8ef(installations, forceRefresh)
    };
    return installationsInternal;
};
function $e6a31eba2ef4ef31$var$registerInstallations() {
    (0, $1ad63299fe0e9682$export$c930050e7bb63965)(new (0, $be24428bd46df3e1$export$16fa2f45be04daa8)($e6a31eba2ef4ef31$var$INSTALLATIONS_NAME, $e6a31eba2ef4ef31$var$publicFactory, "PUBLIC" /* ComponentType.PUBLIC */ ));
    (0, $1ad63299fe0e9682$export$c930050e7bb63965)(new (0, $be24428bd46df3e1$export$16fa2f45be04daa8)($e6a31eba2ef4ef31$var$INSTALLATIONS_NAME_INTERNAL, $e6a31eba2ef4ef31$var$internalFactory, "PRIVATE" /* ComponentType.PRIVATE */ ));
}
/**
 * The Firebase Installations Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */ $e6a31eba2ef4ef31$var$registerInstallations();
(0, $1ad63299fe0e9682$export$d29d5299a7137abc)($e6a31eba2ef4ef31$var$name, $e6a31eba2ef4ef31$var$version);
// BUILD_TARGET will be replaced by values like esm, cjs, etc during the compilation
(0, $1ad63299fe0e9682$export$d29d5299a7137abc)($e6a31eba2ef4ef31$var$name, $e6a31eba2ef4ef31$var$version, 'esm2020');


/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Type constant for Firebase Analytics.
 */ const $a038c313b6ee4f68$var$ANALYTICS_TYPE = 'analytics';
// Key to attach FID to in gtag params.
const $a038c313b6ee4f68$var$GA_FID_KEY = 'firebase_id';
const $a038c313b6ee4f68$var$ORIGIN_KEY = 'origin';
const $a038c313b6ee4f68$var$FETCH_TIMEOUT_MILLIS = 60000;
const $a038c313b6ee4f68$var$DYNAMIC_CONFIG_URL = 'https://firebase.googleapis.com/v1alpha/projects/-/apps/{app-id}/webConfig';
const $a038c313b6ee4f68$var$GTAG_URL = 'https://www.googletagmanager.com/gtag/js';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a038c313b6ee4f68$var$logger = new (0, $6b8f1054ec67b81e$export$efa9a398d6368992)('@firebase/analytics');
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a038c313b6ee4f68$var$ERRORS = {
    ["already-exists" /* AnalyticsError.ALREADY_EXISTS */ ]: "A Firebase Analytics instance with the appId {$id}  already exists. Only one Firebase Analytics instance can be created for each appId.",
    ["already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ ]: "initializeAnalytics() cannot be called again with different options than those it was initially called with. It can be called again with the same options to return the existing instance, or getAnalytics() can be used to get a reference to the already-initialized instance.",
    ["already-initialized-settings" /* AnalyticsError.ALREADY_INITIALIZED_SETTINGS */ ]: "Firebase Analytics has already been initialized.settings() must be called before initializing any Analytics instanceor it will have no effect.",
    ["interop-component-reg-failed" /* AnalyticsError.INTEROP_COMPONENT_REG_FAILED */ ]: 'Firebase Analytics Interop Component failed to instantiate: {$reason}',
    ["invalid-analytics-context" /* AnalyticsError.INVALID_ANALYTICS_CONTEXT */ ]: "Firebase Analytics is not supported in this environment. Wrap initialization of analytics in analytics.isSupported() to prevent initialization in unsupported environments. Details: {$errorInfo}",
    ["indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ ]: "IndexedDB unavailable or restricted in this environment. Wrap initialization of analytics in analytics.isSupported() to prevent initialization in unsupported environments. Details: {$errorInfo}",
    ["fetch-throttle" /* AnalyticsError.FETCH_THROTTLE */ ]: "The config fetch request timed out while in an exponential backoff state. Unix timestamp in milliseconds when fetch request throttling ends: {$throttleEndTimeMillis}.",
    ["config-fetch-failed" /* AnalyticsError.CONFIG_FETCH_FAILED */ ]: 'Dynamic config fetch failed: [{$httpStatus}] {$responseMessage}',
    ["no-api-key" /* AnalyticsError.NO_API_KEY */ ]: 'The "apiKey" field is empty in the local Firebase config. Firebase Analytics requires this field tocontain a valid API key.',
    ["no-app-id" /* AnalyticsError.NO_APP_ID */ ]: 'The "appId" field is empty in the local Firebase config. Firebase Analytics requires this field tocontain a valid app ID.',
    ["no-client-id" /* AnalyticsError.NO_CLIENT_ID */ ]: 'The "client_id" field is empty.',
    ["invalid-gtag-resource" /* AnalyticsError.INVALID_GTAG_RESOURCE */ ]: 'Trusted Types detected an invalid gtag resource: {$gtagURL}.'
};
const $a038c313b6ee4f68$var$ERROR_FACTORY = new (0, $b5eeaa155499f6b0$export$3fa6e1b18a3b2d40)('analytics', 'Analytics', $a038c313b6ee4f68$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Verifies and creates a TrustedScriptURL.
 */ function $a038c313b6ee4f68$var$createGtagTrustedTypesScriptURL(url) {
    if (!url.startsWith($a038c313b6ee4f68$var$GTAG_URL)) {
        const err = $a038c313b6ee4f68$var$ERROR_FACTORY.create("invalid-gtag-resource" /* AnalyticsError.INVALID_GTAG_RESOURCE */ , {
            gtagURL: url
        });
        $a038c313b6ee4f68$var$logger.warn(err.message);
        return '';
    }
    return url;
}
/**
 * Makeshift polyfill for Promise.allSettled(). Resolves when all promises
 * have either resolved or rejected.
 *
 * @param promises Array of promises to wait for.
 */ function $a038c313b6ee4f68$var$promiseAllSettled(promises) {
    return Promise.all(promises.map((promise)=>promise.catch((e)=>e)));
}
/**
 * Creates a TrustedTypePolicy object that implements the rules passed as policyOptions.
 *
 * @param policyName A string containing the name of the policy
 * @param policyOptions Object containing implementations of instance methods for TrustedTypesPolicy, see {@link https://developer.mozilla.org/en-US/docs/Web/API/TrustedTypePolicy#instance_methods
 * | the TrustedTypePolicy reference documentation}.
 */ function $a038c313b6ee4f68$var$createTrustedTypesPolicy(policyName, policyOptions) {
    // Create a TrustedTypes policy that we can use for updating src
    // properties
    let trustedTypesPolicy;
    if (window.trustedTypes) trustedTypesPolicy = window.trustedTypes.createPolicy(policyName, policyOptions);
    return trustedTypesPolicy;
}
/**
 * Inserts gtag script tag into the page to asynchronously download gtag.
 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer").
 */ function $a038c313b6ee4f68$var$insertScriptTag(dataLayerName, measurementId) {
    const trustedTypesPolicy = $a038c313b6ee4f68$var$createTrustedTypesPolicy('firebase-js-sdk-policy', {
        createScriptURL: $a038c313b6ee4f68$var$createGtagTrustedTypesScriptURL
    });
    const script = document.createElement('script');
    // We are not providing an analyticsId in the URL because it would trigger a `page_view`
    // without fid. We will initialize ga-id using gtag (config) command together with fid.
    const gtagScriptURL = `${$a038c313b6ee4f68$var$GTAG_URL}?l=${dataLayerName}&id=${measurementId}`;
    script.src = trustedTypesPolicy ? trustedTypesPolicy?.createScriptURL(gtagScriptURL) : gtagScriptURL;
    script.async = true;
    document.head.appendChild(script);
}
/**
 * Get reference to, or create, global datalayer.
 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer").
 */ function $a038c313b6ee4f68$var$getOrCreateDataLayer(dataLayerName) {
    // Check for existing dataLayer and create if needed.
    let dataLayer = [];
    if (Array.isArray(window[dataLayerName])) dataLayer = window[dataLayerName];
    else window[dataLayerName] = dataLayer;
    return dataLayer;
}
/**
 * Wrapped gtag logic when gtag is called with 'config' command.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 * @param measurementId GA Measurement ID to set config for.
 * @param gtagParams Gtag config params to set.
 */ async function $a038c313b6ee4f68$var$gtagOnConfig(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, measurementId, gtagParams) {
    // If config is already fetched, we know the appId and can use it to look up what FID promise we
    /// are waiting for, and wait only on that one.
    const correspondingAppId = measurementIdToAppId[measurementId];
    try {
        if (correspondingAppId) await initializationPromisesMap[correspondingAppId];
        else {
            // If config is not fetched yet, wait for all configs (we don't know which one we need) and
            // find the appId (if any) corresponding to this measurementId. If there is one, wait on
            // that appId's initialization promise. If there is none, promise resolves and gtag
            // call goes through.
            const dynamicConfigResults = await $a038c313b6ee4f68$var$promiseAllSettled(dynamicConfigPromisesList);
            const foundConfig = dynamicConfigResults.find((config)=>config.measurementId === measurementId);
            if (foundConfig) await initializationPromisesMap[foundConfig.appId];
        }
    } catch (e) {
        $a038c313b6ee4f68$var$logger.error(e);
    }
    gtagCore("config" /* GtagCommand.CONFIG */ , measurementId, gtagParams);
}
/**
 * Wrapped gtag logic when gtag is called with 'event' command.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementId GA Measurement ID to log event to.
 * @param gtagParams Params to log with this event.
 */ async function $a038c313b6ee4f68$var$gtagOnEvent(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementId, gtagParams) {
    try {
        let initializationPromisesToWaitFor = [];
        // If there's a 'send_to' param, check if any ID specified matches
        // an initializeIds() promise we are waiting for.
        if (gtagParams && gtagParams['send_to']) {
            let gaSendToList = gtagParams['send_to'];
            // Make it an array if is isn't, so it can be dealt with the same way.
            if (!Array.isArray(gaSendToList)) gaSendToList = [
                gaSendToList
            ];
            // Checking 'send_to' fields requires having all measurement ID results back from
            // the dynamic config fetch.
            const dynamicConfigResults = await $a038c313b6ee4f68$var$promiseAllSettled(dynamicConfigPromisesList);
            for (const sendToId of gaSendToList){
                // Any fetched dynamic measurement ID that matches this 'send_to' ID
                const foundConfig = dynamicConfigResults.find((config)=>config.measurementId === sendToId);
                const initializationPromise = foundConfig && initializationPromisesMap[foundConfig.appId];
                if (initializationPromise) initializationPromisesToWaitFor.push(initializationPromise);
                else {
                    // Found an item in 'send_to' that is not associated
                    // directly with an FID, possibly a group.  Empty this array,
                    // exit the loop early, and let it get populated below.
                    initializationPromisesToWaitFor = [];
                    break;
                }
            }
        }
        // This will be unpopulated if there was no 'send_to' field , or
        // if not all entries in the 'send_to' field could be mapped to
        // a FID. In these cases, wait on all pending initialization promises.
        if (initializationPromisesToWaitFor.length === 0) /* eslint-disable-next-line @typescript-eslint/no-floating-promises */ initializationPromisesToWaitFor = Object.values(initializationPromisesMap);
        // Run core gtag function with args after all relevant initialization
        // promises have been resolved.
        await Promise.all(initializationPromisesToWaitFor);
        // Workaround for http://b/141370449 - third argument cannot be undefined.
        gtagCore("event" /* GtagCommand.EVENT */ , measurementId, gtagParams || {});
    } catch (e) {
        $a038c313b6ee4f68$var$logger.error(e);
    }
}
/**
 * Wraps a standard gtag function with extra code to wait for completion of
 * relevant initialization promises before sending requests.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 */ function $a038c313b6ee4f68$var$wrapGtag(gtagCore, /**
 * Allows wrapped gtag calls to wait on whichever initialization promises are required,
 * depending on the contents of the gtag params' `send_to` field, if any.
 */ initializationPromisesMap, /**
 * Wrapped gtag calls sometimes require all dynamic config fetches to have returned
 * before determining what initialization promises (which include FIDs) to wait for.
 */ dynamicConfigPromisesList, /**
 * Wrapped gtag config calls can narrow down which initialization promise (with FID)
 * to wait for if the measurementId is already fetched, by getting the corresponding appId,
 * which is the key for the initialization promises map.
 */ measurementIdToAppId) {
    /**
     * Wrapper around gtag that ensures FID is sent with gtag calls.
     * @param command Gtag command type.
     * @param idOrNameOrParams Measurement ID if command is EVENT/CONFIG, params if command is SET.
     * @param gtagParams Params if event is EVENT/CONFIG.
     */ async function gtagWrapper(command, ...args) {
        try {
            // If event, check that relevant initialization promises have completed.
            if (command === "event" /* GtagCommand.EVENT */ ) {
                const [measurementId, gtagParams] = args;
                // If EVENT, second arg must be measurementId.
                await $a038c313b6ee4f68$var$gtagOnEvent(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementId, gtagParams);
            } else if (command === "config" /* GtagCommand.CONFIG */ ) {
                const [measurementId, gtagParams] = args;
                // If CONFIG, second arg must be measurementId.
                await $a038c313b6ee4f68$var$gtagOnConfig(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, measurementId, gtagParams);
            } else if (command === "consent" /* GtagCommand.CONSENT */ ) {
                const [consentAction, gtagParams] = args;
                // consentAction can be one of 'default' or 'update'.
                gtagCore("consent" /* GtagCommand.CONSENT */ , consentAction, gtagParams);
            } else if (command === "get" /* GtagCommand.GET */ ) {
                const [measurementId, fieldName, callback] = args;
                gtagCore("get" /* GtagCommand.GET */ , measurementId, fieldName, callback);
            } else if (command === "set" /* GtagCommand.SET */ ) {
                const [customParams] = args;
                // If SET, second arg must be params.
                gtagCore("set" /* GtagCommand.SET */ , customParams);
            } else gtagCore(command, ...args);
        } catch (e) {
            $a038c313b6ee4f68$var$logger.error(e);
        }
    }
    return gtagWrapper;
}
/**
 * Creates global gtag function or wraps existing one if found.
 * This wrapped function attaches Firebase instance ID (FID) to gtag 'config' and
 * 'event' calls that belong to the GAID associated with this Firebase instance.
 *
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 * @param dataLayerName Name of global GA datalayer array.
 * @param gtagFunctionName Name of global gtag function ("gtag" if not user-specified).
 */ function $a038c313b6ee4f68$var$wrapOrCreateGtag(initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, dataLayerName, gtagFunctionName) {
    // Create a basic core gtag function
    let gtagCore = function(..._args) {
        // Must push IArguments object, not an array.
        window[dataLayerName].push(arguments);
    };
    // Replace it with existing one if found
    if (window[gtagFunctionName] && typeof window[gtagFunctionName] === 'function') // @ts-ignore
    gtagCore = window[gtagFunctionName];
    window[gtagFunctionName] = $a038c313b6ee4f68$var$wrapGtag(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId);
    return {
        gtagCore: gtagCore,
        wrappedGtag: window[gtagFunctionName]
    };
}
/**
 * Returns the script tag in the DOM matching both the gtag url pattern
 * and the provided data layer name.
 */ function $a038c313b6ee4f68$var$findGtagScriptOnPage(dataLayerName) {
    const scriptTags = window.document.getElementsByTagName('script');
    for (const tag of Object.values(scriptTags)){
        if (tag.src && tag.src.includes($a038c313b6ee4f68$var$GTAG_URL) && tag.src.includes(dataLayerName)) return tag;
    }
    return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Backoff factor for 503 errors, which we want to be conservative about
 * to avoid overloading servers. Each retry interval will be
 * BASE_INTERVAL_MILLIS * LONG_RETRY_FACTOR ^ retryCount, so the second one
 * will be ~30 seconds (with fuzzing).
 */ const $a038c313b6ee4f68$var$LONG_RETRY_FACTOR = 30;
/**
 * Base wait interval to multiplied by backoffFactor^backoffCount.
 */ const $a038c313b6ee4f68$var$BASE_INTERVAL_MILLIS = 1000;
/**
 * Stubbable retry data storage class.
 */ class $a038c313b6ee4f68$var$RetryData {
    constructor(throttleMetadata = {}, intervalMillis = $a038c313b6ee4f68$var$BASE_INTERVAL_MILLIS){
        this.throttleMetadata = throttleMetadata;
        this.intervalMillis = intervalMillis;
    }
    getThrottleMetadata(appId) {
        return this.throttleMetadata[appId];
    }
    setThrottleMetadata(appId, metadata) {
        this.throttleMetadata[appId] = metadata;
    }
    deleteThrottleMetadata(appId) {
        delete this.throttleMetadata[appId];
    }
}
const $a038c313b6ee4f68$var$defaultRetryData = new $a038c313b6ee4f68$var$RetryData();
/**
 * Set GET request headers.
 * @param apiKey App API key.
 */ function $a038c313b6ee4f68$var$getHeaders(apiKey) {
    return new Headers({
        Accept: 'application/json',
        'x-goog-api-key': apiKey
    });
}
/**
 * Fetches dynamic config from backend.
 * @param app Firebase app to fetch config for.
 */ async function $a038c313b6ee4f68$var$fetchDynamicConfig(appFields) {
    const { appId: appId, apiKey: apiKey } = appFields;
    const request = {
        method: 'GET',
        headers: $a038c313b6ee4f68$var$getHeaders(apiKey)
    };
    const appUrl = $a038c313b6ee4f68$var$DYNAMIC_CONFIG_URL.replace('{app-id}', appId);
    const response = await fetch(appUrl, request);
    if (response.status !== 200 && response.status !== 304) {
        let errorMessage = '';
        try {
            // Try to get any error message text from server response.
            const jsonResponse = await response.json();
            if (jsonResponse.error?.message) errorMessage = jsonResponse.error.message;
        } catch (_ignored) {}
        throw $a038c313b6ee4f68$var$ERROR_FACTORY.create("config-fetch-failed" /* AnalyticsError.CONFIG_FETCH_FAILED */ , {
            httpStatus: response.status,
            responseMessage: errorMessage
        });
    }
    return response.json();
}
/**
 * Fetches dynamic config from backend, retrying if failed.
 * @param app Firebase app to fetch config for.
 */ async function $a038c313b6ee4f68$var$fetchDynamicConfigWithRetry(app, // retryData and timeoutMillis are parameterized to allow passing a different value for testing.
retryData = $a038c313b6ee4f68$var$defaultRetryData, timeoutMillis) {
    const { appId: appId, apiKey: apiKey, measurementId: measurementId } = app.options;
    if (!appId) throw $a038c313b6ee4f68$var$ERROR_FACTORY.create("no-app-id" /* AnalyticsError.NO_APP_ID */ );
    if (!apiKey) {
        if (measurementId) return {
            measurementId: measurementId,
            appId: appId
        };
        throw $a038c313b6ee4f68$var$ERROR_FACTORY.create("no-api-key" /* AnalyticsError.NO_API_KEY */ );
    }
    const throttleMetadata = retryData.getThrottleMetadata(appId) || {
        backoffCount: 0,
        throttleEndTimeMillis: Date.now()
    };
    const signal = new $a038c313b6ee4f68$var$AnalyticsAbortSignal();
    setTimeout(async ()=>{
        // Note a very low delay, eg < 10ms, can elapse before listeners are initialized.
        signal.abort();
    }, timeoutMillis !== undefined ? timeoutMillis : $a038c313b6ee4f68$var$FETCH_TIMEOUT_MILLIS);
    return $a038c313b6ee4f68$var$attemptFetchDynamicConfigWithRetry({
        appId: appId,
        apiKey: apiKey,
        measurementId: measurementId
    }, throttleMetadata, signal, retryData);
}
/**
 * Runs one retry attempt.
 * @param appFields Necessary app config fields.
 * @param throttleMetadata Ongoing metadata to determine throttling times.
 * @param signal Abort signal.
 */ async function $a038c313b6ee4f68$var$attemptFetchDynamicConfigWithRetry(appFields, { throttleEndTimeMillis: throttleEndTimeMillis, backoffCount: backoffCount }, signal, retryData = $a038c313b6ee4f68$var$defaultRetryData // for testing
) {
    const { appId: appId, measurementId: measurementId } = appFields;
    // Starts with a (potentially zero) timeout to support resumption from stored state.
    // Ensures the throttle end time is honored if the last attempt timed out.
    // Note the SDK will never make a request if the fetch timeout expires at this point.
    try {
        await $a038c313b6ee4f68$var$setAbortableTimeout(signal, throttleEndTimeMillis);
    } catch (e) {
        if (measurementId) {
            $a038c313b6ee4f68$var$logger.warn(`Timed out fetching this Firebase app's measurement ID from the server.` + ` Falling back to the measurement ID ${measurementId}` + ` provided in the "measurementId" field in the local Firebase config. [${e?.message}]`);
            return {
                appId: appId,
                measurementId: measurementId
            };
        }
        throw e;
    }
    try {
        const response = await $a038c313b6ee4f68$var$fetchDynamicConfig(appFields);
        // Note the SDK only clears throttle state if response is success or non-retriable.
        retryData.deleteThrottleMetadata(appId);
        return response;
    } catch (e) {
        const error = e;
        if (!$a038c313b6ee4f68$var$isRetriableError(error)) {
            retryData.deleteThrottleMetadata(appId);
            if (measurementId) {
                $a038c313b6ee4f68$var$logger.warn(`Failed to fetch this Firebase app's measurement ID from the server.` + ` Falling back to the measurement ID ${measurementId}` + ` provided in the "measurementId" field in the local Firebase config. [${error?.message}]`);
                return {
                    appId: appId,
                    measurementId: measurementId
                };
            } else throw e;
        }
        const backoffMillis = Number(error?.customData?.httpStatus) === 503 ? (0, $b5eeaa155499f6b0$export$4d810c0ca64ed8e9)(backoffCount, retryData.intervalMillis, $a038c313b6ee4f68$var$LONG_RETRY_FACTOR) : (0, $b5eeaa155499f6b0$export$4d810c0ca64ed8e9)(backoffCount, retryData.intervalMillis);
        // Increments backoff state.
        const throttleMetadata = {
            throttleEndTimeMillis: Date.now() + backoffMillis,
            backoffCount: backoffCount + 1
        };
        // Persists state.
        retryData.setThrottleMetadata(appId, throttleMetadata);
        $a038c313b6ee4f68$var$logger.debug(`Calling attemptFetch again in ${backoffMillis} millis`);
        return $a038c313b6ee4f68$var$attemptFetchDynamicConfigWithRetry(appFields, throttleMetadata, signal, retryData);
    }
}
/**
 * Supports waiting on a backoff by:
 *
 * <ul>
 *   <li>Promisifying setTimeout, so we can set a timeout in our Promise chain</li>
 *   <li>Listening on a signal bus for abort events, just like the Fetch API</li>
 *   <li>Failing in the same way the Fetch API fails, so timing out a live request and a throttled
 *       request appear the same.</li>
 * </ul>
 *
 * <p>Visible for testing.
 */ function $a038c313b6ee4f68$var$setAbortableTimeout(signal, throttleEndTimeMillis) {
    return new Promise((resolve, reject)=>{
        // Derives backoff from given end time, normalizing negative numbers to zero.
        const backoffMillis = Math.max(throttleEndTimeMillis - Date.now(), 0);
        const timeout = setTimeout(resolve, backoffMillis);
        // Adds listener, rather than sets onabort, because signal is a shared object.
        signal.addEventListener(()=>{
            clearTimeout(timeout);
            // If the request completes before this timeout, the rejection has no effect.
            reject($a038c313b6ee4f68$var$ERROR_FACTORY.create("fetch-throttle" /* AnalyticsError.FETCH_THROTTLE */ , {
                throttleEndTimeMillis: throttleEndTimeMillis
            }));
        });
    });
}
/**
 * Returns true if the {@link Error} indicates a fetch request may succeed later.
 */ function $a038c313b6ee4f68$var$isRetriableError(e) {
    if (!(e instanceof (0, $b5eeaa155499f6b0$export$dd24e9cd51226c56)) || !e.customData) return false;
    // Uses string index defined by ErrorData, which FirebaseError implements.
    const httpStatus = Number(e.customData['httpStatus']);
    return httpStatus === 429 || httpStatus === 500 || httpStatus === 503 || httpStatus === 504;
}
/**
 * Shims a minimal AbortSignal (copied from Remote Config).
 *
 * <p>AbortController's AbortSignal conveniently decouples fetch timeout logic from other aspects
 * of networking, such as retries. Firebase doesn't use AbortController enough to justify a
 * polyfill recommendation, like we do with the Fetch API, but this minimal shim can easily be
 * swapped out if/when we do.
 */ class $a038c313b6ee4f68$var$AnalyticsAbortSignal {
    constructor(){
        this.listeners = [];
    }
    addEventListener(listener) {
        this.listeners.push(listener);
    }
    abort() {
        this.listeners.forEach((listener)=>listener());
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Event parameters to set on 'gtag' during initialization.
 */ let $a038c313b6ee4f68$var$defaultEventParametersForInit;
/**
 * Logs an analytics event through the Firebase SDK.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param eventName Google Analytics event name, choose from standard list or use a custom string.
 * @param eventParams Analytics event parameters.
 */ async function $a038c313b6ee4f68$var$logEvent$1(gtagFunction, initializationPromise, eventName, eventParams, options) {
    if (options && options.global) {
        gtagFunction("event" /* GtagCommand.EVENT */ , eventName, eventParams);
        return;
    } else {
        const measurementId = await initializationPromise;
        const params = {
            ...eventParams,
            'send_to': measurementId
        };
        gtagFunction("event" /* GtagCommand.EVENT */ , eventName, params);
    }
}
/**
 * Set screen_name parameter for this Google Analytics ID.
 *
 * @deprecated Use {@link logEvent} with `eventName` as 'screen_view' and add relevant `eventParams`.
 * See {@link https://firebase.google.com/docs/analytics/screenviews | Track Screenviews}.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param screenName Screen name string to set.
 */ async function $a038c313b6ee4f68$var$setCurrentScreen$1(gtagFunction, initializationPromise, screenName, options) {
    if (options && options.global) {
        gtagFunction("set" /* GtagCommand.SET */ , {
            'screen_name': screenName
        });
        return Promise.resolve();
    } else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
            update: true,
            'screen_name': screenName
        });
    }
}
/**
 * Set user_id parameter for this Google Analytics ID.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param id User ID string to set
 */ async function $a038c313b6ee4f68$var$setUserId$1(gtagFunction, initializationPromise, id, options) {
    if (options && options.global) {
        gtagFunction("set" /* GtagCommand.SET */ , {
            'user_id': id
        });
        return Promise.resolve();
    } else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
            update: true,
            'user_id': id
        });
    }
}
/**
 * Set all other user properties other than user_id and screen_name.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param properties Map of user properties to set
 */ async function $a038c313b6ee4f68$var$setUserProperties$1(gtagFunction, initializationPromise, properties, options) {
    if (options && options.global) {
        const flatProperties = {};
        for (const key of Object.keys(properties))// use dot notation for merge behavior in gtag.js
        flatProperties[`user_properties.${key}`] = properties[key];
        gtagFunction("set" /* GtagCommand.SET */ , flatProperties);
        return Promise.resolve();
    } else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
            update: true,
            'user_properties': properties
        });
    }
}
/**
 * Retrieves a unique Google Analytics identifier for the web client.
 * See {@link https://developers.google.com/analytics/devguides/collection/ga4/reference/config#client_id | client_id}.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 */ async function $a038c313b6ee4f68$var$internalGetGoogleAnalyticsClientId(gtagFunction, initializationPromise) {
    const measurementId = await initializationPromise;
    return new Promise((resolve, reject)=>{
        gtagFunction("get" /* GtagCommand.GET */ , measurementId, 'client_id', (clientId)=>{
            if (!clientId) reject($a038c313b6ee4f68$var$ERROR_FACTORY.create("no-client-id" /* AnalyticsError.NO_CLIENT_ID */ ));
            resolve(clientId);
        });
    });
}
/**
 * Set whether collection is enabled for this ID.
 *
 * @param enabled If true, collection is enabled for this ID.
 */ async function $a038c313b6ee4f68$var$setAnalyticsCollectionEnabled$1(initializationPromise, enabled) {
    const measurementId = await initializationPromise;
    window[`ga-disable-${measurementId}`] = !enabled;
}
/**
 * Consent parameters to default to during 'gtag' initialization.
 */ let $a038c313b6ee4f68$var$defaultConsentSettingsForInit;
/**
 * Sets the variable {@link defaultConsentSettingsForInit} for use in the initialization of
 * analytics.
 *
 * @param consentSettings Maps the applicable end user consent state for gtag.js.
 */ function $a038c313b6ee4f68$var$_setConsentDefaultForInit(consentSettings) {
    $a038c313b6ee4f68$var$defaultConsentSettingsForInit = consentSettings;
}
/**
 * Sets the variable `defaultEventParametersForInit` for use in the initialization of
 * analytics.
 *
 * @param customParams Any custom params the user may pass to gtag.js.
 */ function $a038c313b6ee4f68$var$_setDefaultEventParametersForInit(customParams) {
    $a038c313b6ee4f68$var$defaultEventParametersForInit = customParams;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $a038c313b6ee4f68$var$validateIndexedDB() {
    if (!(0, $b5eeaa155499f6b0$export$3865db50535c2055)()) {
        $a038c313b6ee4f68$var$logger.warn($a038c313b6ee4f68$var$ERROR_FACTORY.create("indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ , {
            errorInfo: 'IndexedDB is not available in this environment.'
        }).message);
        return false;
    } else try {
        await (0, $b5eeaa155499f6b0$export$a8a3018f3d187a4d)();
    } catch (e) {
        $a038c313b6ee4f68$var$logger.warn($a038c313b6ee4f68$var$ERROR_FACTORY.create("indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ , {
            errorInfo: e?.toString()
        }).message);
        return false;
    }
    return true;
}
/**
 * Initialize the analytics instance in gtag.js by calling config command with fid.
 *
 * NOTE: We combine analytics initialization and setting fid together because we want fid to be
 * part of the `page_view` event that's sent during the initialization
 * @param app Firebase app
 * @param gtagCore The gtag function that's not wrapped.
 * @param dynamicConfigPromisesList Array of all dynamic config promises.
 * @param measurementIdToAppId Maps measurementID to appID.
 * @param installations _FirebaseInstallationsInternal instance.
 *
 * @returns Measurement ID.
 */ async function $a038c313b6ee4f68$var$_initializeAnalytics(app, dynamicConfigPromisesList, measurementIdToAppId, installations, gtagCore, dataLayerName, options) {
    const dynamicConfigPromise = $a038c313b6ee4f68$var$fetchDynamicConfigWithRetry(app);
    // Once fetched, map measurementIds to appId, for ease of lookup in wrapped gtag function.
    dynamicConfigPromise.then((config)=>{
        measurementIdToAppId[config.measurementId] = config.appId;
        if (app.options.measurementId && config.measurementId !== app.options.measurementId) $a038c313b6ee4f68$var$logger.warn(`The measurement ID in the local Firebase config (${app.options.measurementId})` + ` does not match the measurement ID fetched from the server (${config.measurementId}).` + ` To ensure analytics events are always sent to the correct Analytics property,` + ` update the` + ` measurement ID field in the local config or remove it from the local config.`);
    }).catch((e)=>$a038c313b6ee4f68$var$logger.error(e));
    // Add to list to track state of all dynamic config promises.
    dynamicConfigPromisesList.push(dynamicConfigPromise);
    const fidPromise = $a038c313b6ee4f68$var$validateIndexedDB().then((envIsValid)=>{
        if (envIsValid) return installations.getId();
        else return undefined;
    });
    const [dynamicConfig, fid] = await Promise.all([
        dynamicConfigPromise,
        fidPromise
    ]);
    // Detect if user has already put the gtag <script> tag on this page with the passed in
    // data layer name.
    if (!$a038c313b6ee4f68$var$findGtagScriptOnPage(dataLayerName)) $a038c313b6ee4f68$var$insertScriptTag(dataLayerName, dynamicConfig.measurementId);
    // Detects if there are consent settings that need to be configured.
    if ($a038c313b6ee4f68$var$defaultConsentSettingsForInit) {
        gtagCore("consent" /* GtagCommand.CONSENT */ , 'default', $a038c313b6ee4f68$var$defaultConsentSettingsForInit);
        $a038c313b6ee4f68$var$_setConsentDefaultForInit(undefined);
    }
    // This command initializes gtag.js and only needs to be called once for the entire web app,
    // but since it is idempotent, we can call it multiple times.
    // We keep it together with other initialization logic for better code structure.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    gtagCore('js', new Date());
    // User config added first. We don't want users to accidentally overwrite
    // base Firebase config properties.
    const configProperties = options?.config ?? {};
    // guard against developers accidentally setting properties with prefix `firebase_`
    configProperties[$a038c313b6ee4f68$var$ORIGIN_KEY] = 'firebase';
    configProperties.update = true;
    if (fid != null) configProperties[$a038c313b6ee4f68$var$GA_FID_KEY] = fid;
    // It should be the first config command called on this GA-ID
    // Initialize this GA-ID and set FID on it using the gtag config API.
    // Note: This will trigger a page_view event unless 'send_page_view' is set to false in
    // `configProperties`.
    gtagCore("config" /* GtagCommand.CONFIG */ , dynamicConfig.measurementId, configProperties);
    // Detects if there is data that will be set on every event logged from the SDK.
    if ($a038c313b6ee4f68$var$defaultEventParametersForInit) {
        gtagCore("set" /* GtagCommand.SET */ , $a038c313b6ee4f68$var$defaultEventParametersForInit);
        $a038c313b6ee4f68$var$_setDefaultEventParametersForInit(undefined);
    }
    return dynamicConfig.measurementId;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Analytics Service class.
 */ class $a038c313b6ee4f68$var$AnalyticsService {
    constructor(app){
        this.app = app;
    }
    _delete() {
        delete $a038c313b6ee4f68$var$initializationPromisesMap[this.app.options.appId];
        return Promise.resolve();
    }
}
/**
 * Maps appId to full initialization promise. Wrapped gtag calls must wait on
 * all or some of these, depending on the call's `send_to` param and the status
 * of the dynamic config fetches (see below).
 */ let $a038c313b6ee4f68$var$initializationPromisesMap = {};
/**
 * List of dynamic config fetch promises. In certain cases, wrapped gtag calls
 * wait on all these to be complete in order to determine if it can selectively
 * wait for only certain initialization (FID) promises or if it must wait for all.
 */ let $a038c313b6ee4f68$var$dynamicConfigPromisesList = [];
/**
 * Maps fetched measurementIds to appId. Populated when the app's dynamic config
 * fetch completes. If already populated, gtag config calls can use this to
 * selectively wait for only this app's initialization promise (FID) instead of all
 * initialization promises.
 */ const $a038c313b6ee4f68$var$measurementIdToAppId = {};
/**
 * Name for window global data layer array used by GA: defaults to 'dataLayer'.
 */ let $a038c313b6ee4f68$var$dataLayerName = 'dataLayer';
/**
 * Name for window global gtag function used by GA: defaults to 'gtag'.
 */ let $a038c313b6ee4f68$var$gtagName = 'gtag';
/**
 * Reproduction of standard gtag function or reference to existing
 * gtag function on window object.
 */ let $a038c313b6ee4f68$var$gtagCoreFunction;
/**
 * Wrapper around gtag function that ensures FID is sent with all
 * relevant event and config calls.
 */ let $a038c313b6ee4f68$var$wrappedGtagFunction;
/**
 * Flag to ensure page initialization steps (creation or wrapping of
 * dataLayer and gtag script) are only run once per page load.
 */ let $a038c313b6ee4f68$var$globalInitDone = false;
/**
 * Configures Firebase Analytics to use custom `gtag` or `dataLayer` names.
 * Intended to be used if `gtag.js` script has been installed on
 * this page independently of Firebase Analytics, and is using non-default
 * names for either the `gtag` function or for `dataLayer`.
 * Must be called before calling `getAnalytics()` or it won't
 * have any effect.
 *
 * @public
 *
 * @param options - Custom gtag and dataLayer names.
 */ function $a038c313b6ee4f68$export$a5a6e0b888b2c992(options) {
    if ($a038c313b6ee4f68$var$globalInitDone) throw $a038c313b6ee4f68$var$ERROR_FACTORY.create("already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ );
    if (options.dataLayerName) $a038c313b6ee4f68$var$dataLayerName = options.dataLayerName;
    if (options.gtagName) $a038c313b6ee4f68$var$gtagName = options.gtagName;
}
/**
 * Returns true if no environment mismatch is found.
 * If environment mismatches are found, throws an INVALID_ANALYTICS_CONTEXT
 * error that also lists details for each mismatch found.
 */ function $a038c313b6ee4f68$var$warnOnBrowserContextMismatch() {
    const mismatchedEnvMessages = [];
    if ((0, $b5eeaa155499f6b0$export$caa8774a9107a58e)()) mismatchedEnvMessages.push('This is a browser extension environment.');
    if (!(0, $b5eeaa155499f6b0$export$f172b7eb6cf60599)()) mismatchedEnvMessages.push('Cookies are not available.');
    if (mismatchedEnvMessages.length > 0) {
        const details = mismatchedEnvMessages.map((message, index)=>`(${index + 1}) ${message}`).join(' ');
        const err = $a038c313b6ee4f68$var$ERROR_FACTORY.create("invalid-analytics-context" /* AnalyticsError.INVALID_ANALYTICS_CONTEXT */ , {
            errorInfo: details
        });
        $a038c313b6ee4f68$var$logger.warn(err.message);
    }
}
/**
 * Analytics instance factory.
 * @internal
 */ function $a038c313b6ee4f68$var$factory(app, installations, options) {
    $a038c313b6ee4f68$var$warnOnBrowserContextMismatch();
    const appId = app.options.appId;
    if (!appId) throw $a038c313b6ee4f68$var$ERROR_FACTORY.create("no-app-id" /* AnalyticsError.NO_APP_ID */ );
    if (!app.options.apiKey) {
        if (app.options.measurementId) $a038c313b6ee4f68$var$logger.warn(`The "apiKey" field is empty in the local Firebase config. This is needed to fetch the latest` + ` measurement ID for this Firebase app. Falling back to the measurement ID ${app.options.measurementId}` + ` provided in the "measurementId" field in the local Firebase config.`);
        else throw $a038c313b6ee4f68$var$ERROR_FACTORY.create("no-api-key" /* AnalyticsError.NO_API_KEY */ );
    }
    if ($a038c313b6ee4f68$var$initializationPromisesMap[appId] != null) throw $a038c313b6ee4f68$var$ERROR_FACTORY.create("already-exists" /* AnalyticsError.ALREADY_EXISTS */ , {
        id: appId
    });
    if (!$a038c313b6ee4f68$var$globalInitDone) {
        // Steps here should only be done once per page: creation or wrapping
        // of dataLayer and global gtag function.
        $a038c313b6ee4f68$var$getOrCreateDataLayer($a038c313b6ee4f68$var$dataLayerName);
        const { wrappedGtag: wrappedGtag, gtagCore: gtagCore } = $a038c313b6ee4f68$var$wrapOrCreateGtag($a038c313b6ee4f68$var$initializationPromisesMap, $a038c313b6ee4f68$var$dynamicConfigPromisesList, $a038c313b6ee4f68$var$measurementIdToAppId, $a038c313b6ee4f68$var$dataLayerName, $a038c313b6ee4f68$var$gtagName);
        $a038c313b6ee4f68$var$wrappedGtagFunction = wrappedGtag;
        $a038c313b6ee4f68$var$gtagCoreFunction = gtagCore;
        $a038c313b6ee4f68$var$globalInitDone = true;
    }
    // Async but non-blocking.
    // This map reflects the completion state of all promises for each appId.
    $a038c313b6ee4f68$var$initializationPromisesMap[appId] = $a038c313b6ee4f68$var$_initializeAnalytics(app, $a038c313b6ee4f68$var$dynamicConfigPromisesList, $a038c313b6ee4f68$var$measurementIdToAppId, installations, $a038c313b6ee4f68$var$gtagCoreFunction, $a038c313b6ee4f68$var$dataLayerName, options);
    const analyticsInstance = new $a038c313b6ee4f68$var$AnalyticsService(app);
    return analyticsInstance;
}
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Returns an {@link Analytics} instance for the given app.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ function $a038c313b6ee4f68$export$b0297573c90085aa(app = (0, $1ad63299fe0e9682$export$f9962582c9e66d99)()) {
    app = (0, $b5eeaa155499f6b0$export$4befe9b5fa509a1b)(app);
    // Dependencies
    const analyticsProvider = (0, $1ad63299fe0e9682$export$fa0d6da0f5838f50)(app, $a038c313b6ee4f68$var$ANALYTICS_TYPE);
    if (analyticsProvider.isInitialized()) return analyticsProvider.getImmediate();
    return $a038c313b6ee4f68$export$e1ffb6ba450b0317(app);
}
/**
 * Returns an {@link Analytics} instance for the given app.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ function $a038c313b6ee4f68$export$e1ffb6ba450b0317(app, options = {}) {
    // Dependencies
    const analyticsProvider = (0, $1ad63299fe0e9682$export$fa0d6da0f5838f50)(app, $a038c313b6ee4f68$var$ANALYTICS_TYPE);
    if (analyticsProvider.isInitialized()) {
        const existingInstance = analyticsProvider.getImmediate();
        if ((0, $b5eeaa155499f6b0$export$9cb4719e2e525b7a)(options, analyticsProvider.getOptions())) return existingInstance;
        else throw $a038c313b6ee4f68$var$ERROR_FACTORY.create("already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ );
    }
    const analyticsInstance = analyticsProvider.initialize({
        options: options
    });
    return analyticsInstance;
}
/**
 * This is a public static method provided to users that wraps four different checks:
 *
 * 1. Check if it's not a browser extension environment.
 * 2. Check if cookies are enabled in current browser.
 * 3. Check if IndexedDB is supported by the browser environment.
 * 4. Check if the current browser context is valid for using `IndexedDB.open()`.
 *
 * @public
 *
 */ async function $a038c313b6ee4f68$export$48c17662a6902497() {
    if ((0, $b5eeaa155499f6b0$export$caa8774a9107a58e)()) return false;
    if (!(0, $b5eeaa155499f6b0$export$f172b7eb6cf60599)()) return false;
    if (!(0, $b5eeaa155499f6b0$export$3865db50535c2055)()) return false;
    try {
        const isDBOpenable = await (0, $b5eeaa155499f6b0$export$a8a3018f3d187a4d)();
        return isDBOpenable;
    } catch (error) {
        return false;
    }
}
/**
 * Use gtag `config` command to set `screen_name`.
 *
 * @public
 *
 * @deprecated Use {@link logEvent} with `eventName` as 'screen_view' and add relevant `eventParams`.
 * See {@link https://firebase.google.com/docs/analytics/screenviews | Track Screenviews}.
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param screenName - Screen name to set.
 */ function $a038c313b6ee4f68$export$a364c5ef84862575(analyticsInstance, screenName, options) {
    analyticsInstance = (0, $b5eeaa155499f6b0$export$4befe9b5fa509a1b)(analyticsInstance);
    $a038c313b6ee4f68$var$setCurrentScreen$1($a038c313b6ee4f68$var$wrappedGtagFunction, $a038c313b6ee4f68$var$initializationPromisesMap[analyticsInstance.app.options.appId], screenName, options).catch((e)=>$a038c313b6ee4f68$var$logger.error(e));
}
/**
 * Retrieves a unique Google Analytics identifier for the web client.
 * See {@link https://developers.google.com/analytics/devguides/collection/ga4/reference/config#client_id | client_id}.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ async function $a038c313b6ee4f68$export$108b704ce5c937fe(analyticsInstance) {
    analyticsInstance = (0, $b5eeaa155499f6b0$export$4befe9b5fa509a1b)(analyticsInstance);
    return $a038c313b6ee4f68$var$internalGetGoogleAnalyticsClientId($a038c313b6ee4f68$var$wrappedGtagFunction, $a038c313b6ee4f68$var$initializationPromisesMap[analyticsInstance.app.options.appId]);
}
/**
 * Use gtag `config` command to set `user_id`.
 *
 * @public
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param id - User ID to set.
 */ function $a038c313b6ee4f68$export$7f5abdb7f5093137(analyticsInstance, id, options) {
    analyticsInstance = (0, $b5eeaa155499f6b0$export$4befe9b5fa509a1b)(analyticsInstance);
    $a038c313b6ee4f68$var$setUserId$1($a038c313b6ee4f68$var$wrappedGtagFunction, $a038c313b6ee4f68$var$initializationPromisesMap[analyticsInstance.app.options.appId], id, options).catch((e)=>$a038c313b6ee4f68$var$logger.error(e));
}
/**
 * Use gtag `config` command to set all params specified.
 *
 * @public
 */ function $a038c313b6ee4f68$export$d0e176862bf869b8(analyticsInstance, properties, options) {
    analyticsInstance = (0, $b5eeaa155499f6b0$export$4befe9b5fa509a1b)(analyticsInstance);
    $a038c313b6ee4f68$var$setUserProperties$1($a038c313b6ee4f68$var$wrappedGtagFunction, $a038c313b6ee4f68$var$initializationPromisesMap[analyticsInstance.app.options.appId], properties, options).catch((e)=>$a038c313b6ee4f68$var$logger.error(e));
}
/**
 * Sets whether Google Analytics collection is enabled for this app on this device.
 * Sets global `window['ga-disable-analyticsId'] = true;`
 *
 * @public
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param enabled - If true, enables collection, if false, disables it.
 */ function $a038c313b6ee4f68$export$7d544a250c4ed423(analyticsInstance, enabled) {
    analyticsInstance = (0, $b5eeaa155499f6b0$export$4befe9b5fa509a1b)(analyticsInstance);
    $a038c313b6ee4f68$var$setAnalyticsCollectionEnabled$1($a038c313b6ee4f68$var$initializationPromisesMap[analyticsInstance.app.options.appId], enabled).catch((e)=>$a038c313b6ee4f68$var$logger.error(e));
}
/**
 * Adds data that will be set on every event logged from the SDK, including automatic ones.
 * With gtag's "set" command, the values passed persist on the current page and are passed with
 * all subsequent events.
 * @public
 * @param customParams - Any custom params the user may pass to gtag.js.
 */ function $a038c313b6ee4f68$export$9bde4a1551d6c3ba(customParams) {
    // Check if reference to existing gtag function on window object exists
    if ($a038c313b6ee4f68$var$wrappedGtagFunction) $a038c313b6ee4f68$var$wrappedGtagFunction("set" /* GtagCommand.SET */ , customParams);
    else $a038c313b6ee4f68$var$_setDefaultEventParametersForInit(customParams);
}
/**
 * Sends a Google Analytics event with given `eventParams`. This method
 * automatically associates this logged event with this Firebase web
 * app instance on this device.
 * List of official event parameters can be found in the gtag.js
 * reference documentation:
 * {@link https://developers.google.com/gtagjs/reference/ga4-events
 * | the GA4 reference documentation}.
 *
 * @public
 */ function $a038c313b6ee4f68$export$5e9eec8001665ac5(analyticsInstance, eventName, eventParams, options) {
    analyticsInstance = (0, $b5eeaa155499f6b0$export$4befe9b5fa509a1b)(analyticsInstance);
    $a038c313b6ee4f68$var$logEvent$1($a038c313b6ee4f68$var$wrappedGtagFunction, $a038c313b6ee4f68$var$initializationPromisesMap[analyticsInstance.app.options.appId], eventName, eventParams, options).catch((e)=>$a038c313b6ee4f68$var$logger.error(e));
}
/**
 * Sets the applicable end user consent state for this web app across all gtag references once
 * Firebase Analytics is initialized.
 *
 * Use the {@link ConsentSettings} to specify individual consent type values. By default consent
 * types are set to "granted".
 * @public
 * @param consentSettings - Maps the applicable end user consent state for gtag.js.
 */ function $a038c313b6ee4f68$export$ff06c4c0781050d7(consentSettings) {
    // Check if reference to existing gtag function on window object exists
    if ($a038c313b6ee4f68$var$wrappedGtagFunction) $a038c313b6ee4f68$var$wrappedGtagFunction("consent" /* GtagCommand.CONSENT */ , 'update', consentSettings);
    else $a038c313b6ee4f68$var$_setConsentDefaultForInit(consentSettings);
}
const $a038c313b6ee4f68$var$name = "@firebase/analytics";
const $a038c313b6ee4f68$var$version = "0.10.19";
/**
 * The Firebase Analytics Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */ function $a038c313b6ee4f68$var$registerAnalytics() {
    (0, $1ad63299fe0e9682$export$c930050e7bb63965)(new (0, $be24428bd46df3e1$export$16fa2f45be04daa8)($a038c313b6ee4f68$var$ANALYTICS_TYPE, (container, { options: analyticsOptions })=>{
        // getImmediate for FirebaseApp will always succeed
        const app = container.getProvider('app').getImmediate();
        const installations = container.getProvider('installations-internal').getImmediate();
        return $a038c313b6ee4f68$var$factory(app, installations, analyticsOptions);
    }, "PUBLIC" /* ComponentType.PUBLIC */ ));
    (0, $1ad63299fe0e9682$export$c930050e7bb63965)(new (0, $be24428bd46df3e1$export$16fa2f45be04daa8)('analytics-internal', internalFactory, "PRIVATE" /* ComponentType.PRIVATE */ ));
    (0, $1ad63299fe0e9682$export$d29d5299a7137abc)($a038c313b6ee4f68$var$name, $a038c313b6ee4f68$var$version);
    // BUILD_TARGET will be replaced by values like esm, cjs, etc during the compilation
    (0, $1ad63299fe0e9682$export$d29d5299a7137abc)($a038c313b6ee4f68$var$name, $a038c313b6ee4f68$var$version, 'esm2020');
    function internalFactory(container) {
        try {
            const analytics = container.getProvider($a038c313b6ee4f68$var$ANALYTICS_TYPE).getImmediate();
            return {
                logEvent: (eventName, eventParams, options)=>$a038c313b6ee4f68$export$5e9eec8001665ac5(analytics, eventName, eventParams, options),
                setUserProperties: (properties, options)=>$a038c313b6ee4f68$export$d0e176862bf869b8(analytics, properties, options)
            };
        } catch (e) {
            throw $a038c313b6ee4f68$var$ERROR_FACTORY.create("interop-component-reg-failed" /* AnalyticsError.INTEROP_COMPONENT_REG_FAILED */ , {
                reason: e
            });
        }
    }
}
$a038c313b6ee4f68$var$registerAnalytics();







/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Constants used in the Firebase Storage library.
 */ /**
 * Domain name for firebase storage.
 */ const $4e5144ee615e69f8$var$DEFAULT_HOST = 'firebasestorage.googleapis.com';
/**
 * The key in Firebase config json for the storage bucket.
 */ const $4e5144ee615e69f8$var$CONFIG_STORAGE_BUCKET_KEY = 'storageBucket';
/**
 * 2 minutes
 *
 * The timeout for all operations except upload.
 */ const $4e5144ee615e69f8$var$DEFAULT_MAX_OPERATION_RETRY_TIME = 120000;
/**
 * 10 minutes
 *
 * The timeout for upload.
 */ const $4e5144ee615e69f8$var$DEFAULT_MAX_UPLOAD_RETRY_TIME = 600000;
/**
 * 1 second
 */ const $4e5144ee615e69f8$var$DEFAULT_MIN_SLEEP_TIME_MILLIS = 1000;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An error returned by the Firebase Storage SDK.
 * @public
 */ class $4e5144ee615e69f8$export$697502632950e9d3 extends (0, $b5eeaa155499f6b0$export$dd24e9cd51226c56) {
    /**
     * @param code - A `StorageErrorCode` string to be prefixed with 'storage/' and
     *  added to the end of the message.
     * @param message  - Error message.
     * @param status_ - Corresponding HTTP Status Code
     */ constructor(code, message, status_ = 0){
        super($4e5144ee615e69f8$var$prependCode(code), `Firebase Storage: ${message} (${$4e5144ee615e69f8$var$prependCode(code)})`);
        this.status_ = status_;
        /**
         * Stores custom error data unique to the `StorageError`.
         */ this.customData = {
            serverResponse: null
        };
        this._baseMessage = this.message;
        // Without this, `instanceof StorageError`, in tests for example,
        // returns false.
        Object.setPrototypeOf(this, $4e5144ee615e69f8$export$697502632950e9d3.prototype);
    }
    get status() {
        return this.status_;
    }
    set status(status) {
        this.status_ = status;
    }
    /**
     * Compares a `StorageErrorCode` against this error's code, filtering out the prefix.
     */ _codeEquals(code) {
        return $4e5144ee615e69f8$var$prependCode(code) === this.code;
    }
    /**
     * Optional response message that was added by the server.
     */ get serverResponse() {
        return this.customData.serverResponse;
    }
    set serverResponse(serverResponse) {
        this.customData.serverResponse = serverResponse;
        if (this.customData.serverResponse) this.message = `${this._baseMessage}\n${this.customData.serverResponse}`;
        else this.message = this._baseMessage;
    }
}
/**
 * @public
 * Error codes that can be attached to `StorageError` objects.
 */ var $4e5144ee615e69f8$export$54592d666d6ce114;
(function(StorageErrorCode) {
    // Shared between all platforms
    StorageErrorCode["UNKNOWN"] = "unknown";
    StorageErrorCode["OBJECT_NOT_FOUND"] = "object-not-found";
    StorageErrorCode["BUCKET_NOT_FOUND"] = "bucket-not-found";
    StorageErrorCode["PROJECT_NOT_FOUND"] = "project-not-found";
    StorageErrorCode["QUOTA_EXCEEDED"] = "quota-exceeded";
    StorageErrorCode["UNAUTHENTICATED"] = "unauthenticated";
    StorageErrorCode["UNAUTHORIZED"] = "unauthorized";
    StorageErrorCode["UNAUTHORIZED_APP"] = "unauthorized-app";
    StorageErrorCode["RETRY_LIMIT_EXCEEDED"] = "retry-limit-exceeded";
    StorageErrorCode["INVALID_CHECKSUM"] = "invalid-checksum";
    StorageErrorCode["CANCELED"] = "canceled";
    // JS specific
    StorageErrorCode["INVALID_EVENT_NAME"] = "invalid-event-name";
    StorageErrorCode["INVALID_URL"] = "invalid-url";
    StorageErrorCode["INVALID_DEFAULT_BUCKET"] = "invalid-default-bucket";
    StorageErrorCode["NO_DEFAULT_BUCKET"] = "no-default-bucket";
    StorageErrorCode["CANNOT_SLICE_BLOB"] = "cannot-slice-blob";
    StorageErrorCode["SERVER_FILE_WRONG_SIZE"] = "server-file-wrong-size";
    StorageErrorCode["NO_DOWNLOAD_URL"] = "no-download-url";
    StorageErrorCode["INVALID_ARGUMENT"] = "invalid-argument";
    StorageErrorCode["INVALID_ARGUMENT_COUNT"] = "invalid-argument-count";
    StorageErrorCode["APP_DELETED"] = "app-deleted";
    StorageErrorCode["INVALID_ROOT_OPERATION"] = "invalid-root-operation";
    StorageErrorCode["INVALID_FORMAT"] = "invalid-format";
    StorageErrorCode["INTERNAL_ERROR"] = "internal-error";
    StorageErrorCode["UNSUPPORTED_ENVIRONMENT"] = "unsupported-environment";
})($4e5144ee615e69f8$export$54592d666d6ce114 || ($4e5144ee615e69f8$export$54592d666d6ce114 = {}));
function $4e5144ee615e69f8$var$prependCode(code) {
    return 'storage/' + code;
}
function $4e5144ee615e69f8$var$unknown() {
    const message = "An unknown error occurred, please check the error payload for server response.";
    return new $4e5144ee615e69f8$export$697502632950e9d3($4e5144ee615e69f8$export$54592d666d6ce114.UNKNOWN, message);
}
function $4e5144ee615e69f8$var$objectNotFound(path) {
    return new $4e5144ee615e69f8$export$697502632950e9d3($4e5144ee615e69f8$export$54592d666d6ce114.OBJECT_NOT_FOUND, "Object '" + path + "' does not exist.");
}
function $4e5144ee615e69f8$var$quotaExceeded(bucket) {
    return new $4e5144ee615e69f8$export$697502632950e9d3($4e5144ee615e69f8$export$54592d666d6ce114.QUOTA_EXCEEDED, "Quota for bucket '" + bucket + "' exceeded, please view quota on " + 'https://firebase.google.com/pricing/.');
}
function $4e5144ee615e69f8$var$unauthenticated() {
    const message = "User is not authenticated, please authenticate using Firebase Authentication and try again.";
    return new $4e5144ee615e69f8$export$697502632950e9d3($4e5144ee615e69f8$export$54592d666d6ce114.UNAUTHENTICATED, message);
}
function $4e5144ee615e69f8$var$unauthorizedApp() {
    return new $4e5144ee615e69f8$export$697502632950e9d3($4e5144ee615e69f8$export$54592d666d6ce114.UNAUTHORIZED_APP, 'This app does not have permission to access Firebase Storage on this project.');
}
function $4e5144ee615e69f8$var$unauthorized(path) {
    return new $4e5144ee615e69f8$export$697502632950e9d3($4e5144ee615e69f8$export$54592d666d6ce114.UNAUTHORIZED, "User does not have permission to access '" + path + "'.");
}
function $4e5144ee615e69f8$var$retryLimitExceeded() {
    return new $4e5144ee615e69f8$export$697502632950e9d3($4e5144ee615e69f8$export$54592d666d6ce114.RETRY_LIMIT_EXCEEDED, 'Max retry time for operation exceeded, please try again.');
}
function $4e5144ee615e69f8$var$canceled() {
    return new $4e5144ee615e69f8$export$697502632950e9d3($4e5144ee615e69f8$export$54592d666d6ce114.CANCELED, 'User canceled the upload/download.');
}
function $4e5144ee615e69f8$var$invalidUrl(url) {
    return new $4e5144ee615e69f8$export$697502632950e9d3($4e5144ee615e69f8$export$54592d666d6ce114.INVALID_URL, "Invalid URL '" + url + "'.");
}
function $4e5144ee615e69f8$var$invalidDefaultBucket(bucket) {
    return new $4e5144ee615e69f8$export$697502632950e9d3($4e5144ee615e69f8$export$54592d666d6ce114.INVALID_DEFAULT_BUCKET, "Invalid default bucket '" + bucket + "'.");
}
function $4e5144ee615e69f8$var$noDefaultBucket() {
    return new $4e5144ee615e69f8$export$697502632950e9d3($4e5144ee615e69f8$export$54592d666d6ce114.NO_DEFAULT_BUCKET, "No default bucket found. Did you set the '" + $4e5144ee615e69f8$var$CONFIG_STORAGE_BUCKET_KEY + "' property when initializing the app?");
}
function $4e5144ee615e69f8$var$cannotSliceBlob() {
    return new $4e5144ee615e69f8$export$697502632950e9d3($4e5144ee615e69f8$export$54592d666d6ce114.CANNOT_SLICE_BLOB, 'Cannot slice blob for upload. Please retry the upload.');
}
function $4e5144ee615e69f8$var$serverFileWrongSize() {
    return new $4e5144ee615e69f8$export$697502632950e9d3($4e5144ee615e69f8$export$54592d666d6ce114.SERVER_FILE_WRONG_SIZE, 'Server recorded incorrect upload file size, please retry the upload.');
}
function $4e5144ee615e69f8$var$noDownloadURL() {
    return new $4e5144ee615e69f8$export$697502632950e9d3($4e5144ee615e69f8$export$54592d666d6ce114.NO_DOWNLOAD_URL, 'The given file does not have any download URLs.');
}
function $4e5144ee615e69f8$var$missingPolyFill(polyFill) {
    return new $4e5144ee615e69f8$export$697502632950e9d3($4e5144ee615e69f8$export$54592d666d6ce114.UNSUPPORTED_ENVIRONMENT, `${polyFill} is missing. Make sure to install the required polyfills. See https://firebase.google.com/docs/web/environments-js-sdk#polyfills for more information.`);
}
/**
 * @internal
 */ function $4e5144ee615e69f8$export$8f74d9881d1936fd(message) {
    return new $4e5144ee615e69f8$export$697502632950e9d3($4e5144ee615e69f8$export$54592d666d6ce114.INVALID_ARGUMENT, message);
}
function $4e5144ee615e69f8$var$appDeleted() {
    return new $4e5144ee615e69f8$export$697502632950e9d3($4e5144ee615e69f8$export$54592d666d6ce114.APP_DELETED, 'The Firebase app was deleted.');
}
/**
 * @param name - The name of the operation that was invalid.
 *
 * @internal
 */ function $4e5144ee615e69f8$export$61f54cdc36500ad(name) {
    return new $4e5144ee615e69f8$export$697502632950e9d3($4e5144ee615e69f8$export$54592d666d6ce114.INVALID_ROOT_OPERATION, "The operation '" + name + "' cannot be performed on a root reference, create a non-root " + "reference using child, such as .child('file.png').");
}
/**
 * @param format - The format that was not valid.
 * @param message - A message describing the format violation.
 */ function $4e5144ee615e69f8$var$invalidFormat(format, message) {
    return new $4e5144ee615e69f8$export$697502632950e9d3($4e5144ee615e69f8$export$54592d666d6ce114.INVALID_FORMAT, "String does not match format '" + format + "': " + message);
}
/**
 * @param message - A message describing the internal error.
 */ function $4e5144ee615e69f8$var$internalError(message) {
    throw new $4e5144ee615e69f8$export$697502632950e9d3($4e5144ee615e69f8$export$54592d666d6ce114.INTERNAL_ERROR, 'Internal error: ' + message);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Firebase Storage location data.
 *
 * @internal
 */ class $4e5144ee615e69f8$export$adb98fff6714334 {
    constructor(bucket, path){
        this.bucket = bucket;
        this.path_ = path;
    }
    get path() {
        return this.path_;
    }
    get isRoot() {
        return this.path.length === 0;
    }
    fullServerUrl() {
        const encode = encodeURIComponent;
        return '/b/' + encode(this.bucket) + '/o/' + encode(this.path);
    }
    bucketOnlyServerUrl() {
        const encode = encodeURIComponent;
        return '/b/' + encode(this.bucket) + '/o';
    }
    static makeFromBucketSpec(bucketString, host) {
        let bucketLocation;
        try {
            bucketLocation = $4e5144ee615e69f8$export$adb98fff6714334.makeFromUrl(bucketString, host);
        } catch (e) {
            // Not valid URL, use as-is. This lets you put bare bucket names in
            // config.
            return new $4e5144ee615e69f8$export$adb98fff6714334(bucketString, '');
        }
        if (bucketLocation.path === '') return bucketLocation;
        else throw $4e5144ee615e69f8$var$invalidDefaultBucket(bucketString);
    }
    static makeFromUrl(url, host) {
        let location = null;
        const bucketDomain = '([A-Za-z0-9.\\-_]+)';
        function gsModify(loc) {
            if (loc.path.charAt(loc.path.length - 1) === '/') loc.path_ = loc.path_.slice(0, -1);
        }
        const gsPath = '(/(.*))?$';
        const gsRegex = new RegExp('^gs://' + bucketDomain + gsPath, 'i');
        const gsIndices = {
            bucket: 1,
            path: 3
        };
        function httpModify(loc) {
            loc.path_ = decodeURIComponent(loc.path);
        }
        const version = 'v[A-Za-z0-9_]+';
        const firebaseStorageHost = host.replace(/[.]/g, '\\.');
        const firebaseStoragePath = '(/([^?#]*).*)?$';
        const firebaseStorageRegExp = new RegExp(`^https?://${firebaseStorageHost}/${version}/b/${bucketDomain}/o${firebaseStoragePath}`, 'i');
        const firebaseStorageIndices = {
            bucket: 1,
            path: 3
        };
        const cloudStorageHost = host === $4e5144ee615e69f8$var$DEFAULT_HOST ? '(?:storage.googleapis.com|storage.cloud.google.com)' : host;
        const cloudStoragePath = '([^?#]*)';
        const cloudStorageRegExp = new RegExp(`^https?://${cloudStorageHost}/${bucketDomain}/${cloudStoragePath}`, 'i');
        const cloudStorageIndices = {
            bucket: 1,
            path: 2
        };
        const groups = [
            {
                regex: gsRegex,
                indices: gsIndices,
                postModify: gsModify
            },
            {
                regex: firebaseStorageRegExp,
                indices: firebaseStorageIndices,
                postModify: httpModify
            },
            {
                regex: cloudStorageRegExp,
                indices: cloudStorageIndices,
                postModify: httpModify
            }
        ];
        for(let i = 0; i < groups.length; i++){
            const group = groups[i];
            const captures = group.regex.exec(url);
            if (captures) {
                const bucketValue = captures[group.indices.bucket];
                let pathValue = captures[group.indices.path];
                if (!pathValue) pathValue = '';
                location = new $4e5144ee615e69f8$export$adb98fff6714334(bucketValue, pathValue);
                group.postModify(location);
                break;
            }
        }
        if (location == null) throw $4e5144ee615e69f8$var$invalidUrl(url);
        return location;
    }
}
/**
 * A request whose promise always fails.
 */ class $4e5144ee615e69f8$var$FailRequest {
    constructor(error){
        this.promise_ = Promise.reject(error);
    }
    /** @inheritDoc */ getPromise() {
        return this.promise_;
    }
    /** @inheritDoc */ cancel(_appDelete = false) {}
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Accepts a callback for an action to perform (`doRequest`),
 * and then a callback for when the backoff has completed (`backoffCompleteCb`).
 * The callback sent to start requires an argument to call (`onRequestComplete`).
 * When `start` calls `doRequest`, it passes a callback for when the request has
 * completed, `onRequestComplete`. Based on this, the backoff continues, with
 * another call to `doRequest` and the above loop continues until the timeout
 * is hit, or a successful response occurs.
 * @description
 * @param doRequest Callback to perform request
 * @param backoffCompleteCb Callback to call when backoff has been completed
 */ function $4e5144ee615e69f8$var$start(doRequest, // eslint-disable-next-line @typescript-eslint/no-explicit-any
backoffCompleteCb, timeout) {
    // TODO(andysoto): make this code cleaner (probably refactor into an actual
    // type instead of a bunch of functions with state shared in the closure)
    let waitSeconds = 1;
    // Would type this as "number" but that doesn't work for Node so ¯\_(ツ)_/¯
    // TODO: find a way to exclude Node type definition for storage because storage only works in browser
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let retryTimeoutId = null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let globalTimeoutId = null;
    let hitTimeout = false;
    let cancelState = 0;
    function canceled() {
        return cancelState === 2;
    }
    let triggeredCallback = false;
    function triggerCallback(...args) {
        if (!triggeredCallback) {
            triggeredCallback = true;
            backoffCompleteCb.apply(null, args);
        }
    }
    function callWithDelay(millis) {
        retryTimeoutId = setTimeout(()=>{
            retryTimeoutId = null;
            doRequest(responseHandler, canceled());
        }, millis);
    }
    function clearGlobalTimeout() {
        if (globalTimeoutId) clearTimeout(globalTimeoutId);
    }
    function responseHandler(success, ...args) {
        if (triggeredCallback) {
            clearGlobalTimeout();
            return;
        }
        if (success) {
            clearGlobalTimeout();
            triggerCallback.call(null, success, ...args);
            return;
        }
        const mustStop = canceled() || hitTimeout;
        if (mustStop) {
            clearGlobalTimeout();
            triggerCallback.call(null, success, ...args);
            return;
        }
        if (waitSeconds < 64) /* TODO(andysoto): don't back off so quickly if we know we're offline. */ waitSeconds *= 2;
        let waitMillis;
        if (cancelState === 1) {
            cancelState = 2;
            waitMillis = 0;
        } else waitMillis = (waitSeconds + Math.random()) * 1000;
        callWithDelay(waitMillis);
    }
    let stopped = false;
    function stop(wasTimeout) {
        if (stopped) return;
        stopped = true;
        clearGlobalTimeout();
        if (triggeredCallback) return;
        if (retryTimeoutId !== null) {
            if (!wasTimeout) cancelState = 2;
            clearTimeout(retryTimeoutId);
            callWithDelay(0);
        } else if (!wasTimeout) cancelState = 1;
    }
    callWithDelay(0);
    globalTimeoutId = setTimeout(()=>{
        hitTimeout = true;
        stop(true);
    }, timeout);
    return stop;
}
/**
 * Stops the retry loop from repeating.
 * If the function is currently "in between" retries, it is invoked immediately
 * with the second parameter as "true". Otherwise, it will be invoked once more
 * after the current invocation finishes iff the current invocation would have
 * triggered another retry.
 */ function $4e5144ee615e69f8$var$stop(id) {
    id(false);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $4e5144ee615e69f8$var$isJustDef(p) {
    return p !== void 0;
}
// eslint-disable-next-line @typescript-eslint/ban-types
function $4e5144ee615e69f8$var$isFunction(p) {
    return typeof p === 'function';
}
function $4e5144ee615e69f8$var$isNonArrayObject(p) {
    return typeof p === 'object' && !Array.isArray(p);
}
function $4e5144ee615e69f8$var$isString(p) {
    return typeof p === 'string' || p instanceof String;
}
function $4e5144ee615e69f8$var$isNativeBlob(p) {
    return $4e5144ee615e69f8$var$isNativeBlobDefined() && p instanceof Blob;
}
function $4e5144ee615e69f8$var$isNativeBlobDefined() {
    return typeof Blob !== 'undefined';
}
function $4e5144ee615e69f8$var$validateNumber(argument, minValue, maxValue, value) {
    if (value < minValue) throw $4e5144ee615e69f8$export$8f74d9881d1936fd(`Invalid value for '${argument}'. Expected ${minValue} or greater.`);
    if (value > maxValue) throw $4e5144ee615e69f8$export$8f74d9881d1936fd(`Invalid value for '${argument}'. Expected ${maxValue} or less.`);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $4e5144ee615e69f8$var$makeUrl(urlPart, host, protocol) {
    let origin = host;
    if (protocol == null) origin = `https://${host}`;
    return `${protocol}://${origin}/v0${urlPart}`;
}
function $4e5144ee615e69f8$var$makeQueryString(params) {
    const encode = encodeURIComponent;
    let queryPart = '?';
    for(const key in params)if (params.hasOwnProperty(key)) {
        const nextPart = encode(key) + '=' + encode(params[key]);
        queryPart = queryPart + nextPart + '&';
    }
    // Chop off the extra '&' or '?' on the end
    queryPart = queryPart.slice(0, -1);
    return queryPart;
}
/**
 * Error codes for requests made by the XhrIo wrapper.
 */ var $4e5144ee615e69f8$var$ErrorCode;
(function(ErrorCode) {
    ErrorCode[ErrorCode["NO_ERROR"] = 0] = "NO_ERROR";
    ErrorCode[ErrorCode["NETWORK_ERROR"] = 1] = "NETWORK_ERROR";
    ErrorCode[ErrorCode["ABORT"] = 2] = "ABORT";
})($4e5144ee615e69f8$var$ErrorCode || ($4e5144ee615e69f8$var$ErrorCode = {}));
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Checks the status code to see if the action should be retried.
 *
 * @param status Current HTTP status code returned by server.
 * @param additionalRetryCodes additional retry codes to check against
 */ function $4e5144ee615e69f8$var$isRetryStatusCode(status, additionalRetryCodes) {
    // The codes for which to retry came from this page:
    // https://cloud.google.com/storage/docs/exponential-backoff
    const isFiveHundredCode = status >= 500 && status < 600;
    const extraRetryCodes = [
        // Request Timeout: web server didn't receive full request in time.
        408,
        // Too Many Requests: you're getting rate-limited, basically.
        429
    ];
    const isExtraRetryCode = extraRetryCodes.indexOf(status) !== -1;
    const isAdditionalRetryCode = additionalRetryCodes.indexOf(status) !== -1;
    return isFiveHundredCode || isExtraRetryCode || isAdditionalRetryCode;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Handles network logic for all Storage Requests, including error reporting and
 * retries with backoff.
 *
 * @param I - the type of the backend's network response.
 * @param - O the output type used by the rest of the SDK. The conversion
 * happens in the specified `callback_`.
 */ class $4e5144ee615e69f8$var$NetworkRequest {
    constructor(url_, method_, headers_, body_, successCodes_, additionalRetryCodes_, callback_, errorCallback_, timeout_, progressCallback_, connectionFactory_, retry = true, isUsingEmulator = false){
        this.url_ = url_;
        this.method_ = method_;
        this.headers_ = headers_;
        this.body_ = body_;
        this.successCodes_ = successCodes_;
        this.additionalRetryCodes_ = additionalRetryCodes_;
        this.callback_ = callback_;
        this.errorCallback_ = errorCallback_;
        this.timeout_ = timeout_;
        this.progressCallback_ = progressCallback_;
        this.connectionFactory_ = connectionFactory_;
        this.retry = retry;
        this.isUsingEmulator = isUsingEmulator;
        this.pendingConnection_ = null;
        this.backoffId_ = null;
        this.canceled_ = false;
        this.appDelete_ = false;
        this.promise_ = new Promise((resolve, reject)=>{
            this.resolve_ = resolve;
            this.reject_ = reject;
            this.start_();
        });
    }
    /**
     * Actually starts the retry loop.
     */ start_() {
        const doTheRequest = (backoffCallback, canceled)=>{
            if (canceled) {
                backoffCallback(false, new $4e5144ee615e69f8$var$RequestEndStatus(false, null, true));
                return;
            }
            const connection = this.connectionFactory_();
            this.pendingConnection_ = connection;
            const progressListener = (progressEvent)=>{
                const loaded = progressEvent.loaded;
                const total = progressEvent.lengthComputable ? progressEvent.total : -1;
                if (this.progressCallback_ !== null) this.progressCallback_(loaded, total);
            };
            if (this.progressCallback_ !== null) connection.addUploadProgressListener(progressListener);
            // connection.send() never rejects, so we don't need to have a error handler or use catch on the returned promise.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            connection.send(this.url_, this.method_, this.isUsingEmulator, this.body_, this.headers_).then(()=>{
                if (this.progressCallback_ !== null) connection.removeUploadProgressListener(progressListener);
                this.pendingConnection_ = null;
                const hitServer = connection.getErrorCode() === $4e5144ee615e69f8$var$ErrorCode.NO_ERROR;
                const status = connection.getStatus();
                if (!hitServer || $4e5144ee615e69f8$var$isRetryStatusCode(status, this.additionalRetryCodes_) && this.retry) {
                    const wasCanceled = connection.getErrorCode() === $4e5144ee615e69f8$var$ErrorCode.ABORT;
                    backoffCallback(false, new $4e5144ee615e69f8$var$RequestEndStatus(false, null, wasCanceled));
                    return;
                }
                const successCode = this.successCodes_.indexOf(status) !== -1;
                backoffCallback(true, new $4e5144ee615e69f8$var$RequestEndStatus(successCode, connection));
            });
        };
        /**
         * @param requestWentThrough - True if the request eventually went
         *     through, false if it hit the retry limit or was canceled.
         */ const backoffDone = (requestWentThrough, status)=>{
            const resolve = this.resolve_;
            const reject = this.reject_;
            const connection = status.connection;
            if (status.wasSuccessCode) try {
                const result = this.callback_(connection, connection.getResponse());
                if ($4e5144ee615e69f8$var$isJustDef(result)) resolve(result);
                else resolve();
            } catch (e) {
                reject(e);
            }
            else {
                if (connection !== null) {
                    const err = $4e5144ee615e69f8$var$unknown();
                    err.serverResponse = connection.getErrorText();
                    if (this.errorCallback_) reject(this.errorCallback_(connection, err));
                    else reject(err);
                } else if (status.canceled) {
                    const err = this.appDelete_ ? $4e5144ee615e69f8$var$appDeleted() : $4e5144ee615e69f8$var$canceled();
                    reject(err);
                } else {
                    const err = $4e5144ee615e69f8$var$retryLimitExceeded();
                    reject(err);
                }
            }
        };
        if (this.canceled_) backoffDone(false, new $4e5144ee615e69f8$var$RequestEndStatus(false, null, true));
        else this.backoffId_ = $4e5144ee615e69f8$var$start(doTheRequest, backoffDone, this.timeout_);
    }
    /** @inheritDoc */ getPromise() {
        return this.promise_;
    }
    /** @inheritDoc */ cancel(appDelete) {
        this.canceled_ = true;
        this.appDelete_ = appDelete || false;
        if (this.backoffId_ !== null) $4e5144ee615e69f8$var$stop(this.backoffId_);
        if (this.pendingConnection_ !== null) this.pendingConnection_.abort();
    }
}
/**
 * A collection of information about the result of a network request.
 * @param opt_canceled - Defaults to false.
 */ class $4e5144ee615e69f8$var$RequestEndStatus {
    constructor(wasSuccessCode, connection, canceled){
        this.wasSuccessCode = wasSuccessCode;
        this.connection = connection;
        this.canceled = !!canceled;
    }
}
function $4e5144ee615e69f8$var$addAuthHeader_(headers, authToken) {
    if (authToken !== null && authToken.length > 0) headers['Authorization'] = 'Firebase ' + authToken;
}
function $4e5144ee615e69f8$var$addVersionHeader_(headers, firebaseVersion) {
    headers['X-Firebase-Storage-Version'] = 'webjs/' + (firebaseVersion ?? 'AppManager');
}
function $4e5144ee615e69f8$var$addGmpidHeader_(headers, appId) {
    if (appId) headers['X-Firebase-GMPID'] = appId;
}
function $4e5144ee615e69f8$var$addAppCheckHeader_(headers, appCheckToken) {
    if (appCheckToken !== null) headers['X-Firebase-AppCheck'] = appCheckToken;
}
function $4e5144ee615e69f8$var$makeRequest(requestInfo, appId, authToken, appCheckToken, requestFactory, firebaseVersion, retry = true, isUsingEmulator = false) {
    const queryPart = $4e5144ee615e69f8$var$makeQueryString(requestInfo.urlParams);
    const url = requestInfo.url + queryPart;
    const headers = Object.assign({}, requestInfo.headers);
    $4e5144ee615e69f8$var$addGmpidHeader_(headers, appId);
    $4e5144ee615e69f8$var$addAuthHeader_(headers, authToken);
    $4e5144ee615e69f8$var$addVersionHeader_(headers, firebaseVersion);
    $4e5144ee615e69f8$var$addAppCheckHeader_(headers, appCheckToken);
    return new $4e5144ee615e69f8$var$NetworkRequest(url, requestInfo.method, headers, requestInfo.body, requestInfo.successCodes, requestInfo.additionalRetryCodes, requestInfo.handler, requestInfo.errorHandler, requestInfo.timeout, requestInfo.progressCallback, requestFactory, retry, isUsingEmulator);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $4e5144ee615e69f8$var$getBlobBuilder() {
    if (typeof BlobBuilder !== 'undefined') return BlobBuilder;
    else if (typeof WebKitBlobBuilder !== 'undefined') return WebKitBlobBuilder;
    else return undefined;
}
/**
 * Concatenates one or more values together and converts them to a Blob.
 *
 * @param args The values that will make up the resulting blob.
 * @return The blob.
 */ function $4e5144ee615e69f8$var$getBlob$1(...args) {
    const BlobBuilder1 = $4e5144ee615e69f8$var$getBlobBuilder();
    if (BlobBuilder1 !== undefined) {
        const bb = new BlobBuilder1();
        for(let i = 0; i < args.length; i++)bb.append(args[i]);
        return bb.getBlob();
    } else {
        if ($4e5144ee615e69f8$var$isNativeBlobDefined()) return new Blob(args);
        else throw new $4e5144ee615e69f8$export$697502632950e9d3($4e5144ee615e69f8$export$54592d666d6ce114.UNSUPPORTED_ENVIRONMENT, "This browser doesn't seem to support creating Blobs");
    }
}
/**
 * Slices the blob. The returned blob contains data from the start byte
 * (inclusive) till the end byte (exclusive). Negative indices cannot be used.
 *
 * @param blob The blob to be sliced.
 * @param start Index of the starting byte.
 * @param end Index of the ending byte.
 * @return The blob slice or null if not supported.
 */ function $4e5144ee615e69f8$var$sliceBlob(blob, start, end) {
    if (blob.webkitSlice) return blob.webkitSlice(start, end);
    else if (blob.mozSlice) return blob.mozSlice(start, end);
    else if (blob.slice) return blob.slice(start, end);
    return null;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Converts a Base64 encoded string to a binary string. */ function $4e5144ee615e69f8$var$decodeBase64(encoded) {
    if (typeof atob === 'undefined') throw $4e5144ee615e69f8$var$missingPolyFill('base-64');
    return atob(encoded);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enumeration of the possible string formats for upload.
 * @public
 */ const $4e5144ee615e69f8$export$f22e7fe56db8ae03 = {
    /**
     * Indicates the string should be interpreted "raw", that is, as normal text.
     * The string will be interpreted as UTF-16, then uploaded as a UTF-8 byte
     * sequence.
     * Example: The string 'Hello! \\ud83d\\ude0a' becomes the byte sequence
     * 48 65 6c 6c 6f 21 20 f0 9f 98 8a
     */ RAW: 'raw',
    /**
     * Indicates the string should be interpreted as base64-encoded data.
     * Padding characters (trailing '='s) are optional.
     * Example: The string 'rWmO++E6t7/rlw==' becomes the byte sequence
     * ad 69 8e fb e1 3a b7 bf eb 97
     */ BASE64: 'base64',
    /**
     * Indicates the string should be interpreted as base64url-encoded data.
     * Padding characters (trailing '='s) are optional.
     * Example: The string 'rWmO--E6t7_rlw==' becomes the byte sequence
     * ad 69 8e fb e1 3a b7 bf eb 97
     */ BASE64URL: 'base64url',
    /**
     * Indicates the string is a data URL, such as one obtained from
     * canvas.toDataURL().
     * Example: the string 'data:application/octet-stream;base64,aaaa'
     * becomes the byte sequence
     * 69 a6 9a
     * (the content-type "application/octet-stream" is also applied, but can
     * be overridden in the metadata object).
     */ DATA_URL: 'data_url'
};
class $4e5144ee615e69f8$var$StringData {
    constructor(data, contentType){
        this.data = data;
        this.contentType = contentType || null;
    }
}
/**
 * @internal
 */ function $4e5144ee615e69f8$export$d80b9b5a2ccdd3e0(format, stringData) {
    switch(format){
        case $4e5144ee615e69f8$export$f22e7fe56db8ae03.RAW:
            return new $4e5144ee615e69f8$var$StringData($4e5144ee615e69f8$var$utf8Bytes_(stringData));
        case $4e5144ee615e69f8$export$f22e7fe56db8ae03.BASE64:
        case $4e5144ee615e69f8$export$f22e7fe56db8ae03.BASE64URL:
            return new $4e5144ee615e69f8$var$StringData($4e5144ee615e69f8$var$base64Bytes_(format, stringData));
        case $4e5144ee615e69f8$export$f22e7fe56db8ae03.DATA_URL:
            return new $4e5144ee615e69f8$var$StringData($4e5144ee615e69f8$var$dataURLBytes_(stringData), $4e5144ee615e69f8$var$dataURLContentType_(stringData));
    }
    // assert(false);
    throw $4e5144ee615e69f8$var$unknown();
}
function $4e5144ee615e69f8$var$utf8Bytes_(value) {
    const b = [];
    for(let i = 0; i < value.length; i++){
        let c = value.charCodeAt(i);
        if (c <= 127) b.push(c);
        else if (c <= 2047) b.push(192 | c >> 6, 128 | c & 63);
        else {
            if ((c & 64512) === 55296) {
                // The start of a surrogate pair.
                const valid = i < value.length - 1 && (value.charCodeAt(i + 1) & 64512) === 56320;
                if (!valid) // The second surrogate wasn't there.
                b.push(239, 191, 189);
                else {
                    const hi = c;
                    const lo = value.charCodeAt(++i);
                    c = 65536 | (hi & 1023) << 10 | lo & 1023;
                    b.push(240 | c >> 18, 128 | c >> 12 & 63, 128 | c >> 6 & 63, 128 | c & 63);
                }
            } else if ((c & 64512) === 56320) // Invalid low surrogate.
            b.push(239, 191, 189);
            else b.push(224 | c >> 12, 128 | c >> 6 & 63, 128 | c & 63);
        }
    }
    return new Uint8Array(b);
}
function $4e5144ee615e69f8$var$percentEncodedBytes_(value) {
    let decoded;
    try {
        decoded = decodeURIComponent(value);
    } catch (e) {
        throw $4e5144ee615e69f8$var$invalidFormat($4e5144ee615e69f8$export$f22e7fe56db8ae03.DATA_URL, 'Malformed data URL.');
    }
    return $4e5144ee615e69f8$var$utf8Bytes_(decoded);
}
function $4e5144ee615e69f8$var$base64Bytes_(format, value) {
    switch(format){
        case $4e5144ee615e69f8$export$f22e7fe56db8ae03.BASE64:
            {
                const hasMinus = value.indexOf('-') !== -1;
                const hasUnder = value.indexOf('_') !== -1;
                if (hasMinus || hasUnder) {
                    const invalidChar = hasMinus ? '-' : '_';
                    throw $4e5144ee615e69f8$var$invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64url encoded?");
                }
                break;
            }
        case $4e5144ee615e69f8$export$f22e7fe56db8ae03.BASE64URL:
            {
                const hasPlus = value.indexOf('+') !== -1;
                const hasSlash = value.indexOf('/') !== -1;
                if (hasPlus || hasSlash) {
                    const invalidChar = hasPlus ? '+' : '/';
                    throw $4e5144ee615e69f8$var$invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64 encoded?");
                }
                value = value.replace(/-/g, '+').replace(/_/g, '/');
                break;
            }
    }
    let bytes;
    try {
        bytes = $4e5144ee615e69f8$var$decodeBase64(value);
    } catch (e) {
        if (e.message.includes('polyfill')) throw e;
        throw $4e5144ee615e69f8$var$invalidFormat(format, 'Invalid character found');
    }
    const array = new Uint8Array(bytes.length);
    for(let i = 0; i < bytes.length; i++)array[i] = bytes.charCodeAt(i);
    return array;
}
class $4e5144ee615e69f8$var$DataURLParts {
    constructor(dataURL){
        this.base64 = false;
        this.contentType = null;
        const matches = dataURL.match(/^data:([^,]+)?,/);
        if (matches === null) throw $4e5144ee615e69f8$var$invalidFormat($4e5144ee615e69f8$export$f22e7fe56db8ae03.DATA_URL, "Must be formatted 'data:[<mediatype>][;base64],<data>");
        const middle = matches[1] || null;
        if (middle != null) {
            this.base64 = $4e5144ee615e69f8$var$endsWith(middle, ';base64');
            this.contentType = this.base64 ? middle.substring(0, middle.length - 7) : middle;
        }
        this.rest = dataURL.substring(dataURL.indexOf(',') + 1);
    }
}
function $4e5144ee615e69f8$var$dataURLBytes_(dataUrl) {
    const parts = new $4e5144ee615e69f8$var$DataURLParts(dataUrl);
    if (parts.base64) return $4e5144ee615e69f8$var$base64Bytes_($4e5144ee615e69f8$export$f22e7fe56db8ae03.BASE64, parts.rest);
    else return $4e5144ee615e69f8$var$percentEncodedBytes_(parts.rest);
}
function $4e5144ee615e69f8$var$dataURLContentType_(dataUrl) {
    const parts = new $4e5144ee615e69f8$var$DataURLParts(dataUrl);
    return parts.contentType;
}
function $4e5144ee615e69f8$var$endsWith(s, end) {
    const longEnough = s.length >= end.length;
    if (!longEnough) return false;
    return s.substring(s.length - end.length) === end;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @param opt_elideCopy - If true, doesn't copy mutable input data
 *     (e.g. Uint8Arrays). Pass true only if you know the objects will not be
 *     modified after this blob's construction.
 *
 * @internal
 */ class $4e5144ee615e69f8$export$8deea8629ff0b8a7 {
    constructor(data, elideCopy){
        let size = 0;
        let blobType = '';
        if ($4e5144ee615e69f8$var$isNativeBlob(data)) {
            this.data_ = data;
            size = data.size;
            blobType = data.type;
        } else if (data instanceof ArrayBuffer) {
            if (elideCopy) this.data_ = new Uint8Array(data);
            else {
                this.data_ = new Uint8Array(data.byteLength);
                this.data_.set(new Uint8Array(data));
            }
            size = this.data_.length;
        } else if (data instanceof Uint8Array) {
            if (elideCopy) this.data_ = data;
            else {
                this.data_ = new Uint8Array(data.length);
                this.data_.set(data);
            }
            size = data.length;
        }
        this.size_ = size;
        this.type_ = blobType;
    }
    size() {
        return this.size_;
    }
    type() {
        return this.type_;
    }
    slice(startByte, endByte) {
        if ($4e5144ee615e69f8$var$isNativeBlob(this.data_)) {
            const realBlob = this.data_;
            const sliced = $4e5144ee615e69f8$var$sliceBlob(realBlob, startByte, endByte);
            if (sliced === null) return null;
            return new $4e5144ee615e69f8$export$8deea8629ff0b8a7(sliced);
        } else {
            const slice = new Uint8Array(this.data_.buffer, startByte, endByte - startByte);
            return new $4e5144ee615e69f8$export$8deea8629ff0b8a7(slice, true);
        }
    }
    static getBlob(...args) {
        if ($4e5144ee615e69f8$var$isNativeBlobDefined()) {
            const blobby = args.map((val)=>{
                if (val instanceof $4e5144ee615e69f8$export$8deea8629ff0b8a7) return val.data_;
                else return val;
            });
            return new $4e5144ee615e69f8$export$8deea8629ff0b8a7($4e5144ee615e69f8$var$getBlob$1.apply(null, blobby));
        } else {
            const uint8Arrays = args.map((val)=>{
                if ($4e5144ee615e69f8$var$isString(val)) return $4e5144ee615e69f8$export$d80b9b5a2ccdd3e0($4e5144ee615e69f8$export$f22e7fe56db8ae03.RAW, val).data;
                else // Blobs don't exist, so this has to be a Uint8Array.
                return val.data_;
            });
            let finalLength = 0;
            uint8Arrays.forEach((array)=>{
                finalLength += array.byteLength;
            });
            const merged = new Uint8Array(finalLength);
            let index = 0;
            uint8Arrays.forEach((array)=>{
                for(let i = 0; i < array.length; i++)merged[index++] = array[i];
            });
            return new $4e5144ee615e69f8$export$8deea8629ff0b8a7(merged, true);
        }
    }
    uploadData() {
        return this.data_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the Object resulting from parsing the given JSON, or null if the
 * given string does not represent a JSON object.
 */ function $4e5144ee615e69f8$var$jsonObjectOrNull(s) {
    let obj;
    try {
        obj = JSON.parse(s);
    } catch (e) {
        return null;
    }
    if ($4e5144ee615e69f8$var$isNonArrayObject(obj)) return obj;
    else return null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Contains helper methods for manipulating paths.
 */ /**
 * @return Null if the path is already at the root.
 */ function $4e5144ee615e69f8$var$parent(path) {
    if (path.length === 0) return null;
    const index = path.lastIndexOf('/');
    if (index === -1) return '';
    const newPath = path.slice(0, index);
    return newPath;
}
function $4e5144ee615e69f8$var$child(path, childPath) {
    const canonicalChildPath = childPath.split('/').filter((component)=>component.length > 0).join('/');
    if (path.length === 0) return canonicalChildPath;
    else return path + '/' + canonicalChildPath;
}
/**
 * Returns the last component of a path.
 * '/foo/bar' -> 'bar'
 * '/foo/bar/baz/' -> 'baz/'
 * '/a' -> 'a'
 */ function $4e5144ee615e69f8$var$lastComponent(path) {
    const index = path.lastIndexOf('/', path.length - 2);
    if (index === -1) return path;
    else return path.slice(index + 1);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $4e5144ee615e69f8$var$noXform_(metadata, value) {
    return value;
}
class $4e5144ee615e69f8$var$Mapping {
    constructor(server, local, writable, xform){
        this.server = server;
        this.local = local || server;
        this.writable = !!writable;
        this.xform = xform || $4e5144ee615e69f8$var$noXform_;
    }
}
let $4e5144ee615e69f8$var$mappings_ = null;
function $4e5144ee615e69f8$var$xformPath(fullPath) {
    if (!$4e5144ee615e69f8$var$isString(fullPath) || fullPath.length < 2) return fullPath;
    else return $4e5144ee615e69f8$var$lastComponent(fullPath);
}
function $4e5144ee615e69f8$var$getMappings() {
    if ($4e5144ee615e69f8$var$mappings_) return $4e5144ee615e69f8$var$mappings_;
    const mappings = [];
    mappings.push(new $4e5144ee615e69f8$var$Mapping('bucket'));
    mappings.push(new $4e5144ee615e69f8$var$Mapping('generation'));
    mappings.push(new $4e5144ee615e69f8$var$Mapping('metageneration'));
    mappings.push(new $4e5144ee615e69f8$var$Mapping('name', 'fullPath', true));
    function mappingsXformPath(_metadata, fullPath) {
        return $4e5144ee615e69f8$var$xformPath(fullPath);
    }
    const nameMapping = new $4e5144ee615e69f8$var$Mapping('name');
    nameMapping.xform = mappingsXformPath;
    mappings.push(nameMapping);
    /**
     * Coerces the second param to a number, if it is defined.
     */ function xformSize(_metadata, size) {
        if (size !== undefined) return Number(size);
        else return size;
    }
    const sizeMapping = new $4e5144ee615e69f8$var$Mapping('size');
    sizeMapping.xform = xformSize;
    mappings.push(sizeMapping);
    mappings.push(new $4e5144ee615e69f8$var$Mapping('timeCreated'));
    mappings.push(new $4e5144ee615e69f8$var$Mapping('updated'));
    mappings.push(new $4e5144ee615e69f8$var$Mapping('md5Hash', null, true));
    mappings.push(new $4e5144ee615e69f8$var$Mapping('cacheControl', null, true));
    mappings.push(new $4e5144ee615e69f8$var$Mapping('contentDisposition', null, true));
    mappings.push(new $4e5144ee615e69f8$var$Mapping('contentEncoding', null, true));
    mappings.push(new $4e5144ee615e69f8$var$Mapping('contentLanguage', null, true));
    mappings.push(new $4e5144ee615e69f8$var$Mapping('contentType', null, true));
    mappings.push(new $4e5144ee615e69f8$var$Mapping('metadata', 'customMetadata', true));
    $4e5144ee615e69f8$var$mappings_ = mappings;
    return $4e5144ee615e69f8$var$mappings_;
}
function $4e5144ee615e69f8$var$addRef(metadata, service) {
    function generateRef() {
        const bucket = metadata['bucket'];
        const path = metadata['fullPath'];
        const loc = new $4e5144ee615e69f8$export$adb98fff6714334(bucket, path);
        return service._makeStorageReference(loc);
    }
    Object.defineProperty(metadata, 'ref', {
        get: generateRef
    });
}
function $4e5144ee615e69f8$var$fromResource(service, resource, mappings) {
    const metadata = {};
    metadata['type'] = 'file';
    const len = mappings.length;
    for(let i = 0; i < len; i++){
        const mapping = mappings[i];
        metadata[mapping.local] = mapping.xform(metadata, resource[mapping.server]);
    }
    $4e5144ee615e69f8$var$addRef(metadata, service);
    return metadata;
}
function $4e5144ee615e69f8$var$fromResourceString(service, resourceString, mappings) {
    const obj = $4e5144ee615e69f8$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    const resource = obj;
    return $4e5144ee615e69f8$var$fromResource(service, resource, mappings);
}
function $4e5144ee615e69f8$var$downloadUrlFromResourceString(metadata, resourceString, host, protocol) {
    const obj = $4e5144ee615e69f8$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    if (!$4e5144ee615e69f8$var$isString(obj['downloadTokens'])) // This can happen if objects are uploaded through GCS and retrieved
    // through list, so we don't want to throw an Error.
    return null;
    const tokens = obj['downloadTokens'];
    if (tokens.length === 0) return null;
    const encode = encodeURIComponent;
    const tokensList = tokens.split(',');
    const urls = tokensList.map((token)=>{
        const bucket = metadata['bucket'];
        const path = metadata['fullPath'];
        const urlPart = '/b/' + encode(bucket) + '/o/' + encode(path);
        const base = $4e5144ee615e69f8$var$makeUrl(urlPart, host, protocol);
        const queryString = $4e5144ee615e69f8$var$makeQueryString({
            alt: 'media',
            token: token
        });
        return base + queryString;
    });
    return urls[0];
}
function $4e5144ee615e69f8$var$toResourceString(metadata, mappings) {
    const resource = {};
    const len = mappings.length;
    for(let i = 0; i < len; i++){
        const mapping = mappings[i];
        if (mapping.writable) resource[mapping.server] = metadata[mapping.local];
    }
    return JSON.stringify(resource);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $4e5144ee615e69f8$var$PREFIXES_KEY = 'prefixes';
const $4e5144ee615e69f8$var$ITEMS_KEY = 'items';
function $4e5144ee615e69f8$var$fromBackendResponse(service, bucket, resource) {
    const listResult = {
        prefixes: [],
        items: [],
        nextPageToken: resource['nextPageToken']
    };
    if (resource[$4e5144ee615e69f8$var$PREFIXES_KEY]) for (const path of resource[$4e5144ee615e69f8$var$PREFIXES_KEY]){
        const pathWithoutTrailingSlash = path.replace(/\/$/, '');
        const reference = service._makeStorageReference(new $4e5144ee615e69f8$export$adb98fff6714334(bucket, pathWithoutTrailingSlash));
        listResult.prefixes.push(reference);
    }
    if (resource[$4e5144ee615e69f8$var$ITEMS_KEY]) for (const item of resource[$4e5144ee615e69f8$var$ITEMS_KEY]){
        const reference = service._makeStorageReference(new $4e5144ee615e69f8$export$adb98fff6714334(bucket, item['name']));
        listResult.items.push(reference);
    }
    return listResult;
}
function $4e5144ee615e69f8$var$fromResponseString(service, bucket, resourceString) {
    const obj = $4e5144ee615e69f8$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    const resource = obj;
    return $4e5144ee615e69f8$var$fromBackendResponse(service, bucket, resource);
}
/**
 * Contains a fully specified request.
 *
 * @param I - the type of the backend's network response.
 * @param O - the output response type used by the rest of the SDK.
 */ class $4e5144ee615e69f8$var$RequestInfo {
    constructor(url, method, /**
     * Returns the value with which to resolve the request's promise. Only called
     * if the request is successful. Throw from this function to reject the
     * returned Request's promise with the thrown error.
     * Note: The XhrIo passed to this function may be reused after this callback
     * returns. Do not keep a reference to it in any way.
     */ handler, timeout){
        this.url = url;
        this.method = method;
        this.handler = handler;
        this.timeout = timeout;
        this.urlParams = {};
        this.headers = {};
        this.body = null;
        this.errorHandler = null;
        /**
         * Called with the current number of bytes uploaded and total size (-1 if not
         * computable) of the request body (i.e. used to report upload progress).
         */ this.progressCallback = null;
        this.successCodes = [
            200
        ];
        this.additionalRetryCodes = [];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws the UNKNOWN StorageError if cndn is false.
 */ function $4e5144ee615e69f8$var$handlerCheck(cndn) {
    if (!cndn) throw $4e5144ee615e69f8$var$unknown();
}
function $4e5144ee615e69f8$var$metadataHandler(service, mappings) {
    function handler(xhr, text) {
        const metadata = $4e5144ee615e69f8$var$fromResourceString(service, text, mappings);
        $4e5144ee615e69f8$var$handlerCheck(metadata !== null);
        return metadata;
    }
    return handler;
}
function $4e5144ee615e69f8$var$listHandler(service, bucket) {
    function handler(xhr, text) {
        const listResult = $4e5144ee615e69f8$var$fromResponseString(service, bucket, text);
        $4e5144ee615e69f8$var$handlerCheck(listResult !== null);
        return listResult;
    }
    return handler;
}
function $4e5144ee615e69f8$var$downloadUrlHandler(service, mappings) {
    function handler(xhr, text) {
        const metadata = $4e5144ee615e69f8$var$fromResourceString(service, text, mappings);
        $4e5144ee615e69f8$var$handlerCheck(metadata !== null);
        return $4e5144ee615e69f8$var$downloadUrlFromResourceString(metadata, text, service.host, service._protocol);
    }
    return handler;
}
function $4e5144ee615e69f8$var$sharedErrorHandler(location) {
    function errorHandler(xhr, err) {
        let newErr;
        if (xhr.getStatus() === 401) {
            if (// This exact message string is the only consistent part of the
            // server's error response that identifies it as an App Check error.
            xhr.getErrorText().includes('Firebase App Check token is invalid')) newErr = $4e5144ee615e69f8$var$unauthorizedApp();
            else newErr = $4e5144ee615e69f8$var$unauthenticated();
        } else {
            if (xhr.getStatus() === 402) newErr = $4e5144ee615e69f8$var$quotaExceeded(location.bucket);
            else if (xhr.getStatus() === 403) newErr = $4e5144ee615e69f8$var$unauthorized(location.path);
            else newErr = err;
        }
        newErr.status = xhr.getStatus();
        newErr.serverResponse = err.serverResponse;
        return newErr;
    }
    return errorHandler;
}
function $4e5144ee615e69f8$var$objectErrorHandler(location) {
    const shared = $4e5144ee615e69f8$var$sharedErrorHandler(location);
    function errorHandler(xhr, err) {
        let newErr = shared(xhr, err);
        if (xhr.getStatus() === 404) newErr = $4e5144ee615e69f8$var$objectNotFound(location.path);
        newErr.serverResponse = err.serverResponse;
        return newErr;
    }
    return errorHandler;
}
function $4e5144ee615e69f8$var$getMetadata$2(service, location, mappings) {
    const urlPart = location.fullServerUrl();
    const url = $4e5144ee615e69f8$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'GET';
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $4e5144ee615e69f8$var$RequestInfo(url, method, $4e5144ee615e69f8$var$metadataHandler(service, mappings), timeout);
    requestInfo.errorHandler = $4e5144ee615e69f8$var$objectErrorHandler(location);
    return requestInfo;
}
function $4e5144ee615e69f8$var$list$2(service, location, delimiter, pageToken, maxResults) {
    const urlParams = {};
    if (location.isRoot) urlParams['prefix'] = '';
    else urlParams['prefix'] = location.path + '/';
    if (delimiter && delimiter.length > 0) urlParams['delimiter'] = delimiter;
    if (pageToken) urlParams['pageToken'] = pageToken;
    if (maxResults) urlParams['maxResults'] = maxResults;
    const urlPart = location.bucketOnlyServerUrl();
    const url = $4e5144ee615e69f8$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'GET';
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $4e5144ee615e69f8$var$RequestInfo(url, method, $4e5144ee615e69f8$var$listHandler(service, location.bucket), timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.errorHandler = $4e5144ee615e69f8$var$sharedErrorHandler(location);
    return requestInfo;
}
function $4e5144ee615e69f8$var$getBytes$1(service, location, maxDownloadSizeBytes) {
    const urlPart = location.fullServerUrl();
    const url = $4e5144ee615e69f8$var$makeUrl(urlPart, service.host, service._protocol) + '?alt=media';
    const method = 'GET';
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $4e5144ee615e69f8$var$RequestInfo(url, method, (_, data)=>data, timeout);
    requestInfo.errorHandler = $4e5144ee615e69f8$var$objectErrorHandler(location);
    if (maxDownloadSizeBytes !== undefined) {
        requestInfo.headers['Range'] = `bytes=0-${maxDownloadSizeBytes}`;
        requestInfo.successCodes = [
            200 /* OK */ ,
            206 /* Partial Content */ 
        ];
    }
    return requestInfo;
}
function $4e5144ee615e69f8$var$getDownloadUrl(service, location, mappings) {
    const urlPart = location.fullServerUrl();
    const url = $4e5144ee615e69f8$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'GET';
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $4e5144ee615e69f8$var$RequestInfo(url, method, $4e5144ee615e69f8$var$downloadUrlHandler(service, mappings), timeout);
    requestInfo.errorHandler = $4e5144ee615e69f8$var$objectErrorHandler(location);
    return requestInfo;
}
function $4e5144ee615e69f8$var$updateMetadata$2(service, location, metadata, mappings) {
    const urlPart = location.fullServerUrl();
    const url = $4e5144ee615e69f8$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'PATCH';
    const body = $4e5144ee615e69f8$var$toResourceString(metadata, mappings);
    const headers = {
        'Content-Type': 'application/json; charset=utf-8'
    };
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $4e5144ee615e69f8$var$RequestInfo(url, method, $4e5144ee615e69f8$var$metadataHandler(service, mappings), timeout);
    requestInfo.headers = headers;
    requestInfo.body = body;
    requestInfo.errorHandler = $4e5144ee615e69f8$var$objectErrorHandler(location);
    return requestInfo;
}
function $4e5144ee615e69f8$var$deleteObject$2(service, location) {
    const urlPart = location.fullServerUrl();
    const url = $4e5144ee615e69f8$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'DELETE';
    const timeout = service.maxOperationRetryTime;
    function handler(_xhr, _text) {}
    const requestInfo = new $4e5144ee615e69f8$var$RequestInfo(url, method, handler, timeout);
    requestInfo.successCodes = [
        200,
        204
    ];
    requestInfo.errorHandler = $4e5144ee615e69f8$var$objectErrorHandler(location);
    return requestInfo;
}
function $4e5144ee615e69f8$var$determineContentType_(metadata, blob) {
    return metadata && metadata['contentType'] || blob && blob.type() || 'application/octet-stream';
}
function $4e5144ee615e69f8$var$metadataForUpload_(location, blob, metadata) {
    const metadataClone = Object.assign({}, metadata);
    metadataClone['fullPath'] = location.path;
    metadataClone['size'] = blob.size();
    if (!metadataClone['contentType']) metadataClone['contentType'] = $4e5144ee615e69f8$var$determineContentType_(null, blob);
    return metadataClone;
}
/**
 * Prepare RequestInfo for uploads as Content-Type: multipart.
 */ function $4e5144ee615e69f8$var$multipartUpload(service, location, mappings, blob, metadata) {
    const urlPart = location.bucketOnlyServerUrl();
    const headers = {
        'X-Goog-Upload-Protocol': 'multipart'
    };
    function genBoundary() {
        let str = '';
        for(let i = 0; i < 2; i++)str = str + Math.random().toString().slice(2);
        return str;
    }
    const boundary = genBoundary();
    headers['Content-Type'] = 'multipart/related; boundary=' + boundary;
    const metadata_ = $4e5144ee615e69f8$var$metadataForUpload_(location, blob, metadata);
    const metadataString = $4e5144ee615e69f8$var$toResourceString(metadata_, mappings);
    const preBlobPart = '--' + boundary + '\r\n' + 'Content-Type: application/json; charset=utf-8\r\n\r\n' + metadataString + '\r\n--' + boundary + '\r\n' + 'Content-Type: ' + metadata_['contentType'] + '\r\n\r\n';
    const postBlobPart = '\r\n--' + boundary + '--';
    const body = $4e5144ee615e69f8$export$8deea8629ff0b8a7.getBlob(preBlobPart, blob, postBlobPart);
    if (body === null) throw $4e5144ee615e69f8$var$cannotSliceBlob();
    const urlParams = {
        name: metadata_['fullPath']
    };
    const url = $4e5144ee615e69f8$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'POST';
    const timeout = service.maxUploadRetryTime;
    const requestInfo = new $4e5144ee615e69f8$var$RequestInfo(url, method, $4e5144ee615e69f8$var$metadataHandler(service, mappings), timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.headers = headers;
    requestInfo.body = body.uploadData();
    requestInfo.errorHandler = $4e5144ee615e69f8$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @param current The number of bytes that have been uploaded so far.
 * @param total The total number of bytes in the upload.
 * @param opt_finalized True if the server has finished the upload.
 * @param opt_metadata The upload metadata, should
 *     only be passed if opt_finalized is true.
 */ class $4e5144ee615e69f8$var$ResumableUploadStatus {
    constructor(current, total, finalized, metadata){
        this.current = current;
        this.total = total;
        this.finalized = !!finalized;
        this.metadata = metadata || null;
    }
}
function $4e5144ee615e69f8$var$checkResumeHeader_(xhr, allowed) {
    let status = null;
    try {
        status = xhr.getResponseHeader('X-Goog-Upload-Status');
    } catch (e) {
        $4e5144ee615e69f8$var$handlerCheck(false);
    }
    const allowedStatus = allowed || [
        'active'
    ];
    $4e5144ee615e69f8$var$handlerCheck(!!status && allowedStatus.indexOf(status) !== -1);
    return status;
}
function $4e5144ee615e69f8$var$createResumableUpload(service, location, mappings, blob, metadata) {
    const urlPart = location.bucketOnlyServerUrl();
    const metadataForUpload = $4e5144ee615e69f8$var$metadataForUpload_(location, blob, metadata);
    const urlParams = {
        name: metadataForUpload['fullPath']
    };
    const url = $4e5144ee615e69f8$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'POST';
    const headers = {
        'X-Goog-Upload-Protocol': 'resumable',
        'X-Goog-Upload-Command': 'start',
        'X-Goog-Upload-Header-Content-Length': `${blob.size()}`,
        'X-Goog-Upload-Header-Content-Type': metadataForUpload['contentType'],
        'Content-Type': 'application/json; charset=utf-8'
    };
    const body = $4e5144ee615e69f8$var$toResourceString(metadataForUpload, mappings);
    const timeout = service.maxUploadRetryTime;
    function handler(xhr) {
        $4e5144ee615e69f8$var$checkResumeHeader_(xhr);
        let url;
        try {
            url = xhr.getResponseHeader('X-Goog-Upload-URL');
        } catch (e) {
            $4e5144ee615e69f8$var$handlerCheck(false);
        }
        $4e5144ee615e69f8$var$handlerCheck($4e5144ee615e69f8$var$isString(url));
        return url;
    }
    const requestInfo = new $4e5144ee615e69f8$var$RequestInfo(url, method, handler, timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.headers = headers;
    requestInfo.body = body;
    requestInfo.errorHandler = $4e5144ee615e69f8$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 */ function $4e5144ee615e69f8$var$getResumableUploadStatus(service, location, url, blob) {
    const headers = {
        'X-Goog-Upload-Command': 'query'
    };
    function handler(xhr) {
        const status = $4e5144ee615e69f8$var$checkResumeHeader_(xhr, [
            'active',
            'final'
        ]);
        let sizeString = null;
        try {
            sizeString = xhr.getResponseHeader('X-Goog-Upload-Size-Received');
        } catch (e) {
            $4e5144ee615e69f8$var$handlerCheck(false);
        }
        if (!sizeString) // null or empty string
        $4e5144ee615e69f8$var$handlerCheck(false);
        const size = Number(sizeString);
        $4e5144ee615e69f8$var$handlerCheck(!isNaN(size));
        return new $4e5144ee615e69f8$var$ResumableUploadStatus(size, blob.size(), status === 'final');
    }
    const method = 'POST';
    const timeout = service.maxUploadRetryTime;
    const requestInfo = new $4e5144ee615e69f8$var$RequestInfo(url, method, handler, timeout);
    requestInfo.headers = headers;
    requestInfo.errorHandler = $4e5144ee615e69f8$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * Any uploads via the resumable upload API must transfer a number of bytes
 * that is a multiple of this number.
 */ const $4e5144ee615e69f8$var$RESUMABLE_UPLOAD_CHUNK_SIZE = 262144;
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 * @param chunkSize Number of bytes to upload.
 * @param status The previous status.
 *     If not passed or null, we start from the beginning.
 * @throws fbs.Error If the upload is already complete, the passed in status
 *     has a final size inconsistent with the blob, or the blob cannot be sliced
 *     for upload.
 */ function $4e5144ee615e69f8$var$continueResumableUpload(location, service, url, blob, chunkSize, mappings, status, progressCallback) {
    // TODO(andysoto): standardize on internal asserts
    // assert(!(opt_status && opt_status.finalized));
    const status_ = new $4e5144ee615e69f8$var$ResumableUploadStatus(0, 0);
    if (status) {
        status_.current = status.current;
        status_.total = status.total;
    } else {
        status_.current = 0;
        status_.total = blob.size();
    }
    if (blob.size() !== status_.total) throw $4e5144ee615e69f8$var$serverFileWrongSize();
    const bytesLeft = status_.total - status_.current;
    let bytesToUpload = bytesLeft;
    if (chunkSize > 0) bytesToUpload = Math.min(bytesToUpload, chunkSize);
    const startByte = status_.current;
    const endByte = startByte + bytesToUpload;
    let uploadCommand = '';
    if (bytesToUpload === 0) uploadCommand = 'finalize';
    else if (bytesLeft === bytesToUpload) uploadCommand = 'upload, finalize';
    else uploadCommand = 'upload';
    const headers = {
        'X-Goog-Upload-Command': uploadCommand,
        'X-Goog-Upload-Offset': `${status_.current}`
    };
    const body = blob.slice(startByte, endByte);
    if (body === null) throw $4e5144ee615e69f8$var$cannotSliceBlob();
    function handler(xhr, text) {
        // TODO(andysoto): Verify the MD5 of each uploaded range:
        // the 'x-range-md5' header comes back with status code 308 responses.
        // We'll only be able to bail out though, because you can't re-upload a
        // range that you previously uploaded.
        const uploadStatus = $4e5144ee615e69f8$var$checkResumeHeader_(xhr, [
            'active',
            'final'
        ]);
        const newCurrent = status_.current + bytesToUpload;
        const size = blob.size();
        let metadata;
        if (uploadStatus === 'final') metadata = $4e5144ee615e69f8$var$metadataHandler(service, mappings)(xhr, text);
        else metadata = null;
        return new $4e5144ee615e69f8$var$ResumableUploadStatus(newCurrent, size, uploadStatus === 'final', metadata);
    }
    const method = 'POST';
    const timeout = service.maxUploadRetryTime;
    const requestInfo = new $4e5144ee615e69f8$var$RequestInfo(url, method, handler, timeout);
    requestInfo.headers = headers;
    requestInfo.body = body.uploadData();
    requestInfo.progressCallback = progressCallback || null;
    requestInfo.errorHandler = $4e5144ee615e69f8$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An event that is triggered on a task.
 * @internal
 */ const $4e5144ee615e69f8$export$2cf04e0422ce9b07 = {
    /**
     * For this event,
     * <ul>
     *   <li>The `next` function is triggered on progress updates and when the
     *       task is paused/resumed with an `UploadTaskSnapshot` as the first
     *       argument.</li>
     *   <li>The `error` function is triggered if the upload is canceled or fails
     *       for another reason.</li>
     *   <li>The `complete` function is triggered if the upload completes
     *       successfully.</li>
     * </ul>
     */ STATE_CHANGED: 'state_changed'
};
// type keys = keyof TaskState
/**
 * Represents the current state of a running upload.
 * @internal
 */ const $4e5144ee615e69f8$export$9dc4203728a9a7c9 = {
    /** The task is currently transferring data. */ RUNNING: 'running',
    /** The task was paused by the user. */ PAUSED: 'paused',
    /** The task completed successfully. */ SUCCESS: 'success',
    /** The task was canceled. */ CANCELED: 'canceled',
    /** The task failed with an error. */ ERROR: 'error'
};
function $4e5144ee615e69f8$var$taskStateFromInternalTaskState(state) {
    switch(state){
        case "running" /* InternalTaskState.RUNNING */ :
        case "pausing" /* InternalTaskState.PAUSING */ :
        case "canceling" /* InternalTaskState.CANCELING */ :
            return $4e5144ee615e69f8$export$9dc4203728a9a7c9.RUNNING;
        case "paused" /* InternalTaskState.PAUSED */ :
            return $4e5144ee615e69f8$export$9dc4203728a9a7c9.PAUSED;
        case "success" /* InternalTaskState.SUCCESS */ :
            return $4e5144ee615e69f8$export$9dc4203728a9a7c9.SUCCESS;
        case "canceled" /* InternalTaskState.CANCELED */ :
            return $4e5144ee615e69f8$export$9dc4203728a9a7c9.CANCELED;
        case "error" /* InternalTaskState.ERROR */ :
            return $4e5144ee615e69f8$export$9dc4203728a9a7c9.ERROR;
        default:
            // TODO(andysoto): assert(false);
            return $4e5144ee615e69f8$export$9dc4203728a9a7c9.ERROR;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $4e5144ee615e69f8$var$Observer {
    constructor(nextOrObserver, error, complete){
        const asFunctions = $4e5144ee615e69f8$var$isFunction(nextOrObserver) || error != null || complete != null;
        if (asFunctions) {
            this.next = nextOrObserver;
            this.error = error ?? undefined;
            this.complete = complete ?? undefined;
        } else {
            const observer = nextOrObserver;
            this.next = observer.next;
            this.error = observer.error;
            this.complete = observer.complete;
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a function that invokes f with its arguments asynchronously as a
 * microtask, i.e. as soon as possible after the current script returns back
 * into browser code.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $4e5144ee615e69f8$var$async(f) {
    return (...argsToForward)=>{
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        Promise.resolve().then(()=>f(...argsToForward));
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** An override for the text-based Connection. Used in tests. */ let $4e5144ee615e69f8$var$textFactoryOverride = null;
/**
 * Network layer for browsers. We use this instead of goog.net.XhrIo because
 * goog.net.XhrIo is hyuuuuge and doesn't work in React Native on Android.
 */ class $4e5144ee615e69f8$var$XhrConnection {
    constructor(){
        this.sent_ = false;
        this.xhr_ = new XMLHttpRequest();
        this.initXhr();
        this.errorCode_ = $4e5144ee615e69f8$var$ErrorCode.NO_ERROR;
        this.sendPromise_ = new Promise((resolve)=>{
            this.xhr_.addEventListener('abort', ()=>{
                this.errorCode_ = $4e5144ee615e69f8$var$ErrorCode.ABORT;
                resolve();
            });
            this.xhr_.addEventListener('error', ()=>{
                this.errorCode_ = $4e5144ee615e69f8$var$ErrorCode.NETWORK_ERROR;
                resolve();
            });
            this.xhr_.addEventListener('load', ()=>{
                resolve();
            });
        });
    }
    send(url, method, isUsingEmulator, body, headers) {
        if (this.sent_) throw $4e5144ee615e69f8$var$internalError('cannot .send() more than once');
        if ((0, $b5eeaa155499f6b0$export$5b4d24b45140ad90)(url) && isUsingEmulator) this.xhr_.withCredentials = true;
        this.sent_ = true;
        this.xhr_.open(method, url, true);
        if (headers !== undefined) {
            for(const key in headers)if (headers.hasOwnProperty(key)) this.xhr_.setRequestHeader(key, headers[key].toString());
        }
        if (body !== undefined) this.xhr_.send(body);
        else this.xhr_.send();
        return this.sendPromise_;
    }
    getErrorCode() {
        if (!this.sent_) throw $4e5144ee615e69f8$var$internalError('cannot .getErrorCode() before sending');
        return this.errorCode_;
    }
    getStatus() {
        if (!this.sent_) throw $4e5144ee615e69f8$var$internalError('cannot .getStatus() before sending');
        try {
            return this.xhr_.status;
        } catch (e) {
            return -1;
        }
    }
    getResponse() {
        if (!this.sent_) throw $4e5144ee615e69f8$var$internalError('cannot .getResponse() before sending');
        return this.xhr_.response;
    }
    getErrorText() {
        if (!this.sent_) throw $4e5144ee615e69f8$var$internalError('cannot .getErrorText() before sending');
        return this.xhr_.statusText;
    }
    /** Aborts the request. */ abort() {
        this.xhr_.abort();
    }
    getResponseHeader(header) {
        return this.xhr_.getResponseHeader(header);
    }
    addUploadProgressListener(listener) {
        if (this.xhr_.upload != null) this.xhr_.upload.addEventListener('progress', listener);
    }
    removeUploadProgressListener(listener) {
        if (this.xhr_.upload != null) this.xhr_.upload.removeEventListener('progress', listener);
    }
}
class $4e5144ee615e69f8$var$XhrTextConnection extends $4e5144ee615e69f8$var$XhrConnection {
    initXhr() {
        this.xhr_.responseType = 'text';
    }
}
function $4e5144ee615e69f8$var$newTextConnection() {
    return $4e5144ee615e69f8$var$textFactoryOverride ? $4e5144ee615e69f8$var$textFactoryOverride() : new $4e5144ee615e69f8$var$XhrTextConnection();
}
class $4e5144ee615e69f8$var$XhrBytesConnection extends $4e5144ee615e69f8$var$XhrConnection {
    initXhr() {
        this.xhr_.responseType = 'arraybuffer';
    }
}
function $4e5144ee615e69f8$var$newBytesConnection() {
    return new $4e5144ee615e69f8$var$XhrBytesConnection();
}
class $4e5144ee615e69f8$var$XhrBlobConnection extends $4e5144ee615e69f8$var$XhrConnection {
    initXhr() {
        this.xhr_.responseType = 'blob';
    }
}
function $4e5144ee615e69f8$var$newBlobConnection() {
    return new $4e5144ee615e69f8$var$XhrBlobConnection();
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a blob being uploaded. Can be used to pause/resume/cancel the
 * upload and manage callbacks for various events.
 * @internal
 */ class $4e5144ee615e69f8$export$86a2a9b92406a048 {
    isExponentialBackoffExpired() {
        return this.sleepTime > this.maxSleepTime;
    }
    /**
     * @param ref - The firebaseStorage.Reference object this task came
     *     from, untyped to avoid cyclic dependencies.
     * @param blob - The blob to upload.
     */ constructor(ref, blob, metadata = null){
        /**
         * Number of bytes transferred so far.
         */ this._transferred = 0;
        this._needToFetchStatus = false;
        this._needToFetchMetadata = false;
        this._observers = [];
        this._error = undefined;
        this._uploadUrl = undefined;
        this._request = undefined;
        this._chunkMultiplier = 1;
        this._resolve = undefined;
        this._reject = undefined;
        this._ref = ref;
        this._blob = blob;
        this._metadata = metadata;
        this._mappings = $4e5144ee615e69f8$var$getMappings();
        this._resumable = this._shouldDoResumable(this._blob);
        this._state = "running" /* InternalTaskState.RUNNING */ ;
        this._errorHandler = (error)=>{
            this._request = undefined;
            this._chunkMultiplier = 1;
            if (error._codeEquals($4e5144ee615e69f8$export$54592d666d6ce114.CANCELED)) {
                this._needToFetchStatus = true;
                this.completeTransitions_();
            } else {
                const backoffExpired = this.isExponentialBackoffExpired();
                if ($4e5144ee615e69f8$var$isRetryStatusCode(error.status, [])) {
                    if (backoffExpired) error = $4e5144ee615e69f8$var$retryLimitExceeded();
                    else {
                        this.sleepTime = Math.max(this.sleepTime * 2, $4e5144ee615e69f8$var$DEFAULT_MIN_SLEEP_TIME_MILLIS);
                        this._needToFetchStatus = true;
                        this.completeTransitions_();
                        return;
                    }
                }
                this._error = error;
                this._transition("error" /* InternalTaskState.ERROR */ );
            }
        };
        this._metadataErrorHandler = (error)=>{
            this._request = undefined;
            if (error._codeEquals($4e5144ee615e69f8$export$54592d666d6ce114.CANCELED)) this.completeTransitions_();
            else {
                this._error = error;
                this._transition("error" /* InternalTaskState.ERROR */ );
            }
        };
        this.sleepTime = 0;
        this.maxSleepTime = this._ref.storage.maxUploadRetryTime;
        this._promise = new Promise((resolve, reject)=>{
            this._resolve = resolve;
            this._reject = reject;
            this._start();
        });
        // Prevent uncaught rejections on the internal promise from bubbling out
        // to the top level with a dummy handler.
        this._promise.then(null, ()=>{});
    }
    _makeProgressCallback() {
        const sizeBefore = this._transferred;
        return (loaded)=>this._updateProgress(sizeBefore + loaded);
    }
    _shouldDoResumable(blob) {
        return blob.size() > 262144;
    }
    _start() {
        if (this._state !== "running" /* InternalTaskState.RUNNING */ ) // This can happen if someone pauses us in a resume callback, for example.
        return;
        if (this._request !== undefined) return;
        if (this._resumable) {
            if (this._uploadUrl === undefined) this._createResumable();
            else {
                if (this._needToFetchStatus) this._fetchStatus();
                else if (this._needToFetchMetadata) // Happens if we miss the metadata on upload completion.
                this._fetchMetadata();
                else this.pendingTimeout = setTimeout(()=>{
                    this.pendingTimeout = undefined;
                    this._continueUpload();
                }, this.sleepTime);
            }
        } else this._oneShotUpload();
    }
    _resolveToken(callback) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        Promise.all([
            this._ref.storage._getAuthToken(),
            this._ref.storage._getAppCheckToken()
        ]).then(([authToken, appCheckToken])=>{
            switch(this._state){
                case "running" /* InternalTaskState.RUNNING */ :
                    callback(authToken, appCheckToken);
                    break;
                case "canceling" /* InternalTaskState.CANCELING */ :
                    this._transition("canceled" /* InternalTaskState.CANCELED */ );
                    break;
                case "pausing" /* InternalTaskState.PAUSING */ :
                    this._transition("paused" /* InternalTaskState.PAUSED */ );
                    break;
            }
        });
    }
    // TODO(andysoto): assert false
    _createResumable() {
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $4e5144ee615e69f8$var$createResumableUpload(this._ref.storage, this._ref._location, this._mappings, this._blob, this._metadata);
            const createRequest = this._ref.storage._makeRequest(requestInfo, $4e5144ee615e69f8$var$newTextConnection, authToken, appCheckToken);
            this._request = createRequest;
            createRequest.getPromise().then((url)=>{
                this._request = undefined;
                this._uploadUrl = url;
                this._needToFetchStatus = false;
                this.completeTransitions_();
            }, this._errorHandler);
        });
    }
    _fetchStatus() {
        // TODO(andysoto): assert(this.uploadUrl_ !== null);
        const url = this._uploadUrl;
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $4e5144ee615e69f8$var$getResumableUploadStatus(this._ref.storage, this._ref._location, url, this._blob);
            const statusRequest = this._ref.storage._makeRequest(requestInfo, $4e5144ee615e69f8$var$newTextConnection, authToken, appCheckToken);
            this._request = statusRequest;
            statusRequest.getPromise().then((status)=>{
                status;
                this._request = undefined;
                this._updateProgress(status.current);
                this._needToFetchStatus = false;
                if (status.finalized) this._needToFetchMetadata = true;
                this.completeTransitions_();
            }, this._errorHandler);
        });
    }
    _continueUpload() {
        const chunkSize = $4e5144ee615e69f8$var$RESUMABLE_UPLOAD_CHUNK_SIZE * this._chunkMultiplier;
        const status = new $4e5144ee615e69f8$var$ResumableUploadStatus(this._transferred, this._blob.size());
        // TODO(andysoto): assert(this.uploadUrl_ !== null);
        const url = this._uploadUrl;
        this._resolveToken((authToken, appCheckToken)=>{
            let requestInfo;
            try {
                requestInfo = $4e5144ee615e69f8$var$continueResumableUpload(this._ref._location, this._ref.storage, url, this._blob, chunkSize, this._mappings, status, this._makeProgressCallback());
            } catch (e) {
                this._error = e;
                this._transition("error" /* InternalTaskState.ERROR */ );
                return;
            }
            const uploadRequest = this._ref.storage._makeRequest(requestInfo, $4e5144ee615e69f8$var$newTextConnection, authToken, appCheckToken, /*retry=*/ false // Upload requests should not be retried as each retry should be preceded by another query request. Which is handled in this file.
            );
            this._request = uploadRequest;
            uploadRequest.getPromise().then((newStatus)=>{
                this._increaseMultiplier();
                this._request = undefined;
                this._updateProgress(newStatus.current);
                if (newStatus.finalized) {
                    this._metadata = newStatus.metadata;
                    this._transition("success" /* InternalTaskState.SUCCESS */ );
                } else this.completeTransitions_();
            }, this._errorHandler);
        });
    }
    _increaseMultiplier() {
        const currentSize = $4e5144ee615e69f8$var$RESUMABLE_UPLOAD_CHUNK_SIZE * this._chunkMultiplier;
        // Max chunk size is 32M.
        if (currentSize * 2 < 33554432) this._chunkMultiplier *= 2;
    }
    _fetchMetadata() {
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $4e5144ee615e69f8$var$getMetadata$2(this._ref.storage, this._ref._location, this._mappings);
            const metadataRequest = this._ref.storage._makeRequest(requestInfo, $4e5144ee615e69f8$var$newTextConnection, authToken, appCheckToken);
            this._request = metadataRequest;
            metadataRequest.getPromise().then((metadata)=>{
                this._request = undefined;
                this._metadata = metadata;
                this._transition("success" /* InternalTaskState.SUCCESS */ );
            }, this._metadataErrorHandler);
        });
    }
    _oneShotUpload() {
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $4e5144ee615e69f8$var$multipartUpload(this._ref.storage, this._ref._location, this._mappings, this._blob, this._metadata);
            const multipartRequest = this._ref.storage._makeRequest(requestInfo, $4e5144ee615e69f8$var$newTextConnection, authToken, appCheckToken);
            this._request = multipartRequest;
            multipartRequest.getPromise().then((metadata)=>{
                this._request = undefined;
                this._metadata = metadata;
                this._updateProgress(this._blob.size());
                this._transition("success" /* InternalTaskState.SUCCESS */ );
            }, this._errorHandler);
        });
    }
    _updateProgress(transferred) {
        const old = this._transferred;
        this._transferred = transferred;
        // A progress update can make the "transferred" value smaller (e.g. a
        // partial upload not completed by server, after which the "transferred"
        // value may reset to the value at the beginning of the request).
        if (this._transferred !== old) this._notifyObservers();
    }
    _transition(state) {
        if (this._state === state) return;
        switch(state){
            case "canceling" /* InternalTaskState.CANCELING */ :
            case "pausing" /* InternalTaskState.PAUSING */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING);
                this._state = state;
                if (this._request !== undefined) this._request.cancel();
                else if (this.pendingTimeout) {
                    clearTimeout(this.pendingTimeout);
                    this.pendingTimeout = undefined;
                    this.completeTransitions_();
                }
                break;
            case "running" /* InternalTaskState.RUNNING */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSED ||
                //        this.state_ === InternalTaskState.PAUSING);
                const wasPaused = this._state === "paused" /* InternalTaskState.PAUSED */ ;
                this._state = state;
                if (wasPaused) {
                    this._notifyObservers();
                    this._start();
                }
                break;
            case "paused" /* InternalTaskState.PAUSED */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSING);
                this._state = state;
                this._notifyObservers();
                break;
            case "canceled" /* InternalTaskState.CANCELED */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSED ||
                //        this.state_ === InternalTaskState.CANCELING);
                this._error = $4e5144ee615e69f8$var$canceled();
                this._state = state;
                this._notifyObservers();
                break;
            case "error" /* InternalTaskState.ERROR */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING ||
                //        this.state_ === InternalTaskState.CANCELING);
                this._state = state;
                this._notifyObservers();
                break;
            case "success" /* InternalTaskState.SUCCESS */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING ||
                //        this.state_ === InternalTaskState.CANCELING);
                this._state = state;
                this._notifyObservers();
                break;
        }
    }
    completeTransitions_() {
        switch(this._state){
            case "pausing" /* InternalTaskState.PAUSING */ :
                this._transition("paused" /* InternalTaskState.PAUSED */ );
                break;
            case "canceling" /* InternalTaskState.CANCELING */ :
                this._transition("canceled" /* InternalTaskState.CANCELED */ );
                break;
            case "running" /* InternalTaskState.RUNNING */ :
                this._start();
                break;
        }
    }
    /**
     * A snapshot of the current task state.
     */ get snapshot() {
        const externalState = $4e5144ee615e69f8$var$taskStateFromInternalTaskState(this._state);
        return {
            bytesTransferred: this._transferred,
            totalBytes: this._blob.size(),
            state: externalState,
            metadata: this._metadata,
            task: this,
            ref: this._ref
        };
    }
    /**
     * Adds a callback for an event.
     * @param type - The type of event to listen for.
     * @param nextOrObserver -
     *     The `next` function, which gets called for each item in
     *     the event stream, or an observer object with some or all of these three
     *     properties (`next`, `error`, `complete`).
     * @param error - A function that gets called with a `StorageError`
     *     if the event stream ends due to an error.
     * @param completed - A function that gets called if the
     *     event stream ends normally.
     * @returns
     *     If only the event argument is passed, returns a function you can use to
     *     add callbacks (see the examples above). If more than just the event
     *     argument is passed, returns a function you can call to unregister the
     *     callbacks.
     */ on(type, nextOrObserver, error, completed) {
        // Note: `type` isn't being used. Its type is also incorrect. TaskEvent should not be a string.
        const observer = new $4e5144ee615e69f8$var$Observer(nextOrObserver || undefined, error || undefined, completed || undefined);
        this._addObserver(observer);
        return ()=>{
            this._removeObserver(observer);
        };
    }
    /**
     * This object behaves like a Promise, and resolves with its snapshot data
     * when the upload completes.
     * @param onFulfilled - The fulfillment callback. Promise chaining works as normal.
     * @param onRejected - The rejection callback.
     */ then(onFulfilled, onRejected) {
        // These casts are needed so that TypeScript can infer the types of the
        // resulting Promise.
        return this._promise.then(onFulfilled, onRejected);
    }
    /**
     * Equivalent to calling `then(null, onRejected)`.
     */ catch(onRejected) {
        return this.then(null, onRejected);
    }
    /**
     * Adds the given observer.
     */ _addObserver(observer) {
        this._observers.push(observer);
        this._notifyObserver(observer);
    }
    /**
     * Removes the given observer.
     */ _removeObserver(observer) {
        const i = this._observers.indexOf(observer);
        if (i !== -1) this._observers.splice(i, 1);
    }
    _notifyObservers() {
        this._finishPromise();
        const observers = this._observers.slice();
        observers.forEach((observer)=>{
            this._notifyObserver(observer);
        });
    }
    _finishPromise() {
        if (this._resolve !== undefined) {
            let triggered = true;
            switch($4e5144ee615e69f8$var$taskStateFromInternalTaskState(this._state)){
                case $4e5144ee615e69f8$export$9dc4203728a9a7c9.SUCCESS:
                    $4e5144ee615e69f8$var$async(this._resolve.bind(null, this.snapshot))();
                    break;
                case $4e5144ee615e69f8$export$9dc4203728a9a7c9.CANCELED:
                case $4e5144ee615e69f8$export$9dc4203728a9a7c9.ERROR:
                    const toCall = this._reject;
                    $4e5144ee615e69f8$var$async(toCall.bind(null, this._error))();
                    break;
                default:
                    triggered = false;
                    break;
            }
            if (triggered) {
                this._resolve = undefined;
                this._reject = undefined;
            }
        }
    }
    _notifyObserver(observer) {
        const externalState = $4e5144ee615e69f8$var$taskStateFromInternalTaskState(this._state);
        switch(externalState){
            case $4e5144ee615e69f8$export$9dc4203728a9a7c9.RUNNING:
            case $4e5144ee615e69f8$export$9dc4203728a9a7c9.PAUSED:
                if (observer.next) $4e5144ee615e69f8$var$async(observer.next.bind(observer, this.snapshot))();
                break;
            case $4e5144ee615e69f8$export$9dc4203728a9a7c9.SUCCESS:
                if (observer.complete) $4e5144ee615e69f8$var$async(observer.complete.bind(observer))();
                break;
            case $4e5144ee615e69f8$export$9dc4203728a9a7c9.CANCELED:
            case $4e5144ee615e69f8$export$9dc4203728a9a7c9.ERROR:
                if (observer.error) $4e5144ee615e69f8$var$async(observer.error.bind(observer, this._error))();
                break;
            default:
                // TODO(andysoto): assert(false);
                if (observer.error) $4e5144ee615e69f8$var$async(observer.error.bind(observer, this._error))();
        }
    }
    /**
     * Resumes a paused task. Has no effect on a currently running or failed task.
     * @returns True if the operation took effect, false if ignored.
     */ resume() {
        const valid = this._state === "paused" /* InternalTaskState.PAUSED */  || this._state === "pausing" /* InternalTaskState.PAUSING */ ;
        if (valid) this._transition("running" /* InternalTaskState.RUNNING */ );
        return valid;
    }
    /**
     * Pauses a currently running task. Has no effect on a paused or failed task.
     * @returns True if the operation took effect, false if ignored.
     */ pause() {
        const valid = this._state === "running" /* InternalTaskState.RUNNING */ ;
        if (valid) this._transition("pausing" /* InternalTaskState.PAUSING */ );
        return valid;
    }
    /**
     * Cancels a currently running or paused task. Has no effect on a complete or
     * failed task.
     * @returns True if the operation took effect, false if ignored.
     */ cancel() {
        const valid = this._state === "running" /* InternalTaskState.RUNNING */  || this._state === "pausing" /* InternalTaskState.PAUSING */ ;
        if (valid) this._transition("canceling" /* InternalTaskState.CANCELING */ );
        return valid;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides methods to interact with a bucket in the Firebase Storage service.
 * @internal
 * @param _location - An fbs.location, or the URL at
 *     which to base this object, in one of the following forms:
 *         gs://<bucket>/<object-path>
 *         http[s]://firebasestorage.googleapis.com/
 *                     <api-version>/b/<bucket>/o/<object-path>
 *     Any query or fragment strings will be ignored in the http[s]
 *     format. If no value is passed, the storage object will use a URL based on
 *     the project ID of the base firebase.App instance.
 */ class $4e5144ee615e69f8$var$Reference {
    constructor(_service, location){
        this._service = _service;
        if (location instanceof $4e5144ee615e69f8$export$adb98fff6714334) this._location = location;
        else this._location = $4e5144ee615e69f8$export$adb98fff6714334.makeFromUrl(location, _service.host);
    }
    /**
     * Returns the URL for the bucket and path this object references,
     *     in the form gs://<bucket>/<object-path>
     * @override
     */ toString() {
        return 'gs://' + this._location.bucket + '/' + this._location.path;
    }
    _newRef(service, location) {
        return new $4e5144ee615e69f8$var$Reference(service, location);
    }
    /**
     * A reference to the root of this object's bucket.
     */ get root() {
        const location = new $4e5144ee615e69f8$export$adb98fff6714334(this._location.bucket, '');
        return this._newRef(this._service, location);
    }
    /**
     * The name of the bucket containing this reference's object.
     */ get bucket() {
        return this._location.bucket;
    }
    /**
     * The full path of this object.
     */ get fullPath() {
        return this._location.path;
    }
    /**
     * The short name of this object, which is the last component of the full path.
     * For example, if fullPath is 'full/path/image.png', name is 'image.png'.
     */ get name() {
        return $4e5144ee615e69f8$var$lastComponent(this._location.path);
    }
    /**
     * The `StorageService` instance this `StorageReference` is associated with.
     */ get storage() {
        return this._service;
    }
    /**
     * A `StorageReference` pointing to the parent location of this `StorageReference`, or null if
     * this reference is the root.
     */ get parent() {
        const newPath = $4e5144ee615e69f8$var$parent(this._location.path);
        if (newPath === null) return null;
        const location = new $4e5144ee615e69f8$export$adb98fff6714334(this._location.bucket, newPath);
        return new $4e5144ee615e69f8$var$Reference(this._service, location);
    }
    /**
     * Utility function to throw an error in methods that do not accept a root reference.
     */ _throwIfRoot(name) {
        if (this._location.path === '') throw $4e5144ee615e69f8$export$61f54cdc36500ad(name);
    }
}
/**
 * Download the bytes at the object's location.
 * @returns A Promise containing the downloaded bytes.
 */ function $4e5144ee615e69f8$var$getBytesInternal(ref, maxDownloadSizeBytes) {
    ref._throwIfRoot('getBytes');
    const requestInfo = $4e5144ee615e69f8$var$getBytes$1(ref.storage, ref._location, maxDownloadSizeBytes);
    return ref.storage.makeRequestWithTokens(requestInfo, $4e5144ee615e69f8$var$newBytesConnection).then((bytes)=>maxDownloadSizeBytes !== undefined ? bytes.slice(0, maxDownloadSizeBytes) : bytes);
}
/**
 * Download the bytes at the object's location.
 * @returns A Promise containing the downloaded blob.
 */ function $4e5144ee615e69f8$var$getBlobInternal(ref, maxDownloadSizeBytes) {
    ref._throwIfRoot('getBlob');
    const requestInfo = $4e5144ee615e69f8$var$getBytes$1(ref.storage, ref._location, maxDownloadSizeBytes);
    return ref.storage.makeRequestWithTokens(requestInfo, $4e5144ee615e69f8$var$newBlobConnection).then((blob)=>maxDownloadSizeBytes !== undefined ? blob.slice(0, maxDownloadSizeBytes) : blob);
}
/**
 * Uploads data to this object's location.
 * The upload is not resumable.
 *
 * @param ref - StorageReference where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the newly uploaded data.
 * @returns A Promise containing an UploadResult
 */ function $4e5144ee615e69f8$var$uploadBytes$1(ref, data, metadata) {
    ref._throwIfRoot('uploadBytes');
    const requestInfo = $4e5144ee615e69f8$var$multipartUpload(ref.storage, ref._location, $4e5144ee615e69f8$var$getMappings(), new $4e5144ee615e69f8$export$8deea8629ff0b8a7(data, true), metadata);
    return ref.storage.makeRequestWithTokens(requestInfo, $4e5144ee615e69f8$var$newTextConnection).then((finalMetadata)=>{
        return {
            metadata: finalMetadata,
            ref: ref
        };
    });
}
/**
 * Uploads data to this object's location.
 * The upload can be paused and resumed, and exposes progress updates.
 * @public
 * @param ref - StorageReference where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the newly uploaded data.
 * @returns An UploadTask
 */ function $4e5144ee615e69f8$var$uploadBytesResumable$1(ref, data, metadata) {
    ref._throwIfRoot('uploadBytesResumable');
    return new $4e5144ee615e69f8$export$86a2a9b92406a048(ref, new $4e5144ee615e69f8$export$8deea8629ff0b8a7(data), metadata);
}
/**
 * Uploads a string to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - StorageReference where string should be uploaded.
 * @param value - The string to upload.
 * @param format - The format of the string to upload.
 * @param metadata - Metadata for the newly uploaded string.
 * @returns A Promise containing an UploadResult
 */ function $4e5144ee615e69f8$var$uploadString$1(ref, value, format = $4e5144ee615e69f8$export$f22e7fe56db8ae03.RAW, metadata) {
    ref._throwIfRoot('uploadString');
    const data = $4e5144ee615e69f8$export$d80b9b5a2ccdd3e0(format, value);
    const metadataClone = {
        ...metadata
    };
    if (metadataClone['contentType'] == null && data.contentType != null) metadataClone['contentType'] = data.contentType;
    return $4e5144ee615e69f8$var$uploadBytes$1(ref, data.data, metadataClone);
}
/**
 * List all items (files) and prefixes (folders) under this storage reference.
 *
 * This is a helper method for calling list() repeatedly until there are
 * no more results. The default pagination size is 1000.
 *
 * Note: The results may not be consistent if objects are changed while this
 * operation is running.
 *
 * Warning: listAll may potentially consume too many resources if there are
 * too many results.
 * @public
 * @param ref - StorageReference to get list from.
 *
 * @returns A Promise that resolves with all the items and prefixes under
 *      the current storage reference. `prefixes` contains references to
 *      sub-directories and `items` contains references to objects in this
 *      folder. `nextPageToken` is never returned.
 */ function $4e5144ee615e69f8$var$listAll$1(ref) {
    const accumulator = {
        prefixes: [],
        items: []
    };
    return $4e5144ee615e69f8$var$listAllHelper(ref, accumulator).then(()=>accumulator);
}
/**
 * Separated from listAll because async functions can't use "arguments".
 * @param ref
 * @param accumulator
 * @param pageToken
 */ async function $4e5144ee615e69f8$var$listAllHelper(ref, accumulator, pageToken) {
    const opt = {
        pageToken: // maxResults is 1000 by default.
        pageToken
    };
    const nextPage = await $4e5144ee615e69f8$var$list$1(ref, opt);
    accumulator.prefixes.push(...nextPage.prefixes);
    accumulator.items.push(...nextPage.items);
    if (nextPage.nextPageToken != null) await $4e5144ee615e69f8$var$listAllHelper(ref, accumulator, nextPage.nextPageToken);
}
/**
 * List items (files) and prefixes (folders) under this storage reference.
 *
 * List API is only available for Firebase Rules Version 2.
 *
 * GCS is a key-blob store. Firebase Storage imposes the semantic of '/'
 * delimited folder structure.
 * Refer to GCS's List API if you want to learn more.
 *
 * To adhere to Firebase Rules's Semantics, Firebase Storage does not
 * support objects whose paths end with "/" or contain two consecutive
 * "/"s. Firebase Storage List API will filter these unsupported objects.
 * list() may fail if there are too many unsupported objects in the bucket.
 * @public
 *
 * @param ref - StorageReference to get list from.
 * @param options - See ListOptions for details.
 * @returns A Promise that resolves with the items and prefixes.
 *      `prefixes` contains references to sub-folders and `items`
 *      contains references to objects in this folder. `nextPageToken`
 *      can be used to get the rest of the results.
 */ function $4e5144ee615e69f8$var$list$1(ref, options) {
    if (options != null) {
        if (typeof options.maxResults === 'number') $4e5144ee615e69f8$var$validateNumber('options.maxResults', /* minValue= */ 1, /* maxValue= */ 1000, options.maxResults);
    }
    const op = options || {};
    const requestInfo = $4e5144ee615e69f8$var$list$2(ref.storage, ref._location, /*delimiter= */ '/', op.pageToken, op.maxResults);
    return ref.storage.makeRequestWithTokens(requestInfo, $4e5144ee615e69f8$var$newTextConnection);
}
/**
 * A `Promise` that resolves with the metadata for this object. If this
 * object doesn't exist or metadata cannot be retrieved, the promise is
 * rejected.
 * @public
 * @param ref - StorageReference to get metadata from.
 */ function $4e5144ee615e69f8$var$getMetadata$1(ref) {
    ref._throwIfRoot('getMetadata');
    const requestInfo = $4e5144ee615e69f8$var$getMetadata$2(ref.storage, ref._location, $4e5144ee615e69f8$var$getMappings());
    return ref.storage.makeRequestWithTokens(requestInfo, $4e5144ee615e69f8$var$newTextConnection);
}
/**
 * Updates the metadata for this object.
 * @public
 * @param ref - StorageReference to update metadata for.
 * @param metadata - The new metadata for the object.
 *     Only values that have been explicitly set will be changed. Explicitly
 *     setting a value to null will remove the metadata.
 * @returns A `Promise` that resolves
 *     with the new metadata for this object.
 *     See `firebaseStorage.Reference.prototype.getMetadata`
 */ function $4e5144ee615e69f8$var$updateMetadata$1(ref, metadata) {
    ref._throwIfRoot('updateMetadata');
    const requestInfo = $4e5144ee615e69f8$var$updateMetadata$2(ref.storage, ref._location, metadata, $4e5144ee615e69f8$var$getMappings());
    return ref.storage.makeRequestWithTokens(requestInfo, $4e5144ee615e69f8$var$newTextConnection);
}
/**
 * Returns the download URL for the given Reference.
 * @public
 * @returns A `Promise` that resolves with the download
 *     URL for this object.
 */ function $4e5144ee615e69f8$var$getDownloadURL$1(ref) {
    ref._throwIfRoot('getDownloadURL');
    const requestInfo = $4e5144ee615e69f8$var$getDownloadUrl(ref.storage, ref._location, $4e5144ee615e69f8$var$getMappings());
    return ref.storage.makeRequestWithTokens(requestInfo, $4e5144ee615e69f8$var$newTextConnection).then((url)=>{
        if (url === null) throw $4e5144ee615e69f8$var$noDownloadURL();
        return url;
    });
}
/**
 * Deletes the object at this location.
 * @public
 * @param ref - StorageReference for object to delete.
 * @returns A `Promise` that resolves if the deletion succeeds.
 */ function $4e5144ee615e69f8$var$deleteObject$1(ref) {
    ref._throwIfRoot('deleteObject');
    const requestInfo = $4e5144ee615e69f8$var$deleteObject$2(ref.storage, ref._location);
    return ref.storage.makeRequestWithTokens(requestInfo, $4e5144ee615e69f8$var$newTextConnection);
}
/**
 * Returns reference for object obtained by appending `childPath` to `ref`.
 *
 * @param ref - StorageReference to get child of.
 * @param childPath - Child path from provided ref.
 * @returns A reference to the object obtained by
 * appending childPath, removing any duplicate, beginning, or trailing
 * slashes.
 *
 */ function $4e5144ee615e69f8$var$_getChild$1(ref, childPath) {
    const newPath = $4e5144ee615e69f8$var$child(ref._location.path, childPath);
    const location = new $4e5144ee615e69f8$export$adb98fff6714334(ref._location.bucket, newPath);
    return new $4e5144ee615e69f8$var$Reference(ref.storage, location);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $4e5144ee615e69f8$var$isUrl(path) {
    return /^[A-Za-z]+:\/\//.test(path);
}
/**
 * Returns a firebaseStorage.Reference for the given url.
 */ function $4e5144ee615e69f8$var$refFromURL(service, url) {
    return new $4e5144ee615e69f8$var$Reference(service, url);
}
/**
 * Returns a firebaseStorage.Reference for the given path in the default
 * bucket.
 */ function $4e5144ee615e69f8$var$refFromPath(ref, path) {
    if (ref instanceof $4e5144ee615e69f8$var$FirebaseStorageImpl) {
        const service = ref;
        if (service._bucket == null) throw $4e5144ee615e69f8$var$noDefaultBucket();
        const reference = new $4e5144ee615e69f8$var$Reference(service, service._bucket);
        if (path != null) return $4e5144ee615e69f8$var$refFromPath(reference, path);
        else return reference;
    } else {
        // ref is a Reference
        if (path !== undefined) return $4e5144ee615e69f8$var$_getChild$1(ref, path);
        else return ref;
    }
}
function $4e5144ee615e69f8$var$ref$1(serviceOrRef, pathOrUrl) {
    if (pathOrUrl && $4e5144ee615e69f8$var$isUrl(pathOrUrl)) {
        if (serviceOrRef instanceof $4e5144ee615e69f8$var$FirebaseStorageImpl) return $4e5144ee615e69f8$var$refFromURL(serviceOrRef, pathOrUrl);
        else throw $4e5144ee615e69f8$export$8f74d9881d1936fd('To use ref(service, url), the first argument must be a Storage instance.');
    } else return $4e5144ee615e69f8$var$refFromPath(serviceOrRef, pathOrUrl);
}
function $4e5144ee615e69f8$var$extractBucket(host, config) {
    const bucketString = config?.[$4e5144ee615e69f8$var$CONFIG_STORAGE_BUCKET_KEY];
    if (bucketString == null) return null;
    return $4e5144ee615e69f8$export$adb98fff6714334.makeFromBucketSpec(bucketString, host);
}
function $4e5144ee615e69f8$var$connectStorageEmulator$1(storage, host, port, options = {}) {
    storage.host = `${host}:${port}`;
    const useSsl = (0, $b5eeaa155499f6b0$export$5b4d24b45140ad90)(host);
    // Workaround to get cookies in Firebase Studio
    if (useSsl) {
        (0, $b5eeaa155499f6b0$export$c0f0d0ce4283a937)(`https://${storage.host}/b`);
        (0, $b5eeaa155499f6b0$export$fd3d2954543183b1)('Storage', true);
    }
    storage._isUsingEmulator = true;
    storage._protocol = useSsl ? 'https' : 'http';
    const { mockUserToken: mockUserToken } = options;
    if (mockUserToken) storage._overrideAuthToken = typeof mockUserToken === 'string' ? mockUserToken : (0, $b5eeaa155499f6b0$export$367bf224123348f1)(mockUserToken, storage.app.options.projectId);
}
/**
 * A service that provides Firebase Storage Reference instances.
 * @param opt_url - gs:// url to a custom Storage Bucket
 *
 * @internal
 */ class $4e5144ee615e69f8$var$FirebaseStorageImpl {
    constructor(/**
     * FirebaseApp associated with this StorageService instance.
     */ app, _authProvider, /**
     * @internal
     */ _appCheckProvider, /**
     * @internal
     */ _url, _firebaseVersion, _isUsingEmulator = false){
        this.app = app;
        this._authProvider = _authProvider;
        this._appCheckProvider = _appCheckProvider;
        this._url = _url;
        this._firebaseVersion = _firebaseVersion;
        this._isUsingEmulator = _isUsingEmulator;
        this._bucket = null;
        /**
         * This string can be in the formats:
         * - host
         * - host:port
         */ this._host = $4e5144ee615e69f8$var$DEFAULT_HOST;
        this._protocol = 'https';
        this._appId = null;
        this._deleted = false;
        this._maxOperationRetryTime = $4e5144ee615e69f8$var$DEFAULT_MAX_OPERATION_RETRY_TIME;
        this._maxUploadRetryTime = $4e5144ee615e69f8$var$DEFAULT_MAX_UPLOAD_RETRY_TIME;
        this._requests = new Set();
        if (_url != null) this._bucket = $4e5144ee615e69f8$export$adb98fff6714334.makeFromBucketSpec(_url, this._host);
        else this._bucket = $4e5144ee615e69f8$var$extractBucket(this._host, this.app.options);
    }
    /**
     * The host string for this service, in the form of `host` or
     * `host:port`.
     */ get host() {
        return this._host;
    }
    set host(host) {
        this._host = host;
        if (this._url != null) this._bucket = $4e5144ee615e69f8$export$adb98fff6714334.makeFromBucketSpec(this._url, host);
        else this._bucket = $4e5144ee615e69f8$var$extractBucket(host, this.app.options);
    }
    /**
     * The maximum time to retry uploads in milliseconds.
     */ get maxUploadRetryTime() {
        return this._maxUploadRetryTime;
    }
    set maxUploadRetryTime(time) {
        $4e5144ee615e69f8$var$validateNumber('time', /* minValue=*/ 0, /* maxValue= */ Number.POSITIVE_INFINITY, time);
        this._maxUploadRetryTime = time;
    }
    /**
     * The maximum time to retry operations other than uploads or downloads in
     * milliseconds.
     */ get maxOperationRetryTime() {
        return this._maxOperationRetryTime;
    }
    set maxOperationRetryTime(time) {
        $4e5144ee615e69f8$var$validateNumber('time', /* minValue=*/ 0, /* maxValue= */ Number.POSITIVE_INFINITY, time);
        this._maxOperationRetryTime = time;
    }
    async _getAuthToken() {
        if (this._overrideAuthToken) return this._overrideAuthToken;
        const auth = this._authProvider.getImmediate({
            optional: true
        });
        if (auth) {
            const tokenData = await auth.getToken();
            if (tokenData !== null) return tokenData.accessToken;
        }
        return null;
    }
    async _getAppCheckToken() {
        if ((0, $1ad63299fe0e9682$export$643c8bc6c389f34e)(this.app) && this.app.settings.appCheckToken) return this.app.settings.appCheckToken;
        const appCheck = this._appCheckProvider.getImmediate({
            optional: true
        });
        if (appCheck) {
            const result = await appCheck.getToken();
            // TODO: What do we want to do if there is an error getting the token?
            // Context: appCheck.getToken() will never throw even if an error happened. In the error case, a dummy token will be
            // returned along with an error field describing the error. In general, we shouldn't care about the error condition and just use
            // the token (actual or dummy) to send requests.
            return result.token;
        }
        return null;
    }
    /**
     * Stop running requests and prevent more from being created.
     */ _delete() {
        if (!this._deleted) {
            this._deleted = true;
            this._requests.forEach((request)=>request.cancel());
            this._requests.clear();
        }
        return Promise.resolve();
    }
    /**
     * Returns a new firebaseStorage.Reference object referencing this StorageService
     * at the given Location.
     */ _makeStorageReference(loc) {
        return new $4e5144ee615e69f8$var$Reference(this, loc);
    }
    /**
     * @param requestInfo - HTTP RequestInfo object
     * @param authToken - Firebase auth token
     */ _makeRequest(requestInfo, requestFactory, authToken, appCheckToken, retry = true) {
        if (!this._deleted) {
            const request = $4e5144ee615e69f8$var$makeRequest(requestInfo, this._appId, authToken, appCheckToken, requestFactory, this._firebaseVersion, retry, this._isUsingEmulator);
            this._requests.add(request);
            // Request removes itself from set when complete.
            request.getPromise().then(()=>this._requests.delete(request), ()=>this._requests.delete(request));
            return request;
        } else return new $4e5144ee615e69f8$var$FailRequest($4e5144ee615e69f8$var$appDeleted());
    }
    async makeRequestWithTokens(requestInfo, requestFactory) {
        const [authToken, appCheckToken] = await Promise.all([
            this._getAuthToken(),
            this._getAppCheckToken()
        ]);
        return this._makeRequest(requestInfo, requestFactory, authToken, appCheckToken).getPromise();
    }
}
const $4e5144ee615e69f8$var$name = "@firebase/storage";
const $4e5144ee615e69f8$var$version = "0.14.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Type constant for Firebase Storage.
 */ const $4e5144ee615e69f8$var$STORAGE_TYPE = 'storage';
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Downloads the data at the object's location. Returns an error if the object
 * is not found.
 *
 * To use this functionality, you have to whitelist your app's origin in your
 * Cloud Storage bucket. See also
 * https://cloud.google.com/storage/docs/configuring-cors
 *
 * @public
 * @param ref - StorageReference where data should be downloaded.
 * @param maxDownloadSizeBytes - If set, the maximum allowed size in bytes to
 * retrieve.
 * @returns A Promise containing the object's bytes
 */ function $4e5144ee615e69f8$export$a3521add2594f3c8(ref, maxDownloadSizeBytes) {
    ref = (0, $b5eeaa155499f6b0$export$4befe9b5fa509a1b)(ref);
    return $4e5144ee615e69f8$var$getBytesInternal(ref, maxDownloadSizeBytes);
}
/**
 * Uploads data to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - {@link StorageReference} where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the data to upload.
 * @returns A Promise containing an UploadResult
 */ function $4e5144ee615e69f8$export$ac40f56b52f99dd1(ref, data, metadata) {
    ref = (0, $b5eeaa155499f6b0$export$4befe9b5fa509a1b)(ref);
    return $4e5144ee615e69f8$var$uploadBytes$1(ref, data, metadata);
}
/**
 * Uploads a string to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - {@link StorageReference} where string should be uploaded.
 * @param value - The string to upload.
 * @param format - The format of the string to upload.
 * @param metadata - Metadata for the string to upload.
 * @returns A Promise containing an UploadResult
 */ function $4e5144ee615e69f8$export$d885b2eb178808b3(ref, value, format, metadata) {
    ref = (0, $b5eeaa155499f6b0$export$4befe9b5fa509a1b)(ref);
    return $4e5144ee615e69f8$var$uploadString$1(ref, value, format, metadata);
}
/**
 * Uploads data to this object's location.
 * The upload can be paused and resumed, and exposes progress updates.
 * @public
 * @param ref - {@link StorageReference} where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the data to upload.
 * @returns An UploadTask
 */ function $4e5144ee615e69f8$export$3895d39eb7ac9b25(ref, data, metadata) {
    ref = (0, $b5eeaa155499f6b0$export$4befe9b5fa509a1b)(ref);
    return $4e5144ee615e69f8$var$uploadBytesResumable$1(ref, data, metadata);
}
/**
 * A `Promise` that resolves with the metadata for this object. If this
 * object doesn't exist or metadata cannot be retrieved, the promise is
 * rejected.
 * @public
 * @param ref - {@link StorageReference} to get metadata from.
 */ function $4e5144ee615e69f8$export$8548546c0aa631e6(ref) {
    ref = (0, $b5eeaa155499f6b0$export$4befe9b5fa509a1b)(ref);
    return $4e5144ee615e69f8$var$getMetadata$1(ref);
}
/**
 * Updates the metadata for this object.
 * @public
 * @param ref - {@link StorageReference} to update metadata for.
 * @param metadata - The new metadata for the object.
 *     Only values that have been explicitly set will be changed. Explicitly
 *     setting a value to null will remove the metadata.
 * @returns A `Promise` that resolves with the new metadata for this object.
 */ function $4e5144ee615e69f8$export$f64791b2d30456a0(ref, metadata) {
    ref = (0, $b5eeaa155499f6b0$export$4befe9b5fa509a1b)(ref);
    return $4e5144ee615e69f8$var$updateMetadata$1(ref, metadata);
}
/**
 * List items (files) and prefixes (folders) under this storage reference.
 *
 * List API is only available for Firebase Rules Version 2.
 *
 * GCS is a key-blob store. Firebase Storage imposes the semantic of '/'
 * delimited folder structure.
 * Refer to GCS's List API if you want to learn more.
 *
 * To adhere to Firebase Rules's Semantics, Firebase Storage does not
 * support objects whose paths end with "/" or contain two consecutive
 * "/"s. Firebase Storage List API will filter these unsupported objects.
 * list() may fail if there are too many unsupported objects in the bucket.
 * @public
 *
 * @param ref - {@link StorageReference} to get list from.
 * @param options - See {@link ListOptions} for details.
 * @returns A `Promise` that resolves with the items and prefixes.
 *      `prefixes` contains references to sub-folders and `items`
 *      contains references to objects in this folder. `nextPageToken`
 *      can be used to get the rest of the results.
 */ function $4e5144ee615e69f8$export$8837f4fc672e936d(ref, options) {
    ref = (0, $b5eeaa155499f6b0$export$4befe9b5fa509a1b)(ref);
    return $4e5144ee615e69f8$var$list$1(ref, options);
}
/**
 * List all items (files) and prefixes (folders) under this storage reference.
 *
 * This is a helper method for calling list() repeatedly until there are
 * no more results. The default pagination size is 1000.
 *
 * Note: The results may not be consistent if objects are changed while this
 * operation is running.
 *
 * Warning: `listAll` may potentially consume too many resources if there are
 * too many results.
 * @public
 * @param ref - {@link StorageReference} to get list from.
 *
 * @returns A `Promise` that resolves with all the items and prefixes under
 *      the current storage reference. `prefixes` contains references to
 *      sub-directories and `items` contains references to objects in this
 *      folder. `nextPageToken` is never returned.
 */ function $4e5144ee615e69f8$export$6a265a7d315dec03(ref) {
    ref = (0, $b5eeaa155499f6b0$export$4befe9b5fa509a1b)(ref);
    return $4e5144ee615e69f8$var$listAll$1(ref);
}
/**
 * Returns the download URL for the given {@link StorageReference}.
 * @public
 * @param ref - {@link StorageReference} to get the download URL for.
 * @returns A `Promise` that resolves with the download
 *     URL for this object.
 */ function $4e5144ee615e69f8$export$c8bf645a0c2a7d9f(ref) {
    ref = (0, $b5eeaa155499f6b0$export$4befe9b5fa509a1b)(ref);
    return $4e5144ee615e69f8$var$getDownloadURL$1(ref);
}
/**
 * Deletes the object at this location.
 * @public
 * @param ref - {@link StorageReference} for object to delete.
 * @returns A `Promise` that resolves if the deletion succeeds.
 */ function $4e5144ee615e69f8$export$39c5ed4ec960eade(ref) {
    ref = (0, $b5eeaa155499f6b0$export$4befe9b5fa509a1b)(ref);
    return $4e5144ee615e69f8$var$deleteObject$1(ref);
}
function $4e5144ee615e69f8$export$eff4d24c3ff7876e(serviceOrRef, pathOrUrl) {
    serviceOrRef = (0, $b5eeaa155499f6b0$export$4befe9b5fa509a1b)(serviceOrRef);
    return $4e5144ee615e69f8$var$ref$1(serviceOrRef, pathOrUrl);
}
/**
 * @internal
 */ function $4e5144ee615e69f8$export$9acd24c0fce96a85(ref, childPath) {
    return $4e5144ee615e69f8$var$_getChild$1(ref, childPath);
}
/**
 * Gets a {@link FirebaseStorage} instance for the given Firebase app.
 * @public
 * @param app - Firebase app to get {@link FirebaseStorage} instance for.
 * @param bucketUrl - The gs:// url to your Firebase Storage Bucket.
 * If not passed, uses the app's default Storage Bucket.
 * @returns A {@link FirebaseStorage} instance.
 */ function $4e5144ee615e69f8$export$fbd9b57a66480737(app = (0, $1ad63299fe0e9682$export$f9962582c9e66d99)(), bucketUrl) {
    app = (0, $b5eeaa155499f6b0$export$4befe9b5fa509a1b)(app);
    const storageProvider = (0, $1ad63299fe0e9682$export$fa0d6da0f5838f50)(app, $4e5144ee615e69f8$var$STORAGE_TYPE);
    const storageInstance = storageProvider.getImmediate({
        identifier: bucketUrl
    });
    const emulator = (0, $b5eeaa155499f6b0$export$a3febcf1f14a3a0c)('storage');
    if (emulator) $4e5144ee615e69f8$export$9850e656f954b889(storageInstance, ...emulator);
    return storageInstance;
}
/**
 * Modify this {@link FirebaseStorage} instance to communicate with the Cloud Storage emulator.
 *
 * @param storage - The {@link FirebaseStorage} instance
 * @param host - The emulator host (ex: localhost)
 * @param port - The emulator port (ex: 5001)
 * @param options - Emulator options. `options.mockUserToken` is the mock auth
 * token to use for unit testing Security Rules.
 * @public
 */ function $4e5144ee615e69f8$export$9850e656f954b889(storage, host, port, options = {}) {
    $4e5144ee615e69f8$var$connectStorageEmulator$1(storage, host, port, options);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Downloads the data at the object's location. Returns an error if the object
 * is not found.
 *
 * To use this functionality, you have to whitelist your app's origin in your
 * Cloud Storage bucket. See also
 * https://cloud.google.com/storage/docs/configuring-cors
 *
 * This API is not available in Node.
 *
 * @public
 * @param ref - StorageReference where data should be downloaded.
 * @param maxDownloadSizeBytes - If set, the maximum allowed size in bytes to
 * retrieve.
 * @returns A Promise that resolves with a Blob containing the object's bytes
 */ function $4e5144ee615e69f8$export$37610328929d7521(ref, maxDownloadSizeBytes) {
    ref = (0, $b5eeaa155499f6b0$export$4befe9b5fa509a1b)(ref);
    return $4e5144ee615e69f8$var$getBlobInternal(ref, maxDownloadSizeBytes);
}
/**
 * Downloads the data at the object's location. Raises an error event if the
 * object is not found.
 *
 * This API is only available in Node.
 *
 * @public
 * @param ref - StorageReference where data should be downloaded.
 * @param maxDownloadSizeBytes - If set, the maximum allowed size in bytes to
 * retrieve.
 * @returns A stream with the object's data as bytes
 */ function $4e5144ee615e69f8$export$747191980cdf43e8(ref, maxDownloadSizeBytes) {
    throw new Error('getStream() is only supported by NodeJS builds');
}
/**
 * Cloud Storage for Firebase
 *
 * @packageDocumentation
 */ function $4e5144ee615e69f8$var$factory(container, { instanceIdentifier: url }) {
    const app = container.getProvider('app').getImmediate();
    const authProvider = container.getProvider('auth-internal');
    const appCheckProvider = container.getProvider('app-check-internal');
    return new $4e5144ee615e69f8$var$FirebaseStorageImpl(app, authProvider, appCheckProvider, url, (0, $1ad63299fe0e9682$export$31499a9cd224b78c));
}
function $4e5144ee615e69f8$var$registerStorage() {
    (0, $1ad63299fe0e9682$export$c930050e7bb63965)(new (0, $be24428bd46df3e1$export$16fa2f45be04daa8)($4e5144ee615e69f8$var$STORAGE_TYPE, $4e5144ee615e69f8$var$factory, "PUBLIC" /* ComponentType.PUBLIC */ ).setMultipleInstances(true));
    //RUNTIME_ENV will be replaced during the compilation to "node" for nodejs and an empty string for browser
    (0, $1ad63299fe0e9682$export$d29d5299a7137abc)($4e5144ee615e69f8$var$name, $4e5144ee615e69f8$var$version, '');
    // BUILD_TARGET will be replaced by values like esm, cjs, etc during the compilation
    (0, $1ad63299fe0e9682$export$d29d5299a7137abc)($4e5144ee615e69f8$var$name, $4e5144ee615e69f8$var$version, 'esm2020');
}
$4e5144ee615e69f8$var$registerStorage();







const $ee5ed6acd5aa4518$var$firebaseConfig = {
    apiKey: "AIzaSyDdozoyQCF0P9Iia3N9UI8-EMdT1TrLEtM",
    authDomain: "f1-sim-game.firebaseapp.com",
    projectId: "f1-sim-game",
    storageBucket: "f1-sim-game.firebasestorage.app",
    messagingSenderId: "519679428139",
    appId: "1:519679428139:web:49c16ce1ae3e94a5ac4c6e",
    measurementId: "G-LPTK1C7S0T"
};
// Initialize Firebase
const $ee5ed6acd5aa4518$var$app = (0, $1ad63299fe0e9682$export$c55cfd413944906d)($ee5ed6acd5aa4518$var$firebaseConfig);
const $ee5ed6acd5aa4518$var$analytics = (0, $a038c313b6ee4f68$export$b0297573c90085aa)($ee5ed6acd5aa4518$var$app);
const $ee5ed6acd5aa4518$var$storage = (0, $4e5144ee615e69f8$export$fbd9b57a66480737)($ee5ed6acd5aa4518$var$app);
const $ee5ed6acd5aa4518$export$6db1e1aa0c34fe0d = {};
// ---------- Helpers ----------
function $ee5ed6acd5aa4518$var$pad6(n) {
    return n.toString().padStart(6, "0");
}
function $ee5ed6acd5aa4518$var$sanitizeTrackId(id) {
    return id.replace(/[^a-z0-9_\-]/gi, "_");
}
function $ee5ed6acd5aa4518$var$sanitizeName3(name) {
    const n = (name || "").toLowerCase().replace(/[^a-z0-9]/g, "");
    if (n.length !== 3) throw new Error("Name must be exactly 3 alphanumerics");
    return n;
}
function $ee5ed6acd5aa4518$var$sanitizeTeamIndex(idx) {
    const n = parseInt(idx, 10);
    if (!Number.isFinite(n)) return 0;
    if (n < 0 || n >= (0, $88461f0b0f431f45$export$d4e3681ec5762859).length) return 0;
    return n;
}
/**
 * Parse ghost filename into lapMs, name3, teamIndex
 * Expected pattern: "{lapMs}_{NAME3}_{teamIndex}_{uuid}.gh3"
 */ function $ee5ed6acd5aa4518$var$parseEntryName(fileName) {
    const m = /^(\d+)_([A-Z0-9]{3})_([0-9])_([a-f0-9-]+)\.gh3$/i.exec(fileName);
    if (!m) return null;
    const lapMs = parseInt(m[1], 10);
    // store internally as lowercase for consistency
    const name3 = m[2].toLowerCase();
    const teamIndex = parseInt(m[3], 10);
    const uuid = m[4];
    return {
        lapMs: lapMs,
        name3: name3,
        teamIndex: teamIndex,
        uuid: uuid
    };
}
async function $ee5ed6acd5aa4518$export$59bd7b086fe49e89(trackId, useDummyWhenEmpty = false) {
    const tid = $ee5ed6acd5aa4518$var$sanitizeTrackId(trackId);
    const dirRef = (0, $4e5144ee615e69f8$export$eff4d24c3ff7876e)($ee5ed6acd5aa4518$var$storage, `ghosts/${tid}`);
    let items = [];
    try {
        const res = await (0, $4e5144ee615e69f8$export$6a265a7d315dec03)(dirRef);
        items = res.items || [];
    } catch (error) {
        items = [];
    }
    // Parse all entries
    const parsed = [];
    for (const it of items){
        const parsedName = $ee5ed6acd5aa4518$var$parseEntryName(it.name);
        if (!parsedName) continue;
        parsed.push({
            trackId: tid,
            path: it.fullPath,
            lapMs: parsedName.lapMs,
            name3: parsedName.name3,
            teamIndex: parsedName.teamIndex,
            file: it.name
        });
    }
    // ---- NEW: dedupe by name (case-insensitive), keep best lap per name ----
    const bestByName = new Map(); // key: lowercase name, value: entry
    for (const entry of parsed){
        const key = entry.name3.toLowerCase();
        const existing = bestByName.get(key);
        if (!existing || entry.lapMs < existing.lapMs) bestByName.set(key, entry);
    }
    const uniqueEntries = Array.from(bestByName.values());
    // Sort by lapMs ascending and keep top 10
    uniqueEntries.sort((a, b)=>a.lapMs - b.lapMs);
    const result = uniqueEntries.slice(0, 10);
    if (useDummyWhenEmpty && result.length === 0) return $ee5ed6acd5aa4518$var$generateDummyLeaderboard();
    // Pad to 10 entries with blanks
    for(let i = result.length; i < 10; i++)result.push({
        trackId: trackId,
        path: null,
        lapMs: -1,
        name3: "---",
        teamIndex: -1,
        file: null
    });
    return result;
}
// ---------- Date helpers for weekly/monthly filtering ----------
function $ee5ed6acd5aa4518$var$getWeekStartDate(date = new Date()) {
    const d = new Date(date);
    const day = d.getUTCDay();
    // Convert Sunday (0) to 7 for easier Monday-based calculation
    const diff = day === 0 ? 6 : day - 1;
    d.setUTCDate(d.getUTCDate() - diff);
    d.setUTCHours(0, 0, 0, 0);
    return d;
}
function $ee5ed6acd5aa4518$var$getMonthStartDate(date = new Date()) {
    const d = new Date(date);
    d.setUTCDate(1);
    d.setUTCHours(0, 0, 0, 0);
    return d;
}
// Load leaderboard entries with their creation timestamps
async function $ee5ed6acd5aa4518$var$loadEntriesWithTimestamps(trackId) {
    const tid = $ee5ed6acd5aa4518$var$sanitizeTrackId(trackId);
    const dirRef = (0, $4e5144ee615e69f8$export$eff4d24c3ff7876e)($ee5ed6acd5aa4518$var$storage, `ghosts/${tid}`);
    let items = [];
    try {
        const res = await (0, $4e5144ee615e69f8$export$6a265a7d315dec03)(dirRef);
        items = res.items || [];
    } catch (error) {
        items = [];
    }
    // Parse all entries and fetch metadata for timestamps
    const entries = [];
    const metadataPromises = items.map(async (it)=>{
        const parsedName = $ee5ed6acd5aa4518$var$parseEntryName(it.name);
        if (!parsedName) return null;
        try {
            const metadata = await (0, $4e5144ee615e69f8$export$8548546c0aa631e6)(it);
            return {
                trackId: tid,
                path: it.fullPath,
                lapMs: parsedName.lapMs,
                name3: parsedName.name3,
                teamIndex: parsedName.teamIndex,
                file: it.name,
                createdAt: new Date(metadata.timeCreated)
            };
        } catch (error) {
            // If metadata fetch fails, still include the entry without timestamp
            return {
                trackId: tid,
                path: it.fullPath,
                lapMs: parsedName.lapMs,
                name3: parsedName.name3,
                teamIndex: parsedName.teamIndex,
                file: it.name,
                createdAt: null
            };
        }
    });
    const results = await Promise.all(metadataPromises);
    return results.filter((entry)=>entry !== null);
}
function $ee5ed6acd5aa4518$var$filterAndSortLeaderboard(entries, filterFn = null) {
    // Apply date filter if provided
    let filtered = filterFn ? entries.filter(filterFn) : entries;
    // Dedupe by name (case-insensitive), keep best lap per name
    const bestByName = new Map();
    for (const entry of filtered){
        const key = entry.name3.toLowerCase();
        const existing = bestByName.get(key);
        if (!existing || entry.lapMs < existing.lapMs) bestByName.set(key, entry);
    }
    const uniqueEntries = Array.from(bestByName.values());
    // Sort by lapMs ascending and keep top 10
    uniqueEntries.sort((a, b)=>a.lapMs - b.lapMs);
    const result = uniqueEntries.slice(0, 10);
    // Pad to 10 entries with blanks
    for(let i = result.length; i < 10; i++)result.push({
        trackId: filtered[0]?.trackId || "",
        path: null,
        lapMs: -1,
        name3: "---",
        teamIndex: -1,
        file: null,
        createdAt: null
    });
    return result;
}
// Cache for entries with timestamps to avoid multiple fetches
let $ee5ed6acd5aa4518$var$cachedEntriesTrackId = null;
let $ee5ed6acd5aa4518$var$cachedEntries = null;
async function $ee5ed6acd5aa4518$export$1450e7c53d93552d(trackId) {
    // Fetch entries with timestamps (cached per track)
    if ($ee5ed6acd5aa4518$var$cachedEntriesTrackId !== trackId) {
        $ee5ed6acd5aa4518$var$cachedEntries = await $ee5ed6acd5aa4518$var$loadEntriesWithTimestamps(trackId);
        $ee5ed6acd5aa4518$var$cachedEntriesTrackId = trackId;
    }
    const now = new Date();
    const weekStart = $ee5ed6acd5aa4518$var$getWeekStartDate(now);
    const monthStart = $ee5ed6acd5aa4518$var$getMonthStartDate(now);
    const weekly = $ee5ed6acd5aa4518$var$filterAndSortLeaderboard($ee5ed6acd5aa4518$var$cachedEntries, (entry)=>entry.createdAt && entry.createdAt >= weekStart);
    const monthly = $ee5ed6acd5aa4518$var$filterAndSortLeaderboard($ee5ed6acd5aa4518$var$cachedEntries, (entry)=>entry.createdAt && entry.createdAt >= monthStart);
    const allTime = $ee5ed6acd5aa4518$var$filterAndSortLeaderboard($ee5ed6acd5aa4518$var$cachedEntries, null);
    return {
        weekly: weekly,
        monthly: monthly,
        allTime: allTime
    };
}
function $ee5ed6acd5aa4518$export$b3c35f54bf8456e5() {
    $ee5ed6acd5aa4518$var$cachedEntriesTrackId = null;
    $ee5ed6acd5aa4518$var$cachedEntries = null;
}
function $ee5ed6acd5aa4518$var$generateDummyLeaderboard() {
    const result = [];
    for(let i = 0; i < 10; i++)result.push({
        trackId: "test",
        path: "/test",
        lapMs: 60000 + i * 1000,
        name3: "USR",
        teamIndex: i,
        file: "test"
    });
    return result;
}
function $ee5ed6acd5aa4518$export$b23d36477ddf4833($leaderboard) {
    $leaderboard.innerHTML = "";
    const $loadingSpinner = document.createElement("tr");
    $loadingSpinner.innerHTML = `<td colspan="4"><div class="spinner-wrapper"><div class="spinner"></div><div>Loading leaderboard...</div></div></td>`;
    $loadingSpinner.className = "spinner-container";
    $leaderboard.appendChild($loadingSpinner);
}
function $ee5ed6acd5aa4518$export$ae67ef93410cdd3a($leaderboard, leaderboard) {
    $leaderboard.innerHTML = "";
    for(let i = 0; i < leaderboard.length; i++){
        const entry = leaderboard[i];
        const team = entry.teamIndex >= 0 ? (0, $88461f0b0f431f45$export$d4e3681ec5762859)[entry.teamIndex] : null;
        const $entryRow = document.createElement("tr");
        $entryRow.innerHTML = `
        <td>${i + 1}</td>
        <td class="team-cell">
          ${team ? `<div class="color-box">
            <div class="color-swatch" style="background:${team.primary}"></div>
            <div class="color-swatch" style="background:${team.secondary}"></div>
            <div class="color-swatch" style="background:${team.accent}"></div>
          </div>
          <span class="team-name">${team.name}</span>` : "---"}
        </td>
        <td class="entry-name">${entry.name3 === "---" ? "---" : entry.name3.toUpperCase()}</td>
        <td>${entry.lapMs >= 0 ? (0, $cb8a4fc1d1568115$export$e0b56eedabd2a5bd)(entry.lapMs) : "---"}</td>
    `;
        $leaderboard.appendChild($entryRow);
    }
}
function $ee5ed6acd5aa4518$export$a41e4bde5fcd58bd($leaderboard) {
    const $entryRows = $leaderboard.querySelectorAll("tr");
    $entryRows.forEach(($entryRow)=>{
        $entryRow.className = "";
    });
}
function $ee5ed6acd5aa4518$export$f49c6050070dad7($leaderboard, rank, entry) {
    const team = entry.teamIndex >= 0 ? (0, $88461f0b0f431f45$export$d4e3681ec5762859)[entry.teamIndex] : null;
    const $entryRow = $leaderboard.querySelectorAll("tr")[rank];
    $entryRow.className = "selected";
    $entryRow.innerHTML = `
      <td>${rank + 1}</td>
      <td class="team-cell">
        ${team ? `<div class="color-box">
          <div class="color-swatch" style="background:${team.primary}"></div>
          <div class="color-swatch" style="background:${team.secondary}"></div>
          <div class="color-swatch" style="background:${team.accent}"></div>
        </div>
        <span class="team-name">${team.name}</span>` : "---"}
      </td>
      <td class="entry-name">${entry.name3 || "---"}</td>
      <td>${entry.lapMs >= 0 ? (0, $cb8a4fc1d1568115$export$e0b56eedabd2a5bd)(entry.lapMs) : "---"}</td>
  `;
    return $entryRow;
}
function $ee5ed6acd5aa4518$export$2eae8c277316db1($leaderboard, rank, entry) {
    const team = entry.teamIndex >= 0 ? (0, $88461f0b0f431f45$export$d4e3681ec5762859)[entry.teamIndex] : null;
    const $entryRows = $leaderboard.querySelectorAll("tr");
    const $insertedEntryRow = document.createElement("tr");
    $insertedEntryRow.className = "selected";
    $insertedEntryRow.innerHTML = `
      <td>${rank + 1}</td>
      <td class="team-cell">
        ${team ? `<div class="color-box">
          <div class="color-swatch" style="background:${team.primary}"></div>
          <div class="color-swatch" style="background:${team.secondary}"></div>
          <div class="color-swatch" style="background:${team.accent}"></div>
        </div>
        <span class="team-name">${team.name}</span>` : "---"}
      </td>
      <td class="entry-name">${entry.name3 || "---"}</td>
      <td>${entry.lapMs >= 0 ? (0, $cb8a4fc1d1568115$export$e0b56eedabd2a5bd)(entry.lapMs) : "---"}</td>
  `;
    $leaderboard.insertBefore($insertedEntryRow, $entryRows[rank]);
    for(let i = rank; i < $entryRows.length; i++)$entryRows[i].querySelectorAll("td")[0].innerText = i + 2;
    if ($entryRows.length === 10) {
        const $lastEntryRow = $entryRows[$entryRows.length - 1];
        $lastEntryRow.parentNode.removeChild($lastEntryRow);
    }
    return $insertedEntryRow;
}
function $ee5ed6acd5aa4518$export$32b9f1f6de0c1125($leaderboard, name) {
    const $entryName = $leaderboard.querySelector("tr.selected td.entry-name");
    $entryName.innerText = name;
}
function $ee5ed6acd5aa4518$export$940767b6acf08f01(leaderboard) {
    const worstLapTime = -1;
    let lapTime;
    for(let i = 0; i < leaderboard.length; i++){
        lapTime = leaderboard[i].lapMs;
        if (worstLapTime < 0 || lapTime >= 0 && worstLapTime > lapTime) worstLapTime = lapTime;
    }
    return worstLapTime;
}
// ---------- Load a single ghost ----------
async function $ee5ed6acd5aa4518$var$loadGhostBinaryOnce(path, timeoutMs = 5000) {
    // Wrap the fetch in a timeout to fail fast on CORS/network issues
    const timeoutPromise = new Promise((_, reject)=>setTimeout(()=>reject(new Error(`Timeout after ${timeoutMs}ms`)), timeoutMs));
    const fetchPromise = (0, $4e5144ee615e69f8$export$a3521add2594f3c8)((0, $4e5144ee615e69f8$export$eff4d24c3ff7876e)($ee5ed6acd5aa4518$var$storage, path));
    const u8 = await Promise.race([
        fetchPromise,
        timeoutPromise
    ]);
    return (0, $74682beda20f55da$export$2d3e1043d88392ae)(u8);
}
async function $ee5ed6acd5aa4518$export$aeb08873aa7431a0(path, maxRetries = 3) {
    // Return cached ghost if already loaded
    if ($ee5ed6acd5aa4518$export$6db1e1aa0c34fe0d[path]) return $ee5ed6acd5aa4518$export$6db1e1aa0c34fe0d[path];
    let lastError;
    for(let attempt = 1; attempt <= maxRetries; attempt++)try {
        const ghostData = await $ee5ed6acd5aa4518$var$loadGhostBinaryOnce(path);
        $ee5ed6acd5aa4518$export$6db1e1aa0c34fe0d[path] = ghostData;
        return ghostData;
    } catch (error) {
        lastError = error;
        console.warn(`Failed to load ghost ${path} (attempt ${attempt}/${maxRetries}):`, error.message || error);
        // Don't retry on the last attempt
        if (attempt < maxRetries) // Wait a bit before retrying (exponential backoff: 100ms, 200ms)
        await new Promise((resolve)=>setTimeout(resolve, 100 * Math.pow(2, attempt - 1)));
    }
    // All retries failed
    console.error(`Failed to load ghost ${path} after ${maxRetries} attempts. Continuing without this ghost.`, lastError);
    return null;
}
function $ee5ed6acd5aa4518$export$7d5bf186290a6446(leaderboard, lapMs) {
    let rank = 0;
    for(let i = 0; i < leaderboard.length; i++)if (leaderboard[i].lapMs >= 0 && lapMs >= leaderboard[i].lapMs) rank = i + 1;
    return rank >= 0 && rank < leaderboard.length ? rank : -1;
}
async function $ee5ed6acd5aa4518$export$37bae23fc4e3990b({ trackId: trackId, name3: name3, teamIndex: teamIndex, samples: samples }) {
    const tid = $ee5ed6acd5aa4518$var$sanitizeTrackId(trackId);
    const NAME3 = $ee5ed6acd5aa4518$var$sanitizeName3(name3);
    const TEAM_INDEX = $ee5ed6acd5aa4518$var$sanitizeTeamIndex(teamIndex);
    const lastSample = samples[samples.length - 1];
    const lapMs = Math.round(lastSample.t * 1000); // seconds -> ms
    if (!Number.isFinite(lapMs) || lapMs <= 0) throw new Error("Invalid lapMs", lapMs);
    const buffer = (0, $74682beda20f55da$export$79b4d3528b9675c3)(samples);
    if (!(buffer instanceof ArrayBuffer)) throw new Error("buffer must be ArrayBuffer");
    const leaderboard = await $ee5ed6acd5aa4518$export$59bd7b086fe49e89(tid);
    const rank = $ee5ed6acd5aa4518$export$7d5bf186290a6446(leaderboard, lapMs);
    if (rank < 0) return {
        accepted: false,
        reason: "Not in top 10",
        leaderboard: leaderboard
    };
    const uuid = crypto.randomUUID && crypto.randomUUID() || Math.random().toString(16).slice(2);
    // include teamIndex
    const fname = `${lapMs}_${NAME3}_${TEAM_INDEX}_${uuid}.gh3`;
    const path = `ghosts/${tid}/${fname}`;
    const bytes = new Uint8Array(buffer);
    if (bytes.byteLength > 262144) return {
        accepted: false,
        reason: "File too large"
    };
    await (0, $4e5144ee615e69f8$export$ac40f56b52f99dd1)((0, $4e5144ee615e69f8$export$eff4d24c3ff7876e)($ee5ed6acd5aa4518$var$storage, path), bytes, {
        contentType: "application/octet-stream"
    });
    const updated = await $ee5ed6acd5aa4518$export$59bd7b086fe49e89(tid);
    return {
        accepted: true,
        path: path,
        leaderboard: updated
    };
}


// Simple, convincing confetti burst using a fullscreen canvas.
// Call fireConfetti() to celebrate 🎉
function $5a46d228fd9605db$export$6031c45eb6abddc9(options = {}) {
    const { particleCount: particleCount = 180, spread: spread = Math.PI / 2, startVelocity: startVelocity = 12, decay: decay = 0.01, gravity: gravity = 4, origin: origin = {
        x: 0.5,
        y: 0.3
    } } = options;
    // Create canvas overlay
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    canvas.style.position = "fixed";
    canvas.style.inset = "0";
    canvas.style.pointerEvents = "none";
    canvas.style.zIndex = "9999";
    document.body.appendChild(canvas);
    let width = canvas.width = window.innerWidth;
    let height = canvas.height = window.innerHeight;
    function onResize() {
        width = canvas.width = window.innerWidth;
        height = canvas.height = window.innerHeight;
    }
    window.addEventListener("resize", onResize);
    const colors = [
        "#FF5252",
        "#FFEB3B",
        "#4CAF50",
        "#03A9F4",
        "#FF9800",
        "#E91E63",
        "#9C27B0"
    ];
    // Create particles
    const particles = [];
    const centerX = origin.x * width;
    const centerY = origin.y * height;
    for(let i = 0; i < particleCount; i++){
        const angle = -Math.PI / 2 + (Math.random() - 0.5) * spread;
        const speed = startVelocity * (0.5 + Math.random() * 0.8);
        particles.push({
            x: centerX,
            y: centerY,
            vx: Math.cos(angle) * speed,
            vy: Math.sin(angle) * speed,
            size: 5 + Math.random() * 6,
            color: colors[Math.floor(Math.random() * colors.length)],
            rotation: Math.random() * Math.PI * 2,
            spin: (Math.random() - 0.5) * 0.3,
            life: 1,
            decay: decay * (0.8 + Math.random() * 0.4),
            tilt: (Math.random() - 0.5) * 0.7
        });
    }
    let animationFrameId;
    function update() {
        ctx.clearRect(0, 0, width, height);
        let alive = 0;
        for (const p of particles){
            if (p.life <= 0) continue;
            // Physics
            p.vy += gravity * 0.1; // small gravity each frame
            p.x += p.vx;
            p.y += p.vy;
            p.rotation += p.spin;
            p.life -= p.decay;
            if (p.life <= 0) continue;
            alive++;
            // Draw
            ctx.save();
            ctx.globalAlpha = Math.max(p.life, 0);
            ctx.translate(p.x, p.y);
            ctx.rotate(p.rotation + p.tilt * Math.sin((1 - p.life) * 10));
            ctx.fillStyle = p.color;
            ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size * 1.4);
            ctx.restore();
        }
        if (alive > 0) animationFrameId = requestAnimationFrame(update);
        else {
            // Clean up when done
            cancelAnimationFrame(animationFrameId);
            window.removeEventListener("resize", onResize);
            canvas.remove();
        }
    }
    update();
}


class $e8fac4c754ed6f24$export$55a5cecb88257141 {
    constructor(audioContext){
        this.ctx = audioContext || new (window.AudioContext || window.webkitAudioContext)();
        // Output chain
        this.gainNode = this.ctx.createGain();
        this.gainNode.gain.value = 1;
        this.gainNode.connect(this.ctx.destination);
        // Current playback state
        this.currentSource = null;
        this.currentBuffer = null;
        this.isPlaying = false;
        this.loop = false;
        // Time tracking
        this.startTime = 0; // ctx.currentTime when playback started (minus offset)
        // Remember last position per buffer
        this.lastOffsets = new Map(); // AudioBuffer -> seconds
    }
    async createAudioBufferFromArrayBuffer(arrayBuffer) {
        if (!this.ctx) this.ctx = new (window.AudioContext || window.webkitAudioContext)();
        const buf = arrayBuffer instanceof ArrayBuffer ? arrayBuffer : arrayBuffer.buffer;
        return await this.ctx.decodeAudioData(buf.slice(0)); // slice to detach if needed
    }
    // 🔓 Call this once from a click/tap/keypress handler
    async unlock() {
        if (!this.ctx) return;
        if (this.ctx.state === "suspended") await this.ctx.resume();
    }
    /**
   * Play a given AudioBuffer.
   * @param {AudioBuffer} audioBuffer
   * @param {Object} options
   * @param {number} [options.volume=1.0]   Volume 0–1
   * @param {boolean} [options.resume=false] Resume from last position if available
   * @param {boolean} [options.loop=false]   Loop the song
   */ async play(audioBuffer, options = {}) {
        const { volume: volume = 1.0, resume: resume = false, loop: loop = false } = options;
        if (!audioBuffer) {
            console.warn("MusicPlayer.play called without an AudioBuffer");
            return;
        }
        // Stop whatever is currently playing (and store its position)
        this._storeCurrentPositionAndStop();
        this.currentBuffer = audioBuffer;
        this.loop = loop;
        // Determine starting offset
        let offset = 0;
        if (resume && this.lastOffsets.has(audioBuffer)) {
            offset = this.lastOffsets.get(audioBuffer) || 0;
            offset = Math.max(0, Math.min(offset, audioBuffer.duration));
        }
        // Create new source node
        const source = this.ctx.createBufferSource();
        source.buffer = audioBuffer;
        source.loop = loop;
        source.connect(this.gainNode);
        this.setVolume(volume);
        this.currentSource = source;
        this.startTime = this.ctx.currentTime - offset;
        this.isPlaying = true;
        // When track ends, reset position (unless looping)
        source.onended = ()=>{
            if (!this.loop) {
                // reset to start
                this.lastOffsets.set(audioBuffer, 0);
                this.currentSource = null;
                this.currentBuffer = null;
                this.isPlaying = false;
            }
        };
        source.start(0, offset);
    }
    /**
   * Pause current song and remember position.
   */ pause() {
        if (!this.isPlaying || !this.currentSource || !this.currentBuffer) return;
        const pos = this._getCurrentTimeInBuffer();
        this.lastOffsets.set(this.currentBuffer, pos);
        try {
            this.currentSource.stop();
        } catch (_) {}
        this.currentSource.disconnect();
        this.currentSource = null;
        this.isPlaying = false;
    }
    /**
   * Stop current song.
   * @param {boolean} [resetPosition=true] If true, next resume starts from 0
   */ stop(resetPosition = true) {
        if (this.currentSource && this.currentBuffer) {
            const pos = this._getCurrentTimeInBuffer();
            this.lastOffsets.set(this.currentBuffer, pos);
            try {
                this.currentSource.stop();
            } catch (_) {}
            this.currentSource.disconnect();
        }
        if (resetPosition && this.currentBuffer) this.lastOffsets.set(this.currentBuffer, 0);
        this.currentSource = null;
        this.currentBuffer = null;
        this.isPlaying = false;
    }
    /**
   * Set volume (0–1).
   */ setVolume(value) {
        const v = Math.max(0, Math.min(value, 1));
        this.gainNode.gain.value = v;
    }
    /**
   * Get current playback position in seconds for the current song.
   */ getCurrentPosition() {
        if (!this.currentBuffer) return 0;
        if (this.isPlaying) return this._getCurrentTimeInBuffer();
        return this.lastOffsets.get(this.currentBuffer) || 0;
    }
    /**
   * Seek within the current song.
   * @param {number} seconds
   * @param {Object} options
   * @param {boolean} [options.playIfPaused=false] If true, start playing from new position
   */ async seek(seconds, options = {}) {
        const { playIfPaused: playIfPaused = false } = options;
        if (!this.currentBuffer) return;
        const clamped = Math.max(0, Math.min(seconds, this.currentBuffer.duration));
        this.lastOffsets.set(this.currentBuffer, clamped);
        const wasPlaying = this.isPlaying;
        // If currently playing, restart from new position
        if (wasPlaying || playIfPaused) {
            const buf = this.currentBuffer;
            const vol = this.gainNode.gain.value;
            const loop = this.loop;
            await this.play(buf, {
                volume: vol,
                resume: true,
                loop: loop
            });
        }
    }
    /**
   * Internal: compute current playback time within buffer.
   */ _getCurrentTimeInBuffer() {
        if (!this.currentBuffer) return 0;
        const elapsed = this.ctx.currentTime - this.startTime;
        return Math.max(0, Math.min(elapsed, this.currentBuffer.duration));
    }
    /**
   * Internal: store position of currently playing track and stop it.
   */ _storeCurrentPositionAndStop() {
        if (!this.currentSource || !this.currentBuffer) return;
        const pos = this._getCurrentTimeInBuffer();
        this.lastOffsets.set(this.currentBuffer, pos);
        try {
            this.currentSource.stop();
        } catch (_) {}
        this.currentSource.disconnect();
        this.currentSource = null;
        this.isPlaying = false;
    }
}


class $018484971ab2c946$export$7eddbba4446d51fc {
    constructor(audioContext){
        this.ctx = audioContext || new (window.AudioContext || window.webkitAudioContext)();
        // Optional global SFX volume control
        this.masterGain = this.ctx.createGain();
        this.masterGain.gain.value = 1.0; // global SFX volume 0–1
        this.masterGain.connect(this.ctx.destination);
    }
    /**
   * Unlock the AudioContext (call once from a user gesture).
   */ async unlock() {
        if (!this.ctx) return;
        if (this.ctx.state === "suspended") await this.ctx.resume();
    }
    /**
   * Play a UI sound once at a given volume.
   *
   * @param {AudioBuffer} audioBuffer
   * @param {Object} [options]
   * @param {number} [options.volume=1.0]  // 0–1 per sound
   * @param {number} [options.playbackRate=1.0] // optional pitch/tempo tweak
   */ playOnce(audioBuffer, options = {}) {
        if (!audioBuffer) {
            console.warn("UISoundPlayer.playOnce called without an AudioBuffer");
            return;
        }
        const { volume: volume = 1.0, playbackRate: playbackRate = 1.0 } = options;
        const source = this.ctx.createBufferSource();
        source.buffer = audioBuffer;
        source.playbackRate.value = playbackRate;
        source.loop = false;
        const gainNode = this.ctx.createGain();
        gainNode.gain.value = Math.max(0, Math.min(volume, 1));
        source.connect(gainNode).connect(this.masterGain);
        // Clean up after it finishes
        source.onended = ()=>{
            try {
                source.disconnect();
                gainNode.disconnect();
            } catch (_) {}
        };
        source.start(0);
    }
    /**
   * Set global SFX volume (0–1).
   */ setMasterVolume(volume) {
        const v = Math.max(0, Math.min(volume, 1));
        this.masterGain.gain.value = v;
    }
    /**
   * Helper: decode an ArrayBuffer into an AudioBuffer for use with playOnce.
   *
   * @param {ArrayBuffer|TypedArray} arrayBuffer
   * @returns {Promise<AudioBuffer>}
   */ async createAudioBufferFromArrayBuffer(arrayBuffer) {
        if (!this.ctx) this.ctx = new (window.AudioContext || window.webkitAudioContext)();
        const buf = arrayBuffer instanceof ArrayBuffer ? arrayBuffer : arrayBuffer.buffer;
        // .slice(0) to ensure it's a standalone buffer
        return await this.ctx.decodeAudioData(buf.slice(0));
    }
}


var $853e1aff337c80f7$exports = {};
$853e1aff337c80f7$exports = $parcel$resolve("aExTk");


var $0c566dadeefd4d8a$exports = {};
$0c566dadeefd4d8a$exports = $parcel$resolve("jRHDS");


var $2b3bb1da1a48d14c$exports = {};
$2b3bb1da1a48d14c$exports = $parcel$resolve("aeC0O");


var $676790fecbf35210$exports = {};
$676790fecbf35210$exports = $parcel$resolve("kJK2s");


var $c5ce40cdd66fb988$exports = {};
$c5ce40cdd66fb988$exports = $parcel$resolve("e5siq");


var $7538a36dd1cc6081$exports = {};
$7538a36dd1cc6081$exports = $parcel$resolve("gCIlP");


var $5e214ef594f24700$exports = {};
$5e214ef594f24700$exports = $parcel$resolve("fMkiN");


var $034c53d8207e0802$exports = {};
$034c53d8207e0802$exports = $parcel$resolve("bbloo");


var $97af12949471d82b$exports = {};
$97af12949471d82b$exports = $parcel$resolve("47dNC");


var $8808f019b91f3b96$exports = {};
$8808f019b91f3b96$exports = $parcel$resolve("gRinf");


var $e7aad061f39fcb2c$exports = {};
$e7aad061f39fcb2c$exports = $parcel$resolve("9HuFo");


var $b31e481a244802b2$exports = {};
$b31e481a244802b2$exports = $parcel$resolve("drjyc");


var $ffaf2c994b68c0f6$exports = {};
$ffaf2c994b68c0f6$exports = $parcel$resolve("frgSB");


var $73b8871508332dc6$exports = {};
$73b8871508332dc6$exports = $parcel$resolve("5KWgb");


var $41fbe54c7b1dc2da$exports = {};
$41fbe54c7b1dc2da$exports = $parcel$resolve("g4oj3");


var $61e6965de84f8e41$exports = {};
$61e6965de84f8e41$exports = $parcel$resolve("eVCrK");


var $4f6e77712ecbd705$exports = {};
$4f6e77712ecbd705$exports = $parcel$resolve("zsGAz");


var $a6e3abce86bb237e$exports = {};
$a6e3abce86bb237e$exports = $parcel$resolve("jeVDx");


var $c434362a5d14d6e0$exports = {};
$c434362a5d14d6e0$exports = $parcel$resolve("cASxw");


var $9cd06d17b643fa4b$exports = {};
$9cd06d17b643fa4b$exports = $parcel$resolve("cSrSj");


var $c7c31ced43b4ad6a$exports = {};
$c7c31ced43b4ad6a$exports = $parcel$resolve("fNqYa");


var $ec7da4c53f07960b$exports = {};
$ec7da4c53f07960b$exports = $parcel$resolve("g8KzK");


var $0b1ff62cada6a2ea$exports = {};
$0b1ff62cada6a2ea$exports = $parcel$resolve("9zTMV");


var $6983b612c306d226$exports = {};
$6983b612c306d226$exports = $parcel$resolve("1U0Wl");


var $ea4f6fd389eb65e4$exports = {};
$ea4f6fd389eb65e4$exports = $parcel$resolve("cqMlZ");


var $9cec841d5802784a$exports = {};
$9cec841d5802784a$exports = $parcel$resolve("6Bb2K");


var $7d0d8cf8d28bd71b$exports = {};
$7d0d8cf8d28bd71b$exports = $parcel$resolve("amb6j");


var $3ca3a57e88534f4b$exports = {};
$3ca3a57e88534f4b$exports = $parcel$resolve("ksW3v");


var $51496741ae699ba5$exports = {};
$51496741ae699ba5$exports = $parcel$resolve("1MB9f");


var $2c89958c532d774e$exports = {};
$2c89958c532d774e$exports = $parcel$resolve("9gynt");


var $ca2052d3110164ca$exports = {};
$ca2052d3110164ca$exports = $parcel$resolve("etgUB");


var $d4a18c90c4f3b3be$exports = {};
$d4a18c90c4f3b3be$exports = $parcel$resolve("aL5i9");


var $8e55ac5ad32e0c2b$exports = {};
$8e55ac5ad32e0c2b$exports = $parcel$resolve("lX6k3");


var $a81deb82870f62f3$exports = {};
$a81deb82870f62f3$exports = $parcel$resolve("hgDRI");


var $158bd4d0f68c910b$exports = {};
$158bd4d0f68c910b$exports = $parcel$resolve("3kjs5");


var $6209ce647a721669$exports = {};
$6209ce647a721669$exports = $parcel$resolve("fl3CV");


var $3113a9b76abc3315$exports = {};
$3113a9b76abc3315$exports = $parcel$resolve("dOQSS");


var $04bdb25701bf1dc8$exports = {};
$04bdb25701bf1dc8$exports = $parcel$resolve("lUHja");


var $1d1faa102200a455$exports = {};
$1d1faa102200a455$exports = $parcel$resolve("hNa2C");


var $564646e3274b14e3$exports = {};
$564646e3274b14e3$exports = $parcel$resolve("22HiZ");


var $0eea380bdf426bef$exports = {};
$0eea380bdf426bef$exports = $parcel$resolve("3fbpw");


var $568346497d6200a5$exports = {};
$568346497d6200a5$exports = $parcel$resolve("5MwQg");


var $c5e192981701ea3d$exports = {};
$c5e192981701ea3d$exports = $parcel$resolve("fAAmF");


var $b4e5754f914b0447$exports = {};
$b4e5754f914b0447$exports = $parcel$resolve("3WKqT");


var $a3eacbecb0e27aef$exports = {};
$a3eacbecb0e27aef$exports = $parcel$resolve("bzrOZ");


var $e618e649e3340ed6$exports = {};
$e618e649e3340ed6$exports = $parcel$resolve("fLDMp");


var $50067adebddadcc4$exports = {};
$50067adebddadcc4$exports = $parcel$resolve("gK0A1");


var $68d7f6c02a2fa651$exports = {};
$68d7f6c02a2fa651$exports = $parcel$resolve("3rYFL");


var $d4ddfdc35a37cce0$exports = {};
$d4ddfdc35a37cce0$exports = $parcel$resolve("kcVPY");


var $9feeadb7f547b3f2$exports = {};
$9feeadb7f547b3f2$exports = $parcel$resolve("fzZBO");


var $af210c30fbeac747$exports = {};
$af210c30fbeac747$exports = $parcel$resolve("4Pd0n");


var $ac628b57915efbcf$exports = {};
$ac628b57915efbcf$exports = $parcel$resolve("92OO6");


var $035df3e44235c350$exports = {};
$035df3e44235c350$exports = $parcel$resolve("hIiQf");


var $7be57d89a1241e9b$exports = {};
$7be57d89a1241e9b$exports = $parcel$resolve("3pb4X");


var $12d34f5c8d796f99$exports = {};
$12d34f5c8d796f99$exports = $parcel$resolve("04DVU");


const $704dcef096bebb7d$var$PERF_KEY = "lap_legends_perf_tier";
function $704dcef096bebb7d$export$3413862760d3d3ad() {
    return localStorage.getItem($704dcef096bebb7d$var$PERF_KEY); // 'high' | 'medium' | 'low' | null
}
function $704dcef096bebb7d$export$6b36a753164a2f3e(tier) {
    localStorage.setItem($704dcef096bebb7d$var$PERF_KEY, tier);
}
async function $704dcef096bebb7d$export$92d3ffdf6eeefe63({ durationMs: durationMs = 10000 } = {}) {
    return new Promise((resolve)=>{
        const samples = [];
        let lastTime = 0;
        const startTime = performance.now();
        function loop(now) {
            if (!lastTime) {
                lastTime = now;
                requestAnimationFrame(loop);
                return;
            }
            const dt = now - lastTime;
            lastTime = now;
            const fps = 1000 / dt;
            samples.push(fps);
            if (now - startTime < durationMs) requestAnimationFrame(loop);
            else resolve(samples);
        }
        requestAnimationFrame(loop);
    });
}
function $704dcef096bebb7d$export$b94d41ee5dda1192(samples) {
    if (!samples.length) return "low";
    const sorted = samples.slice().sort((a, b)=>a - b);
    const median = sorted[Math.floor(sorted.length / 2)];
    const p10 = sorted[Math.floor(sorted.length * 0.1)]; // 10th percentile
    // Tweak these thresholds to taste:
    if (median >= 58 && p10 >= 50) return "high"; // solid 60-ish
    if (median >= 40 && p10 >= 30) return "medium"; // playable but not 60
    return "low";
}


// Create mapping objects for dynamic access
const $a791dc77ae9c188b$var$trackImages = {
    abudhabi: (0, (/*@__PURE__*/$parcel$interopDefault($853e1aff337c80f7$exports))),
    albertpark: (0, (/*@__PURE__*/$parcel$interopDefault($0c566dadeefd4d8a$exports))),
    americas: (0, (/*@__PURE__*/$parcel$interopDefault($2b3bb1da1a48d14c$exports))),
    bahrain: (0, (/*@__PURE__*/$parcel$interopDefault($676790fecbf35210$exports))),
    baku: (0, (/*@__PURE__*/$parcel$interopDefault($c5ce40cdd66fb988$exports))),
    budapest: (0, (/*@__PURE__*/$parcel$interopDefault($7538a36dd1cc6081$exports))),
    catalunya: (0, (/*@__PURE__*/$parcel$interopDefault($5e214ef594f24700$exports))),
    hockenheim: (0, (/*@__PURE__*/$parcel$interopDefault($034c53d8207e0802$exports))),
    interlagos: (0, (/*@__PURE__*/$parcel$interopDefault($97af12949471d82b$exports))),
    marinabay: (0, (/*@__PURE__*/$parcel$interopDefault($8808f019b91f3b96$exports))),
    mexico: (0, (/*@__PURE__*/$parcel$interopDefault($e7aad061f39fcb2c$exports))),
    monaco: (0, (/*@__PURE__*/$parcel$interopDefault($b31e481a244802b2$exports))),
    montreal: (0, (/*@__PURE__*/$parcel$interopDefault($ffaf2c994b68c0f6$exports))),
    monza: (0, (/*@__PURE__*/$parcel$interopDefault($73b8871508332dc6$exports))),
    paulricard: (0, (/*@__PURE__*/$parcel$interopDefault($41fbe54c7b1dc2da$exports))),
    shanghai: (0, (/*@__PURE__*/$parcel$interopDefault($61e6965de84f8e41$exports))),
    silverstone: (0, (/*@__PURE__*/$parcel$interopDefault($4f6e77712ecbd705$exports))),
    sochi: (0, (/*@__PURE__*/$parcel$interopDefault($a6e3abce86bb237e$exports))),
    spa: (0, (/*@__PURE__*/$parcel$interopDefault($c434362a5d14d6e0$exports))),
    spielberg: (0, (/*@__PURE__*/$parcel$interopDefault($9cd06d17b643fa4b$exports))),
    suzuka: (0, (/*@__PURE__*/$parcel$interopDefault($c7c31ced43b4ad6a$exports)))
};
const $a791dc77ae9c188b$var$trackSvgs = {
    abudhabi: (0, (/*@__PURE__*/$parcel$interopDefault($2c89958c532d774e$exports))),
    albertpark: (0, (/*@__PURE__*/$parcel$interopDefault($ca2052d3110164ca$exports))),
    americas: (0, (/*@__PURE__*/$parcel$interopDefault($d4a18c90c4f3b3be$exports))),
    bahrain: (0, (/*@__PURE__*/$parcel$interopDefault($8e55ac5ad32e0c2b$exports))),
    baku: (0, (/*@__PURE__*/$parcel$interopDefault($a81deb82870f62f3$exports))),
    budapest: (0, (/*@__PURE__*/$parcel$interopDefault($158bd4d0f68c910b$exports))),
    catalunya: (0, (/*@__PURE__*/$parcel$interopDefault($6209ce647a721669$exports))),
    hockenheim: (0, (/*@__PURE__*/$parcel$interopDefault($3113a9b76abc3315$exports))),
    interlagos: (0, (/*@__PURE__*/$parcel$interopDefault($04bdb25701bf1dc8$exports))),
    marinabay: (0, (/*@__PURE__*/$parcel$interopDefault($1d1faa102200a455$exports))),
    mexico: (0, (/*@__PURE__*/$parcel$interopDefault($564646e3274b14e3$exports))),
    monaco: (0, (/*@__PURE__*/$parcel$interopDefault($0eea380bdf426bef$exports))),
    montreal: (0, (/*@__PURE__*/$parcel$interopDefault($568346497d6200a5$exports))),
    monza: (0, (/*@__PURE__*/$parcel$interopDefault($c5e192981701ea3d$exports))),
    paulricard: (0, (/*@__PURE__*/$parcel$interopDefault($b4e5754f914b0447$exports))),
    shanghai: (0, (/*@__PURE__*/$parcel$interopDefault($a3eacbecb0e27aef$exports))),
    silverstone: (0, (/*@__PURE__*/$parcel$interopDefault($e618e649e3340ed6$exports))),
    sochi: (0, (/*@__PURE__*/$parcel$interopDefault($50067adebddadcc4$exports))),
    spa: (0, (/*@__PURE__*/$parcel$interopDefault($68d7f6c02a2fa651$exports))),
    spielberg: (0, (/*@__PURE__*/$parcel$interopDefault($d4ddfdc35a37cce0$exports))),
    suzuka: (0, (/*@__PURE__*/$parcel$interopDefault($9feeadb7f547b3f2$exports)))
};
const $a791dc77ae9c188b$var$TRACK_SCALE = 20;
const $a791dc77ae9c188b$var$cameraZoom = 0.5;
const $a791dc77ae9c188b$var$SKID_CANVAS_WIDTH = 1000;
const $a791dc77ae9c188b$var$SKID_CANVAS_HEIGHT = 1000;
const $a791dc77ae9c188b$var$SKID_INTERVAL_SQ = Math.pow(25, 2);
const $a791dc77ae9c188b$var$VIEWPORT_WIDTH = 1600;
const $a791dc77ae9c188b$var$VIEWPORT_HEIGHT = 900;
const $a791dc77ae9c188b$var$assetsManifest = [];
let $a791dc77ae9c188b$var$ASSETS = {};
let $a791dc77ae9c188b$var$isDemo = true;
let $a791dc77ae9c188b$var$isInit = false;
let $a791dc77ae9c188b$var$isRacingLineVisible = false;
let $a791dc77ae9c188b$var$selectedTrackName;
let $a791dc77ae9c188b$var$currentTrackName = (0, $88461f0b0f431f45$export$d0e7720d468a5456)[0];
let $a791dc77ae9c188b$var$hvw = $a791dc77ae9c188b$var$VIEWPORT_WIDTH * 0.5;
let $a791dc77ae9c188b$var$hvh = $a791dc77ae9c188b$var$VIEWPORT_HEIGHT * 0.5;
let $a791dc77ae9c188b$var$startLine = 22;
let $a791dc77ae9c188b$var$finishLine = 23;
let $a791dc77ae9c188b$var$lapCount = 1;
let $a791dc77ae9c188b$var$isRaceStarted = false;
let $a791dc77ae9c188b$var$isRaceFinished = false;
let $a791dc77ae9c188b$var$isPaused = false;
let $a791dc77ae9c188b$var$now = Date.now();
let $a791dc77ae9c188b$var$raceStartTime = $a791dc77ae9c188b$var$now;
let $a791dc77ae9c188b$var$lastPausedTime = -1;
let $a791dc77ae9c188b$var$showSkidEffects = true;
let $a791dc77ae9c188b$var$showSparkEffects = true;
let $a791dc77ae9c188b$var$buttonClickBuffer;
let $a791dc77ae9c188b$var$startLightBuffer;
let $a791dc77ae9c188b$var$titleMusicBuffer;
let $a791dc77ae9c188b$var$gameMusicBuffer;
let $a791dc77ae9c188b$var$currentStartLightCount = -1;
// FPS tracking
let $a791dc77ae9c188b$var$lastFpsTime = $a791dc77ae9c188b$var$now;
let $a791dc77ae9c188b$var$frameCount = 0;
let $a791dc77ae9c188b$var$fps = 60;
const $a791dc77ae9c188b$var$$startGameButton = document.getElementById("startGameButton");
const $a791dc77ae9c188b$var$$game = document.getElementById("game");
const $a791dc77ae9c188b$var$$cars = document.getElementById("cars");
const $a791dc77ae9c188b$var$$track = document.getElementById("track");
const $a791dc77ae9c188b$var$$randomTrackOption = document.getElementById("randomTrackOption");
const $a791dc77ae9c188b$var$$samples = document.getElementById("samples");
const $a791dc77ae9c188b$var$$startLine = document.getElementById("startLine");
const $a791dc77ae9c188b$var$$finishLine = document.getElementById("finishLine");
const $a791dc77ae9c188b$var$$gridContainer = document.getElementById("gridContainer");
const $a791dc77ae9c188b$var$$lapLabel = document.getElementById("lapLabel");
const $a791dc77ae9c188b$var$$speedLabel = document.getElementById("speedLabel");
const $a791dc77ae9c188b$var$$trackLabel = document.getElementById("trackLabel");
const $a791dc77ae9c188b$var$$lapTimeLabel = document.getElementById("lapTimeLabel");
const $a791dc77ae9c188b$var$$skids = document.getElementById("skids");
const $a791dc77ae9c188b$var$$sparks = document.getElementById("sparks");
const $a791dc77ae9c188b$var$$startLights = document.getElementById("startLights");
const $a791dc77ae9c188b$var$$pauseDialog = document.getElementById("pauseDialog");
const $a791dc77ae9c188b$var$$pauseResumeRaceButton = document.getElementById("pauseResumeRaceButton");
const $a791dc77ae9c188b$var$$pauseQuitRaceButton = document.getElementById("pauseQuitRaceButton");
const $a791dc77ae9c188b$var$$pauseDialogCloseButton = document.getElementById("pauseDialogCloseButton");
const $a791dc77ae9c188b$var$$startRaceDialog = document.getElementById("startRaceDialog");
const $a791dc77ae9c188b$var$$startRaceDialogCloseButton = document.getElementById("startRaceDialogCloseButton");
const $a791dc77ae9c188b$var$$startRaceTrackTitle = document.getElementById("startRaceTrackTitle");
const $a791dc77ae9c188b$var$$startRaceTrackInfo = document.getElementById("startRaceTrackInfo");
const $a791dc77ae9c188b$var$$startRaceLeaderboardSlider = document.getElementById("startRaceLeaderboardSlider");
const $a791dc77ae9c188b$var$$startRaceLeaderboardWeekly = document.getElementById("startRaceLeaderboardWeekly");
const $a791dc77ae9c188b$var$$startRaceLeaderboardMonthly = document.getElementById("startRaceLeaderboardMonthly");
const $a791dc77ae9c188b$var$$startRaceLeaderboardAllTime = document.getElementById("startRaceLeaderboardAllTime");
const $a791dc77ae9c188b$var$$startRaceLeaderboardTabs = document.querySelectorAll("#startRaceDialog .leaderboard-tab");
const $a791dc77ae9c188b$var$$startRaceButton = document.getElementById("startRaceButton");
const $a791dc77ae9c188b$var$$startRaceShareButton = document.getElementById("startRaceShareButton");
const $a791dc77ae9c188b$var$$startRaceTeamOptions = document.getElementById("startRaceTeamOptions");
const $a791dc77ae9c188b$var$$bestLapDialog = document.getElementById("bestLapDialog");
const $a791dc77ae9c188b$var$$bestLapLeaderboard = document.getElementById("bestLapLeaderboard");
const $a791dc77ae9c188b$var$$bestLapLeaderboardType = document.getElementById("bestLapLeaderboardType");
const $a791dc77ae9c188b$var$$bestLapInputMessage = document.getElementById("bestLapInputMessage");
const $a791dc77ae9c188b$var$$bestLapSubmitButton = document.getElementById("bestLapSubmitButton");
const $a791dc77ae9c188b$var$$bestLapDialogCloseButton = document.getElementById("bestLapDialogCloseButton");
const $a791dc77ae9c188b$var$$bestLapShareButton = document.getElementById("bestLapShareButton");
const $a791dc77ae9c188b$var$$bestLapInput = document.getElementById("bestLapInput");
const $a791dc77ae9c188b$var$$copyFallbackDialog = document.getElementById("copyFallbackDialog");
const $a791dc77ae9c188b$var$$copyFallbackInput = document.getElementById("copyFallbackInput");
const $a791dc77ae9c188b$var$$copyFallbackCloseButton = document.getElementById("copyFallbackCloseButton");
const $a791dc77ae9c188b$var$$fpsCounter = document.getElementById("fpsCounter");
const $a791dc77ae9c188b$var$$viz = document.getElementById("viz");
const $a791dc77ae9c188b$var$$steeringViz = document.getElementById("steeringViz");
const $a791dc77ae9c188b$var$$steeringAccViz = document.getElementById("steeringAccViz");
const $a791dc77ae9c188b$var$$accelerationViz = document.getElementById("accelerationViz");
const $a791dc77ae9c188b$var$$speedViz = document.getElementById("speedViz");
const $a791dc77ae9c188b$var$$lapProgressViz = document.getElementById("lapProgressViz");
const $a791dc77ae9c188b$var$$lapTimes = document.getElementById("lapTimes");
const $a791dc77ae9c188b$var$$trackOptions = document.getElementById("trackOptions");
const $a791dc77ae9c188b$var$$trackCarouselLeft = document.getElementById("trackCarouselLeft");
const $a791dc77ae9c188b$var$$trackCarouselRight = document.getElementById("trackCarouselRight");
const $a791dc77ae9c188b$var$$titleScreen = document.getElementById("titleScreen");
const $a791dc77ae9c188b$var$$gameVersion = document.getElementById("gameVersion");
const $a791dc77ae9c188b$var$$loadingDialog = document.getElementById("loadingDialog");
const $a791dc77ae9c188b$var$$loadingDialogText = document.getElementById("loadingDialogText");
const $a791dc77ae9c188b$var$$bestLapTimeValue = document.getElementById("bestLapTimeValue");
const $a791dc77ae9c188b$var$$finishFlag = document.getElementById("finishFlag");
const $a791dc77ae9c188b$var$$muteButton = document.getElementById("muteButton");
let $a791dc77ae9c188b$var$isMuted = false;
let $a791dc77ae9c188b$var$leaderboard;
let $a791dc77ae9c188b$var$allLeaderboards = {
    weekly: null,
    monthly: null,
    allTime: null
};
let $a791dc77ae9c188b$var$currentLeaderboardTab = 0; // 0 = weekly, 1 = monthly, 2 = allTime
let $a791dc77ae9c188b$var$leaderboardAutoCycleInterval = null;
const $a791dc77ae9c188b$var$LEADERBOARD_TAB_NAMES = [
    "weekly",
    "monthly",
    "allTime"
];
const $a791dc77ae9c188b$var$LEADERBOARD_TAB_LABELS = [
    "Weekly",
    "Monthly",
    "All time"
];
const $a791dc77ae9c188b$var$skidCanvases = [];
const $a791dc77ae9c188b$var$trackOptions = [];
let $a791dc77ae9c188b$var$lastSkids = {};
const $a791dc77ae9c188b$var$samples = [];
const $a791dc77ae9c188b$var$grids = [];
const $a791dc77ae9c188b$var$lapTimes = [];
// Carousel state
let $a791dc77ae9c188b$var$carouselCurrentPage = 0;
let $a791dc77ae9c188b$var$carouselAnimationId = null;
const $a791dc77ae9c188b$var$TRACKS_PER_PAGE = 8; // 4 columns x 2 rows
const $a791dc77ae9c188b$var$TRACK_ITEM_WIDTH = 320;
const $a791dc77ae9c188b$var$TRACK_GAP = 20;
const $a791dc77ae9c188b$var$PAGE_WIDTH = $a791dc77ae9c188b$var$TRACK_ITEM_WIDTH * 4 + $a791dc77ae9c188b$var$TRACK_GAP * 4;
let $a791dc77ae9c188b$var$selectedTeamIndex = +(localStorage.getItem("selectedTeamIndex") || Math.floor(Math.random() * (0, $88461f0b0f431f45$export$d4e3681ec5762859).length));
let $a791dc77ae9c188b$var$$trackRoad, $a791dc77ae9c188b$var$$trackRoadTarmac, $a791dc77ae9c188b$var$$trackCenterline, $a791dc77ae9c188b$var$$trackRacingline, $a791dc77ae9c188b$var$$trackContainer;
let $a791dc77ae9c188b$var$trackCenterlineSegments, $a791dc77ae9c188b$var$trackCenterlineOffset;
let $a791dc77ae9c188b$var$trackRacinglineSegments, $a791dc77ae9c188b$var$trackRacinglineOffset;
const $a791dc77ae9c188b$var$ctx = new (window.AudioContext || window.webkitAudioContext)();
const $a791dc77ae9c188b$var$musicPlayer = new (0, $e8fac4c754ed6f24$export$55a5cecb88257141)($a791dc77ae9c188b$var$ctx);
const $a791dc77ae9c188b$var$soundPlayer = new (0, $018484971ab2c946$export$7eddbba4446d51fc)($a791dc77ae9c188b$var$ctx);
const $a791dc77ae9c188b$var$playerCar = $a791dc77ae9c188b$var$createCar("player", $a791dc77ae9c188b$var$selectedTeamIndex, true);
$a791dc77ae9c188b$var$playerCar.isPlayer = true;
const $a791dc77ae9c188b$var$cars = [];
const $a791dc77ae9c188b$var$camera = {
    x: $a791dc77ae9c188b$var$playerCar.x,
    y: $a791dc77ae9c188b$var$playerCar.y,
    hvw: $a791dc77ae9c188b$var$hvw,
    hvh: $a791dc77ae9c188b$var$hvh
};
const $a791dc77ae9c188b$var$keyPresses = {
    ArrowUp: false,
    ArrowDown: false,
    ArrowLeft: false,
    ArrowRight: false,
    z: false,
    x: false
};
const $a791dc77ae9c188b$var$registeredKeys = Object.keys($a791dc77ae9c188b$var$keyPresses);
function $a791dc77ae9c188b$var$createCar(carId, colorIndex, isPlayer) {
    const $car = document.createElement("div");
    $car.id = carId;
    $car.className = "car";
    $car.classList.toggle("ghost", !isPlayer);
    $car.innerHTML = `
    <div class="wheel-fl wheel"></div>
    <div class="wheel-fr wheel"></div>
  `;
    $a791dc77ae9c188b$var$$cars.appendChild($car);
    const car = new (0, $cfb31d3eb43e151e$export$91030e912f5b0749)($car, carId, colorIndex, !Boolean(isPlayer), isPlayer ? $a791dc77ae9c188b$var$ASSETS[0, (/*@__PURE__*/$parcel$interopDefault($af210c30fbeac747$exports))] : null);
    car.trackScale = $a791dc77ae9c188b$var$TRACK_SCALE;
    car.x = $a791dc77ae9c188b$var$hvw;
    car.y = $a791dc77ae9c188b$var$hvh;
    if (isPlayer) {
        car.onBestLapTime = $a791dc77ae9c188b$var$handlePlayerBestLapTime;
        car.onLapComplete = $a791dc77ae9c188b$var$handlePlayerLapComplete;
    }
    return car;
}
async function $a791dc77ae9c188b$var$initManifest() {
    for(let i = 0; i < (0, $88461f0b0f431f45$export$d0e7720d468a5456).length; i++){
        const trackName = (0, $88461f0b0f431f45$export$d0e7720d468a5456)[i];
        const assetUrl = $a791dc77ae9c188b$var$trackImages[trackName];
        $a791dc77ae9c188b$var$assetsManifest.push({
            url: assetUrl,
            type: "image"
        });
    }
    $a791dc77ae9c188b$var$assetsManifest.push({
        url: (0, (/*@__PURE__*/$parcel$interopDefault($ec7da4c53f07960b$exports))),
        type: "image"
    });
    $a791dc77ae9c188b$var$assetsManifest.push({
        url: (0, (/*@__PURE__*/$parcel$interopDefault($0b1ff62cada6a2ea$exports))),
        type: "image"
    });
    $a791dc77ae9c188b$var$assetsManifest.push({
        url: (0, (/*@__PURE__*/$parcel$interopDefault($6983b612c306d226$exports))),
        type: "image"
    });
    $a791dc77ae9c188b$var$assetsManifest.push({
        url: (0, (/*@__PURE__*/$parcel$interopDefault($ea4f6fd389eb65e4$exports))),
        type: "image"
    });
    $a791dc77ae9c188b$var$assetsManifest.push({
        url: (0, (/*@__PURE__*/$parcel$interopDefault($9cec841d5802784a$exports))),
        type: "image"
    });
    $a791dc77ae9c188b$var$assetsManifest.push({
        url: (0, (/*@__PURE__*/$parcel$interopDefault($7d0d8cf8d28bd71b$exports))),
        type: "image"
    });
    $a791dc77ae9c188b$var$assetsManifest.push({
        url: (0, (/*@__PURE__*/$parcel$interopDefault($3ca3a57e88534f4b$exports))),
        type: "image"
    });
    $a791dc77ae9c188b$var$assetsManifest.push({
        url: (0, (/*@__PURE__*/$parcel$interopDefault($51496741ae699ba5$exports))),
        type: "image"
    });
    $a791dc77ae9c188b$var$assetsManifest.push({
        url: (0, (/*@__PURE__*/$parcel$interopDefault($af210c30fbeac747$exports))),
        type: "arraybuffer"
    });
    $a791dc77ae9c188b$var$assetsManifest.push({
        url: (0, (/*@__PURE__*/$parcel$interopDefault($035df3e44235c350$exports))),
        type: "arraybuffer"
    });
    $a791dc77ae9c188b$var$assetsManifest.push({
        url: (0, (/*@__PURE__*/$parcel$interopDefault($ac628b57915efbcf$exports))),
        type: "arraybuffer"
    });
    $a791dc77ae9c188b$var$assetsManifest.push({
        url: (0, (/*@__PURE__*/$parcel$interopDefault($7be57d89a1241e9b$exports))),
        type: "arraybuffer"
    });
    $a791dc77ae9c188b$var$assetsManifest.push({
        url: (0, (/*@__PURE__*/$parcel$interopDefault($12d34f5c8d796f99$exports))),
        type: "arraybuffer"
    });
    const load = (item)=>{
        if (item.type === "image") return fetch(item.url, {
            cache: "reload"
        }).then((r)=>r.blob()).then(createImageBitmap);
        if (item.type === "json") return fetch(item.url, {
            cache: "reload"
        }).then((r)=>r.json());
        if (item.type === "arraybuffer") return fetch(item.url, {
            cache: "reload"
        }).then((r)=>r.arrayBuffer());
        if (item.type === "audio") // Load as blob → object URL → HTMLAudioElement
        return fetch(item.url, {
            cache: "reload"
        }).then((r)=>r.blob()).then((blob)=>{
            const objectUrl = URL.createObjectURL(blob);
            const audio = new Audio();
            audio.src = objectUrl;
            audio.preload = "auto";
            return audio;
        });
        return fetch(item.url, {
            cache: "reload"
        }).then((r)=>r.blob());
    };
    // Progress reporting
    let done = 0;
    const total = $a791dc77ae9c188b$var$assetsManifest.length;
    const tick = ()=>{
        const p = Math.round(done / total * 100);
        bar.style.width = p + "%";
        tip.textContent = `Loading core assets... ${p}%`;
    };
    // Kick off asset fetches in parallel
    const results = {};
    await Promise.all($a791dc77ae9c188b$var$assetsManifest.map((m, i)=>load(m).then((v)=>{
            results[m.url] = v;
            done++;
            tick();
        }).catch((e)=>{
            console.warn("Failed to load", m.url, e);
            done++;
            tick();
        })));
    $a791dc77ae9c188b$var$ASSETS = results;
    $a791dc77ae9c188b$var$playerCar.setEngineSound($a791dc77ae9c188b$var$ASSETS[0, (/*@__PURE__*/$parcel$interopDefault($af210c30fbeac747$exports))]);
    if (!$a791dc77ae9c188b$var$titleMusicBuffer) $a791dc77ae9c188b$var$titleMusicBuffer = await $a791dc77ae9c188b$var$musicPlayer.createAudioBufferFromArrayBuffer($a791dc77ae9c188b$var$ASSETS[0, (/*@__PURE__*/$parcel$interopDefault($035df3e44235c350$exports))]);
    if (!$a791dc77ae9c188b$var$gameMusicBuffer) $a791dc77ae9c188b$var$gameMusicBuffer = await $a791dc77ae9c188b$var$musicPlayer.createAudioBufferFromArrayBuffer($a791dc77ae9c188b$var$ASSETS[0, (/*@__PURE__*/$parcel$interopDefault($ac628b57915efbcf$exports))]);
    if (!$a791dc77ae9c188b$var$buttonClickBuffer) $a791dc77ae9c188b$var$buttonClickBuffer = await $a791dc77ae9c188b$var$musicPlayer.createAudioBufferFromArrayBuffer($a791dc77ae9c188b$var$ASSETS[0, (/*@__PURE__*/$parcel$interopDefault($12d34f5c8d796f99$exports))]);
    if (!$a791dc77ae9c188b$var$startLightBuffer) $a791dc77ae9c188b$var$startLightBuffer = await $a791dc77ae9c188b$var$musicPlayer.createAudioBufferFromArrayBuffer($a791dc77ae9c188b$var$ASSETS[0, (/*@__PURE__*/$parcel$interopDefault($7be57d89a1241e9b$exports))]);
    $a791dc77ae9c188b$var$$startGameButton.disabled = false;
    $a791dc77ae9c188b$var$$startGameButton.addEventListener("click", $a791dc77ae9c188b$var$handleStartGameButtonClick);
}
async function $a791dc77ae9c188b$var$handleStartGameButtonClick() {
    $a791dc77ae9c188b$var$soundButtonClick();
    await $a791dc77ae9c188b$var$musicPlayer.unlock();
    await $a791dc77ae9c188b$var$soundPlayer.unlock();
    $a791dc77ae9c188b$var$initGame();
    $a791dc77ae9c188b$var$update();
}
async function $a791dc77ae9c188b$var$initGame() {
    window.addEventListener("keydown", $a791dc77ae9c188b$var$handleKeyDown);
    window.addEventListener("keyup", $a791dc77ae9c188b$var$handleKeyUp);
    $a791dc77ae9c188b$var$$bestLapInput.addEventListener("input", $a791dc77ae9c188b$var$handleBestLapInput);
    $a791dc77ae9c188b$var$$bestLapSubmitButton.addEventListener("click", $a791dc77ae9c188b$var$handleBestLapSubmitButtonClick);
    $a791dc77ae9c188b$var$$bestLapDialogCloseButton.addEventListener("click", $a791dc77ae9c188b$var$handleBestLapDialogCloseButtonClick);
    $a791dc77ae9c188b$var$$bestLapShareButton.addEventListener("click", $a791dc77ae9c188b$var$handleBestLapShareButtonClick);
    $a791dc77ae9c188b$var$$copyFallbackCloseButton.addEventListener("click", $a791dc77ae9c188b$var$handleCopyFallbackCloseButtonClick);
    $a791dc77ae9c188b$var$$startRaceButton.addEventListener("click", $a791dc77ae9c188b$var$handleStartRaceButtonClick);
    $a791dc77ae9c188b$var$$startRaceDialogCloseButton.addEventListener("click", $a791dc77ae9c188b$var$handleStartRaceDialogCloseButtonClick);
    $a791dc77ae9c188b$var$$startRaceShareButton.addEventListener("click", $a791dc77ae9c188b$var$handleStartRaceShareButtonClick);
    // Leaderboard tab click handlers
    $a791dc77ae9c188b$var$$startRaceLeaderboardTabs.forEach((tab)=>{
        tab.addEventListener("click", $a791dc77ae9c188b$var$handleLeaderboardTabClick);
    });
    $a791dc77ae9c188b$var$$pauseResumeRaceButton.addEventListener("click", $a791dc77ae9c188b$var$handleResumeRaceButtonClick);
    $a791dc77ae9c188b$var$$pauseQuitRaceButton.addEventListener("click", $a791dc77ae9c188b$var$handleQuitRaceButtonClick);
    $a791dc77ae9c188b$var$$pauseDialogCloseButton.addEventListener("click", $a791dc77ae9c188b$var$handlePauseDialogCloseButtonClick);
    $a791dc77ae9c188b$var$$randomTrackOption.addEventListener("click", $a791dc77ae9c188b$var$handleRandomTrackOptionClick);
    $a791dc77ae9c188b$var$$muteButton.addEventListener("click", $a791dc77ae9c188b$var$toggleMute);
    $a791dc77ae9c188b$var$initTrackOptions();
    $a791dc77ae9c188b$var$initCarousel();
    $a791dc77ae9c188b$var$initTeamOptions();
    (0, $3df263189409ffaa$export$aff2be167080a97f)($a791dc77ae9c188b$var$$sparks);
    $a791dc77ae9c188b$var$initLapTimes();
    $a791dc77ae9c188b$var$initStartLights();
    $a791dc77ae9c188b$var$setIsDemo(true);
    $a791dc77ae9c188b$var$invalidateHUD();
    await $a791dc77ae9c188b$var$loadTrack((0, $88461f0b0f431f45$export$d0e7720d468a5456)[0], false);
    $a791dc77ae9c188b$var$leaderboard = await (0, $ee5ed6acd5aa4518$export$59bd7b086fe49e89)((0, $88461f0b0f431f45$export$d0e7720d468a5456)[0], true);
    (0, $ee5ed6acd5aa4518$export$ae67ef93410cdd3a)($a791dc77ae9c188b$var$$bestLapLeaderboard, $a791dc77ae9c188b$var$leaderboard);
    $a791dc77ae9c188b$var$isInit = true;
    // Hide share buttons when running on itch.io
    if ((0, $cb8a4fc1d1568115$export$c45b2c24995cfb78)()) {
        $a791dc77ae9c188b$var$$bestLapShareButton.style.display = "none";
        $a791dc77ae9c188b$var$$startRaceShareButton.style.display = "none";
        console.log("Running on itch.io - share buttons disabled");
    }
    // Check for deep-linked track in URL
    const urlParams = new URLSearchParams(window.location.search);
    const trackParam = urlParams.get("track");
    $a791dc77ae9c188b$var$showTrackOptions();
    $a791dc77ae9c188b$var$musicPlayer.play($a791dc77ae9c188b$var$titleMusicBuffer, {
        resume: true,
        loop: true,
        volume: 1
    });
    const storedTier = (0, $704dcef096bebb7d$export$3413862760d3d3ad)();
    console.log("Running performance benchmark...");
    if (storedTier) $a791dc77ae9c188b$var$applyPerfTier(storedTier);
    else {
        $a791dc77ae9c188b$var$setSkidEffects(true);
        $a791dc77ae9c188b$var$setSparkEffects(true);
        const perfSamples = await (0, $704dcef096bebb7d$export$92d3ffdf6eeefe63)({
            durationMs: 10000
        });
        const tier = (0, $704dcef096bebb7d$export$b94d41ee5dda1192)(perfSamples);
        (0, $704dcef096bebb7d$export$6b36a753164a2f3e)(tier);
        $a791dc77ae9c188b$var$applyPerfTier(tier);
    }
    $a791dc77ae9c188b$var$$gameVersion.textContent = (0, $88461f0b0f431f45$export$9badeb9b04b4b71c);
    console.log("Game version:", (0, $88461f0b0f431f45$export$9badeb9b04b4b71c));
    if (trackParam && (0, $88461f0b0f431f45$export$d0e7720d468a5456).includes(trackParam)) {
        // Valid track parameter - auto-show start race dialog
        console.log(`Deep-linking to track: ${trackParam}`);
        $a791dc77ae9c188b$var$showStartRaceDialog(trackParam);
    }
}
function $a791dc77ae9c188b$var$applyPerfTier(tier) {
    console.log("Perf tier:", tier);
    if (tier === "high") {
        $a791dc77ae9c188b$var$setSkidEffects(true);
        $a791dc77ae9c188b$var$setSparkEffects(true);
    } else if (tier === "medium") {
        $a791dc77ae9c188b$var$setSkidEffects(false);
        $a791dc77ae9c188b$var$setSparkEffects(true);
    } else {
        $a791dc77ae9c188b$var$setSkidEffects(false);
        $a791dc77ae9c188b$var$setSparkEffects(false);
    }
}
function $a791dc77ae9c188b$var$initTrackOptions() {
    for(let i = 0; i < (0, $88461f0b0f431f45$export$d0e7720d468a5456).length; i++){
        const $trackOption = document.createElement("div");
        const trackName = (0, $88461f0b0f431f45$export$d0e7720d468a5456)[i];
        const assetUrl = $a791dc77ae9c188b$var$trackImages[trackName];
        $trackOption.style.backgroundImage = `url(${assetUrl})`;
        const [track, region] = (0, $88461f0b0f431f45$export$5cc6edba7251fc3e)[trackName].split(",");
        $trackOption.setAttribute("trackName", trackName);
        $trackOption.innerHTML = `<span>${track}</span><span>${region}</span>`;
        $a791dc77ae9c188b$var$$trackOptions.appendChild($trackOption);
        $a791dc77ae9c188b$var$trackOptions.push($trackOption);
        $trackOption.addEventListener("click", $a791dc77ae9c188b$var$handleTrackOptionClick);
    }
}
// Easing function for smooth animation
function $a791dc77ae9c188b$var$easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
}
// Smooth scroll carousel to a specific page
function $a791dc77ae9c188b$var$scrollToPage(page) {
    if ($a791dc77ae9c188b$var$carouselAnimationId !== null) cancelAnimationFrame($a791dc77ae9c188b$var$carouselAnimationId);
    const startScroll = parseFloat($a791dc77ae9c188b$var$$trackOptions.style.transform?.match(/-?\d+(\.\d+)?/)?.[0] || 0);
    const targetScroll = -page * $a791dc77ae9c188b$var$PAGE_WIDTH;
    const duration = 400; // ms
    const startTime = performance.now();
    function animate(currentTime) {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const easedProgress = $a791dc77ae9c188b$var$easeInOutCubic(progress);
        const currentScroll = startScroll + (targetScroll - startScroll) * easedProgress;
        $a791dc77ae9c188b$var$$trackOptions.style.transform = `translateX(${currentScroll}px)`;
        if (progress < 1) $a791dc77ae9c188b$var$carouselAnimationId = requestAnimationFrame(animate);
        else {
            $a791dc77ae9c188b$var$carouselAnimationId = null;
            $a791dc77ae9c188b$var$carouselCurrentPage = page;
            $a791dc77ae9c188b$var$updateCarouselButtons();
        }
    }
    $a791dc77ae9c188b$var$carouselAnimationId = requestAnimationFrame(animate);
}
// Update carousel button states based on current page
function $a791dc77ae9c188b$var$updateCarouselButtons() {
    const totalItems = (0, $88461f0b0f431f45$export$d0e7720d468a5456).length + 1; // +1 for random option
    const totalPages = Math.ceil(totalItems / $a791dc77ae9c188b$var$TRACKS_PER_PAGE);
    $a791dc77ae9c188b$var$$trackCarouselLeft.disabled = $a791dc77ae9c188b$var$carouselCurrentPage === 0;
    $a791dc77ae9c188b$var$$trackCarouselRight.disabled = $a791dc77ae9c188b$var$carouselCurrentPage >= totalPages - 1;
}
// Initialize carousel
function $a791dc77ae9c188b$var$initCarousel() {
    $a791dc77ae9c188b$var$carouselCurrentPage = 0;
    $a791dc77ae9c188b$var$$trackOptions.style.transform = "translateX(0px)";
    $a791dc77ae9c188b$var$updateCarouselButtons();
    $a791dc77ae9c188b$var$$trackCarouselLeft.addEventListener("click", ()=>{
        // Ignore clicks while animation is in progress
        if ($a791dc77ae9c188b$var$carouselAnimationId !== null) return;
        $a791dc77ae9c188b$var$soundButtonClick();
        if ($a791dc77ae9c188b$var$carouselCurrentPage > 0) $a791dc77ae9c188b$var$scrollToPage($a791dc77ae9c188b$var$carouselCurrentPage - 1);
    });
    $a791dc77ae9c188b$var$$trackCarouselRight.addEventListener("click", ()=>{
        // Ignore clicks while animation is in progress
        if ($a791dc77ae9c188b$var$carouselAnimationId !== null) return;
        $a791dc77ae9c188b$var$soundButtonClick();
        if ($a791dc77ae9c188b$var$carouselCurrentPage < Math.ceil(((0, $88461f0b0f431f45$export$d0e7720d468a5456).length + 1) / $a791dc77ae9c188b$var$TRACKS_PER_PAGE) - 1) $a791dc77ae9c188b$var$scrollToPage($a791dc77ae9c188b$var$carouselCurrentPage + 1);
    });
}
function $a791dc77ae9c188b$var$initTeamOptions() {
    for(let i = 0; i < (0, $88461f0b0f431f45$export$d4e3681ec5762859).length; i++){
        const $teamOption = document.createElement("div");
        $teamOption.className = "team-option";
        const team = (0, $88461f0b0f431f45$export$d4e3681ec5762859)[i];
        const $car = document.createElement("div");
        $car.className = "car";
        $car.innerHTML = `
      <div class="wheel-fl wheel"></div>
      <div class="wheel-fr wheel"></div>
    `;
        $car.style.backgroundPositionX = `${i * -74}px`;
        $teamOption.setAttribute("data-team-index", i);
        $teamOption.classList.toggle("selected", $a791dc77ae9c188b$var$selectedTeamIndex === i);
        $teamOption.appendChild($car);
        const $teamName = document.createElement("div");
        $teamName.className = "team-name";
        $teamName.innerText = team.name;
        $teamOption.appendChild($teamName);
        $a791dc77ae9c188b$var$$startRaceTeamOptions.appendChild($teamOption);
        $teamOption.addEventListener("click", $a791dc77ae9c188b$var$handleTeamOptionClick);
    }
}
function $a791dc77ae9c188b$var$handleTeamOptionClick(event) {
    $a791dc77ae9c188b$var$soundButtonClick();
    const teamIndex = +event.currentTarget.getAttribute("data-team-index");
    $a791dc77ae9c188b$var$selectedTeamIndex = teamIndex;
    localStorage.setItem("selectedTeamIndex", $a791dc77ae9c188b$var$selectedTeamIndex);
    const $teamOptions = $a791dc77ae9c188b$var$$startRaceTeamOptions.querySelectorAll(".team-option");
    for(let i = 0; i < $teamOptions.length; i++)$teamOptions[i].classList.toggle("selected", i === teamIndex);
    if ($a791dc77ae9c188b$var$playerCar) $a791dc77ae9c188b$var$playerCar.setColor($a791dc77ae9c188b$var$selectedTeamIndex);
}
function $a791dc77ae9c188b$var$showLoadingSpinner(text) {
    $a791dc77ae9c188b$var$$loadingDialogText.innerText = text;
    $a791dc77ae9c188b$var$$loadingDialog.style.visibility = "visible";
}
function $a791dc77ae9c188b$var$hideLoadingSpinner() {
    $a791dc77ae9c188b$var$$loadingDialog.style.visibility = "hidden";
}
function $a791dc77ae9c188b$var$showTrackOptions() {
    $a791dc77ae9c188b$var$$trackOptions.classList.remove("show"); // reset
    $a791dc77ae9c188b$var$$trackOptions.offsetWidth; // force reflow so animation restarts
    $a791dc77ae9c188b$var$$trackOptions.classList.add("show");
}
function $a791dc77ae9c188b$var$handleTrackOptionClick(event) {
    $a791dc77ae9c188b$var$soundButtonClick();
    const trackName = event.currentTarget.getAttribute("trackName");
    $a791dc77ae9c188b$var$showStartRaceDialog(trackName);
}
function $a791dc77ae9c188b$var$handleRandomTrackOptionClick() {
    $a791dc77ae9c188b$var$handleTrackOptionClick({
        currentTarget: $a791dc77ae9c188b$var$trackOptions[Math.floor(Math.random() * $a791dc77ae9c188b$var$trackOptions.length)]
    });
}
function $a791dc77ae9c188b$var$showPauseDialog() {
    $a791dc77ae9c188b$var$isPaused = true;
    $a791dc77ae9c188b$var$lastPausedTime = Date.now();
    $a791dc77ae9c188b$var$$pauseDialog.style.visibility = "visible";
    $a791dc77ae9c188b$var$$pauseDialog.classList.toggle("hidden", false);
}
function $a791dc77ae9c188b$var$hidePauseDialog() {
    $a791dc77ae9c188b$var$isPaused = false;
    if ($a791dc77ae9c188b$var$lastPausedTime >= 0) $a791dc77ae9c188b$var$raceStartTime += Date.now() - $a791dc77ae9c188b$var$lastPausedTime;
    $a791dc77ae9c188b$var$lastPausedTime = -1;
    (0, $e24eb4b533960f8a$export$ec57c86e1502e26)(); // Reset physics timing to prevent stale delta
    $a791dc77ae9c188b$var$$pauseDialog.style.visibility = "hidden";
    $a791dc77ae9c188b$var$$pauseDialog.classList.toggle("hidden", true);
}
function $a791dc77ae9c188b$var$handleQuitRaceButtonClick() {
    $a791dc77ae9c188b$var$soundButtonClick();
    $a791dc77ae9c188b$var$showTitleScreen();
    $a791dc77ae9c188b$var$hidePauseDialog();
}
function $a791dc77ae9c188b$var$handleResumeRaceButtonClick() {
    $a791dc77ae9c188b$var$soundButtonClick();
    $a791dc77ae9c188b$var$hidePauseDialog();
}
function $a791dc77ae9c188b$var$handlePauseDialogCloseButtonClick() {
    $a791dc77ae9c188b$var$soundButtonClick();
    $a791dc77ae9c188b$var$hidePauseDialog();
}
async function $a791dc77ae9c188b$var$showBestLapDialog(bestLapTime) {
    // Clear cache to get fresh data
    (0, $ee5ed6acd5aa4518$export$b3c35f54bf8456e5)();
    // Load all leaderboards
    $a791dc77ae9c188b$var$allLeaderboards = await (0, $ee5ed6acd5aa4518$export$1450e7c53d93552d)($a791dc77ae9c188b$var$currentTrackName);
    // Check qualification in priority order: All-time, Monthly, Weekly
    const allTimeRank = (0, $ee5ed6acd5aa4518$export$7d5bf186290a6446)($a791dc77ae9c188b$var$allLeaderboards.allTime, bestLapTime);
    const monthlyRank = (0, $ee5ed6acd5aa4518$export$7d5bf186290a6446)($a791dc77ae9c188b$var$allLeaderboards.monthly, bestLapTime);
    const weeklyRank = (0, $ee5ed6acd5aa4518$export$7d5bf186290a6446)($a791dc77ae9c188b$var$allLeaderboards.weekly, bestLapTime);
    let selectedLeaderboard;
    let selectedRank;
    let selectedLabel;
    if (allTimeRank >= 0) {
        selectedLeaderboard = $a791dc77ae9c188b$var$allLeaderboards.allTime;
        selectedRank = allTimeRank;
        selectedLabel = "All time";
    } else if (monthlyRank >= 0) {
        selectedLeaderboard = $a791dc77ae9c188b$var$allLeaderboards.monthly;
        selectedRank = monthlyRank;
        selectedLabel = "Monthly";
    } else if (weeklyRank >= 0) {
        selectedLeaderboard = $a791dc77ae9c188b$var$allLeaderboards.weekly;
        selectedRank = weeklyRank;
        selectedLabel = "Weekly";
    } else {
        // Doesn't qualify for any leaderboard, show all-time
        selectedLeaderboard = $a791dc77ae9c188b$var$allLeaderboards.allTime;
        selectedRank = -1;
        selectedLabel = "All time";
    }
    // Set the leaderboard reference for validation
    $a791dc77ae9c188b$var$leaderboard = selectedLeaderboard;
    // Display the selected leaderboard
    (0, $ee5ed6acd5aa4518$export$ae67ef93410cdd3a)($a791dc77ae9c188b$var$$bestLapLeaderboard, selectedLeaderboard);
    $a791dc77ae9c188b$var$$bestLapLeaderboardType.innerText = selectedLabel;
    (0, $ee5ed6acd5aa4518$export$a41e4bde5fcd58bd)($a791dc77ae9c188b$var$$bestLapLeaderboard);
    const qualifies = selectedRank >= 0;
    if (qualifies) {
        (0, $ee5ed6acd5aa4518$export$2eae8c277316db1)($a791dc77ae9c188b$var$$bestLapLeaderboard, selectedRank, {
            teamIndex: $a791dc77ae9c188b$var$playerCar.colorIndex,
            name3: "",
            lapMs: bestLapTime
        });
        $a791dc77ae9c188b$var$$bestLapInput.value = window.localStorage.getItem("name3") || "";
        (0, $ee5ed6acd5aa4518$export$32b9f1f6de0c1125)($a791dc77ae9c188b$var$$bestLapLeaderboard, $a791dc77ae9c188b$var$$bestLapInput.value);
    }
    $a791dc77ae9c188b$var$$bestLapTimeValue.setAttribute("data-value", bestLapTime);
    $a791dc77ae9c188b$var$$bestLapTimeValue.innerText = (0, $cb8a4fc1d1568115$export$e0b56eedabd2a5bd)(bestLapTime);
    $a791dc77ae9c188b$var$$bestLapDialog.querySelectorAll(".good-enough").forEach(($el)=>{
        $el.classList.toggle("hidden", !qualifies);
    });
    $a791dc77ae9c188b$var$$bestLapDialog.querySelectorAll(".not-good-enough").forEach(($el)=>{
        $el.classList.toggle("hidden", qualifies);
    });
    $a791dc77ae9c188b$var$$bestLapDialog.setAttribute("data-step", "entering");
    $a791dc77ae9c188b$var$$bestLapDialog.style.visibility = "visible";
    $a791dc77ae9c188b$var$$bestLapDialog.classList.toggle("hidden", false);
    $a791dc77ae9c188b$var$$bestLapInput.focus();
    $a791dc77ae9c188b$var$validateBestLapSubmission();
}
function $a791dc77ae9c188b$var$hideBestLapDialog() {
    $a791dc77ae9c188b$var$$bestLapDialog.style.visibility = "hidden";
    $a791dc77ae9c188b$var$$bestLapDialog.classList.toggle("hidden", true);
}
function $a791dc77ae9c188b$var$soundButtonClick() {
    $a791dc77ae9c188b$var$soundPlayer.playOnce($a791dc77ae9c188b$var$buttonClickBuffer, {
        volume: 0.5
    });
}
function $a791dc77ae9c188b$var$soundStartLight() {
    $a791dc77ae9c188b$var$soundPlayer.playOnce($a791dc77ae9c188b$var$startLightBuffer, {
        volume: 1
    });
}
function $a791dc77ae9c188b$var$toggleMute() {
    $a791dc77ae9c188b$var$isMuted = !$a791dc77ae9c188b$var$isMuted;
    if ($a791dc77ae9c188b$var$isMuted) {
        $a791dc77ae9c188b$var$musicPlayer.setVolume(0);
        $a791dc77ae9c188b$var$soundPlayer.setMasterVolume(0);
        if ($a791dc77ae9c188b$var$playerCar.engineSound && $a791dc77ae9c188b$var$playerCar.engineSound.engineGain) $a791dc77ae9c188b$var$playerCar.engineSound.engineGain.gain.value = 0;
    } else {
        $a791dc77ae9c188b$var$musicPlayer.setVolume(1);
        $a791dc77ae9c188b$var$soundPlayer.setMasterVolume(1);
        if ($a791dc77ae9c188b$var$playerCar.engineSound && $a791dc77ae9c188b$var$playerCar.engineSound.engineGain) $a791dc77ae9c188b$var$playerCar.engineSound.engineGain.gain.value = 0.25;
    }
    $a791dc77ae9c188b$var$updateMuteButton();
}
function $a791dc77ae9c188b$var$updateMuteButton() {
    if ($a791dc77ae9c188b$var$$muteButton) {
        $a791dc77ae9c188b$var$$muteButton.innerHTML = $a791dc77ae9c188b$var$isMuted ? "&#x1F507;" : "&#x1F50A;";
        $a791dc77ae9c188b$var$$muteButton.setAttribute("aria-label", $a791dc77ae9c188b$var$isMuted ? "Unmute" : "Mute");
    }
}
async function $a791dc77ae9c188b$var$handleBestLapSubmitButtonClick() {
    $a791dc77ae9c188b$var$soundButtonClick();
    window.localStorage.setItem("name3", $a791dc77ae9c188b$var$$bestLapInput.value);
    $a791dc77ae9c188b$var$$bestLapDialog.setAttribute("data-step", "submitting");
    const result = await (0, $ee5ed6acd5aa4518$export$37bae23fc4e3990b)({
        trackId: $a791dc77ae9c188b$var$currentTrackName,
        name3: $a791dc77ae9c188b$var$$bestLapInput.value,
        teamIndex: $a791dc77ae9c188b$var$playerCar.colorIndex,
        samples: (0, $74682beda20f55da$export$130ae2c21d4eb59a)()
    });
    $a791dc77ae9c188b$var$leaderboard = result.leaderboard;
    $a791dc77ae9c188b$var$$bestLapDialog.setAttribute("data-step", "submitted");
}
function $a791dc77ae9c188b$var$handleBestLapInput(event) {
    const input = event.target;
    // Remove any characters that are not letters or numbers
    input.value = input.value.replace(/[^A-Za-z0-9]/g, "");
    $a791dc77ae9c188b$var$$bestLapSubmitButton.setAttribute("disable", input.value.length !== 3);
    (0, $ee5ed6acd5aa4518$export$32b9f1f6de0c1125)($a791dc77ae9c188b$var$$bestLapLeaderboard, input.value);
    $a791dc77ae9c188b$var$validateBestLapSubmission();
}
function $a791dc77ae9c188b$var$validateBestLapSubmission() {
    const inputName = $a791dc77ae9c188b$var$$bestLapInput.value.toLowerCase();
    let isDuplicateName = false;
    const bestLapMs = +$a791dc77ae9c188b$var$$bestLapTimeValue.getAttribute("data-value");
    let validState = "valid";
    for(let i = 0; i < $a791dc77ae9c188b$var$leaderboard.length; i++){
        const entry = $a791dc77ae9c188b$var$leaderboard[i];
        if (entry.name3 === inputName) {
            if (bestLapMs < entry.lapMs) validState = "faster";
            else validState = "slower";
        }
    }
    switch(validState){
        case "faster":
            $a791dc77ae9c188b$var$$bestLapInputMessage.innerText = "Your lap time will replace an existing entry.";
            break;
        case "slower":
            $a791dc77ae9c188b$var$$bestLapInputMessage.innerText = "You can't submit a slower lap time.";
            break;
        default:
            $a791dc77ae9c188b$var$$bestLapInputMessage.innerText = "";
            break;
    }
    $a791dc77ae9c188b$var$$bestLapDialog.setAttribute("data-validation", validState);
    $a791dc77ae9c188b$var$$bestLapSubmitButton.disabled = validState === "slower";
}
function $a791dc77ae9c188b$var$handleBestLapDialogCloseButtonClick() {
    $a791dc77ae9c188b$var$soundButtonClick();
    $a791dc77ae9c188b$var$showTitleScreen();
    $a791dc77ae9c188b$var$hideBestLapDialog();
}
async function $a791dc77ae9c188b$var$handleBestLapShareButtonClick() {
    $a791dc77ae9c188b$var$soundButtonClick();
    const trackName = $a791dc77ae9c188b$var$currentTrackName;
    const url = `${window.location.origin}${window.location.pathname}?track=${trackName}`;
    const result = await (0, $cb8a4fc1d1568115$export$2cdf1b96a9f86d16)(url);
    if (result.success) {
        // Temporarily change button text to show success
        const originalText = $a791dc77ae9c188b$var$$bestLapShareButton.textContent;
        $a791dc77ae9c188b$var$$bestLapShareButton.textContent = "Link copied!";
        setTimeout(()=>{
            $a791dc77ae9c188b$var$$bestLapShareButton.textContent = originalText;
        }, 2000);
    } else // Show manual copy fallback dialog
    $a791dc77ae9c188b$var$showCopyFallbackDialog(url);
}
async function $a791dc77ae9c188b$var$showStartRaceDialog(trackName) {
    // show track
    $a791dc77ae9c188b$var$selectedTrackName = trackName;
    const assetUrl = $a791dc77ae9c188b$var$trackImages[trackName];
    $a791dc77ae9c188b$var$$startRaceTrackInfo.style.backgroundImage = `url(${assetUrl})`;
    const [track, region] = (0, $88461f0b0f431f45$export$5cc6edba7251fc3e)[trackName].split(",");
    $a791dc77ae9c188b$var$$startRaceTrackTitle.innerHTML = `<span>${track}</span><span>${region}</span>`;
    $a791dc77ae9c188b$var$$startRaceDialog.style.visibility = "visible";
    $a791dc77ae9c188b$var$$startRaceDialog.classList.toggle("hidden", false);
    // Show loading state for all leaderboards
    (0, $ee5ed6acd5aa4518$export$b23d36477ddf4833)($a791dc77ae9c188b$var$$startRaceLeaderboardWeekly);
    (0, $ee5ed6acd5aa4518$export$b23d36477ddf4833)($a791dc77ae9c188b$var$$startRaceLeaderboardMonthly);
    (0, $ee5ed6acd5aa4518$export$b23d36477ddf4833)($a791dc77ae9c188b$var$$startRaceLeaderboardAllTime);
    // Reset to weekly tab (index 0)
    $a791dc77ae9c188b$var$currentLeaderboardTab = 0;
    $a791dc77ae9c188b$var$setLeaderboardTab(0, false);
    // Clear cache to get fresh data
    (0, $ee5ed6acd5aa4518$export$b3c35f54bf8456e5)();
    // Load all leaderboards
    $a791dc77ae9c188b$var$allLeaderboards = await (0, $ee5ed6acd5aa4518$export$1450e7c53d93552d)(trackName);
    // Display all leaderboards
    (0, $ee5ed6acd5aa4518$export$ae67ef93410cdd3a)($a791dc77ae9c188b$var$$startRaceLeaderboardWeekly, $a791dc77ae9c188b$var$allLeaderboards.weekly);
    (0, $ee5ed6acd5aa4518$export$ae67ef93410cdd3a)($a791dc77ae9c188b$var$$startRaceLeaderboardMonthly, $a791dc77ae9c188b$var$allLeaderboards.monthly);
    (0, $ee5ed6acd5aa4518$export$ae67ef93410cdd3a)($a791dc77ae9c188b$var$$startRaceLeaderboardAllTime, $a791dc77ae9c188b$var$allLeaderboards.allTime);
    // Set the main leaderboard reference to allTime for ghost loading
    $a791dc77ae9c188b$var$leaderboard = $a791dc77ae9c188b$var$allLeaderboards.allTime;
    (0, $ee5ed6acd5aa4518$export$ae67ef93410cdd3a)($a791dc77ae9c188b$var$$bestLapLeaderboard, $a791dc77ae9c188b$var$leaderboard);
    // Start auto-cycle
    $a791dc77ae9c188b$var$startLeaderboardAutoCycle();
}
function $a791dc77ae9c188b$var$setLeaderboardTab(tabIndex, animate = true) {
    $a791dc77ae9c188b$var$currentLeaderboardTab = tabIndex;
    // Update tab active states
    $a791dc77ae9c188b$var$$startRaceLeaderboardTabs.forEach((tab, index)=>{
        tab.classList.toggle("active", index === tabIndex);
    });
    // Slide the leaderboard
    const offset = -tabIndex * 470;
    if (animate) $a791dc77ae9c188b$var$$startRaceLeaderboardSlider.style.transition = "transform 0.4s ease-in-out";
    else $a791dc77ae9c188b$var$$startRaceLeaderboardSlider.style.transition = "none";
    $a791dc77ae9c188b$var$$startRaceLeaderboardSlider.style.transform = `translateX(${offset}px)`;
}
function $a791dc77ae9c188b$var$cycleToNextLeaderboardTab() {
    const nextTab = ($a791dc77ae9c188b$var$currentLeaderboardTab + 1) % 3;
    $a791dc77ae9c188b$var$setLeaderboardTab(nextTab, true);
}
function $a791dc77ae9c188b$var$startLeaderboardAutoCycle() {
    $a791dc77ae9c188b$var$stopLeaderboardAutoCycle();
    $a791dc77ae9c188b$var$leaderboardAutoCycleInterval = setInterval($a791dc77ae9c188b$var$cycleToNextLeaderboardTab, 5000);
}
function $a791dc77ae9c188b$var$stopLeaderboardAutoCycle() {
    if ($a791dc77ae9c188b$var$leaderboardAutoCycleInterval) {
        clearInterval($a791dc77ae9c188b$var$leaderboardAutoCycleInterval);
        $a791dc77ae9c188b$var$leaderboardAutoCycleInterval = null;
    }
}
function $a791dc77ae9c188b$var$handleLeaderboardTabClick(event) {
    $a791dc77ae9c188b$var$soundButtonClick();
    $a791dc77ae9c188b$var$stopLeaderboardAutoCycle();
    const tabName = event.currentTarget.getAttribute("data-tab");
    const tabIndex = $a791dc77ae9c188b$var$LEADERBOARD_TAB_NAMES.indexOf(tabName);
    if (tabIndex >= 0) $a791dc77ae9c188b$var$setLeaderboardTab(tabIndex, true);
}
function $a791dc77ae9c188b$var$hideStartRaceDialog() {
    $a791dc77ae9c188b$var$stopLeaderboardAutoCycle();
    $a791dc77ae9c188b$var$$startRaceDialog.style.visibility = "hidden";
    $a791dc77ae9c188b$var$$startRaceDialog.classList.toggle("hidden", true);
}
async function $a791dc77ae9c188b$var$handleStartRaceButtonClick() {
    $a791dc77ae9c188b$var$soundButtonClick();
    $a791dc77ae9c188b$var$setIsDemo(false);
    $a791dc77ae9c188b$var$hideStartRaceDialog();
    $a791dc77ae9c188b$var$hideTitleScreen();
    await $a791dc77ae9c188b$var$loadTrack($a791dc77ae9c188b$var$selectedTrackName, true);
    $a791dc77ae9c188b$var$invalidateHUD();
    $a791dc77ae9c188b$var$musicPlayer.play($a791dc77ae9c188b$var$gameMusicBuffer, {
        resume: true,
        loop: true,
        volume: 0.5
    });
}
function $a791dc77ae9c188b$var$handleStartRaceDialogCloseButtonClick() {
    $a791dc77ae9c188b$var$hideStartRaceDialog();
}
async function $a791dc77ae9c188b$var$handleStartRaceShareButtonClick() {
    $a791dc77ae9c188b$var$soundButtonClick();
    const trackName = $a791dc77ae9c188b$var$selectedTrackName;
    const url = `${window.location.origin}?track=${trackName}`;
    const result = await (0, $cb8a4fc1d1568115$export$2cdf1b96a9f86d16)(url);
    if (result.success) {
        // Temporarily change button text to show success
        const originalText = $a791dc77ae9c188b$var$$startRaceShareButton.textContent;
        $a791dc77ae9c188b$var$$startRaceShareButton.textContent = "Link copied!";
        setTimeout(()=>{
            $a791dc77ae9c188b$var$$startRaceShareButton.textContent = originalText;
        }, 2000);
    } else // Show manual copy fallback dialog
    $a791dc77ae9c188b$var$showCopyFallbackDialog(url);
}
let $a791dc77ae9c188b$var$copyFallbackTimeout = null;
function $a791dc77ae9c188b$var$showCopyFallbackDialog(url) {
    $a791dc77ae9c188b$var$$copyFallbackInput.value = url;
    $a791dc77ae9c188b$var$$copyFallbackDialog.style.visibility = "visible";
    $a791dc77ae9c188b$var$$copyFallbackDialog.classList.toggle("hidden", false);
    // Auto-select the text for easy manual copying
    setTimeout(()=>{
        $a791dc77ae9c188b$var$$copyFallbackInput.select();
        $a791dc77ae9c188b$var$$copyFallbackInput.focus();
    }, 100);
    // Auto-dismiss after 10 seconds
    if ($a791dc77ae9c188b$var$copyFallbackTimeout) clearTimeout($a791dc77ae9c188b$var$copyFallbackTimeout);
    $a791dc77ae9c188b$var$copyFallbackTimeout = setTimeout(()=>{
        $a791dc77ae9c188b$var$hideCopyFallbackDialog();
    }, 10000);
}
function $a791dc77ae9c188b$var$hideCopyFallbackDialog() {
    if ($a791dc77ae9c188b$var$copyFallbackTimeout) {
        clearTimeout($a791dc77ae9c188b$var$copyFallbackTimeout);
        $a791dc77ae9c188b$var$copyFallbackTimeout = null;
    }
    $a791dc77ae9c188b$var$$copyFallbackDialog.style.visibility = "hidden";
    $a791dc77ae9c188b$var$$copyFallbackDialog.classList.toggle("hidden", true);
}
function $a791dc77ae9c188b$var$handleCopyFallbackCloseButtonClick() {
    $a791dc77ae9c188b$var$soundButtonClick();
    $a791dc77ae9c188b$var$hideCopyFallbackDialog();
}
function $a791dc77ae9c188b$var$showTitleScreen() {
    $a791dc77ae9c188b$var$$titleScreen.style.display = "flex";
    $a791dc77ae9c188b$var$setIsDemo(true);
    $a791dc77ae9c188b$var$invalidateHUD();
    $a791dc77ae9c188b$var$musicPlayer.play($a791dc77ae9c188b$var$titleMusicBuffer, {
        resume: true,
        loop: true,
        volume: 1
    });
}
function $a791dc77ae9c188b$var$hideTitleScreen() {
    $a791dc77ae9c188b$var$$titleScreen.style.display = "none";
}
async function $a791dc77ae9c188b$var$loadGhosts() {
    $a791dc77ae9c188b$var$cars.length = 0;
    $a791dc77ae9c188b$var$$cars.innerHTML = "";
    if ($a791dc77ae9c188b$var$leaderboard) {
        const ghostEntries = [];
        for(let i = 0; i < Math.min($a791dc77ae9c188b$var$leaderboard.length, 9); i++){
            const entry = $a791dc77ae9c188b$var$leaderboard[i];
            if (entry.lapMs >= 0 && Boolean(entry.path)) ghostEntries.push(entry);
        }
        // Use allSettled instead of all to allow partial failures
        const results = await Promise.allSettled(ghostEntries.map((entry)=>(0, $ee5ed6acd5aa4518$export$aeb08873aa7431a0)(entry.path)));
        // Track how many ghosts loaded successfully
        let loadedCount = 0;
        let failedCount = 0;
        for(let i = 0; i < ghostEntries.length; i++){
            const entry = ghostEntries[i];
            const result = results[i];
            // Only create ghost car if loading succeeded and data exists
            if (result.status === "fulfilled" && result.value && (0, $ee5ed6acd5aa4518$export$6db1e1aa0c34fe0d)[entry.path]) {
                const ghostCar = $a791dc77ae9c188b$var$createCar(`ghost_${i}`, entry.teamIndex, false);
                ghostCar.setGhostData((0, $ee5ed6acd5aa4518$export$6db1e1aa0c34fe0d)[entry.path].samples);
                $a791dc77ae9c188b$var$cars.push(ghostCar);
                loadedCount++;
            } else failedCount++;
        }
        if (failedCount > 0) console.warn(`Loaded ${loadedCount} ghost(s), ${failedCount} failed to load. Race will continue without failed ghosts.`);
    }
    $a791dc77ae9c188b$var$$cars.appendChild($a791dc77ae9c188b$var$playerCar.$el);
    $a791dc77ae9c188b$var$cars.push($a791dc77ae9c188b$var$playerCar);
}
function $a791dc77ae9c188b$var$initLapTimes() {
    $a791dc77ae9c188b$var$$lapTimes.innerHTML = "";
    $a791dc77ae9c188b$var$$lapTimes.classList.toggle("hidden", $a791dc77ae9c188b$var$isDemo || $a791dc77ae9c188b$var$lapCount <= 1);
    $a791dc77ae9c188b$var$lapTimes.length = 0;
    for(let i = 0; i < $a791dc77ae9c188b$var$lapCount; i++){
        const $lapTime = document.createElement("li");
        $lapTime.innerText = (0, $cb8a4fc1d1568115$export$e0b56eedabd2a5bd)(-1);
        $a791dc77ae9c188b$var$lapTimes.push($lapTime);
        $a791dc77ae9c188b$var$$lapTimes.appendChild($lapTime);
    }
}
function $a791dc77ae9c188b$var$initStartLights() {
    $a791dc77ae9c188b$var$$startLights.innerHTML = "";
    $a791dc77ae9c188b$var$$startLights.lights = [];
    for(let i = 0; i < 5; i++){
        const $startLight = document.createElement("div");
        $a791dc77ae9c188b$var$$startLights.lights.push($startLight);
        $a791dc77ae9c188b$var$$startLights.appendChild($startLight);
    }
}
function $a791dc77ae9c188b$var$setStartLight(count) {
    if (count >= 1 && count <= 5 && $a791dc77ae9c188b$var$currentStartLightCount !== count) {
        $a791dc77ae9c188b$var$currentStartLightCount = count;
        $a791dc77ae9c188b$var$soundStartLight();
    }
    for(let i = 0; i < $a791dc77ae9c188b$var$$startLights.lights.length; i++)$a791dc77ae9c188b$var$$startLights.lights[i].style.backgroundPositionX = i < count ? "-104px" : "0";
}
function $a791dc77ae9c188b$var$setRacingLineVisible(value = $a791dc77ae9c188b$var$isRacingLineVisible) {
    $a791dc77ae9c188b$var$isRacingLineVisible = value;
    $a791dc77ae9c188b$var$$trackRacingline.style.opacity = $a791dc77ae9c188b$var$isRacingLineVisible ? 1 : 0;
    $a791dc77ae9c188b$var$$samples.style.opacity = $a791dc77ae9c188b$var$isRacingLineVisible ? 1 : 0;
}
async function $a791dc77ae9c188b$var$loadTrack(trackName, showSpinner = true) {
    if (showSpinner) $a791dc77ae9c188b$var$showLoadingSpinner("Loading race...");
    $a791dc77ae9c188b$var$currentStartLightCount = -1;
    $a791dc77ae9c188b$var$currentTrackName = trackName || (0, $88461f0b0f431f45$export$d0e7720d468a5456)[0];
    $a791dc77ae9c188b$var$$trackLabel.innerText = (0, $88461f0b0f431f45$export$5cc6edba7251fc3e)[$a791dc77ae9c188b$var$currentTrackName];
    await (0, $cb8a4fc1d1568115$export$c32505ea942c7f01)($a791dc77ae9c188b$var$trackSvgs[$a791dc77ae9c188b$var$currentTrackName], $a791dc77ae9c188b$var$$track);
    $a791dc77ae9c188b$var$lastSkids = {};
    $a791dc77ae9c188b$var$clearSkids();
    $a791dc77ae9c188b$var$resetRace();
    $a791dc77ae9c188b$var$$track.querySelector("svg").style.transform = `scale(${$a791dc77ae9c188b$var$TRACK_SCALE})`;
    $a791dc77ae9c188b$var$$trackRoad = $a791dc77ae9c188b$var$$track.querySelector("svg #road");
    $a791dc77ae9c188b$var$$trackRoadTarmac = $a791dc77ae9c188b$var$$track.querySelector("svg #tarmac");
    $a791dc77ae9c188b$var$$trackCenterline = $a791dc77ae9c188b$var$$track.querySelector("svg #centerline");
    $a791dc77ae9c188b$var$$trackRacingline = $a791dc77ae9c188b$var$$track.querySelector("svg #racingline") || $a791dc77ae9c188b$var$$trackCenterline;
    $a791dc77ae9c188b$var$$trackContainer = $a791dc77ae9c188b$var$$track.querySelector("svg #trackContainer");
    $a791dc77ae9c188b$var$setRacingLineVisible();
    const trackContainerTransform = $a791dc77ae9c188b$var$$trackContainer.getAttribute("transform");
    $a791dc77ae9c188b$var$trackCenterlineOffset = (0, $cb8a4fc1d1568115$export$17768e0e20632e02)(trackContainerTransform);
    $a791dc77ae9c188b$var$trackCenterlineSegments = (0, $cb8a4fc1d1568115$export$9f6b931a34229784)($a791dc77ae9c188b$var$$trackCenterline, 5, $a791dc77ae9c188b$var$trackCenterlineOffset, $a791dc77ae9c188b$var$TRACK_SCALE);
    $a791dc77ae9c188b$var$trackRacinglineSegments = (0, $cb8a4fc1d1568115$export$9f6b931a34229784)($a791dc77ae9c188b$var$$trackRacingline || $a791dc77ae9c188b$var$$trackCenterline, 5, $a791dc77ae9c188b$var$trackCenterlineOffset, $a791dc77ae9c188b$var$TRACK_SCALE);
    $a791dc77ae9c188b$var$renderTrackRacingline();
    let startingGridSegmentIndex = $a791dc77ae9c188b$var$startLine - 3;
    if (startingGridSegmentIndex < 0) startingGridSegmentIndex += $a791dc77ae9c188b$var$trackCenterlineSegments.length;
    $a791dc77ae9c188b$var$placeStartLine($a791dc77ae9c188b$var$startLine);
    $a791dc77ae9c188b$var$placeFinishLine($a791dc77ae9c188b$var$finishLine);
    $a791dc77ae9c188b$var$renderGrids(startingGridSegmentIndex);
    await $a791dc77ae9c188b$var$loadGhosts();
    for(let i = 0; i < $a791dc77ae9c188b$var$cars.length; i++){
        const car = $a791dc77ae9c188b$var$cars[i];
        car.$trackRoad = $a791dc77ae9c188b$var$$trackRoad;
        car.$trackRoadTarmac = $a791dc77ae9c188b$var$$trackRoadTarmac;
        car.finishLine = $a791dc77ae9c188b$var$finishLine;
        car.camera = $a791dc77ae9c188b$var$camera;
        car.setTrackRacinglineSegments($a791dc77ae9c188b$var$trackRacinglineSegments);
        car.setStartingGrid($a791dc77ae9c188b$var$grids[i]);
    }
    $a791dc77ae9c188b$var$generateSkids();
    $a791dc77ae9c188b$var$startRace();
    document.getElementById("loadingScreen").style.display = "none";
    $a791dc77ae9c188b$var$hideLoadingSpinner();
}
function $a791dc77ae9c188b$var$setIsDemo(value) {
    $a791dc77ae9c188b$var$isDemo = value;
    $a791dc77ae9c188b$var$playerCar.setBot($a791dc77ae9c188b$var$isDemo);
    for(let i = 0; i < $a791dc77ae9c188b$var$cars.length; i++){
        const car = $a791dc77ae9c188b$var$cars[i];
        if (!car.isPlayer) car.setVisible(!$a791dc77ae9c188b$var$isDemo);
    }
}
function $a791dc77ae9c188b$var$invalidateHUD() {
    $a791dc77ae9c188b$var$$startLights.classList.toggle("hidden", $a791dc77ae9c188b$var$isDemo);
    $a791dc77ae9c188b$var$$viz.classList.toggle("hidden", $a791dc77ae9c188b$var$isDemo);
    $a791dc77ae9c188b$var$$lapTimes.classList.toggle("hidden", $a791dc77ae9c188b$var$isDemo || $a791dc77ae9c188b$var$lapCount <= 1);
}
function $a791dc77ae9c188b$var$resetRace() {
    $a791dc77ae9c188b$var$isRaceStarted = false;
    $a791dc77ae9c188b$var$isRaceFinished = false;
    for(let i = 0; i < $a791dc77ae9c188b$var$cars.length; i++){
        const car = $a791dc77ae9c188b$var$cars[i];
        car.reset();
    }
}
function $a791dc77ae9c188b$var$startRace() {
    (0, $74682beda20f55da$export$6353eccc1d45a7e0)();
    $a791dc77ae9c188b$var$isRaceStarted = true;
    $a791dc77ae9c188b$var$raceStartTime = Date.now() + ($a791dc77ae9c188b$var$isDemo ? 0 : 6000);
    (0, $e24eb4b533960f8a$export$ec57c86e1502e26)();
    for(let i = 0; i < $a791dc77ae9c188b$var$cars.length; i++){
        const car = $a791dc77ae9c188b$var$cars[i];
        car.startRace();
    }
}
function $a791dc77ae9c188b$var$generateSkids() {
    const colCount = $a791dc77ae9c188b$var$$track.offsetWidth * $a791dc77ae9c188b$var$TRACK_SCALE / $a791dc77ae9c188b$var$SKID_CANVAS_WIDTH;
    const rowCount = $a791dc77ae9c188b$var$$track.offsetHeight * $a791dc77ae9c188b$var$TRACK_SCALE / $a791dc77ae9c188b$var$SKID_CANVAS_HEIGHT;
    for(let r = 0; r < rowCount; r++)for(let c = 0; c < colCount; c++){
        const $skidCanvas = document.createElement("canvas");
        $skidCanvas.width = $a791dc77ae9c188b$var$SKID_CANVAS_WIDTH;
        $skidCanvas.height = $a791dc77ae9c188b$var$SKID_CANVAS_HEIGHT;
        $skidCanvas.style.transform = `translate(${c * $a791dc77ae9c188b$var$SKID_CANVAS_WIDTH}px, ${r * $a791dc77ae9c188b$var$SKID_CANVAS_HEIGHT}px)`;
        const ctx = $skidCanvas.getContext("2d");
        $skidCanvas.ctx = ctx;
        ctx.translate(-c * $a791dc77ae9c188b$var$SKID_CANVAS_WIDTH, -r * $a791dc77ae9c188b$var$SKID_CANVAS_HEIGHT);
        ctx.strokeStyle = "rgba(0, 0, 0, 0.3)";
        ctx.lineWidth = 12;
        $a791dc77ae9c188b$var$$skids.appendChild($skidCanvas);
        $a791dc77ae9c188b$var$skidCanvases.push($skidCanvas);
    }
}
function $a791dc77ae9c188b$var$getSkidCanvas(x, y) {
    const colCount = $a791dc77ae9c188b$var$$track.offsetWidth * $a791dc77ae9c188b$var$TRACK_SCALE / $a791dc77ae9c188b$var$SKID_CANVAS_WIDTH;
    const c = Math.floor(x / $a791dc77ae9c188b$var$SKID_CANVAS_WIDTH);
    const r = Math.floor(y / $a791dc77ae9c188b$var$SKID_CANVAS_HEIGHT);
    const i = r * colCount + c;
    return $a791dc77ae9c188b$var$skidCanvases[i];
}
function $a791dc77ae9c188b$var$clearSkids() {
    for(let i = 0; i < $a791dc77ae9c188b$var$skidCanvases.length; i++){
        const canvas = $a791dc77ae9c188b$var$skidCanvases[i];
        const ctx = canvas.ctx;
        ctx.save();
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.restore();
    }
}
function $a791dc77ae9c188b$var$drawSkid(id, x, y, onlyOffroad = true) {
    if (!$a791dc77ae9c188b$var$showSkidEffects) return;
    const $skidCanvas = $a791dc77ae9c188b$var$getSkidCanvas(x, y);
    if (!$a791dc77ae9c188b$var$lastSkids[id]) {
        $a791dc77ae9c188b$var$lastSkids[id] = {
            x: x,
            y: y
        };
        return;
    }
    const dx = x - $a791dc77ae9c188b$var$lastSkids[id].x;
    const dy = y - $a791dc77ae9c188b$var$lastSkids[id].y;
    if (dx * dx + dy * dy > $a791dc77ae9c188b$var$SKID_INTERVAL_SQ) {
        const ctx = $skidCanvas.ctx;
        const isOffroad = !onlyOffroad || !(0, $cb8a4fc1d1568115$export$b61bf3053f58d778)($a791dc77ae9c188b$var$$trackRoad, $a791dc77ae9c188b$var$$trackRoadTarmac, x - $a791dc77ae9c188b$var$camera.x + $a791dc77ae9c188b$var$hvw, y - $a791dc77ae9c188b$var$camera.y + $a791dc77ae9c188b$var$hvh);
        if (isOffroad) {
            ctx.beginPath();
            ctx.moveTo($a791dc77ae9c188b$var$lastSkids[id].x, $a791dc77ae9c188b$var$lastSkids[id].y);
            ctx.lineTo(x, y);
            ctx.stroke();
        }
        $a791dc77ae9c188b$var$lastSkids[id].x = x;
        $a791dc77ae9c188b$var$lastSkids[id].y = y;
    }
}
function $a791dc77ae9c188b$var$drawTireSkid(player) {
    if ($a791dc77ae9c188b$var$now < $a791dc77ae9c188b$var$raceStartTime) return;
    const dv = (0, $cb8a4fc1d1568115$export$4e54fd7202dafda6)(player.heading);
    const wheelOffsetH = 1.3 * $a791dc77ae9c188b$var$TRACK_SCALE;
    const wheelOffsetV = 3 * $a791dc77ae9c188b$var$TRACK_SCALE;
    const rearWheelLeftX = player.x + dv.left.x * wheelOffsetH + dv.backward.x * wheelOffsetV;
    const rearWheelLeftY = player.y + dv.left.y * wheelOffsetH + dv.backward.y * wheelOffsetV;
    const rearWheelRightX = player.x + dv.right.x * wheelOffsetH + dv.backward.x * wheelOffsetV;
    const rearWheelRightY = player.y + dv.right.y * wheelOffsetH + dv.backward.y * wheelOffsetV;
    $a791dc77ae9c188b$var$drawSkid(`${player.id}_wrl`, rearWheelLeftX, rearWheelLeftY);
    $a791dc77ae9c188b$var$drawSkid(`${player.id}_wrr`, rearWheelRightX, rearWheelRightY);
}
function $a791dc77ae9c188b$var$placeStartLine(trackSegmentIndex) {
    $a791dc77ae9c188b$var$$startLine.x = $a791dc77ae9c188b$var$trackCenterlineSegments[trackSegmentIndex].x;
    $a791dc77ae9c188b$var$$startLine.y = $a791dc77ae9c188b$var$trackCenterlineSegments[trackSegmentIndex].y;
    const angle = (0, $cb8a4fc1d1568115$export$afd58ae2e5ad6fa2)($a791dc77ae9c188b$var$trackCenterlineSegments, trackSegmentIndex);
    $a791dc77ae9c188b$var$$startLine.style.transform = `translate(${$a791dc77ae9c188b$var$$startLine.x}px, ${$a791dc77ae9c188b$var$$startLine.y}px) rotate(${angle}rad)`;
}
function $a791dc77ae9c188b$var$placeFinishLine(trackSegmentIndex) {
    $a791dc77ae9c188b$var$$finishLine.x = $a791dc77ae9c188b$var$trackCenterlineSegments[trackSegmentIndex].x;
    $a791dc77ae9c188b$var$$finishLine.y = $a791dc77ae9c188b$var$trackCenterlineSegments[trackSegmentIndex].y;
    const angle = (0, $cb8a4fc1d1568115$export$afd58ae2e5ad6fa2)($a791dc77ae9c188b$var$trackCenterlineSegments, trackSegmentIndex);
    $a791dc77ae9c188b$var$$finishLine.style.transform = `translate(${$a791dc77ae9c188b$var$$finishLine.x}px, ${$a791dc77ae9c188b$var$$finishLine.y}px) rotate(${angle}rad)`;
}
function $a791dc77ae9c188b$var$renderTrackRacingline() {
    $a791dc77ae9c188b$var$$samples.innerHTML = "";
    $a791dc77ae9c188b$var$samples.length = 0;
    $a791dc77ae9c188b$var$trackRacinglineSegments.forEach((point)=>{
        const sample = document.createElement("div");
        sample.style.transform = `translate(${point.x}px, ${point.y}px)`;
        $a791dc77ae9c188b$var$$samples.appendChild(sample);
        $a791dc77ae9c188b$var$samples.push(sample);
    });
}
function $a791dc77ae9c188b$var$renderGrids(trackSegmentIndex) {
    $a791dc77ae9c188b$var$$gridContainer.innerHTML = "";
    $a791dc77ae9c188b$var$grids.length = 0;
    for(let i = 0; i > -10; i--){
        const segmentIndex = trackSegmentIndex + i + Math.floor((i + 1) / 2) * 2;
        const grid = document.createElement("div");
        const angle = (0, $cb8a4fc1d1568115$export$afd58ae2e5ad6fa2)($a791dc77ae9c188b$var$trackCenterlineSegments, segmentIndex);
        const point = $a791dc77ae9c188b$var$trackCenterlineSegments[segmentIndex];
        const dv = (0, $cb8a4fc1d1568115$export$4e54fd7202dafda6)(angle);
        grid.x = point.x + (i % 2 === 0 ? dv.left.x : dv.right.x) * 5 * $a791dc77ae9c188b$var$TRACK_SCALE;
        grid.y = point.y + (i % 2 === 0 ? dv.left.y : dv.right.y) * 5 * $a791dc77ae9c188b$var$TRACK_SCALE;
        grid.angle = angle;
        grid.style.transform = `translate(${grid.x}px, ${grid.y}px) rotate(${grid.angle}rad)`;
        $a791dc77ae9c188b$var$$gridContainer.appendChild(grid);
        $a791dc77ae9c188b$var$grids.push(grid);
    }
}
function $a791dc77ae9c188b$var$setSkidEffects(value) {
    $a791dc77ae9c188b$var$showSkidEffects = value;
    $a791dc77ae9c188b$var$updateEffectsDisplay();
}
function $a791dc77ae9c188b$var$setSparkEffects(value) {
    $a791dc77ae9c188b$var$showSparkEffects = value;
    $a791dc77ae9c188b$var$updateEffectsDisplay();
}
function $a791dc77ae9c188b$var$updateEffectsDisplay() {
    $a791dc77ae9c188b$var$$skids.classList.toggle("hidden", !$a791dc77ae9c188b$var$showSkidEffects);
    $a791dc77ae9c188b$var$$sparks.classList.toggle("hidden", !$a791dc77ae9c188b$var$showSparkEffects);
}
async function $a791dc77ae9c188b$var$handleKeyDown(event) {
    if ($a791dc77ae9c188b$var$registeredKeys.includes(event.key)) $a791dc77ae9c188b$var$keyPresses[event.key] = true;
    if (event.ctrlKey && event.shiftKey) {
        const key = event.key.toLowerCase();
        // // car color selection
        // if (key === ",") {
        //   playerCar.choosePreviousCarColor();
        // } else if (event.key === ".") {
        //   playerCar.chooseNextCarColor();
        // }
        // // track selection
        // if (!Number.isNaN(+key) && +key < TRACK_NAMES.length) {
        //   loadTrack(TRACK_NAMES[+event.key - 1]);
        // }
        // // toggle auto-pilot
        // if (key === "`") {
        //   playerCar.control.isBot = !playerCar.control.isBot;
        // }
        // toggle racing line visibility
        if (key === "r") $a791dc77ae9c188b$var$setRacingLineVisible(!$a791dc77ae9c188b$var$isRacingLineVisible);
        // clear skid lines
        if (key === "s") $a791dc77ae9c188b$var$clearSkids();
        // test best lap dialog
        if (key === "l") {
            if ($a791dc77ae9c188b$var$$bestLapDialog.style.visibility === "visible") $a791dc77ae9c188b$var$hideBestLapDialog();
            else $a791dc77ae9c188b$var$showBestLapDialog(40000 + Math.floor(Math.random() * 9000));
        }
    // // test start race dialog
    // if (key === "t") {
    //   if ($startRaceDialog.style.visibility === "visible") {
    //     hideStartRaceDialog();
    //   } else {
    //     showStartRaceDialog(currentTrackName);
    //   }
    // }
    // // fire confetti
    // if (key === "f") {
    //   showFinishFlag();
    // }
    // // test save best lap
    // if (key === "b") {
    //   const ghostData = loadLocalGhost(currentTrackName);
    //   try {
    //     const result = await submitBestLapTime({
    //       trackId: currentTrackName,
    //       name3: "TEN",
    //       teamIndex: 2,
    //       samples: ghostData.samples,
    //     });
    //     leaderboard = result.leaderboard;
    //     displayLeaderboard($bestLapLeaderboard, leaderboard);
    //   } catch (error) {
    //     console.warn(error);
    //   }
    // }
    }
    // close all dialogs
    if (event.key === "Escape") {
        if ($a791dc77ae9c188b$var$$bestLapDialog.style.visibility === "visible") $a791dc77ae9c188b$var$hideBestLapDialog();
        if ($a791dc77ae9c188b$var$$startRaceDialog.style.visibility === "visible") $a791dc77ae9c188b$var$hideStartRaceDialog();
        if ($a791dc77ae9c188b$var$$pauseDialog.style.visibility === "visible") $a791dc77ae9c188b$var$hidePauseDialog();
        else if (!$a791dc77ae9c188b$var$isDemo && $a791dc77ae9c188b$var$isRaceStarted) $a791dc77ae9c188b$var$showPauseDialog();
    }
    // toggle sound mute (skip if typing in an input field)
    if ((event.key === "m" || event.key === "M") && document.activeElement?.tagName !== "INPUT") $a791dc77ae9c188b$var$toggleMute();
}
async function $a791dc77ae9c188b$var$showFinishFlag() {
    $a791dc77ae9c188b$var$isRaceFinished = true;
    $a791dc77ae9c188b$var$playerCar.setBot(true);
    $a791dc77ae9c188b$var$$finishFlag.classList.remove("show"); // reset
    $a791dc77ae9c188b$var$$finishFlag.offsetWidth; // force reflow so animation restarts
    $a791dc77ae9c188b$var$$finishFlag.classList.add("show");
    await (0, $cb8a4fc1d1568115$export$1391212d75b2ee65)(500);
    (0, $5a46d228fd9605db$export$6031c45eb6abddc9)();
}
function $a791dc77ae9c188b$var$hideFinishFlag() {
    $a791dc77ae9c188b$var$$finishFlag.classList.remove("show"); // reset
}
function $a791dc77ae9c188b$var$handleKeyUp(event) {
    if ($a791dc77ae9c188b$var$registeredKeys.includes(event.key)) $a791dc77ae9c188b$var$keyPresses[event.key] = false;
}
function $a791dc77ae9c188b$var$processKeyPresses() {
    if ($a791dc77ae9c188b$var$now < $a791dc77ae9c188b$var$raceStartTime || $a791dc77ae9c188b$var$isRaceFinished) return;
    const playerControl = $a791dc77ae9c188b$var$playerCar.control;
    // break
    playerControl.isBreak = $a791dc77ae9c188b$var$keyPresses.ArrowDown || $a791dc77ae9c188b$var$keyPresses.x;
    // accellerate
    playerControl.isAccelerate = !playerControl.isBreak && ($a791dc77ae9c188b$var$keyPresses.ArrowUp || $a791dc77ae9c188b$var$keyPresses.z);
    // steer left/right - just set flags, actual steering applied in physics tick
    playerControl.isSteeringLeft = $a791dc77ae9c188b$var$keyPresses.ArrowLeft;
    playerControl.isSteeringRight = $a791dc77ae9c188b$var$keyPresses.ArrowRight;
}
function $a791dc77ae9c188b$var$updateViz(now) {
    const playerControl = $a791dc77ae9c188b$var$playerCar.control;
    $a791dc77ae9c188b$var$$steeringAccViz.style.transform = `scaleX(${playerControl.steeringAcc / playerControl.maxSteeringAcc})`;
    $a791dc77ae9c188b$var$$steeringViz.style.transform = `scaleX(${playerControl.steering})`;
    $a791dc77ae9c188b$var$$accelerationViz.style.transform = `scaleX(${playerControl.acceleration / playerControl.maxAcceleration})`;
    $a791dc77ae9c188b$var$$speedViz.style.transform = `scaleX(${playerControl.speed / $a791dc77ae9c188b$var$playerCar.getMaxSpeed()})`;
    $a791dc77ae9c188b$var$$lapProgressViz.style.transform = `scaleX(${$a791dc77ae9c188b$var$playerCar.lapProgress / $a791dc77ae9c188b$var$trackRacinglineSegments.length})`;
    $a791dc77ae9c188b$var$$speedLabel.innerText = Math.floor(playerControl.speed * 10);
    $a791dc77ae9c188b$var$$lapLabel.innerText = $a791dc77ae9c188b$var$playerCar.lap + 1;
    const lapTime = $a791dc77ae9c188b$var$playerCar.lapStartTimes[$a791dc77ae9c188b$var$playerCar.lap] >= 0 ? now - $a791dc77ae9c188b$var$raceStartTime - $a791dc77ae9c188b$var$playerCar.lapStartTimes[$a791dc77ae9c188b$var$playerCar.lap] : 0;
    $a791dc77ae9c188b$var$$lapTimeLabel.innerText = (0, $cb8a4fc1d1568115$export$e0b56eedabd2a5bd)(lapTime >= 0 ? lapTime : 0);
    $a791dc77ae9c188b$var$$startLights.style.opacity = now > -1 && now < $a791dc77ae9c188b$var$raceStartTime ? 1 : 0;
    const startLightCount = now < $a791dc77ae9c188b$var$raceStartTime - 6000 || now > $a791dc77ae9c188b$var$raceStartTime ? 0 : Math.floor(5 - ($a791dc77ae9c188b$var$raceStartTime - 1000 - now) / 5000 * 5);
    $a791dc77ae9c188b$var$setStartLight(startLightCount);
}
function $a791dc77ae9c188b$var$highlightRacinglinePoint(index) {
    for(let i = 0; i < $a791dc77ae9c188b$var$samples.length; i++)$a791dc77ae9c188b$var$samples[i].style.background = i === index ? "orange" : "gray";
}
function $a791dc77ae9c188b$var$updateLapTimesBoard() {
    if ($a791dc77ae9c188b$var$lapCount <= 1) return;
    for(let i = 0; i < $a791dc77ae9c188b$var$lapCount; i++){
        const $lapTime = $a791dc77ae9c188b$var$lapTimes[i];
        $lapTime.innerText = (0, $cb8a4fc1d1568115$export$e0b56eedabd2a5bd)($a791dc77ae9c188b$var$playerCar.getLapTime(i));
    }
}
function $a791dc77ae9c188b$var$updateCamera(alpha) {
    // Guard against uninitialized prevX/prevY or large position jumps (teleportation)
    const dx = $a791dc77ae9c188b$var$playerCar.x - $a791dc77ae9c188b$var$playerCar.prevX;
    const dy = $a791dc77ae9c188b$var$playerCar.y - $a791dc77ae9c188b$var$playerCar.prevY;
    const distSq = dx * dx + dy * dy;
    const TELEPORT_THRESHOLD_SQ = 10000; // ~100 units - larger than any normal frame movement
    let cameraX, cameraY;
    if ($a791dc77ae9c188b$var$playerCar.prevX === undefined || $a791dc77ae9c188b$var$playerCar.prevY === undefined || distSq > TELEPORT_THRESHOLD_SQ) {
        // Skip interpolation during initialization or teleportation
        cameraX = $a791dc77ae9c188b$var$playerCar.x;
        cameraY = $a791dc77ae9c188b$var$playerCar.y;
    } else {
        // Normal interpolation for smooth following
        cameraX = $a791dc77ae9c188b$var$playerCar.prevX + ($a791dc77ae9c188b$var$playerCar.x - $a791dc77ae9c188b$var$playerCar.prevX) * alpha;
        cameraY = $a791dc77ae9c188b$var$playerCar.prevY + ($a791dc77ae9c188b$var$playerCar.y - $a791dc77ae9c188b$var$playerCar.prevY) * alpha;
    }
    $a791dc77ae9c188b$var$camera.x = cameraX;
    $a791dc77ae9c188b$var$camera.y = cameraY;
    $a791dc77ae9c188b$var$$game.style.transform = `translate(${(-$a791dc77ae9c188b$var$camera.x + $a791dc77ae9c188b$var$hvw) * $a791dc77ae9c188b$var$cameraZoom}px, ${(-$a791dc77ae9c188b$var$camera.y + $a791dc77ae9c188b$var$hvh) * $a791dc77ae9c188b$var$cameraZoom}px) scale(${$a791dc77ae9c188b$var$cameraZoom})`;
}
function $a791dc77ae9c188b$var$updateCarsPhysics(now) {
    for(let i = 0; i < $a791dc77ae9c188b$var$cars.length; i++){
        const car = $a791dc77ae9c188b$var$cars[i];
        // Skip ghost cars only when they're actively replaying
        // During bot phase (driving from grid to start line), run physics
        if (!car.ghostData || !car.isGhostReplayActive) car.physicsTick(now);
    }
}
function $a791dc77ae9c188b$var$updateGhosts(now) {
    // Ghost cars use time-based interpolation, updated every render frame
    for(let i = 0; i < $a791dc77ae9c188b$var$cars.length; i++){
        const car = $a791dc77ae9c188b$var$cars[i];
        if (car.ghostData) car.updateGhost(now);
    }
}
function $a791dc77ae9c188b$var$renderCars(alpha) {
    for(let i = 0; i < $a791dc77ae9c188b$var$cars.length; i++){
        const car = $a791dc77ae9c188b$var$cars[i];
        car.render(alpha);
    }
    // Update engine sound in render loop for smooth audio
    $a791dc77ae9c188b$var$playerCar.updateEngineSound();
}
function $a791dc77ae9c188b$var$recordGhostIfNeeded(now) {
    if (!$a791dc77ae9c188b$var$isDemo && $a791dc77ae9c188b$var$playerCar.lapStartTimes[$a791dc77ae9c188b$var$playerCar.lap] >= 0 && now >= $a791dc77ae9c188b$var$playerCar.lapStartTimes[$a791dc77ae9c188b$var$playerCar.lap]) (0, $74682beda20f55da$export$5df67d441e0c8bea)(now - $a791dc77ae9c188b$var$playerCar.lapStartTimes[$a791dc77ae9c188b$var$playerCar.lap], $a791dc77ae9c188b$var$playerCar.x, $a791dc77ae9c188b$var$playerCar.y, $a791dc77ae9c188b$var$playerCar.heading);
}
function $a791dc77ae9c188b$var$updateCarsVisuals() {
    if ($a791dc77ae9c188b$var$playerCar.racinglinePoint) $a791dc77ae9c188b$var$highlightRacinglinePoint($a791dc77ae9c188b$var$playerCar.racinglinePoint.index);
    $a791dc77ae9c188b$var$drawTireSkid($a791dc77ae9c188b$var$playerCar);
}
function $a791dc77ae9c188b$var$handlePlayerBestLapTime() {
    if (!$a791dc77ae9c188b$var$isDemo) (0, $74682beda20f55da$export$1a28bbfe6308d9c9)($a791dc77ae9c188b$var$currentTrackName);
}
async function $a791dc77ae9c188b$var$handlePlayerLapComplete() {
    if (!$a791dc77ae9c188b$var$isDemo) {
        $a791dc77ae9c188b$var$updateLapTimesBoard();
        // when finished
        if ($a791dc77ae9c188b$var$playerCar.getLapCount() >= $a791dc77ae9c188b$var$lapCount) {
            await $a791dc77ae9c188b$var$showFinishFlag();
            await (0, $cb8a4fc1d1568115$export$1391212d75b2ee65)(2000);
            $a791dc77ae9c188b$var$hideFinishFlag();
            $a791dc77ae9c188b$var$showBestLapDialog($a791dc77ae9c188b$var$playerCar.getBestLapTime());
        }
    }
}
function $a791dc77ae9c188b$var$updateFPS() {
    $a791dc77ae9c188b$var$frameCount++;
    const currentTime = $a791dc77ae9c188b$var$now;
    if (currentTime - $a791dc77ae9c188b$var$lastFpsTime >= 1000) {
        $a791dc77ae9c188b$var$fps = Math.round($a791dc77ae9c188b$var$frameCount * 1000 / (currentTime - $a791dc77ae9c188b$var$lastFpsTime));
        $a791dc77ae9c188b$var$frameCount = 0;
        $a791dc77ae9c188b$var$lastFpsTime = currentTime;
        // Update FPS display with color coding
        $a791dc77ae9c188b$var$$fpsCounter.textContent = `${$a791dc77ae9c188b$var$fps} FPS`;
        if ($a791dc77ae9c188b$var$fps >= 50) {
            $a791dc77ae9c188b$var$$fpsCounter.style.color = "#00ff88";
            $a791dc77ae9c188b$var$$fpsCounter.style.borderColor = "rgba(0, 255, 136, 0.3)";
        } else if ($a791dc77ae9c188b$var$fps >= 30) {
            $a791dc77ae9c188b$var$$fpsCounter.style.color = "#ffaa00";
            $a791dc77ae9c188b$var$$fpsCounter.style.borderColor = "rgba(255, 170, 0, 0.3)";
        } else {
            $a791dc77ae9c188b$var$$fpsCounter.style.color = "#ff4444";
            $a791dc77ae9c188b$var$$fpsCounter.style.borderColor = "rgba(255, 68, 68, 0.3)";
        }
    }
}
function $a791dc77ae9c188b$var$update() {
    $a791dc77ae9c188b$var$now = Date.now();
    const offsetNow = $a791dc77ae9c188b$var$now - $a791dc77ae9c188b$var$raceStartTime;
    $a791dc77ae9c188b$var$updateFPS();
    if ($a791dc77ae9c188b$var$isInit) {
        $a791dc77ae9c188b$var$processKeyPresses();
        if (!$a791dc77ae9c188b$var$isPaused) {
            // Run physics at fixed 60 Hz timestep
            (0, $e24eb4b533960f8a$export$11ec2289ecd96598)(offsetNow, ()=>{
                $a791dc77ae9c188b$var$updateCarsPhysics(offsetNow);
                if ($a791dc77ae9c188b$var$showSparkEffects) (0, $3df263189409ffaa$export$82f1959c43a38055)(offsetNow);
            });
            // Update ghost cars every render frame (time-based, not physics-based)
            $a791dc77ae9c188b$var$updateGhosts(offsetNow);
            // Render with interpolation for smooth visuals
            const alpha = (0, $e24eb4b533960f8a$export$2be38fe441e278c1)();
            $a791dc77ae9c188b$var$renderCars(alpha);
            if ($a791dc77ae9c188b$var$showSparkEffects) (0, $3df263189409ffaa$export$a47de188f7a2507b)(offsetNow, alpha);
            // Time-based updates (ghost recording, visuals, UI)
            $a791dc77ae9c188b$var$recordGhostIfNeeded(offsetNow);
            $a791dc77ae9c188b$var$updateCarsVisuals();
            $a791dc77ae9c188b$var$updateViz($a791dc77ae9c188b$var$now);
            $a791dc77ae9c188b$var$updateCamera(alpha);
        }
    }
    window.requestAnimationFrame($a791dc77ae9c188b$var$update);
}
$a791dc77ae9c188b$var$initManifest();


//# sourceMappingURL=game.7752d032.js.map
